'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var debounce = _interopDefault(require('lodash/debounce'));
var classnames = _interopDefault(require('classnames'));
var ReactDOM = require('react-dom');
var ReactDOM__default = _interopDefault(ReactDOM);
var reactPopper = require('react-popper');
var Immutable = require('immutable');
var Immutable__default = _interopDefault(Immutable);
var PropTypes = _interopDefault(require('prop-types'));
var Hotkeys = _interopDefault(require('slate-hotkeys'));
var memoizeOne = _interopDefault(require('memoize-one'));
var Slate = require('slate');
var Slate__default = _interopDefault(Slate);
var slateReact = require('slate-react');
var reactColorful = require('react-colorful');
var renderIf = _interopDefault(require('render-if'));
var Base64 = _interopDefault(require('slate-base64-serializer'));
var getWindow = _interopDefault(require('get-window'));
var slateDevEnvironment = require('slate-dev-environment');
var isHotkey = require('is-hotkey');
var isHotkey__default = _interopDefault(isHotkey);
var EditList = _interopDefault(require('@aha-app/slate-edit-list'));
var omit = _interopDefault(require('lodash/omit'));
var Debug = _interopDefault(require('debug'));
var ShareDB = _interopDefault(require('sharedb/lib/client'));
var otSlate = require('@aha-app/ot-slate');
var isUrl = _interopDefault(require('is-url'));
var shortid = _interopDefault(require('shortid'));
var StickyInlines = _interopDefault(require('slate-sticky-inlines'));
var PlainSerializer = _interopDefault(require('slate-plain-serializer'));
var marked = require('marked');
var Prism = _interopDefault(require('prismjs/components/prism-core'));
require('prismjs/components/prism-clike');
require('prismjs/components/prism-markup');
require('prismjs/components/prism-javascript');
require('prismjs/components/prism-css');
require('prismjs/components/prism-ruby');
require('prismjs/components/prism-markup-templating');
require('prismjs/components/prism-erb');
require('prismjs/plugins/line-numbers/prism-line-numbers');
require('prismjs/plugins/unescaped-markup/prism-unescaped-markup');
require('prismjs/components/prism-java');
require('prismjs/components/prism-jsx');
require('prismjs/components/prism-python');
require('prismjs/components/prism-shell-session');
require('prismjs/components/prism-typescript');
require('prismjs/components/prism-tsx');
var isEqual = _interopDefault(require('lodash/isEqual'));
var wordFilter = _interopDefault(require('@aha-app/tinymce-word-paste-filter'));
var Html = _interopDefault(require('slate-html-serializer'));
var flatMap = _interopDefault(require('lodash/flatMap'));
var AutoReplace = _interopDefault(require('slate-auto-replace'));
var isObject = _interopDefault(require('lodash/isObject'));

var findParent = (function (condition) {
  return function (el) {
    while (el) {
      if (el.nodeType === el.ELEMENT_NODE && condition(el)) {
        return el;
      } else {
        el = el.parentNode;
      }
    }
    return null;
  };
});

function shallowCompare(a, b) {
  var except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var allKeys = new Set();
  Object.keys(a).forEach(function (key) {
    return allKeys.add(key);
  });
  Object.keys(b).forEach(function (key) {
    return allKeys.add(key);
  });
  except.forEach(function (key) {
    return allKeys.delete(key);
  });

  return Array.from(allKeys).every(function (key) {
    return a[key] === b[key];
  });
}

var styles = { "anchor": "Anchor-module_anchor__3FfnA" };

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};





var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Anchor = function (_React$Component) {
  inherits(Anchor, _React$Component);

  function Anchor(props) {
    classCallCheck(this, Anchor);

    var _this = possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props));

    _this.state = {
      style: {},
      computedTop: 0,
      computedLeft: 0,
      computedHeight: 0,
      computedWidth: 0
    };

    _this.recomputeStyle = function () {
      var node = _this.state.style.position ? _this.placeholderRef.current : _this.anchorRef.current;

      if (!node) return;

      var rect = node.getBoundingClientRect();

      if (rect.height === 0) {
        rect = node.parentElement.getBoundingClientRect();
      }

      var top = _this.getAbsoluteCoordinate(rect.top);

      _this.setState({
        computedTop: top,
        computedLeft: rect.left,
        computedHeight: rect.height,
        computedWidth: rect.width
      });
    };

    _this.debouncedRecomputeStyle = debounce(_this.recomputeStyle, 100);

    _this.resetStyle = function () {
      _this.setState({
        style: {}
      });
    };

    _this.checkSticky = function () {
      if (_this.animationFrameRequest) return;

      // If the focused editor does not contain the anchor, we don't want to float the toolbar.
      var focusedEditor = document.activeElement.closest('.aha-editor');

      // If there is no focused editor, check to see if there is a "pseudo-focused" editor. This could be an editor which is in a "locked" state (so not focusable) but is otherwise "active" (in the sense that scrolling the editor should cause the "locked" toolbar to stick in place).
      if (!focusedEditor) {
        focusedEditor = document.querySelector('.aha-editor-field-focused .aha-editor');
      }

      if (!_this.anchorRef.current || !focusedEditor || !focusedEditor.contains(_this.anchorRef.current)) {
        // If we ever lose the reference to the anchor, we should reset the style, or the anchor is not part of the focused editor, we should reset the style. This prevents the toolbar from ending up in strange places on the page.
        _this.resetStyle();
      } else {
        _this.animationFrameRequest = window.requestAnimationFrame(function () {
          _this.animationFrameRequest = null;

          var scrollContainerOriginalTop = _this.scrollContainer ? _this.scrollContainer.getBoundingClientRect().top : 0;
          var _this$props$toolbarOf = _this.props.toolbarOffset,
              toolbarOffset = _this$props$toolbarOf === undefined ? 0 : _this$props$toolbarOf;

          var top = _this.getAbsoluteCoordinate(scrollContainerOriginalTop) + toolbarOffset;

          var bottom = void 0;

          if (_this.container) {
            var containerRect = _this.container.getBoundingClientRect();
            // If the container is hidden, its height will be zero, which
            // means we'd always float the toolbar, which makes it hard to
            // calculate the size when it's shown. It's better to treat a
            // hidden container as a nonexistent container.
            if (containerRect.height > 0) {
              bottom = _this.getAbsoluteCoordinate(containerRect.bottom);
            }
          }

          if (_this.state.computedHeight > 0 && bottom !== undefined && bottom <= top + _this.state.computedHeight) {
            _this.setState({
              style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 1 // move above Bootstrap checklists
              }
            });
          } else if (_this.state.computedHeight > 0 && top > _this.state.computedTop) {
            var _this$props$toolbarOf2 = _this.props.toolbarOffset,
                _toolbarOffset = _this$props$toolbarOf2 === undefined ? 0 : _this$props$toolbarOf2;

            _this.setState({
              style: {
                position: 'fixed',
                top: _toolbarOffset,
                left: 0,
                width: _this.state.computedWidth,
                zIndex: 1, // move above Bootstrap checklists
                transform: 'translate3d(' + _this.state.computedLeft + 'px, ' + scrollContainerOriginalTop + 'px, 0px)'
              }
            });
          } else if (_this.state.style.position) {
            _this.resetStyle();
          }
        });
      }
    };

    _this.findScrollContainer = findParent(function (el) {
      var computedStyle = window.getComputedStyle(el);
      var overflow = computedStyle && computedStyle.overflow;
      return overflow === 'auto' || overflow === 'scroll';
    });
    _this.findRelativeContainer = findParent(function (el) {
      var computedStyle = window.getComputedStyle(el);
      var position = computedStyle && computedStyle.position;
      return position === 'relative';
    });

    _this.placeholderRef = React__default.createRef();
    _this.anchorRef = React__default.createRef();
    return _this;
  }

  createClass(Anchor, [{
    key: 'getAbsoluteCoordinate',
    value: function getAbsoluteCoordinate(coordinate) {
      var absoluteCoordinate = coordinate + window.pageYOffset;
      if (this.scrollContainer) {
        absoluteCoordinate += this.scrollContainer.scrollTop;
      }
      return absoluteCoordinate;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.animationFrameRequest = null;
      this.scrollContainer = this.findScrollContainer(this.anchorRef.current);
      this.container = this.findRelativeContainer(this.anchorRef.current);

      (this.scrollContainer || window).addEventListener('scroll', this.checkSticky);
      window.addEventListener('resize', this.recomputeStyle);
      window.addEventListener('aha-editor:focus', this.checkSticky);
      window.addEventListener('resize', this.checkSticky);
      this.recomputeStyle();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.cancelAnimationFrame(this.animationFrameRequest);
      this.debouncedRecomputeStyle.cancel();
      (this.scrollContainer || window).removeEventListener('scroll', this.checkSticky);
      window.removeEventListener('resize', this.checkSticky);
      window.removeEventListener('aha-editor:focus', this.checkSticky);
      window.removeEventListener('resize', this.recomputeStyle);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Changes to us and our children, like adding or showing child
      // elements, can affect our original dimensions.
      if (this.props !== prevProps || !shallowCompare(this.state, prevState, ['style'])) {
        this.debouncedRecomputeStyle();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props !== nextProps) return true;
      if (!shallowCompare(this.state, nextState, ['style'])) return true;
      if (!shallowCompare(this.state.style, nextState.style)) return true;
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        willChange: 'transform'
      };
      var placeholder = null;

      if (this.state.style.position) {
        style = _extends({}, style, this.state.style);

        var placeholderContainerStyle = {
          height: this.state.computedHeight
        };

        placeholder = React__default.createElement('div', {
          className: classnames('anchor-placeholder', styles.anchor, this.props.className),
          ref: this.placeholderRef,
          style: placeholderContainerStyle
        });
      }

      return React__default.createElement(
        'div',
        null,
        React__default.createElement(
          'div',
          {
            ref: this.anchorRef,
            style: style,
            className: classnames('anchor', styles.anchor, this.props.className)
          },
          this.props.children
        ),
        placeholder
      );
    }
  }]);
  return Anchor;
}(React__default.Component);

var styles$1 = { "toolbar": "Toolbar-module_toolbar__VbT_e", "selectionBasedToolbar": "Toolbar-module_selectionBasedToolbar__3DBrr", "faded": "Toolbar-module_faded__Cmsd2", "toolbarGroup": "Toolbar-module_toolbarGroup__3HiIu", "collapsedToolbarGroup": "Toolbar-module_collapsedToolbarGroup__cJXKo", "collapsedToolbarGroupItem": "Toolbar-module_collapsedToolbarGroupItem__28jd2" };

var styles$2 = { "hidden": "Popup-module_hidden__1O7qK", "shown": "Popup-module_shown__3ARrT", "popup": "Popup-module_popup__1v3bE", "arrow": "Popup-module_arrow__21eSA", "arrow-bottom": "Popup-module_arrow-bottom__fX2Uq", "arrow-bottom-background": "Popup-module_arrow-bottom-background__3SzRZ", "arrow-top": "Popup-module_arrow-top__1Qvfn", "arrow-top-background": "Popup-module_arrow-top-background__EYReQ", "toolbar": "Popup-module_toolbar__bOyHZ", "item": "Popup-module_item__1Fekt", "toggled": "Popup-module_toggled__Ox0qB" };

// @ts-ignore
/**
 * @typedef PortalPopupProps
 * @prop {HTMLElement|Component=} parent
 * @prop {boolean} visible
 * @prop {boolean=} hasFocus
 * @prop {string=} className
 * @prop {string=} popupClassName
 * @prop {number} [zIndex]
 * @prop {('top-start'|'right'|'bottom'|'bottom-start')=} placement
 * @prop {((event) => void)=} onClickOutside
 * @prop {boolean=} arrow
 * @prop {(String|HTMLElement)=} boundariesElement
 * @prop {(HTMLElement)=} referenceElement
 * @prop {object} [modifiers]
 * @prop {((props: {scheduleUpdate: any}) => React.ReactNode)} children
 */

var CONTAINER_ID = 'aha-editor-popup-container';

/**
 * @augments {React.Component<PortalPopupProps, {}>}
 */
var PortalPopup = function (_Component) {
  inherits(PortalPopup, _Component);

  function PortalPopup(props) {
    classCallCheck(this, PortalPopup);

    var _this = possibleConstructorReturn(this, (PortalPopup.__proto__ || Object.getPrototypeOf(PortalPopup)).call(this, props));

    _this.onMouseDown = function (event) {
      if (_this.el.contains(event.target)) {
        _this.setState({ hasFakeFocus: true });
      } else {
        _this.setState({ hasFakeFocus: false });
        if (_this.props.onClickOutside) {
          _this.props.onClickOutside(event);
        }
      }
    };

    _this.el = document.createElement('div');
    _this.state = { hasFakeFocus: false };
    _this.wrappedEl = null;
    return _this;
  }

  createClass(PortalPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var parent = this.props.parent;


      if (!parent) {
        parent = PortalPopup.body();
      }

      if (!parent.appendChild) {
        parent = ReactDOM__default.findDOMNode(parent).closest('.aha-editor');
      }

      parent.appendChild(this.el);

      if (this.props.visible) {
        this.registerListeners();
      }

      if (this.props.wrappedRef && this.props.wrappedRef.current) {
        this.wrappedEl = ReactDOM__default.findDOMNode(this.props.wrappedRef.current);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.el.remove();
      if (this.props.visible) {
        this.unregisterListeners();
      }
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.setState({ hasFakeFocus: false });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.visible && !prevProps.visible) {
        this.registerListeners();
      } else if (!this.props.visible && prevProps.visible) {
        this.unregisterListeners();
      }
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      document.addEventListener('mousedown', this.onMouseDown, true);
      document.addEventListener('touchstart', this.onMouseDown, true);
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      document.removeEventListener('mousedown', this.onMouseDown, true);
      document.removeEventListener('touchstart', this.onMouseDown, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          arrow = _props.arrow,
          visible = _props.visible,
          className = _props.className,
          zIndex = _props.zIndex,
          children = _props.children,
          boundariesElement = _props.boundariesElement,
          referenceElement = _props.referenceElement,
          popupClassName = _props.popupClassName,
          modifierProps = _props.modifiers;


      var modifiers = _extends({
        arrow: { enabled: arrow },
        preventOverflow: {}
      }, modifierProps);

      if (arrow) {
        modifiers.offset = { options: { offset: [0, 10] } };
      }

      modifiers.preventOverflow = {
        options: {
          boundary: boundariesElement,
          altAxis: true, // Prevent overflow in both axes
          tether: false, // Allow popup to overlap reference if there isn't enough room
          padding: 8
        }
      };

      modifiers.eventListeners = {
        options: { scroll: visible, resize: visible }
      };

      var transformedModifiers = Object.keys(modifiers).reduce(function (acc, key) {
        return [].concat(toConsumableArray(acc), [_extends({ name: key }, modifiers[key])]);
      }, []);

      var zStyle = { zIndex: zIndex };
      var classes = classnames('aha-editor-popup', (_classnames = {}, defineProperty(_classnames, styles$2.hidden, !visible), defineProperty(_classnames, styles$2.shown, visible), _classnames), popupClassName);

      return ReactDOM__default.createPortal(React__default.createElement(
        reactPopper.Popper,
        {
          placement: placement || 'bottom',
          modifiers: transformedModifiers,
          strategy: 'fixed',
          referenceElement: referenceElement
        },
        function (_ref) {
          var ref = _ref.ref,
              style = _ref.style,
              placement = _ref.placement,
              arrowProps = _ref.arrowProps,
              update = _ref.update;

          var arrowClass = 'arrow-' + (placement || '').split('-')[0];

          var arrowClasses = {
            arrow: styles$2[arrowClass],
            background: styles$2[arrowClass + '-background']
          };

          // It is necessary at times to tweak the location computed by
          // popper.js for where the popup should appear. As an example,
          // in Monet the slide canvas uses `transform: scale(...)` which
          // messes up the default popper.js calculations and results in
          // a popup that is not near its intended element. To fix this
          // issue, we pass in a function that can adjust the positioning
          // styles as needed. Note that this is the only place where this
          // adjustment can happen since this is the only point where
          // `style` as computed by popper.js is readily accessible. In addition
          // to the style computed by popper.js, the function needs some
          // way of accessing the dom node that the popup should be pointing
          // to. Since the actual wrapped element is not a part of this component,
          // but instead the part <Reference> component, that ref needs to be
          // passed here so it can in term be passed to the adjuster function.
          if (visible && _this2.props.popupPlacementAdjuster && _this2.wrappedEl) {
            style = _this2.props.popupPlacementAdjuster(style, _this2.wrappedEl);
          }

          return React__default.createElement(
            'div',
            {
              ref: ref,
              className: classes,
              style: _extends({}, style, zStyle),
              'data-placement': placement
            },
            React__default.createElement(
              'div',
              { className: classnames(className) },
              children({ scheduleUpdate: update })
            ),
            arrow ? React__default.createElement(
              'div',
              {
                ref: arrowProps.ref,
                style: arrowProps.style,
                className: styles$2.arrow
              },
              React__default.createElement('div', { className: arrowClasses.arrow }),
              React__default.createElement('div', { className: arrowClasses.background })
            ) : null
          );
        }
      ), this.el);
    }
  }, {
    key: 'hasFocus',
    get: function get$$1() {
      return this.state.hasFakeFocus || this.el.contains(document.activeElement);
    }
  }]);
  return PortalPopup;
}(React.Component);

PortalPopup.body = function () {
  var container = document.getElementById(CONTAINER_ID);
  if (container) {
    return container;
  }

  container = document.createElement('div');
  container.id = CONTAINER_ID;
  container.style.position = 'absolute';
  document.body.appendChild(container);
  return container;
};

/**
 * Returns true if the node in the given props is selected and the only node selected. Any partial
 * selection within the node will return true, but any selection that falls outside of the node will
 * be false.
 *
 *
 * @param {AhaEditor.NodeComponentProps} props
 * @returns {boolean}
 */
function onlySelected(props) {
  var node = props.node,
      _props$editor$value$s = props.editor.value.selection,
      start = _props$editor$value$s.start,
      end = _props$editor$value$s.end,
      isFocused = _props$editor$value$s.isFocused;


  if (!isFocused) return false;
  var document = props.editor.value.document;

  var selected = [node.getDescendant(start.key), node.getDescendant(end.key)];

  if (selected.every(Boolean)) {
    return true;
  }

  if (Boolean(selected[0]) && end.offset === 0) {
    var nextNode = document.getNextSibling(node.key);

    if (nextNode.object === 'text' && nextNode.key === end.key) {
      return true;
    }

    if (nextNode && nextNode.getFirstText) {
      var firstText = nextNode.getFirstText();
      return firstText.key === end.key;
    }
  }

  return false;
}

/**
 * Cache of popups by node key
 * @type {Immutable.Map<string, any>}
 */
var componentsByKey = Immutable__default.Map();

/**
 * @param {string} key
 * @return {React.Component | undefined}
 */
function componentByKey(key) {
  var wrapper = componentsByKey.get(key);
  if (wrapper) {
    return wrapper.wrappedComponent;
  }
}

/**
 * @param {React.ComponentClass} WrappedComponent
 * @return {React.ComponentClass}
 */
function enhanceWithComponentByKey(WrappedComponent) {
  return function (_React$Component) {
    inherits(_class, _React$Component);

    function _class(props) {
      classCallCheck(this, _class);

      /** @type {any} */
      var _this = possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.wrapped = null;
      _this.storeKey();
      return _this;
    }

    createClass(_class, [{
      key: 'storeKey',
      value: function storeKey() {
        componentsByKey = componentsByKey.set(this.props.node.key, this);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(newProps) {
        this.storeKey();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        componentsByKey = componentsByKey.remove(this.props.node.key);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return React__default.createElement(WrappedComponent, _extends({
          ref: function ref(w) {
            _this2.wrapped = w;
          }
        }, this.props));
      }
    }, {
      key: 'wrappedComponent',
      get: function get$$1() {
        return this.wrapped;
      }
    }]);
    return _class;
  }(React__default.Component);
}

// @ts-ignore
/**
 * @typedef ComponentWithPopupProps
 * @prop {*} node
 * @prop {*} editor
 * @prop {*} attributes
 * @prop {boolean} isSelected
 */
/**
 * @typedef ComponentWithPropsState
 * @prop {boolean} visible
 * @prop {boolean} dismissed
 * @prop {boolean} hiddenByScroll
 */
/**
 * HOC that adds a popup to a block or inline.
 *
 * @example
 *   const MyExportedInline = componentWithPopup(MyInline, MyPopup)
 *
 * Props are passed to both components, plus the popup compoennt gets a `visible` prop.
 */
function componentWithPopup(WrappedComponent, Items) {
  var _class, _temp, _initialiseProps;

  return enhanceWithComponentByKey((
  /** @augments {React.Component<ComponentWithPopupProps, ComponentWithPropsState>} */
  _temp = _class = function (_Component) {
    inherits(_class, _Component);

    function _class(props) {
      classCallCheck(this, _class);

      var _this = possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = { visible: onlySelected(props), dismissed: false, hiddenByScroll: false };
      _this.popup = null;
      _this.wrappedRef = React__default.createRef();
      return _this;
    }

    createClass(_class, [{
      key: 'shouldShowPopup',
      value: function shouldShowPopup(props) {
        var readOnly = props.editor.readOnly;

        // Never show popups for readonly content.

        if (readOnly) return false;

        return this.popup && this.popup.hasFocus || onlySelected(props);
      }

      // Debounce, because we want a little bit of leeway for the
      // selection to move from one component to another.

    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(newProps) {
        this.updateVisibility(newProps);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (!prevState.visible && this.state.visible) {
          document.addEventListener('click', this.onClick);
        } else if (prevState.visible && !this.state.visible) {
          document.removeEventListener('click', this.onClick);
          this.setState({ dismissed: false });
        }

        if (this.state.visible && this.scheduleUpdate) {
          this.scheduleUpdate();
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.state.visible) {
          document.addEventListener('click', this.onClick);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.updateVisibility.cancel();
        if (this.state.visible) {
          document.removeEventListener('click', this.onClick);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var visible = this.visible;


        return React__default.createElement(
          reactPopper.Manager,
          null,
          React__default.createElement(
            reactPopper.Reference,
            null,
            function (_ref) {
              var ref = _ref.ref;
              return React__default.createElement(
                'span',
                _extends({}, _this2.props.attributes, { ref: ref }),
                React__default.createElement(WrappedComponent, _extends({}, _this2.props, { ref: _this2.wrappedRef }))
              );
            }
          ),
          React__default.createElement(
            PortalPopup,
            {
              parent: this.props.popupParent || this,
              visible: visible,
              className: styles$2.popup,
              zIndex: 15,
              arrow: true,
              placement: 'bottom',
              ref: function ref(_ref3) {
                return _this2.popup = _ref3;
              },
              popupPlacementAdjuster: this.props.popupPlacementAdjuster,
              wrappedRef: this.wrappedRef
            },
            function (_ref2) {
              var scheduleUpdate = _ref2.scheduleUpdate;

              _this2.scheduleUpdate = scheduleUpdate;
              return React__default.createElement(Items, _extends({}, _this2.props, {
                scheduleUpdate: scheduleUpdate,
                popup: _this2.popup,
                visible: visible,
                setHiddenByScroll: _this2.setHiddenByScroll,
                onDismiss: _this2.onDismiss
              }));
            }
          )
        );
      }
    }, {
      key: 'visible',
      get: function get$$1() {
        return this.state.visible && !this.state.dismissed && !this.state.hiddenByScroll;
      }
    }]);
    return _class;
  }(React.Component), _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateVisibility = debounce(function (props) {
      _this3.setState({ visible: _this3.shouldShowPopup(props) });
    }, 10);

    this.onClick = function () {
      _this3.updateVisibility(_this3.props);
    };

    this.onDismiss = function () {
      _this3.setState({ dismissed: true });
    };

    this.setHiddenByScroll = function (value) {
      _this3.setState({ hiddenByScroll: value });
    };
  }, _temp));
}

// @ts-ignore
/**
 * @param {{className?:string, children?: any}} props
 */
function PopupToolbar(props) {
  var className = props.className,
      children = props.children;

  return React__default.createElement(
    'div',
    { className: classnames(styles$2.toolbar, className) },
    children
  );
}

/** @typedef PopupToolbarItemProps
 * @prop {(event) => void} [onClick]
 * @prop {(event) => void} [onMouseDown]
 * @prop {(event) => void} [onMouseUp]
 * @prop {boolean=} toggled
 * @prop {string=} className
 * @prop {(*)=} children
 */
/**
 * @param {PopupToolbarItemProps} props
 */
function PopupToolbarItem(props) {
  var onClick = props.onClick,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      toggled = props.toggled,
      className = props.className,
      children = props.children;

  var classes = classnames(styles$2.item, className, defineProperty({}, styles$2.toggled, toggled));

  return React__default.createElement(
    'div',
    {
      onClick: onClick,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      className: classes
    },
    children
  );
}

var MenuContext = React__default.createContext({
  // Is the menu in "collapsed" mode? (Shown as a menu, rather than a toolbar)
  collapsed: false,
  // The name of the currently selected (hovered / open) menu item
  activeMenuItem: null,
  // Callback to be called when the active menu item changes, usually
  // on mouseEnter of a different item
  onMenuItemActivated: null,
  // Callback to be called when a descendant menu is dismissed, so we
  // can also dismiss our menu
  onMenuHidden: null
});

var cssClasses = {
  menu: 'react-contextmenu',
  menuVisible: 'react-contextmenu--visible',
  menuWrapper: 'react-contextmenu-wrapper',
  menuItem: 'react-contextmenu-item',
  menuItemActive: 'react-contextmenu-item--active',
  menuItemDisabled: 'react-contextmenu-item--disabled',
  menuItemDivider: 'react-contextmenu-item--divider',
  menuItemChecked: 'react-contextmenu-item--checked',
  menuItemOpen: 'react-contextmenu-item--open',
  subMenu: 'react-contextmenu-submenu'
};

/**
 * @typedef MenuItemProps
 * @prop {(*)=} attributes
 * @prop {(*)=} data
 * @prop {boolean=} disabled
 * @prop {boolean=} divider
 * @prop {((event: any, data: any) => void)=} onClick
 * @prop {boolean=} selected
 * @prop {boolean=} open
 * @prop {((event: any) => void)=} onMouseEnter
 */
/**
 * Implementation of MenuItem for Toolbar. Exposes the same interface as React ContextMenu but with
 * simpler event handling.
 *
 * @augments {React.Component<MenuItemProps, {}>}
 */
var MenuItem = function (_Component) {
  inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          divider = _this$props.divider,
          onClick = _this$props.onClick,
          data = _this$props.data;


      event.preventDefault();

      if (disabled || divider) return;
      if (!onClick) return;

      onClick(event, data);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MenuItem, [{
    key: 'render',
    value: function render() {
      var _cx,
          _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          divider = _props.divider,
          children = _props.children,
          attributes = _props.attributes,
          selected = _props.selected,
          onMouseEnter = _props.onMouseEnter,
          open = _props.open;


      var menuItemClassNames = classnames(cssClasses.menuItem, attributes && attributes.className, (_cx = {}, defineProperty(_cx, cssClasses.menuItemDisabled, disabled), defineProperty(_cx, cssClasses.menuItemDivider, divider), defineProperty(_cx, cssClasses.menuItemChecked, selected), defineProperty(_cx, cssClasses.menuItemOpen, open), _cx));

      return React__default.createElement(
        'div',
        _extends({}, attributes, {
          className: menuItemClassNames,
          role: 'menuitem',
          tabIndex: '-1',
          'aria-disabled': disabled ? 'true' : 'false',
          disabled: disabled,
          ref: function ref(_ref2) {
            _this2.ref = _ref2;
          },
          onMouseDown: this.handleClick,
          onMouseEnter: onMouseEnter
        }),
        divider ? null : children
      );
    }
  }]);
  return MenuItem;
}(React.Component);
MenuItem.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.object,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  open: PropTypes.bool,
  onMouseEnter: PropTypes.func
};
MenuItem.defaultProps = {
  disabled: false,
  data: {},
  divider: false,
  attributes: {},
  preventClose: false,
  onClick: function onClick() {
    return null;
  },

  children: null,
  selected: false,
  onMouseEnter: function onMouseEnter() {
    return null;
  }
};

/** @typedef ToolbarItemProps
 * @prop {JSX.Element|JSX.Element[]} children
 * @prop {boolean} [showTitle]
 * @prop {string} [label]
 * @prop {string} [title]
 * @prop {string} [hotkey]
 * @prop {JSX.Element} [iconComponent]
 * @prop {string} [className]
 * @prop {string} [name]
 * @prop {boolean} [divider]
 * @prop {boolean} [active]
 * @prop {boolean} [disabled]
 * @prop {boolean} [open]
 * @prop {(event:any) => void} [onClick]
 * @prop {(name:string) => void} [onMenuItemActivated]
 */

/**
 * @augments {React.Component<ToolbarItemProps, {}>}
 */
var ToolbarItemExpanded = function (_React$Component) {
  inherits(ToolbarItemExpanded, _React$Component);

  function ToolbarItemExpanded() {
    classCallCheck(this, ToolbarItemExpanded);
    return possibleConstructorReturn(this, (ToolbarItemExpanded.__proto__ || Object.getPrototypeOf(ToolbarItemExpanded)).apply(this, arguments));
  }

  createClass(ToolbarItemExpanded, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(prevProps) {
      if (!shallowCompare(prevProps, this.props, ['children'])) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          showTitle = _props.showTitle,
          hotkey = _props.hotkey,
          disabled = _props.disabled,
          className = _props.className,
          onClick = _props.onClick,
          children = _props.children,
          active = _props.active,
          open = _props.open;


      var isActive = !!active;
      var isDisabled = !!disabled;

      var plainTitle = this.props.title || label;
      var titleWithHotkey = void 0;

      if (showTitle !== false && !isDisabled) {
        titleWithHotkey = plainTitle;
        if (titleWithHotkey && hotkey) {
          titleWithHotkey = [titleWithHotkey, '(' + hotkey + ')'].join(' ');
        }
      }

      /** @type {JSX.IntrinsicElements['button']} */
      var ariaState = active !== undefined ? { 'aria-pressed': isActive } : { 'aria-haspopup': true, 'aria-expanded': open };

      return React__default.createElement(
        'button',
        _extends({
          type: 'button',
          className: classnames('aha-editor-toolbar-btn', className, {
            'aha-editor-toolbar-btn--active': isActive
          }),
          onMouseDown: onClick,
          disabled: isDisabled,
          tabIndex: -1,
          'aria-label': plainTitle,
          'data-title': titleWithHotkey
        }, ariaState),
        children
      );
    }
  }]);
  return ToolbarItemExpanded;
}(React__default.Component);

/**
 * @augments {React.Component<ToolbarItemProps, {}>}
 */

var ToolbarItemCollapsed = function (_React$Component2) {
  inherits(ToolbarItemCollapsed, _React$Component2);

  function ToolbarItemCollapsed() {
    var _ref;

    var _temp, _this2, _ret;

    classCallCheck(this, ToolbarItemCollapsed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = possibleConstructorReturn(this, (_ref = ToolbarItemCollapsed.__proto__ || Object.getPrototypeOf(ToolbarItemCollapsed)).call.apply(_ref, [this].concat(args))), _this2), _this2.onMouseEnter = function (event) {
      var _this2$props = _this2.props,
          onMenuItemActivated = _this2$props.onMenuItemActivated,
          disabled = _this2$props.disabled,
          name = _this2$props.name;

      if (onMenuItemActivated) {
        _this2.props.onMenuItemActivated(disabled ? null : name);
      }
    }, _temp), possibleConstructorReturn(_this2, _ret);
  }

  createClass(ToolbarItemCollapsed, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(prevProps) {
      if (!shallowCompare(prevProps, this.props, ['children'])) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          label = _props2.label,
          divider = _props2.divider,
          active = _props2.active,
          disabled = _props2.disabled,
          onClick = _props2.onClick,
          className = _props2.className,
          children = _props2.children,
          open = _props2.open;


      var isActive = active;
      var isDisabled = disabled;
      var attributes = { className: className };

      return React__default.createElement(
        MenuItem,
        {
          onClick: onClick,
          onMouseEnter: this.onMouseEnter,
          divider: divider,
          disabled: isDisabled,
          selected: isActive,
          open: open,
          attributes: attributes
        },
        children,
        label && React__default.createElement(
          'span',
          { className: 'react-contextmenu-label' },
          label
        )
      );
    }
  }]);
  return ToolbarItemCollapsed;
}(React__default.Component);

/**
 * @param {ToolbarItemProps} props
 */


function ToolbarItem(props) {
  return React__default.createElement(
    MenuContext.Consumer,
    null,
    function (_ref2) {
      var collapsed = _ref2.collapsed,
          onMenuItemActivated = _ref2.onMenuItemActivated;

      if (collapsed) {
        return React__default.createElement(ToolbarItemCollapsed, _extends({}, props, {
          onMenuItemActivated: onMenuItemActivated
        }));
      } else {
        return React__default.createElement(ToolbarItemExpanded, props);
      }
    }
  );
}

/**
 * @typedef StaticMenuProps
 * @prop {boolean} visible
 * @prop {string=} className
 * @prop {()=>void} onHide
 */
/**
 * @typedef StaticMenuState
 * @prop {boolean} isVisible
 */

/**
 * A dropdown menu for the Toolbars. This reuses the styles from React ContextMenu.
 * @augments {React.Component<StaticMenuProps, StaticMenuState>}
 */
var StaticMenu = function (_Component) {
  inherits(StaticMenu, _Component);

  function StaticMenu(props) {
    classCallCheck(this, StaticMenu);

    var _this = possibleConstructorReturn(this, (StaticMenu.__proto__ || Object.getPrototypeOf(StaticMenu)).call(this, props));

    _this.onClick = function (event) {
      _this.hideMenu();
    };

    _this.handlers = false;
    _this.state = { isVisible: props.visible };
    return _this;
  }

  createClass(StaticMenu, [{
    key: 'hideMenu',
    value: function hideMenu() {
      if (this.props.visible) {
        this.props.onHide();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({ isVisible: newProps.visible });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return React__default.createElement(
        'nav',
        {
          role: 'menu',
          tabIndex: -1,
          className: classnames('react-contextmenu', 'react-contextmenu--visible', className),
          onClick: this.onClick,
          onTouchEnd: this.onClick
        },
        children
      );
    }
  }]);
  return StaticMenu;
}(React.Component);

// @ts-ignore
function MenuItems(_ref) {
  var open = _ref.open,
      dismissed = _ref.dismissed,
      onHide = _ref.onHide,
      children = _ref.children,
      className = _ref.className;

  var _useState = React.useState(null),
      _useState2 = slicedToArray(_useState, 2),
      activeMenuItem = _useState2[0],
      setActiveMenuItem = _useState2[1];

  if (!onHide) onHide = function onHide() {};

  var onMenuItemActivated = function onMenuItemActivated(name) {
    setActiveMenuItem(name);
  };

  var onChildClosed = function onChildClosed(event) {
    setActiveMenuItem(null);
    onHide();
  };

  var onMenuHidden = function onMenuHidden(event) {
    if (!activeMenuItem) {
      onHide();
    }
  };

  if (dismissed) {
    onMenuHidden();
  }

  var classes = classnames([styles$1.collapsedToolbarDropdown, className]);

  return React__default.createElement(
    MenuContext.Provider,
    {
      value: {
        collapsed: true,
        onMenuItemActivated: onMenuItemActivated,
        activeMenuItem: activeMenuItem,
        onMenuHidden: onChildClosed
      }
    },
    React__default.createElement(
      StaticMenu,
      { visible: open, onHide: onMenuHidden, className: classes },
      children
    )
  );
}

// @ts-ignore
var MenuLabel = React__default.memo(function (_ref) {
  var popupRef = _ref.popupRef,
      label = _ref.label,
      icon = _ref.icon,
      name = _ref.name,
      open = _ref.open,
      disabled = _ref.disabled;
  return React__default.createElement(
    'nav',
    {
      className: 'react-contextmenu-item react-contextmenu-submenu',
      role: 'menuitem',
      tabIndex: -1,
      'aria-haspopup': 'true',
      ref: popupRef
    },
    React__default.createElement(
      ToolbarItem,
      {
        label: label,
        iconComponent: icon,
        open: open,
        name: name,
        disabled: disabled
      },
      icon
    )
  );
});

var MenuIcon = React__default.memo(function (_ref2) {
  var popupRef = _ref2.popupRef,
      onClick = _ref2.onClick,
      title = _ref2.title,
      label = _ref2.label,
      icon = _ref2.icon,
      open = _ref2.open,
      disabled = _ref2.disabled;

  var shouldShowLabel = !icon;
  return React__default.createElement(
    'div',
    { ref: popupRef },
    React__default.createElement(
      ToolbarItem,
      {
        onClick: onClick,
        className: styles$1.collapsedToolbarGroupItem,
        showTitle: !shouldShowLabel,
        title: title,
        label: label,
        iconComponent: icon,
        open: open,
        disabled: disabled
      },
      React__default.createElement(
        'span',
        null,
        icon,
        shouldShowLabel ? label : '',
        React__default.createElement('i', { className: 'fa-solid fa-caret-down' })
      )
    )
  );
});

function SubMenu(props) {
  var collapsed = props.collapsed,
      icon = props.icon,
      title = props.title,
      label = props.label,
      name = props.name,
      disabled = props.disabled,
      isActive = props.isActive,
      onMenuHidden = props.onMenuHidden,
      popupBoundaries = props.popupBoundaries,
      children = props.children,
      className = props.className;

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      dismiss = _useState4[0],
      setDismiss = _useState4[1];

  var triggerRef = React__default.createRef(null);
  var titleText = typeof title === 'function' ? title(props) : title;
  var labelText = typeof label === 'function' ? label(props) : label;
  var iconComponent = typeof icon === 'function' ? icon(props) : React__default.createElement('i', { className: icon });

  var scheduleUpdate = void 0;

  React.useEffect(function () {
    if (scheduleUpdate && open) {
      scheduleUpdate();
    }

    if (collapsed) {
      setOpen(isActive);
    }

    var animationFrameHandle = void 0;

    if (dismiss) {
      // When we dismiss the toolbar menu, the onClick handler fires
      // after the onHide handler -- this means that the toolbar item
      // will immediately reopen! In order to prevent this, wait a
      // frame before clearing the dismiss state.
      window.cancelAnimationFrame(animationFrameHandle);
      animationFrameHandle = window.requestAnimationFrame(function () {
        setDismiss(false);
      });
    }

    return function () {
      window.cancelAnimationFrame(animationFrameHandle);
    };
  }, [scheduleUpdate, open, collapsed, dismiss, isActive]);

  var onClick = React.useCallback(function (event) {
    if (!open && !dismiss) {
      setOpen(true);
    }
  }, [open, dismiss]);

  var onClickOutside = React.useCallback(function (event) {
    // Ignore clicks on the submenu trigger item, otherwise close
    // the menu
    if (!collapsed || !(triggerRef.current && triggerRef.current.contains(event.target))) {
      setDismiss(true);
    }
  }, [collapsed, triggerRef]);

  var onHide = function onHide(event) {
    if (onMenuHidden) {
      onMenuHidden();
    }

    setOpen(false);
  };

  return React__default.createElement(
    reactPopper.Manager,
    null,
    React__default.createElement(
      'div',
      { ref: triggerRef },
      React__default.createElement(
        reactPopper.Reference,
        null,
        function (_ref3) {
          var ref = _ref3.ref;

          if (collapsed) {
            return React__default.createElement(MenuLabel, {
              popupRef: ref,
              label: labelText,
              icon: iconComponent,
              name: name,
              open: open,
              disabled: disabled
            });
          } else {
            return React__default.createElement(MenuIcon, {
              popupRef: ref,
              onClick: onClick,
              title: titleText,
              label: labelText,
              icon: icon ? iconComponent : null,
              open: open,
              disabled: disabled
            });
          }
        }
      )
    ),
    React__default.createElement(
      PortalPopup,
      {
        visible: open,
        placement: collapsed ? 'right' : 'bottom-start',
        onClickOutside: onClickOutside,
        zIndex: 20,
        boundariesElement: popupBoundaries
      },
      function (props) {
        scheduleUpdate = props.scheduleUpdate;
        if (!open) return null;
        return React__default.createElement(
          MenuItems,
          {
            open: open,
            dismissed: dismiss,
            onHide: onHide,
            className: className
          },
          titleText && React__default.createElement(
            'div',
            { className: 'react-contextmenu-title' },
            titleText
          ),
          children
        );
      }
    )
  );
}

function ToolbarMenu(props) {
  return React__default.createElement(
    MenuContext.Consumer,
    null,
    function (_ref4) {
      var collapsed = _ref4.collapsed,
          activeMenuItem = _ref4.activeMenuItem,
          onMenuHidden = _ref4.onMenuHidden;

      if (collapsed) {
        var name = props.name;

        return React__default.createElement(SubMenu, _extends({}, props, {
          collapsed: collapsed,
          isActive: activeMenuItem && activeMenuItem === name,
          onMenuHidden: onMenuHidden
        }));
      } else {
        var position = props.position,
            bordered = props.bordered,
            className = props.className;


        var plainAriaLabel = typeof props.ariaLabel === 'function' ? props.ariaLabel(props) : props.ariaLabel;
        var plainLabel = typeof props.label === 'function' ? props.label(props) : props.label;
        var label = plainAriaLabel || plainLabel || props.title || props.name;

        var classNames = classnames(className, 'btn-group', 'aha-editor-toolbar-group', defineProperty({
          'aha-editor-toolbar-group--collapsed': !bordered,
          'aha-editor-toolbar-group--expanded': bordered
        }, styles$1.alignedRight, position === 'right'), 'aha-editor-toolbar-group--' + props.name, styles$1.collapsedToolbarGroup);

        return React__default.createElement(
          'div',
          { className: classNames, role: 'group', 'aria-label': label },
          React__default.createElement(SubMenu, _extends({}, props, { collapsed: collapsed }))
        );
      }
    }
  );
}

// @ts-check
// @ts-ignore
/**
 * @typedef ToolbarGroupProps
 * @prop {boolean} collapsed
 * @prop {boolean} canExpand
 * @prop {(string | ((editor: any) => JSX.Element))} icon
 * @prop {(string | ((editor: any) => string))} title
 * @prop {(string | ((editor: any) => string))} label
 * @prop {*} editor
 * @prop {string=} position
 * @prop {string=} className
 * @prop {string=} popupBoundaries
 * @prop {JSX.Element|JSX.Element[]} children
 */

/** @param {ToolbarGroupProps} props */
function CollapsedToolbar(props) {
  var children = props.children,
      canExpand = props.canExpand;

  return React__default.createElement(
    ToolbarMenu,
    _extends({ bordered: !canExpand }, props),
    children
  );
}

/** @param {ToolbarGroupProps} props */
function ExpandedToolbar(props) {
  var children = props.children,
      name = props.name,
      position = props.position,
      className = props.className,
      label = props.label;


  var plainLabel = typeof label === 'function' ? label(props) : label;

  return React__default.createElement(
    'div',
    {
      className: classnames(className, 'btn-group', 'aha-editor-toolbar-group', 'aha-editor-toolbar-group--expanded', 'aha-editor-toolbar-group--' + name, { 'aha-editor__toolbar-group--aligned-right': position === 'right' }, styles$1.toolbarGroup),
      role: 'group',
      'aria-label': plainLabel
    },
    children
  );
}

/** @augments {React.Component<ToolbarGroupProps>} */
var ToolbarGroup = function (_React$Component) {
  inherits(ToolbarGroup, _React$Component);

  function ToolbarGroup() {
    classCallCheck(this, ToolbarGroup);
    return possibleConstructorReturn(this, (ToolbarGroup.__proto__ || Object.getPrototypeOf(ToolbarGroup)).apply(this, arguments));
  }

  createClass(ToolbarGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          collapsed = _props.collapsed;


      if (collapsed) {
        return React__default.createElement(
          CollapsedToolbar,
          this.props,
          children
        );
      } else {
        return React__default.createElement(
          ExpandedToolbar,
          this.props,
          children
        );
      }
    }
  }]);
  return ToolbarGroup;
}(React__default.Component);

// @ts-ignore
/**
 * @typedef ToolbarProps
 * @prop {Configuration} config;
 * @prop {string} className;
 * @prop {string=} popupBoundaries;
 * @prop {*} editor;
 */

/**
 * @typedef GroupState
 * @prop {string} name
 * @prop {string} icon
 * @prop {(string|((editor:any) => string))} label
 * @prop {boolean} collapsed
 * @prop {boolean} canCollapse
 * @prop {boolean} canExpand
 * @prop {string} position
 * @prop {Immutable.List<any>} items
 */

/**
 * @typedef ToolbarState
 * @prop {Immutable.List<GroupState>} groups
 * @prop {boolean} compact
 * @prop {boolean} faded
 */

/**
 *
 * @param {GroupState} group
 */
function canCollapse(group) {
  return group.canCollapse && !group.collapsed && group.items.size > 1;
}

/**
 * @param {GroupState} group
 */
function canExpand(group) {
  return group.canExpand && group.collapsed;
}

/**
 * @returns {Immutable.List<GroupState>}
 */
function groupDataFromGroupArray(groups) {
  return groups.map(function (group) {
    return _extends({}, group, { collapsed: !group.canExpand });
  });
}

/**
 * @augments {React.Component<ToolbarProps, ToolbarState>}
 */

var Toolbar = function (_React$Component) {
  inherits(Toolbar, _React$Component);

  /** @param {ToolbarProps} props */
  function Toolbar(props) {
    classCallCheck(this, Toolbar);

    var _this = possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, props));

    _this.resize = function () {
      if (!_this.compactAtWidth || !_this.toolbar) return;

      if (_this.toolbar.clientWidth <= _this.compactAtWidth) {
        if (!_this.state.compact) {
          _this.compactToolbar();
        }
      } else {
        if (_this.state.compact) {
          _this.expandToolbar();
        }
      }
    };

    _this.onResize = debounce(_this.resize, 20);

    _this.state = {
      compact: false,
      groups: groupDataFromGroupArray(props.config.toolbarGroups),
      faded: true
    };
    return _this;
  }

  createClass(Toolbar, [{
    key: 'fade',
    value: function fade() {
      var _this2 = this;

      this.setState({ faded: true });

      // Each time the groups are updated set a timer to fade them back into view in 10ms.
      if (this.fadedTimer) {
        clearTimeout(this.fadedTimer);
      }
      this.fadedTimer = setTimeout(function () {
        _this2.setState({ faded: false });
      }, 10);
    }

    /**
     * Construct the ToolbarGroup components with ref setup for storing the group
     */

  }, {
    key: 'renderGroups',
    value: function renderGroups() {
      var _this3 = this;

      var _props = this.props,
          editor = _props.editor,
          readOnly = _props.readOnly;


      return this.groups.reduce(function (acc, group, index) {
        var name = group.name,
            items = group.items,
            merged = group.merged,
            label = group.label,
            showReadOnly = group.showReadOnly,
            hideWhenEditing = group.hideWhenEditing;

        if (merged) return acc;
        if (readOnly && !showReadOnly) return acc;
        if (!readOnly && hideWhenEditing) return acc;

        var groupItems = _this3.groups.reduce(function (acc, g) {
          if (!g.merged) return acc;
          if (g.merge !== group.name) return acc;

          var divider = function divider() {
            return React__default.createElement(MenuItem, { divider: true });
          };

          if (g.mergeToTop) {
            return g.items.push(divider).concat(acc);
          } else {
            return acc.push(divider).concat(g.items);
          }
        }, items);

        return [].concat(toConsumableArray(acc), [React__default.createElement(
          ToolbarGroup,
          _extends({
            title: label
          }, group, {
            label: label,
            key: 'toolbar-group-' + name,
            editor: editor,
            popupBoundaries: _this3.props.popupBoundaries,
            className: _this3.props.groupClassName,
            compactToolbar: _this3.state.compact
          }),
          groupItems.map(function (Item, index) {
            return React__default.createElement(Item, {
              key: name + '-' + index,
              editor: editor,
              compactToolbar: _this3.state.compact
            });
          }).toArray()
        )]);
      }, []);
    }

    /** @param {ToolbarProps} newProps */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var toolbarGroups = newProps.config.toolbarGroups;


      if (!toolbarGroups.equals(this.props.config.toolbarGroups)) {
        this.groups = groupDataFromGroupArray(toolbarGroups);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(prevProps, prevState) {
      return !(prevState === this.state && shallowCompare(prevProps, this.props));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.resize();
      this.fade();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.onResize.cancel();
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.fadedTimer);
    }
  }, {
    key: 'compactToolbar',
    value: function compactToolbar() {
      var compactGroups = this.groups.map(function (group) {
        if (canCollapse(group)) {
          return _extends({}, group, { collapsed: true });
        } else {
          return group;
        }
      });

      compactGroups = compactGroups.map(function (group) {
        if (group.merged) return group;
        if (!group.collapsed && group.canCollapse) return group;
        if (!group.merge) return group;

        var targetGroup = compactGroups.find(function (t) {
          return t.name === group.merge;
        });
        if (!targetGroup) return group;
        if (!targetGroup.collapsed) return group;

        return _extends({}, group, {
          merged: true
        });
      });

      this.groups = compactGroups;
      this.setState({ compact: true });
    }
  }, {
    key: 'expandToolbar',
    value: function expandToolbar() {
      var expandedGroups = this.groups.map(function (group) {
        var updatedGroup = group;

        if (updatedGroup.merged) {
          updatedGroup = _extends({}, updatedGroup, {
            merged: false
          });
        }

        if (canExpand(updatedGroup)) {
          return _extends({}, updatedGroup, {
            collapsed: false
          });
        }

        return updatedGroup;
      });

      this.groups = expandedGroups;
      this.setState({ compact: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var className = this.props.className;
      var faded = this.state.faded;


      return React__default.createElement(
        'div',
        {
          className: classnames('toolbar', className),
          onMouseDown: function onMouseDown(e) {
            return e.preventDefault();
          }
        },
        React__default.createElement(
          'div',
          {
            className: classnames('btn-toolbar', styles$1.toolbar, defineProperty({}, styles$1.faded, faded)),
            role: 'toolbar',
            'aria-label': 'Text editor',
            ref: function ref(el) {
              return _this4.toolbar = el;
            }
          },
          this.renderGroups()
        )
      );
    }
  }, {
    key: 'compactAtWidth',
    get: function get$$1() {
      return this.props.compactAtWidth;
    }
  }, {
    key: 'groups',
    get: function get$$1() {
      return this.state.groups;
    },
    set: function set$$1(value) {
      this.setState({ groups: value });
      this.fade();
    }
  }]);
  return Toolbar;
}(React__default.Component);

// @ts-ignore
/**
 * @typedef ToolbarProps
 * @prop {import('../../Configuration').default} config;
 * @prop {string} [className];
 * @prop {string=} popupBoundaries;
 * @prop {*} editor;
 * @prop {*} selection;
 */

/**
 * @typedef SelectionBasedToolbarState
 * @prop {object} referenceElement with a top and left attributes
 */

/**
 * @augments {React.Component<ToolbarProps, SelectionBasedToolbarState>}
 */

var SelectionBasedToolbar = function (_React$Component) {
  inherits(SelectionBasedToolbar, _React$Component);

  /** @param {ToolbarProps} props */
  function SelectionBasedToolbar(props) {
    classCallCheck(this, SelectionBasedToolbar);

    var _this = possibleConstructorReturn(this, (SelectionBasedToolbar.__proto__ || Object.getPrototypeOf(SelectionBasedToolbar)).call(this, props));

    _this.debouncedComputeToolbarStyle = debounce(_this.computeToolbarStyle, 200);

    _this.renderDelay = null;
    _this.selectionHandler = null;
    _this.state = {
      referenceElement: null
    };

    _this.offset = {
      x: -80,
      y: 12
    };
    return _this;
  }

  /** @param {ToolbarProps} newProps */


  createClass(SelectionBasedToolbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      this.onSelectionChange(newProps, {
        onNewSelection: function onNewSelection(editor) {
          if (_this2.state.referenceElement) {
            _this2.computeToolbarStyle(editor);
          } else {
            _this2.debouncedComputeToolbarStyle(editor);
          }
        },
        onLostSelection: function onLostSelection() {
          _this2.debouncedComputeToolbarStyle.cancel();
          _this2.hideToolbar();
        }
      });
    }

    /**
     * Computes the top and left position of the toolbar with the current selection.
     *
     * @param {import('slate').Editor} editor The Slate editor object
     */

  }, {
    key: 'computeToolbarStyle',
    value: function computeToolbarStyle(editor) {
      // Position the toolbar just above the selection rect.
      var range = editor.findDOMRange(editor.value.selection);
      if (!range) return;

      this.setState({
        referenceElement: {
          getBoundingClientRect: function getBoundingClientRect() {
            var domRange = editor.findDOMRange(editor.value.selection);

            var rects = domRange.getClientRects();
            var rect = rects[0];
            return rect || new DOMRect(0, 0, 0, 0);
          },

          contextElement: range.startContainer.parentElement
        }
      });

      // Trigger a resize event to ensure the toolbar is sized correctly
      window.dispatchEvent(new Event('resize'));
    }
  }, {
    key: 'hideToolbar',


    /**
     * Hides the toolbar
     */
    value: function hideToolbar() {
      this.setState({
        referenceElement: null
      });
    }

    /**
     * Determines when the selection changes and calls the appropriate callback.
     * @param {object} props
     * @param {object} param1 callbacks for when there's a new selection and for
     * when the selection is gone
     */

  }, {
    key: 'onSelectionChange',
    value: function onSelectionChange(props) {
      var _this3 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$onNewSelection = _ref.onNewSelection,
          onNewSelection = _ref$onNewSelection === undefined ? null : _ref$onNewSelection,
          _ref$onLostSelection = _ref.onLostSelection,
          onLostSelection = _ref$onLostSelection === undefined ? null : _ref$onLostSelection;

      var selection = props.selection;
      var prevSelection = this.props.selection;

      // Avoid recalculating unless something significant has changed
      if (selection.isFocused !== prevSelection.isFocused || selection.anchor.offset !== prevSelection.anchor.offset || selection.anchor.path !== prevSelection.anchor.path || selection.focus.offset !== prevSelection.focus.offset || selection.focus.path !== prevSelection.focus.path) {
        var editor = props.editor;


        window.cancelAnimationFrame(this.renderDelay);
        this.renderDelay = window.requestAnimationFrame(function () {
          if (_this3.selectionHandler) {
            document.removeEventListener('mouseup', _this3.selectionHandler);
            document.removeEventListener('keyup', _this3.selectionHandler);
            _this3.selectionHandler = null;
          }

          if (selection.isCollapsed || !selection.isFocused) {
            // No selection or the selection was not found in the editor
            // If the range is collapsed, it means nothing is selected, the cursor is just standing there
            if (onLostSelection) onLostSelection();
          } else {
            _this3.selectionHandler = function (event) {
              if (onNewSelection) onNewSelection(editor);
            };

            document.addEventListener('mouseup', _this3.selectionHandler);
            document.addEventListener('keyup', _this3.selectionHandler);
          }
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.selectionHandler) {
        document.removeEventListener('mouseup', this.selectionHandler);
        document.removeEventListener('keyup', this.selectionHandler);
        this.selectionHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var referenceElement = this.state.referenceElement;


      return React__default.createElement(
        PortalPopup,
        {
          referenceElement: referenceElement,
          placement: 'top-start',
          visible: true,
          modifiers: {
            flip: { enabled: false },
            offset: { options: { offset: [this.offset.x, this.offset.y] } }
          },
          popupClassName: referenceElement ? '' : 'aha-editor-toolbar__popup--hidden',
          className: 'aha-editor-toolbar__container--selection-based'
        },
        function (_ref2) {
          var scheduleUpdate = _ref2.scheduleUpdate;

          return React__default.createElement(Toolbar, _this4.props);
        }
      );
    }
  }]);
  return SelectionBasedToolbar;
}(React__default.Component);

var styles$3 = { "tableOfContents": "TableOfContents-module_tableOfContents__3qJJU", "title": "TableOfContents-module_title__2o44s", "titleIcon": "TableOfContents-module_titleIcon__28gLE", "item": "TableOfContents-module_item__26ic_", "anchorLink": "TableOfContents-module_anchorLink__3V33k", "focusHeaderBackground": "TableOfContents-module_focusHeaderBackground__3RpkD", "aha-editor__focus-header-background": "TableOfContents-module_aha-editor__focus-header-background__wfRCL", "focusHeader": "TableOfContents-module_focusHeader__36e9u", "aha-editor__focus-header": "TableOfContents-module_aha-editor__focus-header__3z0YY", "itemLink": "TableOfContents-module_itemLink__1o0lu", "verticalLine": "TableOfContents-module_verticalLine__2jR5W", "empty": "TableOfContents-module_empty__21s6W", "collapse": "TableOfContents-module_collapse__zqbbe" };

function generateId(str) {
  return str.toLowerCase().trim().replace(/\W+/g, '-');
}

var copyToClipboard = function copyToClipboard(value) {
  var standIn = document.createElement('textarea');
  document.body.appendChild(standIn);

  standIn.value = value;
  standIn.select();

  document.execCommand('copy');

  document.body.removeChild(standIn);
};

var copyLink = function copyLink(lookupKey) {
  return function () {
    var url = window.location.href.split('#')[0];
    var urlHash = 'aha-editor-header--' + lookupKey;

    copyToClipboard([url, urlHash].join('#'));
  };
};

function TableOfContentsItem(props) {
  var verticalLines = [].concat(toConsumableArray(Array(props.depth))).map(function (depth, i) {
    return React__default.createElement(
      'span',
      {
        key: i,
        className: styles$3.verticalLine
      },
      '\xA0'
    );
  });

  return React__default.createElement(
    'div',
    { className: styles$3.item },
    verticalLines,
    React__default.createElement(
      'a',
      {
        href: '#' + generateId(props.text),
        className: styles$3.itemLink + ' aha-editor__table-of-contents-item',
        onClick: props.onClick,
        'data-item-key': props.lookupKey

      },
      props.text
    ),
    props.showAnchorLinks && React__default.createElement(
      'a',
      { onClick: copyLink(props.lookupKey) },
      React__default.createElement('i', { className: 'fa-regular fa-link fa-fw ' + styles$3.anchorLink })
    )
  );
}

function isHeader(node) {
  return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(node.type) && node.text;
}

function recursivelyFindHeaders(nodes, editor, fn) {
  var accumulator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  nodes.forEach(function (node) {
    if (!node.nodes || node.nodes.isEmpty()) return;

    if (fn(node)) {
      if (!node.getIn(['data', 'hashLookupKey'])) {
        node = node.setIn(['data', 'hashLookupKey'], generateRandomHashLookupKey());

        editor.setNodeByKey(node.key, node);
      }

      accumulator.push(node);
    }

    recursivelyFindHeaders(node.nodes, editor, fn, accumulator);
  });

  return accumulator;
}

function generateRandomHashLookupKey() {
  return Math.random().toString(16).substr(2, 16);
}

function scrollToNode(node) {
  return function (event) {
    var selector = node.type + '[data-key="' + node.key + '"]';
    var element = document.querySelector(selector).children[0];

    window.requestAnimationFrame(function () {
      element.scrollIntoView({ block: 'center' });

      var originalClassName = element.className;
      var withFocusHeaderClassName = originalClassName + ' ' + styles$3.focusHeader + ' aha-editor__focus-header';
      var withFocusHeaderAndBackgroundClassName = withFocusHeaderClassName + ' ' + styles$3.focusHeaderBackground + ' aha-editor__focus-header-background';

      element.className = withFocusHeaderAndBackgroundClassName;

      setTimeout(function () {
        element.style.transition = 'background-color 1.5s';
        element.className = withFocusHeaderClassName;

        setTimeout(function () {
          element.className = originalClassName;
          element.style.transition = '';
        }, 1500);
      }, 50);
    });
  };
}

// When loading the table of contents, if there is an anchor hash
// associated with a header, scroll to it. We can't use the default
// browser behavior that handles this via id attributes because
// that could involve messing with existing id attributes which
// could cause unforeseen issues. Our own mechanism is easy enough
// and also allows us to do the highlight flash.
function scrollToNodeByHashLookup(editor) {
  var href = window.location.href;

  var _href$split = href.split('#'),
      _href$split2 = slicedToArray(_href$split, 2),
      url = _href$split2[0],
      anchorHash = _href$split2[1];

  if (!url || !anchorHash) return;

  var _anchorHash$split = anchorHash.split('--'),
      _anchorHash$split2 = slicedToArray(_anchorHash$split, 2),
      hashIdentifier = _anchorHash$split2[0],
      hashNodeLookup = _anchorHash$split2[1];

  if (hashIdentifier !== 'aha-editor-header' || !hashNodeLookup) return;

  var nodeByHashLookup = recursivelyFindHeaders(editor.value.document.nodes, editor, function (node) {
    return isHeader(node) && node.getIn(['data', 'hashLookupKey']) === hashNodeLookup;
  })[0];

  if (!nodeByHashLookup) return;

  scrollToNode(nodeByHashLookup)();
}

function TableOfContents(props) {
  var editor = props.editor;

  var _useState = React.useState([]),
      _useState2 = slicedToArray(_useState, 2),
      headerNodes = _useState2[0],
      setHeaderNodes = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      isCollapsed = _useState4[0],
      setIsCollapsed = _useState4[1];

  // editor used as the argument to useEffect so scrollToNodeByHashLookup
  // only gets called once when mounted.


  React.useEffect(function () {
    scrollToNodeByHashLookup(editor);
  }, [editor]);

  React.useEffect(function () {
    setHeaderNodes(recursivelyFindHeaders(editor.value.document.nodes, editor, isHeader));
  }, [editor, editor.value]);

  var headerNodeToTableOfContentsItem = function headerNodeToTableOfContentsItem(node) {
    var depth = parseInt(node.type[1], 10) - 1;

    return React__default.createElement(TableOfContentsItem, {
      onClick: scrollToNode(node),
      key: node.key,
      lookupKey: node.getIn(['data', 'hashLookupKey']) // Passed for the read-only lookup in 'Share as webpage' feature
      , depth: depth,
      text: node.text
    });
  };

  var emptyItem = function emptyItem() {
    return React__default.createElement(
      'div',
      { className: styles$3.empty },
      React__default.createElement('i', { className: 'fa-regular fa-poll-h fa-fw' }),
      React__default.createElement(
        'p',
        null,
        'Headings you add to your document will appear as sections here'
      )
    );
  };

  var handleTableOfContentsClick = function handleTableOfContentsClick() {
    editor.focus();
  };

  var collapsed = function collapsed() {
    return editor.props.readOnly ? isCollapsed : editor.value.document.data.get('tableOfContentsCollapse') || false;
  };

  var toggleCollapse = function toggleCollapse(e) {
    e.preventDefault();
    // When the editor is read-only, the call to setNodeByKey won't result in a
    // re-render, so we need to manage the state of the collapse ourselves.
    if (editor.props.readOnly) {
      setIsCollapsed(!isCollapsed);
    } else {
      var document = editor.value.document;
      var newData = { data: document.data.merge({ tableOfContentsCollapse: !collapsed() }) };

      editor.setNodeByKey(document.key, newData);
    }
  };

  var tableOfContentsItems = headerNodes.map(function (node) {
    return headerNodeToTableOfContentsItem(node);
  });
  var tableOfContentsBody = tableOfContentsItems.length === 0 ? emptyItem() : tableOfContentsItems;

  return React__default.createElement(
    'details',
    { onClick: handleTableOfContentsClick, className: styles$3.tableOfContents + ' aha-editor__table-of-contents', open: !collapsed(), role: 'navigation' },
    React__default.createElement(
      'summary',
      { className: styles$3.titleBar, onClick: toggleCollapse },
      React__default.createElement('i', { className: 'fa-regular fa-poll-h fa-fw' }),
      React__default.createElement(
        'strong',
        { className: styles$3.title },
        'Table of contents'
      )
    ),
    React__default.createElement(
      'nav',
      { role: 'tree', className: 'aha-editor__table-of-contents-body' },
      tableOfContentsBody
    )
  );
}

/**
 * @typedef ToolbarItemOptions
 * @prop {string} group
 * @prop {number=} index
 *
 */

/**
 * @typedef ToolbarItemDefinition
 * @prop {(props:{value:any}) => JSX.Element} item
 * @prop {string} [name]
 * @prop {object} [plugin]
 * @prop {(import('slate').Editor) => void} [changeFunction]
 * @prop {(import('slate').Editor) => boolean} [enabled]
 */

/**
 * @typedef ToolbarGroupOptions
 * @prop {string} name
 * @prop {(string | ((value:any) => string))=} label
 * @prop {(string | ((value:any) => string))=} ariaLabel
 * @prop {(string | ((value:any) => JSX.Element))=} icon
 * @prop {(string | ((value:any) => string))=} title
 * @prop {number=} priority
 * @prop {number=} index
 * @prop {boolean=} canCollapse
 * @prop {boolean=} canExpand
 * @prop {boolean=} mergeToTop
 * @prop {string=} position
 * @prop {string=} merge
 * @prop {Immutable.List<(props:{value:any}) => JSX.Element>} items
 */

/**
 * @typedef CommandGroupOptions
 * @prop {string} name
 * @prop {(string | ((value:any) => string))=} label
 * @prop {(string | ((value:any) => string))=} ariaLabel
 * @prop {(string | ((value:any) => JSX.Element))=} icon
 * @prop {(string | ((value:any) => string))=} title
 * @prop {number=} index
 * @prop {Immutable.List<(props:{value:any}) => JSX.Element>} items
 */

var Configuration = function () {
  function Configuration() {
    classCallCheck(this, Configuration);
    this.plugins = [];
    this.normalPlugins = [];
    this.priorityPlugins = [];
    this._toolbarGroupNames = Immutable.List();
    this._toolbarGroups = Immutable.Map();
    this._commandGroupNames = Immutable.List();
    this._commandGroups = Immutable.Map();
  }

  /** @type {Immutable.List<string>} */


  /** @type {Immutable.Map<string, ToolbarGroupOptions>} */


  createClass(Configuration, [{
    key: 'insertCommandGroup',


    /**
     * @param {string} name
     * @param {Partial<CommandGroupOptions>} options
     */
    value: function insertCommandGroup(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index === undefined ? this.commandGroups.size : options.index;
      this._commandGroupNames = this._commandGroupNames.filterNot(function (n) {
        return n === name;
      }).insert(index, name);
      this._commandGroups = this._commandGroups.update(name, { name: name, items: Immutable.List() }, function (existing) {
        return _extends({}, existing, {
          name: name
        }, options);
      });
      return this._commandGroups.get(name);
    }

    /**
     * @param {ToolbarItemDefinition} itemDefinition
     * @param {ToolbarItemOptions} options
     */

  }, {
    key: 'insertCommandItem',
    value: function insertCommandItem(itemDefinition, options) {
      var _ref = this._commandGroups.get(options.group) || this.insertCommandGroup(options.group),
          items = _ref.items;

      var index = isNaN(Number(options.index)) ? items.size : options.index;
      var name = itemDefinition.name,
          item = itemDefinition.item,
          plugin = itemDefinition.plugin,
          changeFunction = itemDefinition.changeFunction;


      this._commandGroups = this._commandGroups.update(options.group, function (existing) {
        return _extends({}, existing, {
          items: items.insert(index, {
            name: name,
            item: item,
            changeFunction: changeFunction,
            enabled: itemDefinition.enabled || function (_editor) {
              return true;
            }
          })
        });
      });

      if (plugin) {
        this.insertPlugins([plugin]);
      }
      return this;
    }

    /**
     * @param {Array<ToolbarItemDefinition>} items
     * @param {ToolbarItemOptions} options
     */

  }, {
    key: 'insertCommandItems',
    value: function insertCommandItems(items, options) {
      var _this = this;

      items.forEach(function (item) {
        return _this.insertCommandItem(item, options);
      });
      return this;
    }

    /**
     * @param {string} name
     * @param {Partial<ToolbarGroupOptions>} options
     */

  }, {
    key: 'insertToolbarGroup',
    value: function insertToolbarGroup(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index === undefined ? this.toolbarGroups.size : options.index;
      this._toolbarGroupNames = this._toolbarGroupNames.filterNot(function (n) {
        return n === name;
      }).insert(index, name);
      this._toolbarGroups = this._toolbarGroups.update(name, { name: name, items: Immutable.List() }, function (existing) {
        return _extends({}, existing, {
          name: name,
          canCollapse: true,
          canExpand: true,
          priority: -1,
          position: 'left',
          showReadOnly: false,
          hideWhenEditing: false,
          mergeToTop: false
        }, options);
      });
      return this._toolbarGroups.get(name);
    }

    /**
     * @param {ToolbarItemDefinition} itemDefinition
     * @param {ToolbarItemOptions} options
     */

  }, {
    key: 'insertToolbarItem',
    value: function insertToolbarItem(itemDefinition, options) {
      var _ref2 = this._toolbarGroups.get(options.group) || this.insertToolbarGroup(options.group),
          items = _ref2.items;

      var index = isNaN(Number(options.index)) ? items.size : options.index;
      var item = itemDefinition.item,
          plugin = itemDefinition.plugin;


      this._toolbarGroups = this._toolbarGroups.update(options.group, function (existing) {
        return _extends({}, existing, {
          items: items.insert(index, item)
        });
      });

      if (plugin) {
        this.insertPlugins([plugin]);
      }
      return this;
    }

    /**
     * @param {Array<ToolbarItemDefinition>} items
     * @param {ToolbarItemOptions} options
     */

  }, {
    key: 'insertToolbarItems',
    value: function insertToolbarItems(items, options) {
      var _this2 = this;

      items.forEach(function (item) {
        return _this2.insertToolbarItem(item, options);
      });
      return this;
    }

    /**
     * Add plugins to the editor. By default, adds plugins at the
     * highest priority. Use options.alwaysBefore = true to keep plugins
     * at a higher priority than any plugin added without the option.
     *
     *
     * @param {Array<object>} plugins
     * @param {number} index
     * @param {object} options
     *
     */

  }, {
    key: 'insertPlugins',
    value: function insertPlugins(plugins) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (options.alwaysBefore) {
        var _priorityPlugins;

        (_priorityPlugins = this.priorityPlugins).splice.apply(_priorityPlugins, [index, 0].concat(toConsumableArray(plugins)));
      } else {
        var _normalPlugins;

        (_normalPlugins = this.normalPlugins).splice.apply(_normalPlugins, [index, 0].concat(toConsumableArray(plugins)));
      }
      this.plugins = this.priorityPlugins.concat(this.normalPlugins);
    }
  }, {
    key: 'toolbarGroups',
    get: function get$$1() {
      var _this3 = this;

      return this._toolbarGroupNames.map(function (name) {
        return _this3._toolbarGroups.get(name);
      });
    }

    /** @type {Immutable.List<string>} */


    /** @type {Immutable.Map<string, CommandGroupOptions>} */

  }, {
    key: 'commandGroups',
    get: function get$$1() {
      var _this4 = this;

      return this._commandGroupNames.map(function (name) {
        return _this4._commandGroups.get(name);
      });
    }
  }]);
  return Configuration;
}();

function isDocumentBlank(document) {
  if (document.nodes.size > 1) return false;

  if (document.nodes.size === 1 && document.nodes.first().type === 'paragraph' && document.nodes.first().nodes.size === 1 && document.nodes.first().nodes.first().object === 'text' && document.text === '') {
    return true;
  }

  return false;
}

var PlaceholderPlugin = (function (options) {
  var placeholder = options.placeholder;


  function renderDocument(_ref, editor, next) {
    var node = _ref.node;

    if (!isDocumentBlank(node)) return next();
    if (editor.value.selection.isFocused) return next();

    return React__default.createElement(
      React__default.Fragment,
      null,
      React__default.createElement('span', {
        contentEditable: false,
        className: 'aha-editor__placeholder-text',
        style: {
          pointerEvents: 'none',
          display: 'inline-block'
        },
        dangerouslySetInnerHTML: { __html: placeholder }
      })
    );
  }

  return {
    renderDocument: renderDocument
  };
});

var isModifyingOperation = (function (operation) {
  return !['add_annotation', 'set_annotation', 'remove_annotation', 'set_selection'].includes(operation.type);
});

var AnnotateOnlyPlugin = (function (options) {
  var previousValue = null;

  var queries = {
    hasModifyingOperations: function hasModifyingOperations(editor) {
      return editor.operations.some(function (op) {
        return isModifyingOperation(op);
      });
    },
    isModifiable: function isModifiable() {
      return options.isModifiable();
    }
  };

  function resetEditor(editor) {
    if (editor.operations.size > 0) {
      // If we don't have a previousValue, it means this probably
      // happened during normalization. In that case, we'll use the
      // normalized value, but still remove the operations. Otherwise,
      // we'll restore the value before the operations happened.
      if (previousValue) {
        editor.setValue(previousValue, { normalize: false });
      }
      editor.operations = new Immutable.List();
    }
    editor.tmp = {
      dirty: [],
      flushing: false,
      merge: null,
      normalize: true,
      save: true
    };
  }

  function onChange(editor, next) {
    if (!editor.isModifiable() && editor.hasModifyingOperations()) {
      resetEditor(editor.controller);
    }
    previousValue = editor.value;
    return next();
  }

  return {
    plugins: [{
      queries: queries,
      onChange: onChange
    }]
  };
});

var Migration = function () {
  function Migration() {
    classCallCheck(this, Migration);
  }

  createClass(Migration, [{
    key: 'valueIsCurrentVersion',
    value: function valueIsCurrentVersion(value) {
      if (!value.document) return false;
      return !!this.isVersion(value.document);
    }
  }, {
    key: 'migrateValueUp',
    value: function migrateValueUp(value) {
      return _extends({}, value, { document: this.up(value.document) });
    }
  }, {
    key: 'migrateValueDown',
    value: function migrateValueDown(value) {
      return _extends({}, value, { document: this.down(value.document) });
    }
  }, {
    key: 'isVersion',
    value: function isVersion(node) {
      throw new Error('Not implemented, override in a subclass');
    }
  }, {
    key: 'up',
    value: function up(node) {
      throw new Error('Not implemented, override in a subclass');
    }
  }, {
    key: 'down',
    value: function down(node) {
      throw new Error('Not implemented, override in a subclass');
    }
  }]);
  return Migration;
}();

var Slate034 = function (_Migration) {
  inherits(Slate034, _Migration);

  function Slate034() {
    classCallCheck(this, Slate034);
    return possibleConstructorReturn(this, (Slate034.__proto__ || Object.getPrototypeOf(Slate034)).apply(this, arguments));
  }

  createClass(Slate034, [{
    key: 'up',
    value: function up() {
      throw new Error('initial version, should not get called');
    }
  }, {
    key: 'down',
    value: function down() {
      throw new Error('initial version, should not get called');
    }
  }, {
    key: 'isVersion',
    value: function isVersion(node) {
      var treeDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (node.isVoid !== undefined) return true; // Has isVoid, not 0.38+
      if (node.object === 'text') {
        treeDetails.foundTextNode = true;
      }

      if (node.object === 'text' && node.text !== undefined) return false; // 0.46

      if (!node.nodes) {
        // We've reached a leaf, but don't have a conclusive answer
        // yet. Back up and go down another branch.
        return undefined;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          var result = this.isVersion(child, treeDetails);
          if (result !== undefined) return result;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (node.object === 'document') {
        if (treeDetails.foundTextNode) {
          // No conclusive answer after reading the entire document. This
          // must not be version 0.34.
          return false;
        } else {
          // This document didn't have any text nodes. This could
          // concievably be one of several different versions. Treating
          // it as the earliest version is safest, because it means
          // we'll migrate the rest of the document upward through any
          // possible changes, and migrating downward should be rare and
          // temporary. This should also be a temporary state, because
          // after a document is loaded into an editor, it will be
          // normalized, inserting text nodes.
          return true;
        }
      }
    }
  }]);
  return Slate034;
}(Migration);

/**
 * Slate 0.38.0: Node.isVoid access is deprecated. Previously the
 * "voidness" of a node was hardcoded in the data model. Soon it will
 * be determined at runtime based on your editor's schema.
 *
 * Because voidness is determined at runtime, we have to hardcode the
 * different conditions that make something void in order to migrate
 * up and down.
 */

var Slate038 = function (_Migration) {
  inherits(Slate038, _Migration);

  function Slate038() {
    classCallCheck(this, Slate038);
    return possibleConstructorReturn(this, (Slate038.__proto__ || Object.getPrototypeOf(Slate038)).apply(this, arguments));
  }

  createClass(Slate038, [{
    key: 'up',
    value: function up(node) {
      var _this2 = this;

      if (node.object === 'text') return node;

      var newNode = _extends({}, node);

      if (node.nodes) {
        newNode.nodes = node.nodes.map(function (node) {
          return _this2.up(node);
        });
      }

      if (node.type && node.type.match(/-reference$/) && !node.isVoid) {
        newNode.type = node.type + '-editable';
      }

      delete newNode.isVoid;

      return newNode;
    }
  }, {
    key: 'down',
    value: function down(node) {
      var _this3 = this;

      if (node.object === 'text') return node;

      var newNode = _extends({}, node);

      if (node.nodes) {
        newNode.nodes = node.nodes.map(function (node) {
          return _this3.down(node);
        });
      }

      if (['block', 'inline'].includes(node.object)) {
        if (['image', 'image-placeholder'].includes(node.type) || node.type.match(/-reference$/)) {
          newNode.isVoid = true;
        } else {
          newNode.isVoid = false;
        }

        if (node.type && node.type.match(/-reference-editable$/)) {
          newNode.type = node.type.replace(/-editable$/, '');
        }
      }

      return newNode;
    }
  }, {
    key: 'isVersion',
    value: function isVersion(node) {
      if (node.isVoid !== undefined) return false; // 0.34

      if (node.object === 'text') {
        if (node.text === undefined) {
          // If we found a text node, and it has leaves, and we haven't seen
          // a void property yet, we can assume it's 0.38, and we've
          // stripped out the voids.
          return true;
        } else {
          return false;
        }
      }

      if (!node.nodes) {
        // We've reached a leaf, but don't have a conclusive answer
        // yet. Back up and go down another branch.
        return undefined;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          var result = this.isVersion(child);
          if (result !== undefined) return result;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);
  return Slate038;
}(Migration);

/**
 * Slate 0.46.0: Initializing editors with Text nodes with a leaves
 * property is deprecated.
 *
 * Old: { object: 'text', leaves: [{object: 'leaf', marks: [...], text: "..."}]}
 * New: { object: 'text', marks: [...], text: "..."}
 *
 * Multiple leaves become multiple text nodes.
 */

var Slate046 = function (_Migration) {
  inherits(Slate046, _Migration);

  function Slate046() {
    classCallCheck(this, Slate046);
    return possibleConstructorReturn(this, (Slate046.__proto__ || Object.getPrototypeOf(Slate046)).apply(this, arguments));
  }

  createClass(Slate046, [{
    key: 'up',
    value: function up(node) {
      var _this2 = this;

      if (node.nodes) {
        var newNodes = node.nodes.reduce(function (nodes, child) {
          if (child.object === 'text' && child.leaves) {
            return nodes.concat(_this2._convertLeavesToTextNode(child));
          } else {
            return nodes.concat(_this2.up(child));
          }
        }, []);
        return _extends({}, node, { nodes: newNodes });
      }
      return node;
    }
  }, {
    key: 'down',
    value: function down(node) {
      var _this3 = this;

      if (node.nodes) {
        var newNodes = node.nodes.reduce(function (acc, child) {
          var nodes = acc.nodes,
              prevTextNode = acc.prevTextNode;

          if (child.object === 'text') {
            return _this3._convertTextNodeToLeaves(child, nodes, prevTextNode);
          } else {
            return {
              nodes: nodes.concat(_this3.down(child)),
              prevTextNode: null
            };
          }
        }, { nodes: [], prevTextNode: null }).nodes;
        return _extends({}, node, { nodes: newNodes });
      }
      return node;
    }
  }, {
    key: '_convertLeavesToTextNode',
    value: function _convertLeavesToTextNode(node) {
      var nodes = [];

      node.leaves.forEach(function (leaf) {
        nodes.push({ object: 'text', marks: leaf.marks || [], text: leaf.text });
      });

      return nodes;
    }
  }, {
    key: '_convertTextNodeToLeaves',
    value: function _convertTextNodeToLeaves(node, nodes, prevTextNode) {
      var leaf = {
        object: 'leaf',
        marks: node.marks,
        text: node.text
      };

      if (prevTextNode) {
        prevTextNode.leaves.push(leaf);
        return { nodes: nodes, prevTextNode: prevTextNode };
      } else {
        var textNode = { object: 'text', leaves: [leaf] };
        return { nodes: nodes.concat(textNode), prevTextNode: textNode };
      }
    }
  }, {
    key: 'isVersion',
    value: function isVersion(node) {
      if (node.leaves) return false; // 0.34
      if (node.object === 'text' && node.text !== undefined) return true; // 0.46

      if (!node.nodes) {
        // We've reached a leaf, but don't have a conclusive answer
        // yet. Back up and go down another branch.
        return undefined;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = node.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          var result = this.isVersion(child);
          if (result !== undefined) return result;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);
  return Slate046;
}(Migration);

var migrations = [new Slate034(), new Slate038(), new Slate046()];

var targetVersion = 2;

var ValueMigrator = function () {
  function ValueMigrator(valueJSON) {
    classCallCheck(this, ValueMigrator);

    this.value = valueJSON;
    if (Immutable__default.Iterable.isIterable(valueJSON)) {
      this.value = valueJSON.toJS();
    }
    if (valueJSON) {
      this.currentVersion = this.detectVersion(this.value);
      if (this.currentVersion === -1) {
        throw new Error("Couldn't detect a version from the value JSON");
      }
    }
  }

  createClass(ValueMigrator, [{
    key: 'detectVersion',
    value: function detectVersion(valueJSON) {
      return migrations.findIndex(function (migration) {
        return migration.valueIsCurrentVersion(valueJSON);
      });
    }
  }, {
    key: 'migrate',
    value: function migrate() {
      return this.migrateTo(targetVersion);
    }
  }, {
    key: 'migrateTo',
    value: function migrateTo(targetVersion) {
      if (!this.value) return this.value;
      if (this.currentVersion === targetVersion) return this.value;

      var value = this.value;
      if (this.currentVersion < targetVersion) {
        // Migrating upward. Skip the current version, and include the target version.
        var versions = migrations.slice(this.currentVersion + 1, targetVersion + 1);

        value = versions.reduce(function (value, version) {
          return version.migrateValueUp(value);
        }, value);
      } else {
        // Migrating downward. Include the current version, and skip the
        // target version, and reverse.
        var _versions = migrations.slice(targetVersion + 1, this.currentVersion + 1).reverse();

        value = _versions.reduce(function (value, version) {
          return version.migrateValueDown(value);
        }, value);
      }

      return value;
    }
  }]);
  return ValueMigrator;
}();

// Implements base version of query / command methods with default
// behavior, that can be overridden up the stack.

var BasePlugin = (function () {
  return {
    plugins: [{
      queries: {
        isModifiable: function isModifiable(editor) {
          return !editor.props.readOnly;
        }
      }
    }]
  };
});

/**
 * Provide queries and commands for common behavior that _could_ be in
 * base Slate.
 */

/**
 * Given a value with a collapsed selection, will return all of the
 * text in all of the nodes of the containing block node, up to the
 * cursor, as a single string.
 *
 * For example, if the paragraph block has three text nodes
 * ["Hello ", "th|ere", "!"],
 * And `|` represents the cursor, this function will return "Hello th"
 *
 * @param {import('slate').Editor} editor
 */
function getPreviousTextInBlock(editor) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection,
      startBlock = value.startBlock,
      startText = value.startText;
  var start = selection.start;

  var range = selection.moveAnchorToStartOfNode(startBlock);
  var texts = document.getTextsAtRange(range);
  return texts.reduce(function (acc, node) {
    if (node === startText) {
      return acc.concat(node.text.slice(0, start.offset));
    } else {
      return acc.concat(node.text);
    }
  }, '');
}

/**
 * Returns true if the closest block containing the cursor has no text,
 * false otherwise.
 * @param {Editor} editor
 * @return {boolean}
 */
function inEmptyBlock(editor) {
  if (editor.value.isCollapsed) return false;

  var block = editor.value.anchorBlock;

  return editor.isEmptyBlock(block);
}

/**
 * Returns true if the given block has no text,
 * false otherwise.
 * @param {Editor} editor
 * @param {Block} block
 * @return {boolean}
 */
function isEmptyBlock(editor, block) {
  if (!block) return false;

  return block.nodes.size === 1 && block.nodes.first().object === 'text' && block.text === '';
}

/**
 * Returns the most up-to-date copy of `node` from `editor`. Since
 * nodes are immutable, they don't change as commands are run. This
 * function is useful when you modify the node and want to do
 * something else with it.
 *
 * @param {Editor} editor
 * @param {Node} node
 * @return {Node}
 */
function reloadNode(editor, node) {
  if (node.object === 'document') {
    return editor.value.document;
  }

  return editor.value.document.getDescendant(node.key);
}

/**
 * Insert a block, splitting the current block if necessary. If the
 * current block is empty, will replace the current block with the new
 * block instead of adding the new block below.
 *
 * @param {Editor} editor
 * @param {Block} block the block to insert
 */
function insertOrReplaceEmptyBlock(editor, block) {
  var currentBlock = editor.value.anchorBlock;
  var inEmptyBlock = editor.inEmptyBlock();
  editor.insertBlock(block);
  if (inEmptyBlock) {
    editor.removeNodeByKey(currentBlock.key);
  }
}

var ExtrasPlugin = (function () {
  return {
    plugins: [{
      queries: {
        getPreviousTextInBlock: getPreviousTextInBlock,
        inEmptyBlock: inEmptyBlock,
        isEmptyBlock: isEmptyBlock,
        reloadNode: reloadNode
      },
      commands: {
        insertOrReplaceEmptyBlock: insertOrReplaceEmptyBlock
      }
    }]
  };
});

function DisableMarksBetweenCells(options, utils) {
  var queries = {
    getInsertMarksAtPoint: function getInsertMarksAtPoint(editor, point, node) {
      var path = point.path,
          offset = point.offset;

      var text = node.getDescendant(path);
      if (offset !== 0) {
        return text.marks;
      }

      var parentCell = utils.getClosestTableCellByKey(editor.value.document, path);
      if (!parentCell) return;

      // Don't carry marks from other cells. If you're the first text
      // in a cell, only consider your own marks.
      if (text === parentCell.getFirstText()) {
        return text.marks;
      }
    }
  };

  return {
    queries: queries
  };
}

function OnUpDown(utils, changes) {
  function extendSelectionToRange(editor, newRange, extendSelection) {
    if (extendSelection) {
      var focus = newRange.focus;

      editor.select({ focus: focus });
    } else {
      editor.select(newRange);
    }
  }

  function findTargetText(value, direction) {
    var document = value.document,
        selection = value.selection;


    if (direction === 'down') {
      return document.getNextText(selection.focus.key);
    } else {
      return document.getPreviousText(selection.focus.key);
    }
  }

  function findTargetTable(value, targetText) {
    return utils.getClosestTableByKey(value.document, targetText.key);
  }

  /**
   * Lets the event run for a frame, then calls onChanged if the event
   * caused the cursor to move to a new table cell.
   * @param {Value} value
   * @param {Block} currentCell - The table cell the selection focus is currently in
   * @param {function} onChanged - The function to be called if the event caused the selection to change cells
   */
  function ifCellChanged(editor, currentCell, onChanged) {
    window.requestAnimationFrame(function () {
      var domSelection = window.getSelection();
      var newNode = editor.findNode(domSelection.focusNode.parentNode);
      var newCell = utils.getClosestTableCellByKey(editor.value.document, newNode.key);

      if (!newCell && !currentCell) {
        return;
      }

      if (!newCell && currentCell || newCell && !currentCell || newCell.key !== currentCell.key) {
        onChanged();
      }
    });
  }

  function findTargetCell(editor, table, cursorRect, direction) {
    var targetCell = void 0;
    var document = editor.value.document;


    if (direction === 'down') {
      // Find the first cell below the cursor, that our cursor is to the right of.
      utils.getVisibleRows(table.nodes).forEach(function (row) {
        if (editor.findDOMNode(document.getPath(row)).getBoundingClientRect().top <= cursorRect.bottom) {
          return;
        }
        row.nodes.forEach(function (cell) {
          if (editor.findDOMNode(document.getPath(cell)).getBoundingClientRect().right > cursorRect.left) {
            targetCell = cell;
            return false;
          }
        });
        if (!targetCell) {
          targetCell = row.nodes.last();
        }
        return false;
      });
    } else {
      // Find the last cell above the cursor, that our cursor is to the left of.
      utils.getVisibleRows(table.nodes).reverse().forEach(function (row) {
        if (editor.findDOMNode(document.getPath(row)).getBoundingClientRect().bottom >= cursorRect.top) {
          return;
        }
        row.nodes.reverse().forEach(function (cell) {
          if (editor.findDOMNode(document.getPath(cell)).getBoundingClientRect().left < cursorRect.right) {
            targetCell = cell;
            return false;
          }
        });
        if (!targetCell) {
          targetCell = row.nodes.first();
        }
        return false;
      });
    }
    return targetCell;
  }

  /**
   *  Find the first or last DOM rect in targetCell, depending on direction.
   */
  function findTargetRectInCell(editor, targetCell, cursorRect, direction) {
    var targetText = void 0;
    if (direction === 'down') {
      targetText = targetCell.getFirstText();
    } else {
      targetText = targetCell.getLastText();
    }
    return findTargetRectInText(editor, targetText, cursorRect, direction);
  }

  /**
   *  Find the first or last DOM rect in the text node called
   *  targetText, depending on direction.
   */
  function findTargetRectInText(editor, targetText, cursorRect, direction) {
    if (!targetText) return;
    var targetRects = Immutable.List(editor.findDOMNode(editor.value.document.getPath(targetText)).getClientRects());

    if (direction === 'down') {
      return targetRects.reduce(function (targetRect, rect) {
        if (rect.top > targetRect.top || rect.right > cursorRect.left) {
          return targetRect;
        } else {
          return rect;
        }
      }, targetRects.first());
    } else {
      return targetRects.reduceRight(function (targetRect, rect) {
        if (rect.top < targetRect.top || rect.right < cursorRect.left) {
          return targetRect;
        } else {
          return rect;
        }
      }, targetRects.last());
    }
  }

  /**
   * Find the first or last text element before or after the selected
   * table.
   */
  function findTargetTextExitingTable(value, table, direction) {
    if (direction === 'down') {
      return value.document.getNextText(table.getLastText().key);
    } else {
      return value.document.getPreviousText(table.getFirstText().key);
    }
  }

  function findTargetElementExitingTable(editor, table, direction) {
    return editor.value.document.getClosestBlock(findTargetTextExitingTable(editor.value, table, direction).key);
  }

  /**
   *  Find the first or last DOM rect in the text node after or before
   *  table, depending on direction.
   */
  function findTargetRectExitingTable(editor, table, cursorRect, direction) {
    var targetText = findTargetTextExitingTable(editor.value, table, direction);
    return findTargetRectInText(editor, targetText, cursorRect, direction);
  }

  /**
   * Moves the cursor's y position to match targetRect's.
   */
  function moveCursorToText(editor, targetElement, targetRect, cursorRect, extendSelection) {
    // If the cursor is to the left of the table, we'll skip the table
    // entirely. Instead, clamp it to the edge of the target rect.
    var xPosition = Math.max(cursorRect.left, targetRect.left);
    var newRange = void 0;
    if (document.caretPositionFromPoint) {
      var newPosition = document.caretPositionFromPoint(xPosition, targetRect.top);
      newRange = document.createRange();
      newRange.setStart(newPosition.offsetNode, newPosition.offset);
      newRange.setEnd(newPosition.offsetNode, newPosition.offset);
    } else if (document.caretRangeFromPoint) {
      newRange = window.document.caretRangeFromPoint(xPosition, targetRect.top);
    } else {
      // COMPAT: IE 11
      newRange = document.body.createTextRange();
      try {
        newRange.moveToPoint(xPosition, targetRect.top);
      } catch (error) {
        // IE11 will raise an `unspecified error` sometimes. It
        // doesn't affect our cursor position, so ignore it.
      }
    }

    var selection = void 0;

    if (newRange) {
      selection = editor.findRange(newRange);

      // COMPAT: Sometimes Slate won't be able to convert the
      // generated IE11 range back into a Slate range. If that
      // happens, just ignore it -- we'll pick it up on the next pass.
      if (!selection) return;
    } else {
      // The browser can't help us, so we'll make our best
      // guess. Other (possible) options: scroll the viewport before
      // finding the caret range, or iterating over the target element
      // using the browser selection until we find the x position
      // closest to us. Considering we're scrolling anyway, losing the
      // x position doesn't seem like the worst thing in the world.
      selection = editor.value.selection.setAnchor({
        key: targetElement.getFirstText().key,
        offset: 0
      }).setFocus({
        key: targetElement.getFirstText().key,
        offset: 0
      });
    }

    editor.command(extendSelectionToRange, selection, extendSelection);
  }

  return function (event, editor, next, direction) {
    var value = editor.value;
    var document = value.document,
        selection = value.selection;
    var shiftKey = event.shiftKey;

    var targetText = findTargetText(value, direction);
    if (!targetText) {
      var table = utils.getClosestTable(editor);
      if (!table) return next();

      // Add a new block above or below the table.
      editor.command(changes.insertSiblingParagraph, {
        below: direction === 'down'
      });
      return;
    }

    var targetTable = findTargetTable(value, targetText);
    if (!targetTable) return next();

    var domSelection = window.getSelection();
    var cursorRects = domSelection.getRangeAt(0).getClientRects();
    var cursorRect = cursorRects[cursorRects.length - 1];
    var currentCell = utils.getClosestTableCellByKey(document, selection.focus.key);

    ifCellChanged(editor, currentCell, function () {
      if (!cursorRect) return;

      var currentTable = utils.getClosestTableByKey(document, selection.focus.key);
      var differentTables = currentTable && targetTable.key !== currentTable.key;
      var targetCell = findTargetCell(editor, targetTable, cursorRect, direction);
      var targetRect = void 0;

      if (differentTables) {
        if (currentTable.getDescendant(targetTable.key)) {
          targetRect = findTargetRectInCell(editor, targetCell, cursorRect, direction);
        } else {
          targetRect = findTargetRectExitingTable(editor, currentTable, cursorRect, direction);
        }
      } else if (targetCell) {
        targetRect = findTargetRectInCell(editor, targetCell, cursorRect, direction);
      } else if (currentCell) {
        targetRect = findTargetRectExitingTable(editor, currentTable, cursorRect, direction);
      }

      if (!targetRect) {
        // Add a new block above or below the table.
        editor.command(changes.insertSiblingParagraph, {
          below: direction === 'down'
        });
        return;
      }

      var targetElement = targetCell || findTargetElementExitingTable(editor, currentTable, direction);

      editor.command(moveCursorToText, targetElement, targetRect, cursorRect, shiftKey).command(changes.updateSelection, editor.value.selection);
    });
    return next();
  };
}

var KEY_TAB = 'Tab';
var KEY_UP = 'ArrowUp';
var KEY_DOWN = 'ArrowDown';
var KEY_LEFT = 'ArrowLeft';
var KEY_RIGHT = 'ArrowRight';

function KeyPresses(options, utils, changes) {
  var onUpDown = OnUpDown(utils, changes);

  // Tab goes to (and selects) the next cell. Shift-tab goes to (and
  // selects) the previous cell.
  function onTab(event, editor, next) {
    var value = editor.value;
    var document = value.document,
        selection = value.selection;


    if (!utils.getClosestTableCellByKey(document, selection.end.key)) {
      return next();
    }

    event.preventDefault();

    if (event.shiftKey) {
      return editor.command(changes.moveToRangeOfPreviousCell, selection.end.key);
    } else {
      return editor.command(changes.moveToRangeOfNextCell, selection.end.key);
    }
  }

  // When your cursor is after a table, backspace deletes the table.
  function onBackspace(event, editor, next) {
    var value = editor.value;
    var document = value.document,
        selection = value.selection;

    if (!selection.isCollapsed) return next();
    if (!selection.anchor.isAtStartOfNode(value.startText)) return next();

    var previousBlock = document.getPreviousBlock(selection.start.key);
    if (!previousBlock) return next();

    var previousTable = utils.getClosestTableByKey(document, previousBlock.key);
    if (!previousTable) return next();

    var currentTable = utils.getClosestTableByKey(document, selection.start.key);
    if (currentTable && currentTable.key === previousTable.key) return next();

    // If the current block is empty, remove it. Otherwise, block the
    // backspace.
    if (editor.inEmptyBlock()) {
      editor.removeNodeByKey(value.startBlock.key);
    } else {
      return true;
    }
  }

  // When your cursor is before a table, delete deletes the table
  function onDelete(event, editor, next) {
    var value = editor.value;
    var document = value.document,
        selection = value.selection;

    if (!selection.isCollapsed) return next();
    if (!selection.anchor.isAtEndOfNode(value.startText)) return next();

    var nextBlock = document.getNextBlock(selection.start.key);
    if (!nextBlock) return next();

    var nextTable = utils.getClosestTableByKey(document, nextBlock.key);
    if (!nextTable) return next();

    var currentTable = utils.getClosestTableByKey(document, selection.start.key);
    if (currentTable && nextTable.key === currentTable.key) return next();

    // If the current block is empty, remove it. Otherwise, block the
    // backspace.
    if (editor.inEmptyBlock()) {
      editor.removeNodeByKey(value.startBlock.key);
    } else {
      return true;
    }
  }

  function isDeleteKey(event) {
    return isBackwardDeleteKey(event) || isForwardDeleteKey(event);
  }

  function isForwardDeleteKey(event) {
    return Hotkeys.isDeleteForward(event) || Hotkeys.isDeleteLineForward(event) || Hotkeys.isDeleteWordForward(event);
  }

  function isBackwardDeleteKey(event) {
    return Hotkeys.isDeleteBackward(event) || Hotkeys.isDeleteLineBackward(event) || Hotkeys.isDeleteWordBackward(event);
  }

  var isMovementKey = function isMovementKey(event) {
    return [KEY_UP, KEY_DOWN, KEY_LEFT, KEY_RIGHT].includes(event.key);
  };

  function onSelectionMove(event, editor, next) {
    var value = editor.value;
    var selection = value.selection;

    if (selection.isCollapsed) return next();
    if (!utils.inTableWithActiveTableSelection(value, selection.focus.key)) {
      return next();
    }

    var targetCell = void 0,
        selectionDirection = void 0;
    switch (event.key) {
      case KEY_RIGHT:
        targetCell = utils.getCellInDirection(value, 'right');
        selectionDirection = 'start';
        break;
      case KEY_LEFT:
        targetCell = utils.getCellInDirection(value, 'left');
        selectionDirection = 'end';
        break;
      case KEY_UP:
        targetCell = utils.getCellInDirection(value, 'up');
        selectionDirection = 'end';
        break;
      case KEY_DOWN:
        targetCell = utils.getCellInDirection(value, 'down');
        selectionDirection = 'start';
        break;
      default:
        return next();
    }

    event.preventDefault();
    if (targetCell) {
      editor.command(changes.updateSelection, value.selection, targetCell.getLastText().key);
      if (selectionDirection === 'start') {
        return editor.moveFocusTo(targetCell.getFirstText().key, 0);
      } else {
        var text = targetCell.getLastText();
        return editor.moveFocusTo(text.key, text.text.length);
      }
    } else {
      return next();
    }
  }

  function preventDeleteAtEdgeOfTableCell(event, editor) {
    if (!isDeleteKey(event)) return false;

    var _editor$value = editor.value,
        document = _editor$value.document,
        selection = _editor$value.selection;

    if (!selection.isCollapsed) return false;

    var tableCell = utils.getClosestTableCellByKey(document, selection.anchor.key);
    if (!tableCell) return false;

    if (isBackwardDeleteKey(event) && (selection.anchor.key !== tableCell.getFirstText().key || selection.anchor.offset !== 0)) {
      return false;
    }

    if (isForwardDeleteKey(event) && (selection.anchor.key !== tableCell.getLastText().key || selection.anchor.offset !== tableCell.getLastText().text.length)) {
      return false;
    }

    event.preventDefault();
    return true;
  }

  function escapeTable(event, editor, next) {
    var _editor$value2 = editor.value,
        document = _editor$value2.document,
        selection = _editor$value2.selection;


    if (event.key === KEY_LEFT) {
      if (selection.focus.offset !== 0) return next();
      var table = utils.getClosestTableByKey(document, selection.focus.key);
      if (!table) return next();
      if (selection.focus.key !== table.getFirstText().key) return next();
      var prevSibling = document.getPreviousSibling(table.key);
      if (!prevSibling) return next();
      var target = prevSibling.getLastText();

      event.preventDefault();
      if (event.shiftKey) {
        return editor.moveFocusToEndOfNode(target);
      } else {
        return editor.moveToEndOfNode(target);
      }
    } else {
      var _table = utils.getClosestTableByKey(document, selection.focus.key);
      if (!_table) return next();
      var lastText = utils.getVisibleRows(_table.nodes).last().getLastText();
      if (selection.focus.key !== lastText.key) return next();
      if (!selection.anchor.isAtEndOfNode(lastText)) return next();

      var nextSibling = document.getNextSibling(_table.key);
      if (!nextSibling) return next();
      var _target = nextSibling.getFirstText();
      event.preventDefault();
      if (event.shiftKey) {
        return editor.moveFocusToStartOfNode(_target);
      } else {
        return editor.moveToStartOfNode(_target);
      }
    }
  }

  function onKeyDown(event, editor, next) {
    var key = event.key;


    if (isDeleteKey(event) && utils.hasActiveTableSelection(editor.value)) {
      return editor.command(changes.clearSelectedCells);
    }

    if (preventDeleteAtEdgeOfTableCell(event, editor)) {
      return editor;
    }

    if (isBackwardDeleteKey(event)) {
      return onBackspace(event, editor, next);
    }

    if (isForwardDeleteKey(event)) {
      return onDelete(event, editor, next);
    }

    if (key === KEY_TAB) {
      return onTab(event, editor, next);
    }

    if (event.shiftKey && isMovementKey(event) && utils.hasActiveTableSelection(editor.value)) {
      return onSelectionMove(event, editor, next);
    }

    if (key === KEY_UP) {
      return onUpDown(event, editor, next, 'up');
    }

    if (key === KEY_DOWN) {
      return onUpDown(event, editor, next, 'down');
    }

    if (key === KEY_LEFT || key === KEY_RIGHT) {
      return escapeTable(event, editor, next);
    }

    return next();
  }

  return {
    onKeyDown: onKeyDown
  };
}

function Schema(options, utils, changes) {
  var _blocks;

  var schema = {
    blocks: (_blocks = {}, defineProperty(_blocks, options.tableRowType, {
      parent: { type: options.tableType },
      normalize: function normalize(change, error) {
        if (error.code === 'parent_type_invalid') {
          return change.removeNodeByKey(error.node.key);
        }
      }
    }), defineProperty(_blocks, options.tableCellType, {
      nodes: [{
        match: [{ object: 'block' }]
      }],
      normalize: function normalize(change, error) {
        if (error.code === 'child_object_invalid') {
          return change.command(wrapChildrenInBlock, error.node);
        }
      }
    }), _blocks)
  };

  function wrapChildrenInBlock(change, node) {
    var nodes = node.nodes;


    change.withoutNormalizing(function (change) {
      change.wrapNodeByKey(nodes.first().key, {
        object: 'block',
        type: 'paragraph'
      });

      var wrapperNode = change.value.document.getDescendant(node.key).nodes.first();

      nodes.rest().forEach(function (child, index) {
        return change.moveNodeByKey(child.key, wrapperNode.key, index + 1);
      });
    });
  }

  // We use empty trs for merged cells, but it causes major
  // problems if the first row is empty. It's not really
  // valid, either, because nothing can rowspan into it. If
  // the first row has no cells, we'll remove it.
  function validateTableHasPopulatedFirstRow(node, editor, next) {
    if (node.type !== options.tableType) return next();
    var firstRow = node.nodes.first();
    if (!firstRow || firstRow.type !== options.tableRowType) return next();
    if (firstRow.nodes.size === 1 && firstRow.nodes.first().object === 'text') {
      return function (change) {
        return change.removeNodeByKey(firstRow.key);
      };
    }
    return next();
  }

  // We may somehow end up with a table with missing cells. If that's
  // the case, we need to fill in the gaps with table cells.
  function validateTableIsRectangular(node, editor, next) {
    if (node.type !== options.tableType) return next();

    var tableStructure = utils.getStructureOfTable(node);
    var missingCells = tableStructure.missingCellPositions;
    if (missingCells.length === 0) return next();

    return function (change) {
      change.withoutNormalizing(function (c) {
        missingCells.forEach(function (_ref) {
          var row = _ref.row,
              column = _ref.column;

          c.command(changes.insertCell, node, row, column);
        });
      });
    };
  }

  return [{
    schema: schema
  }, {
    normalizeNode: validateTableHasPopulatedFirstRow
  }, {
    normalizeNode: validateTableIsRectangular
  }];
}

/**
 * In IE11, certain elements inside a contentEditable with hasLayout
 * (so, a div with a fixed width, for example) will get
 * browser-controlled resize indicators. When you click on the
 * element, the element itself gets focus, which steals focus from
 * Slate, which prevents editing.
 *
 * There's no clean way to prevent this. There are several hacky ways,
 * but nothing which I could get to work consistently, and they all
 * have pretty terrible UX implications:
 * https://stackoverflow.com/questions/21864047/how-to-disable-elements-selection-and-resizing-in-contenteditable-div
 *
 * The cleanest solution is to wrap the element with hasLayout inside
 * a div with contentEditable=false. Unfortunately, this also prevents
 * moving the cursor outside of the contentEditable false element, so
 * we don't want to do it in all browsers. In IE, it's still better
 * than not being able to edit, though.
 *
 * This component wraps an element that could have hasLayout. In IE,
 * it will wrap it so the resize indicators don't appear. In other
 * browsers, it will pass it through.
 *
 * Usage:
 *   <HiddenResizeHandle>
 *     {(extraProps) => (
 *       <div className="haslayout-div" {...extraProps}>Content</div>
 *     )}
 *   </HiddenResizeHandle>
 */

var HiddenResizeHandle = function (_React$Component) {
  inherits(HiddenResizeHandle, _React$Component);

  function HiddenResizeHandle() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, HiddenResizeHandle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = HiddenResizeHandle.__proto__ || Object.getPrototypeOf(HiddenResizeHandle)).call.apply(_ref, [this].concat(args))), _this), _this.state = { needsWrapper: false }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(HiddenResizeHandle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.elementHasLayout) {
        this.setState({ needsWrapper: true });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var needsWrapper = this.elementHasLayout;

      if (this.state.needsWrapper !== needsWrapper) {
        this.setState({ needsWrapper: needsWrapper });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var extraProps = {
        ref: function ref(_ref2) {
          _this2.wrappedElement = _ref2;
        }
      };

      if (this.state.needsWrapper) {
        return React__default.createElement(
          'div',
          { contentEditable: false },
          this.props.children(_extends({}, extraProps, {
            contentEditable: true,
            suppressContentEditableWarning: true
          }))
        );
      } else {
        return this.props.children(extraProps);
      }
    }
  }, {
    key: 'elementHasLayout',
    get: function get$$1() {
      // currentStyle is an IE-only property
      var style = this.wrappedElement.currentStyle;
      if (!style) return false;

      return style.hasLayout;
    }
  }]);
  return HiddenResizeHandle;
}(React__default.Component);

var TableRange = function () {
  function TableRange(_ref) {
    var anchorPosition = _ref.anchorPosition,
        focusPosition = _ref.focusPosition;
    classCallCheck(this, TableRange);

    this.anchorPosition = anchorPosition;
    this.focusPosition = focusPosition;
    this.startPosition = null;
    this.endPosition = null;
    this.normalize();
  }

  createClass(TableRange, [{
    key: "normalize",
    value: function normalize() {
      var _anchorPosition = this.anchorPosition,
          anchorRow = _anchorPosition.row,
          anchorColumn = _anchorPosition.column;
      var _focusPosition = this.focusPosition,
          focusRow = _focusPosition.row,
          focusColumn = _focusPosition.column;


      this.startPosition = {
        row: Math.min(anchorRow, focusRow),
        column: Math.min(anchorColumn, focusColumn)
      };

      this.endPosition = {
        row: Math.max(anchorRow, focusRow),
        column: Math.max(anchorColumn, focusColumn)
      };
    }
  }, {
    key: "isBackward",
    get: function get$$1() {
      return this.anchorPosition.row > this.focusPosition.row || this.anchorPosition.row === this.focusPosition.row && this.anchorPosition.column > this.focusPosition.column;
    }
  }, {
    key: "isCollapsed",
    get: function get$$1() {
      var _size = this.size,
          rows = _size.rows,
          columns = _size.columns;

      return rows <= 1 && columns <= 1;
    }

    /**
     * The size of the selection, in actual table cells selected. A cell
     * with a rowspan of 2 will count as 1x1, not 1x2. This is useful
     * for figuring out whether we have multiple cells selected, or how
     * many cells we want to insert.
     */

  }, {
    key: "size",
    get: function get$$1() {
      var startPosition = this.startPosition,
          endPosition = this.endPosition;

      if (!startPosition || !endPosition) {
        return { rows: 0, columns: 0 };
      }
      return {
        rows: endPosition.row - startPosition.row + 1,
        columns: endPosition.column - startPosition.column + 1
      };
    }
  }]);
  return TableRange;
}();

var DEFAULTS = {
  utils: null,
  key: null,
  anchorCellKey: null,
  focusCellKey: null,
  selectedCellKeys: new Immutable.Set(),
  selectedTableKeys: new Immutable.Set(),
  document: null,
  range: null
};

/**
 * @typedef Position
 * @property {number} row - a table row
 * @property {number} column - a table column
 */

/**
 * @type {Record.Class}
 */

var TableSelection = function (_Record) {
  inherits(TableSelection, _Record);

  function TableSelection() {
    classCallCheck(this, TableSelection);
    return possibleConstructorReturn(this, (TableSelection.__proto__ || Object.getPrototypeOf(TableSelection)).apply(this, arguments));
  }

  createClass(TableSelection, [{
    key: 'select',


    /**
     * Updates the editor's selection with the total range of cells
     * covered by this table selection.
     */
    value: function select(editor) {
      var value = editor.value;

      var selection = this.withDocument(value.document);

      if (selection.hasActiveTableSelection) {
        var structure = selection.structure,
            startPosition = selection.startPosition,
            endPosition = selection.endPosition;

        var startCell = structure.cellInPosition(startPosition);
        var endCell = structure.cellInPosition(endPosition);

        if (this.range.isBackward) {
          return editor.moveToEndOfNode(endCell).moveFocusToStartOfNode(startCell);
        } else {
          return editor.moveToStartOfNode(startCell).moveFocusToEndOfNode(endCell);
        }
      } else {
        return editor.select(value.selection);
      }
    }

    /**
     * Updates the tableSelection's document, and updates the list of
     * selected cells based on the new document.
     */

  }, {
    key: 'withDocument',
    value: function withDocument(document) {
      if (document === this.document) return this;
      return this.withUpdatedCellSelection(document);
    }

    /**
     * Returns a selection object, spanning the same keys, with the
     * positions in the range updated to be up-to-date with the new
     * document.
     */

  }, {
    key: 'withUpdatedCellSelection',
    value: function withUpdatedCellSelection(document) {
      if (this.hasMultipleTableSelection) {
        return this.merge({ document: document });
      }

      var utils = this.utils,
          key = this.key;

      if (!key) return this;

      var table = document.getDescendant(key);
      var anchorCell = document.getDescendant(this.get('anchorCellKey'));
      var focusCell = document.getDescendant(this.get('focusCellKey'));
      if (!table || !anchorCell || !focusCell) {
        return this.withEmptyTableSelection();
      }
      var anchorPosition = utils.getPositionOfCellInTable(table, anchorCell);
      var focusPosition = utils.getPositionOfCellInTable(table, focusCell);
      var range = new TableRange({ anchorPosition: anchorPosition, focusPosition: focusPosition });

      var structure = this.utils.getStructureOfTable(table);
      var selectedCellKeys = structure.cellKeysInRange(range);
      return this.merge({ document: document, range: range, selectedCellKeys: selectedCellKeys });
    }
  }, {
    key: 'withSelectionExtendedToKey',
    value: function withSelectionExtendedToKey(document, selection, targetKey) {
      if (!selection || selection.focus.key === targetKey && selection.isCollapsed) {
        return this.withEmptyTableSelection(selection);
      }

      var anchor = selection.anchor;


      var selectedTableKeys = this.getSelectedTablesAtRange(document, anchor.key, targetKey);
      var newTableSelection = void 0;

      if (selectedTableKeys.size > 0) {
        newTableSelection = this.withEmptyTableSelection(selection).merge({
          selectedTableKeys: selectedTableKeys
        });
      } else {
        var _getTableSelectionAtR = this.getTableSelectionAtRange(document, anchor.key, targetKey),
            key = _getTableSelectionAtR.key,
            anchorCellKey = _getTableSelectionAtR.anchorCellKey,
            focusCellKey = _getTableSelectionAtR.focusCellKey;

        newTableSelection = this.merge({
          key: key,
          anchorCellKey: anchorCellKey,
          focusCellKey: focusCellKey,
          selectedTableKeys: new Immutable.Set()
        });
      }

      return newTableSelection.withUpdatedCellSelection(document);
    }
  }, {
    key: 'withEmptyTableSelection',
    value: function withEmptyTableSelection(selection) {
      // TODO: remove selection as a param
      return this.merge({
        key: null,
        range: null,
        document: null,
        anchorCellKey: null,
        focusCellKey: null,
        selectedCellKeys: new Immutable.Set(),
        selectedTableKeys: new Immutable.Set()
      });
    }

    /**
     *  Applies changeFunction to the range of each selected cell,
     *  independently.
     */

  }, {
    key: 'applyChange',
    value: function applyChange(change, changeFunction) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      if (this.hasActiveTableSelection) {
        var _change$value = change.value,
            document = _change$value.document,
            selection = _change$value.selection;

        var previousSelection = selection;
        this.withDocument(document).getSelectedCells().forEach(function (cell) {
          var _change$moveToStartOf;

          (_change$moveToStartOf = change.moveToStartOfNode(cell.getFirstText()).moveFocusToEndOfNode(cell.getLastText())).command.apply(_change$moveToStartOf, [changeFunction].concat(args));
        });
        return change.select(previousSelection);
      } else {
        return change.command.apply(change, [changeFunction].concat(args));
      }
    }
  }, {
    key: 'reduceSelectedCells',
    value: function reduceSelectedCells(editor, reduceFunction, initialValue) {
      var _this2 = this;

      var result = initialValue;
      var tempEditor = editor.getClone({ value: editor.value }, { normalize: false });

      if (this.hasActiveTableSelection) {
        // Prevent saving these selection changes to the undo stack,
        // because they're not user-initiated.
        tempEditor.withoutSaving(function (tempEditor) {
          tempEditor.withoutUndoTransforming(function (tempEditor) {
            tempEditor.withoutNormalizing(function (tempEditor) {
              result = _this2.withDocument(tempEditor.value.document).getSelectedCells().reduce(function (acc, cell) {
                tempEditor.moveToStartOfNode(cell.getFirstText()).moveFocusToEndOfNode(cell.getLastText());
                return reduceFunction(acc, tempEditor);
              }, result);
            });
          });
        });
      } else {
        result = reduceFunction(result, tempEditor);
      }

      return result;
    }

    /**
     * Returns true if testFunction returns true for every selected
     * cell, false otherwise. This is useful for things like making sure
     * all cells in a selection have certain marks.
     */

  }, {
    key: 'everySelectedCell',
    value: function everySelectedCell(editor, testFunction) {
      return this.reduceSelectedCells(editor, function (acc, editor) {
        if (acc === false) return false;

        return testFunction(editor);
      }, undefined);
    }
  }, {
    key: 'getSelectedCells',
    value: function getSelectedCells() {
      if (!this.structure) return Immutable.List([]);
      return Immutable.List(this.structure.cellsInRange(this.range));
    }
  }, {
    key: 'isCellSelected',
    value: function isCellSelected(cellKey) {
      if (this.hasActiveTableSelection) {
        return this.selectedCellKeys.has(cellKey);
      } else if (this.hasMultipleTableSelection) {
        var parentTable = this.utils.getClosestTableByKey(this.document, cellKey);
        return parentTable && this.isTableSelected(parentTable.key);
      }
    }
  }, {
    key: 'isTableSelected',
    value: function isTableSelected(tableKey) {
      return this.selectedTableKeys.has(tableKey);
    }
  }, {
    key: 'getSelectedTablesAtRange',
    value: function getSelectedTablesAtRange(document, anchorKey, focusKey) {
      var utils = this.utils;

      var selectedTables = new Immutable.Set();
      if (anchorKey === focusKey) return selectedTables;

      var anchorTable = utils.getClosestTableByKey(document, anchorKey);
      var focusTable = utils.getClosestTableByKey(document, focusKey);

      if (anchorTable && anchorTable === focusTable) {
        return selectedTables;
      }

      if (anchorTable) {
        selectedTables = selectedTables.add(anchorTable.key);
      }

      if (focusTable) {
        selectedTables = selectedTables.add(focusTable.key);
      }

      var range = document.createRange({
        anchor: { key: anchorKey, offset: 0 },
        focus: { key: focusKey, offset: 0 }
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = document.blocks({ range: range })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = slicedToArray(_ref, 1);

          var block = _ref2[0];

          if (this.utils.isTable(block)) {
            selectedTables = selectedTables.add(block.key);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return selectedTables;
    }
  }, {
    key: 'getTableSelectionAtRange',
    value: function getTableSelectionAtRange(document, anchorKey, focusKey) {
      var utils = this.utils;


      if (anchorKey === focusKey) return {};

      var anchorTableCell = utils.getClosestTableCellByKey(document, anchorKey);
      var focusTableCell = utils.getClosestTableCellByKey(document, focusKey);

      if (!anchorTableCell || !focusTableCell) return {};
      if (anchorTableCell === focusTableCell) return {};

      var anchorTable = utils.getClosestTableByKey(document, anchorKey);
      var focusTable = utils.getClosestTableByKey(document, focusKey);
      if (!anchorTable || !focusTable) return {};

      // Handle nested tables
      if (anchorTable.hasDescendant(focusTable.key)) {
        focusTable = anchorTable;
        focusTableCell = utils.getTableCellInTableByKey(document, anchorTable, focusTableCell.key);
      } else if (focusTable.hasDescendant(anchorTable.key)) {
        anchorTable = focusTable;
        anchorTableCell = utils.getTableCellInTableByKey(document, focusTable, anchorTableCell.key);
      }

      if (anchorTable !== focusTable) return {};

      return {
        key: anchorTable.key,
        anchorCellKey: anchorTableCell.key,
        focusCellKey: focusTableCell.key
      };
    }
  }, {
    key: 'hasActiveTableSelection',
    get: function get$$1() {
      return this.key && this.range && !this.range.isCollapsed;
    }
  }, {
    key: 'hasMultipleTableSelection',
    get: function get$$1() {
      return this.selectedTableKeys.size !== 0;
    }
  }, {
    key: 'document',
    get: function get$$1() {
      return this.get('document');
    }
  }, {
    key: 'utils',
    get: function get$$1() {
      return this.get('utils');
    }

    /**
     * The Slate key of the table containing selected cells.
     * @type {string}
     */

  }, {
    key: 'key',
    get: function get$$1() {
      return this.get('key');
    }
  }, {
    key: 'range',
    get: function get$$1() {
      return this.get('range');
    }
  }, {
    key: 'structure',
    get: function get$$1() {
      return this.key && this.utils.getStructureOfTable(this.table);
    }

    /**
     * The upper-left position of the selection.
     * @type {Position}
     */

  }, {
    key: 'startPosition',
    get: function get$$1() {
      return this.range && this.range.startPosition;
    }

    /**
     * The lower-right position of the selection.
     * @type {Position}
     */

  }, {
    key: 'endPosition',
    get: function get$$1() {
      return this.range && this.range.endPosition;
    }

    /**
     * The position of the cell that was selected first.
     * @type {Position}
     */

  }, {
    key: 'anchorPosition',
    get: function get$$1() {
      return this.range && this.range.anchorPosition;
    }

    /**
     * The position of the cell that was selected most recently.
     */

  }, {
    key: 'focusPosition',
    get: function get$$1() {
      return this.range && this.range.focusPosition;
    }
  }, {
    key: 'selectionSize',
    get: function get$$1() {
      return this.range ? this.range.size : { rows: 0, columns: 0 };
    }

    /**
     * The selected table block.
     */

  }, {
    key: 'table',
    get: function get$$1() {
      return this.document.getDescendant(this.key);
    }

    /**
     * The actual dimensions of the selection, taking into account
     * row/colspans and merged cells.
     */

  }, {
    key: 'dimensions',
    get: function get$$1() {
      if (this.range) {
        return this.utils.getStructureOfTable(this.table).dimensionsOfRange(this.range);
      } else {
        return { rows: 0, columns: 0 };
      }
    }
  }]);
  return TableSelection;
}(Immutable.Record(DEFAULTS));

/* To make eslint happy with jsdoc / proptypes */
/* eslint-disable no-unused-vars */
/* eslint-enable no-unused-vars */

/**
 * @augments {React.Component<{node:Block, editor:Editor, attributes:object, readOnly:boolean, selected:boolean, selection:TableSelection, menuIdentifier:string, onSelectionUpdate:function, columnWidths:List}>}
 */

var Table = function (_React$Component) {
  inherits(Table, _React$Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.leftButtonPressed = function (event) {
      // Safari has a bug with button / buttons, Firefox has a bug with
      // which. Such is life.
      var mouseEvent = event.nativeEvent;
      if (mouseEvent.buttons !== undefined) {
        return mouseEvent.buttons & 1;
      } else {
        return mouseEvent.which === 1;
      }
    }, _this.updateSelection = function (nativeEvent) {
      var _this$props = _this.props,
          editor = _this$props.editor,
          onSelectionUpdate = _this$props.onSelectionUpdate;

      editor.command(function (change) {
        onSelectionUpdate(nativeEvent, change, editor);
      });
    }, _this.onMouseLeave = function (event) {
      if (!_this.leftButtonPressed(event) || !_this.isTableClick) return;
      var mouseOverDocument = function mouseOverDocument(event) {
        _this.updateSelection(event);
        document.removeEventListener('mouseover', mouseOverDocument);
      };
      document.addEventListener('mouseover', mouseOverDocument);
    }, _this.onMouseOver = function (event) {
      if (_this.leftButtonPressed(event) && _this.isTableClick) {
        _this.updateSelection(event);
      }
    }, _this.onMouseDown = function (event) {
      if (!_this.leftButtonPressed(event)) return;

      _this.isTableClick = true;

      if (event.shiftKey) {
        event.stopPropagation();
        _this.updateSelection(event);
      }
    }, _this.onMouseUp = function (event) {
      _this.isTableClick = false;
    }, _this.getTableCellContext = memoizeOne(function (tableSelection, entireTableSelected) {
      return {
        tableSelection: tableSelection,
        entireTableSelected: entireTableSelected
      };
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  // Fire one last event as we leave, so we can update the table
  // selection with the next node we enter.


  createClass(Table, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // COMPAT: For Firefox, stops default contenteditable table resizing.
      window.document.execCommand('enableObjectResizing', false, 'false');
      window.document.execCommand('enableInlineTableEditing', false, 'false');
    }
  }, {
    key: 'columns',
    value: function columns() {
      return this.props.columnWidths.map(function (width, i) {
        var style = { width: typeof width === 'number' ? width + '%' : null };
        return React__default.createElement('col', { key: i, style: style });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          selection = _props.selection,
          editor = _props.editor,
          node = _props.node,
          attributes = _props.attributes,
          children = _props.children;


      var CellContext = this.props.cellContext;

      var classes = classnames({
        'active-selection': this.props.selected || this.props.selectedKey === node.key
      });

      var style = {};
      style.width = node.data.get('width') ? node.data.get('width') + 'px' : '100%';
      style.maxWidth = '100%';

      if (editor.isModifiable()) {
        return React__default.createElement(
          HiddenResizeHandle,
          null,
          function (extraProps) {
            return React__default.createElement(
              'div',
              _extends({ className: 'table-wrapper', style: style }, extraProps),
              React__default.createElement(
                'table',
                _extends({
                  onMouseDown: _this2.onMouseDown,
                  onMouseUp: _this2.onMouseUp,
                  onMouseOver: _this2.onMouseOver,
                  onMouseLeave: _this2.onMouseLeave,
                  className: classes
                }, attributes),
                React__default.createElement(
                  'colgroup',
                  null,
                  _this2.columns()
                ),
                React__default.createElement(
                  CellContext.Provider,
                  {
                    value: _this2.getTableCellContext(_this2.props.selectedKey === node.key ? selection : null, _this2.props.selected)
                  },
                  React__default.createElement(
                    'tbody',
                    null,
                    children
                  )
                )
              )
            );
          }
        );
      } else {
        return (
          // Wrapper is required to prevent table from overflowing the boundary of the editor
          React__default.createElement(
            'div',
            { className: 'table-wrapper', style: style },
            React__default.createElement(
              'table',
              _extends({ className: classes, style: style }, attributes),
              React__default.createElement(
                'colgroup',
                null,
                this.columns()
              ),
              React__default.createElement(
                'tbody',
                null,
                children
              )
            )
          )
        );
      }
    }
  }]);
  return Table;
}(React__default.Component);

Table.propTypes = {
  node: PropTypes.instanceOf(Slate.Block).isRequired,
  editor: PropTypes.instanceOf(slateReact.Editor).isRequired,
  attributes: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  selected: PropTypes.bool,
  selection: PropTypes.instanceOf(TableSelection).isRequired,
  menuIdentifier: PropTypes.string.isRequired,
  onSelectionUpdate: PropTypes.func.isRequired
};

/* To make eslint happy with jsdoc / proptypes */
/* eslint-disable no-unused-vars */
/* eslint-enable no-unused-vars */

/**
 * @augments {React.Component<{node:Block, editor:Editor, value:Value, utils:object, selection:TableSelection, tableCellType:string, attributes:object, isSelected:boolean, isFocused:boolean, readOnly:boolean}>}
 */

var TableRow = function (_React$Component) {
  inherits(TableRow, _React$Component);

  function TableRow() {
    classCallCheck(this, TableRow);
    return possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).apply(this, arguments));
  }

  createClass(TableRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          node = _props.node,
          attributes = _props.attributes,
          children = _props.children,
          tableCellType = _props.tableCellType;

      if (node.nodes.some(function (node) {
        return node.type === tableCellType;
      })) {
        return React__default.createElement(
          'tr',
          attributes,
          children
        );
      } else {
        var style = { display: 'none' };
        return React__default.createElement(
          'tr',
          attributes,
          React__default.createElement(
            'td',
            { style: style },
            children
          )
        );
      }
    }
  }]);
  return TableRow;
}(React__default.Component);

TableRow.propTypes = {
  node: PropTypes.instanceOf(Slate.Block).isRequired,
  editor: PropTypes.instanceOf(slateReact.Editor).isRequired,
  value: PropTypes.instanceOf(Slate.Value).isRequired,
  utils: PropTypes.object.isRequired,
  selection: PropTypes.instanceOf(TableSelection).isRequired,
  attributes: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  isFocused: PropTypes.bool,
  readOnly: PropTypes.bool
};

/**
 * @augments {React.Component<{ onMoved:function }, {dragging:boolean}>}
 */

var DragHandle = function (_React$Component) {
  inherits(DragHandle, _React$Component);

  function DragHandle() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, DragHandle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DragHandle.__proto__ || Object.getPrototypeOf(DragHandle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false,
      top: null,
      height: null
    }, _this.onMouseMove = function (event) {
      if (_this.state.dragging) {
        event.stopPropagation();
        event.preventDefault();

        _this.props.onMoved(event.clientX, event.clientY);
      }
    }, _this.onMouseDown = function (event) {
      var tableDimensions = {};
      if (_this.enclosingTable) {
        _this.enclosingTable.style.position = 'relative';

        var tableRect = _this.enclosingTable.getBoundingClientRect();
        var containerRect = _this.container.getBoundingClientRect();
        tableDimensions.top = tableRect.top - containerRect.top;
        tableDimensions.height = tableRect.height;
      }

      _this.setState(_extends({ dragging: true }, tableDimensions));

      document.addEventListener('mousemove', _this.onMouseMove);
      document.addEventListener('mouseup', _this.onMouseUp);

      event.stopPropagation();
    }, _this.onMouseUp = function (event) {
      _this.setState({ dragging: false, top: null, height: null });
      if (_this.enclosingTable) {
        _this.enclosingTable.style.position = null;
      }
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('mouseup', _this.onMouseUp);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(DragHandle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enclosingTable = this.container.closest('table');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var className = classnames('drag-handle', {
        dragging: this.state.dragging
      });

      var style = {};

      if (this.state.dragging) {
        style.position = 'absolute';
        style.top = this.state.top;
        style.height = this.state.height;
        if (this.props.zoomEnabled) {
          style.top = '-999px';
          style.height = '9999px';
        }
      }

      return React__default.createElement(
        'div',
        {
          contentEditable: false,
          onMouseDown: this.onMouseDown,
          className: className,
          ref: function ref(_ref2) {
            _this2.container = _ref2;
          }
        },
        React__default.createElement('div', { className: 'drag-handle-indicator', style: style })
      );
    }
  }]);
  return DragHandle;
}(React__default.Component);

DragHandle.propTypes = {
  onMoved: PropTypes.func.isRequired,
  zoomEnabled: PropTypes.bool
};

var removeUndefined = (function (object) {
  Object.keys(object).forEach(function (key) {
    if (object[key] === undefined) {
      delete object[key];
    }
  });
  return object;
});

function foreground() {
  return utils.darkMode() ? '#e8eef3' : '#333333';
}

function defaultColors () {
  return {
    foreground: foreground(),
    background: 'transparent'
  };
}

// This is a duplication of the code in Aha! For now copy paste is fine. It's
// far easier than somehow linking to another package. Could be an easy middle
// ground to expose mapColorFromColorPickerToDarkMode on window.
var PALETTE_COLORS_LIGHT_THEME_TO_DARK = {
  '#ee9999': '#a83b3b',
  '#e24d4d': '#872929',
  '#d50000': '#731717',
  '#aa0000': '#590909',
  '#800000': '#400000',
  '#fdd4a3': '#99672b',
  '#fbb35f': '#875c29',
  '#f9931a': '#6e4516',
  '#c77615': '#543208',
  '#955810': '#3c2000',
  '#ffee99': '#a39241',
  '#ffe24d': '#857428',
  '#ffd500': '#6b5c15',
  '#ccaa00': '#524608',
  '#998000': '#382f00',
  '#dfefc5': '#75943b',
  '#c8e29a': '#5c7a25',
  '#b0d66e': '#476314',
  '#8dab58': '#324a07',
  '#6a8042': '#1e3000',
  '#c1e39d': '#5f8f2b',
  '#93cd54': '#4c781d',
  '#64b80a': '#3b6111',
  '#509308': '#284707',
  '#3c6e06': '#1a3300',
  '#bddcdd': '#389394',
  '#8cc1c3': '#22797a',
  '#5ba7a9': '#146566',
  '#498687': '#084b4d',
  '#376465': '#003233',
  '#99c7ec': '#226eab',
  '#4d9ddd': '#1a5c91',
  '#0173cf': '#0173cf',
  '#015ca6': '#015ca6',
  '#01457c': '#01457c',
  '#c5dfe9': '#408199',
  '#9ac8d9': '#29708a',
  '#6fb0c8': '#165870',
  '#598da0': '#094257',
  '#436a78': '#002d3e',
  '#c2b7c8': '#9775a9',
  '#95829e': '#815d92',
  '#674c75': '#5d3a6f',
  '#523d5e': '#432653',
  '#3e2e46': '#2f143d',
  '#ddbec7': '#a3526b',
  '#c38d9e': '#8a3751',
  '#a95c74': '#701c36',
  '#874a5d': '#570921',
  '#653746': '#3d0013',
  '#f7c6c3': '#a34841',
  '#f09c95': '#8a2f29',
  '#ea7168': '#701c16',
  '#bb5a53': '#570e09',
  '#8c443e': '#3d0400',
  '#f1e2cf': '#99764d',
  '#e7cdab': '#805c2e',
  '#dcb787': '#664214',
  '#b0926c': '#4d2e08',
  '#846e51': '#341d00',
  '#000000': '#e8eef3',
  '#4c4c4c': '#cbd5de',
  '#666666': '#b3bcc4',
  '#7f7f7f': '#9ca4ab',
  '#a5a5a5': '#78828a',
  '#cccccc': '#5a6673',
  '#d9d9d9': '#48525c',
  '#e5e5e5': '#3c454d',
  '#f2f2f2': '#2d363d',
  '#ffffff': '#21282e',

  // Map named web colors to the equivalent dark mode colors
  black: '#e8eef3',
  white: '#21282e'
};

var HIGHLIGHTS_LIGHT_THEME_TO_DARK = {
  '#ffff9d': '#6b5c15',
  '#f1f1f1': '#3c454d',
  '#e5f3d6': '#3b6111',
  '#d4e8f7': '#01457c',
  '#fbebeb': '#590909'
};

var TEXT_LIGHT_THEME_TO_DARK = {
  '#999999': 'var(--aha-gray-200)',
  '#f9931a': '#f99319',
  '#64b80b': '#7bba34',
  '#ffffff': 'var(--aha-gray-100)'
};

var utils = {
  getColorFromMark: function getColorFromMark(mark) {
    return removeUndefined({
      foreground: mark.data.get('foreground'),
      background: mark.data.get('background'),
      gradient: mark.data.get('gradient')
    });
  },
  getCurrentColor: function getCurrentColor(editor) {
    var colorMarks = editor.getActiveMarks().filter(function (mark) {
      return mark.type === 'color';
    });

    if (colorMarks.size === 0) return;

    var color = utils.getColorFromMark(colorMarks.first());

    if (colorMarks.every(function (mark) {
      return utils.isSameColor(color, utils.getColorFromMark(mark));
    })) {
      return color;
    }
  },
  getStyleFromMark: function getStyleFromMark(mark) {
    var addDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (mark.type !== 'color') {
      return {};
    }

    var color = utils.getColorFromMark(mark);

    if (addDefaults) {
      color = utils.addDefaultsToColor(color);
    }

    var gradientSettings = {};
    if (color.gradient) {
      gradientSettings = {
        backgroundImage: '-webkit-linear-gradient(left, ' + color.gradient.gradientStart + ' 10%, ' + color.gradient.gradientEnd + ' 80%)',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundColor: 'transparent',
        color: color.gradient.gradientStart
      };
    }

    return removeUndefined(_extends({
      color: color.foreground ? utils.mapTextColor(color.foreground) : null,
      backgroundColor: color.background ? utils.mapHighlightColor(color.background) : null
    }, gradientSettings));
  },
  addDefaultsToColor: function addDefaultsToColor(color) {
    return _extends({}, defaultColors(), removeUndefined(color));
  },
  isSameColor: function isSameColor(color1, color2) {
    return color1.foreground === color2.foreground && color1.background === color2.background && color1.gradient === color2.gradient;
  },
  rgbToHex: function rgbToHex(color) {
    if (color.substr(0, 1) === '#') {
      return color;
    }

    var digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);
    if (!digits) return color;

    var red = parseInt(digits[2], 10);
    var green = parseInt(digits[3], 10);
    var blue = parseInt(digits[4], 10);

    var rgb = blue | green << 8 | red << 16;
    return (digits[1] + '#' + rgb.toString(16).padStart(6, '0')).toUpperCase();
  },
  normalizeTextColor: function normalizeTextColor(color) {
    if (color) {
      color = utils.rgbToHex(color);
    }

    if (color && ![defaultColors().foreground, '#000000', ''].includes(color)) {
      return color;
    }
  },
  normalizeTextHighlight: function normalizeTextHighlight(color) {
    if (color) {
      color = utils.rgbToHex(color);
    }

    if (color && ![defaultColors().background, '#FFFFFF', ''].includes(color)) {
      return color;
    }
  },
  mapColorFromColorPickerToDarkMode: function mapColorFromColorPickerToDarkMode(color) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return utils.darkMode() || force ? PALETTE_COLORS_LIGHT_THEME_TO_DARK[color.toLowerCase()] || color : color;
  },
  mapColorFromColorPickerFromDarkMode: function mapColorFromColorPickerFromDarkMode(color) {
    if (!utils.darkMode()) {
      return color;
    }

    color = color.toLowerCase();

    return Object.keys(PALETTE_COLORS_LIGHT_THEME_TO_DARK).find(function (key) {
      return PALETTE_COLORS_LIGHT_THEME_TO_DARK[key] === color;
    }) || color;
  },
  mapTextColor: function mapTextColor(color) {
    return utils.darkMode() ? TEXT_LIGHT_THEME_TO_DARK[color.toLowerCase()] || color : color;
  },
  mapHighlightColor: function mapHighlightColor(color) {
    return utils.darkMode() ? HIGHLIGHTS_LIGHT_THEME_TO_DARK[color.toLowerCase()] || color : color;
  },
  darkMode: function darkMode() {
    // Would be nice to pass into the editor the theme as a prop. Then when it
    // changes, the entire editor will rerender.
    return typeof window !== 'undefined' && window.themeStore && window.themeStore.theme === 'dark';
  }
};

function TableSize(props) {
  var className = '';
  if (props.selected) {
    className += 'selected';
  }
  return React__default.createElement('td', {
    className: className,
    onMouseEnter: props.onMouseEnter,
    onClick: props.onClick,
    onTouchEnd: props.onClick
  });
}

TableSize.propTypes = {
  selected: PropTypes.bool,
  onMouseEnter: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};

var DEFAULT_STATE = { rowIndex: 2, columnIndex: 2 };

/**
 * @augments {React.Component<{onClick:function, maxRows:number, maxColumns:number}, {rowIndex:number, columnIndex:number}>}
 */

var NewTableSizer = function (_React$Component) {
  inherits(NewTableSizer, _React$Component);

  function NewTableSizer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, NewTableSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = NewTableSizer.__proto__ || Object.getPrototypeOf(NewTableSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = DEFAULT_STATE, _this.resetState = function () {
      _this.setState(DEFAULT_STATE);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(NewTableSizer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          maxRows = _props.maxRows,
          maxColumns = _props.maxColumns;

      return React__default.createElement(
        'div',
        { className: 'new-table-sizer', onMouseOut: this.resetState },
        React__default.createElement(
          'table',
          null,
          React__default.createElement(
            'tbody',
            null,
            Immutable.Range(1, maxRows + 1).map(function (rowIndex) {
              return React__default.createElement(
                'tr',
                { key: rowIndex },
                Immutable.Range(1, maxColumns + 1).map(function (columnIndex) {
                  return React__default.createElement(TableSize, {
                    key: rowIndex + '-' + columnIndex,
                    selected: rowIndex <= _this2.state.rowIndex && columnIndex <= _this2.state.columnIndex,
                    onClick: function onClick(event) {
                      return _this2.props.onClick(event, rowIndex, columnIndex);
                    },
                    onMouseEnter: function onMouseEnter(event) {
                      return _this2.setState({ rowIndex: rowIndex, columnIndex: columnIndex });
                    },
                    row: rowIndex,
                    column: columnIndex
                  });
                })
              );
            })
          )
        ),
        React__default.createElement(
          'p',
          null,
          this.state.columnIndex,
          ' x ',
          this.state.rowIndex
        )
      );
    }
  }]);
  return NewTableSizer;
}(React__default.Component);

NewTableSizer.propTypes = {
  onClick: PropTypes.func.isRequired,
  maxRows: PropTypes.number.isRequired,
  maxColumns: PropTypes.number.isRequired
};

var COLORS = ['#ee9999', '#fdd4a3', '#ffee99', '#dfefc5', '#c1e39d', '#bddcdd', '#99c7ec', '#c5dfe9', '#c2b7c8', '#ddbec7', '#f7c6c3', '#f1e2cf', '#a5a5a5', '#ffffff', '#e24d4d', '#fbb35f', '#ffe24d', '#c8e29a', '#93cd54', '#8cc1c3', '#4d9ddd', '#9ac8d9', '#95829e', '#c38d9e', '#f09c95', '#e7cdab', '#7f7f7f', '#f2f2f2', '#d50000', '#f9931a', '#ffd500', '#b0d66e', '#64b80a', '#5ba7a9', '#0173cf', '#6fb0c8', '#674c75', '#a95c74', '#ea7168', '#dcb787', '#666666', '#e5e5e5', '#aa0000', '#c77615', '#ccaa00', '#8dab58', '#509308', '#498687', '#015ca6', '#598da0', '#523d5e', '#874a5d', '#bb5a53', '#b0926c', '#4c4c4c', '#d9d9d9', '#800000', '#955810', '#998000', '#6a8042', '#3c6e06', '#376465', '#01457c', '#436a78', '#3e2e46', '#653746', '#8c443e', '#846e51', '#000000', '#cccccc'];

var DARK_COLORS = COLORS.map(function (color) {
  return utils.mapColorFromColorPickerToDarkMode(color, true);
});

var styles$4 = { "colorPicker": "ColorPicker-module_colorPicker__1nGRp", "colorSwatches": "ColorPicker-module_colorSwatches__1194Q", "colorSwatchContainer": "ColorPicker-module_colorSwatchContainer__2HoKf", "colorSwatchBorder": "ColorPicker-module_colorSwatchBorder__izhGt", "colorSwatch": "ColorPicker-module_colorSwatch__12eSD", "customColorSwatch": "ColorPicker-module_customColorSwatch__3_OBm", "colorControls": "ColorPicker-module_colorControls__2al4E", "clearColorButton": "ColorPicker-module_clearColorButton__2F3c5", "customColor": "ColorPicker-module_customColor__3FsYT", "customColorHex": "ColorPicker-module_customColorHex__12KfR", "customColorHexInput": "ColorPicker-module_customColorHexInput__26GnG", "customColorPickerContainer": "ColorPicker-module_customColorPickerContainer__V-Eun", "customColorPicker": "ColorPicker-module_customColorPicker__1I00R" };

var isValidHex = function isValidHex(hex) {
  return (/^#([0-9A-F]{3}){1,2}$/i.test(hex)
  );
};

var ColorSlider = function ColorSlider(_ref) {
  var open = _ref.open,
      onChange = _ref.onChange,
      color = _ref.color;

  var onChangeDebounced = React.useMemo(function () {
    return debounce(onChange, 200);
  }, [onChange]);

  if (!open) return null;
  return React__default.createElement(
    'div',
    { className: styles$4.customColorPickerContainer },
    React__default.createElement(
      'div',
      { className: styles$4.customColorPicker },
      React__default.createElement(reactColorful.HexColorPicker, { color: color, onChange: onChangeDebounced })
    )
  );
};

var ColorPickerSwatch = function ColorPickerSwatch(_ref2) {
  var color = _ref2.color,
      onClick = _ref2.onClick,
      className = _ref2.className,
      border = _ref2.border;

  return React__default.createElement(
    'div',
    { className: classnames(styles$4.colorSwatchContainer, className) },
    React__default.createElement('div', { className: classnames(styles$4.colorSwatch, defineProperty({}, styles$4.colorSwatchBorder, border)), style: { backgroundColor: color }, onClick: onClick })
  );
};

var CustomColorPickerSwatch = function CustomColorPickerSwatch(_ref3) {
  var color = _ref3.color,
      onClick = _ref3.onClick;

  return React__default.createElement(
    'div',
    { className: styles$4.customColorSwatch },
    React__default.createElement(ColorPickerSwatch, { border: color === '#ffffff', color: color, onClick: onClick })
  );
};

var ColorPicker = function ColorPicker(_ref4) {
  var currentColor = _ref4.currentColor,
      handleColorChange = _ref4.handleColorChange,
      handleClearColor = _ref4.handleClearColor,
      showClearButton = _ref4.showClearButton,
      showCustomColorInput = _ref4.showCustomColorInput;

  var colors = utils.darkMode() ? DARK_COLORS : COLORS;

  var _useState = React.useState(currentColor),
      _useState2 = slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      customColorPickerOpen = _useState4[0],
      setCustomColorPickerOpen = _useState4[1];

  var showColorPickerFooter = showCustomColorInput || showClearButton;

  var handleInputChange = function handleInputChange(e) {
    var color = e.target.value;
    setInputValue(color);
    if (isValidHex(color)) {
      handleColorChange(color)();
    }
  };

  var toggleCustomColorPicker = function toggleCustomColorPicker(e) {
    e.stopPropagation();
    setCustomColorPickerOpen(function (open) {
      return !open;
    });
  };

  var stopPropagation = React.useMemo(function () {
    var targetClasses = [styles$4.customColorPicker, styles$4.customColorHexInput, styles$4.colorSwatches, styles$4.colorControls, 'react-colorful'];

    var handler = function handler(e) {
      if (targetClasses.some(function (className) {
        return e.target.className.includes(className);
      })) {
        e.stopPropagation();
      }
    };

    return {
      onMouseDown: handler,
      onClick: handler
    };
  }, []);

  return React__default.createElement(
    'div',
    _extends({ className: styles$4.colorPicker }, stopPropagation),
    React__default.createElement(
      'div',
      { className: styles$4.colorSwatches },
      colors.map(function (color) {
        return React__default.createElement(ColorPickerSwatch, { key: color, color: color, onClick: handleColorChange(color) });
      })
    ),
    showColorPickerFooter && React__default.createElement(
      React__default.Fragment,
      null,
      React__default.createElement(
        'div',
        { className: styles$4.colorControls },
        showCustomColorInput && React__default.createElement(
          'div',
          { className: styles$4.customColor },
          React__default.createElement(CustomColorPickerSwatch, { color: currentColor, onClick: toggleCustomColorPicker }),
          React__default.createElement(
            'div',
            { className: styles$4.customColorHex },
            React__default.createElement('input', { type: 'text',
              value: inputValue.toUpperCase(),
              onChange: handleInputChange,
              className: styles$4.customColorHexInput })
          )
        ),
        showClearButton && React__default.createElement(
          'div',
          null,
          React__default.createElement(
            'button',
            { type: 'button', className: styles$4.clearColorButton, onClick: handleClearColor },
            React__default.createElement('i', { className: 'fa-regular fa-droplet-slash' }),
            ' None'
          )
        )
      ),
      showCustomColorInput && React__default.createElement(ColorSlider, { open: customColorPickerOpen, onChange: function onChange(color) {
          handleColorChange(color)();
          setInputValue(color);
        }, color: currentColor })
    )
  );
};

var trackToolbarAnalytics = function trackToolbarAnalytics(_ref) {
  var eventName = _ref.eventName,
      _ref$properties = _ref.properties,
      properties = _ref$properties === undefined ? {} : _ref$properties;

  if (window.AhaAnalytics && eventName) {
    window.AhaAnalytics.track('Feature-7244186879861792725', eventName, properties);
  }
};

/* To make eslint happy with jsdoc / proptypes */
/* eslint-disable no-unused-vars */
/* eslint-enable no-unused-vars */

var ColorPickerContainer = React__default.memo(function (_ref) {
  var currentColor = _ref.currentColor,
      handleColorChange = _ref.handleColorChange,
      handleClearColor = _ref.handleClearColor;

  return React__default.createElement(ColorPicker, {
    currentColor: currentColor,
    handleColorChange: handleColorChange,
    handleClearColor: handleClearColor
  });
});

/**
 * @augments {React.Component<{ value:Slate.Value, utils:object, changes:object, change:function }, {}>}
 */

var TableMenu = function (_React$Component) {
  inherits(TableMenu, _React$Component);

  function TableMenu() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, TableMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = TableMenu.__proto__ || Object.getPrototypeOf(TableMenu)).call.apply(_ref2, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(TableMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          utils$$1 = _props.utils,
          changes = _props.changes;
      var document = value.document,
          selection = value.selection;


      var currentTable = utils$$1.getClosestTableByKey(document, selection.start.key);

      var isEntireTableSelected = currentTable && utils$$1.isEntireTableSelected(value, currentTable.key);
      var isInTable = currentTable && !isEntireTableSelected;
      var hasActiveTableSelection = utils$$1.hasActiveTableSelection(value);
      var selectionSize = utils$$1.getTableSelectionSize(value);
      var selectedRowCount = selectionSize.rows,
          selectedColumnCount = selectionSize.columns;


      var tableStructure = isInTable && utils$$1.getStructureOfTable(currentTable);
      var range = utils$$1.getSelectedRange(value);
      var canMergeCells = tableStructure && range && tableStructure.canMergeCells(range);
      var canSplitCells = utils$$1.getMergedCellsInCurrentRange(value).size !== 0;

      var canAddSpacing = !this.props.preventTableBlockSurrounding;

      var canResetColumnWidths = isInTable && !utils$$1.getColumnWidths(currentTable).isEmpty();

      var canDeleteRow = tableStructure ? tableStructure.dimensions.rows > (selectedRowCount || 1) : true;
      var canDeleteColumn = tableStructure ? tableStructure.dimensions.columns > (selectedColumnCount || 1) : true;
      var canDeleteTable = !this.props.disableTableDelete;

      var canInsertTable = !isInTable && !isEntireTableSelected;
      var verticalAlignments = ['top', 'middle', 'bottom'];
      var verticalAlignmentLabels = ['Top', 'Middle', 'Bottom'];

      var cellBackgroundColor = isInTable && utils$$1.getCurrentCellBackgroundColor(document, selection.focus.key);

      var handleCellColorChange = function handleCellColorChange(color) {
        return function () {
          var hex = utils.mapColorFromColorPickerFromDarkMode(color);
          _this2.props.change(function (change) {
            return change.command(changes.updateCellColorOnSelection, hex);
          });
        };
      };

      return React__default.createElement(
        React__default.Fragment,
        null,
        canInsertTable && React__default.createElement(
          ToolbarMenu,
          { label: 'Insert table', name: 'table-sizer' },
          React__default.createElement(
            ToolbarItem,
            { className: 'table-sizer' },
            React__default.createElement(NewTableSizer, {
              maxRows: 8,
              maxColumns: 8,
              onClick: function onClick(event, rows, columns) {
                trackToolbarAnalytics({
                  eventName: 'User selects toolbar + menu',
                  properties: { 'Toolbar + menu': 'Table' }
                });
                _this2.handleClick(changes.insertTable, rows, columns)(event);
              }
            })
          )
        ),
        canInsertTable && React__default.createElement(ToolbarItem, { divider: true }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.mergeCells),
          disabled: !canMergeCells,
          label: 'Merge cells'
        }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.splitCells),
          disabled: !canSplitCells,
          label: 'Split cells'
        }),
        React__default.createElement(ToolbarItem, { divider: true }),
        React__default.createElement(
          ToolbarMenu,
          {
            label: 'Cell background color',
            name: 'background-color',
            disabled: !isInTable,
            className: 'aha-color-picker__menu'
          },
          React__default.createElement(ColorPickerContainer, {
            currentColor: cellBackgroundColor,
            handleColorChange: handleCellColorChange
          })
        ),
        React__default.createElement(
          ToolbarMenu,
          {
            label: 'Cell vertical alignment',
            name: 'table-valign',
            disabled: !isInTable
          },
          verticalAlignments.map(function (alignment, index) {
            var active = utils$$1.selectionMatchesVerticalAlignment(value, alignment, alignment === 'top');
            return React__default.createElement(ToolbarItem, {
              active: isInTable && active,
              key: index,
              onClick: _this2.handleClick(changes.updateVerticalAlignment, alignment),
              disabled: !isInTable,
              label: verticalAlignmentLabels[index]
            });
          })
        ),
        React__default.createElement(ToolbarItem, { divider: true }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertRowsAbove, 1),
          disabled: !isInTable,
          label: 'Insert row above'
        }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertRowsBelow, 1),
          disabled: !isInTable,
          label: 'Insert row below'
        }),
        this.showBulkModify(selectedRowCount) && React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertRowsAbove, selectedRowCount),
          disabled: !isInTable,
          label: 'Insert ' + selectedRowCount + ' rows above'
        }),
        this.showBulkModify(selectedRowCount) && React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertRowsBelow, selectedRowCount),
          disabled: !isInTable,
          label: 'Insert ' + selectedRowCount + ' rows below'
        }),
        React__default.createElement(ToolbarItem, { divider: true }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertColumnsLeft, 1),
          disabled: !isInTable,
          label: 'Insert column left'
        }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertColumnsRight, 1),
          disabled: !isInTable,
          label: 'Insert column right'
        }),
        this.showBulkModify(selectedColumnCount) && React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertColumnsLeft, selectedColumnCount),
          disabled: !isInTable,
          label: 'Insert ' + selectedColumnCount + ' columns left'
        }),
        this.showBulkModify(selectedColumnCount) && React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.insertColumnsRight, selectedColumnCount),
          disabled: !isInTable,
          label: 'Insert ' + selectedColumnCount + ' columns right'
        }),
        renderIf(canAddSpacing)(function () {
          return React__default.createElement(
            React__default.Fragment,
            null,
            React__default.createElement(ToolbarItem, { divider: true }),
            React__default.createElement(ToolbarItem, {
              onClick: _this2.handleClick(changes.insertSiblingParagraph),
              disabled: !isInTable,
              label: 'Add space above table'
            }),
            React__default.createElement(ToolbarItem, {
              onClick: _this2.handleClick(changes.insertSiblingParagraph, {
                below: true
              }),
              disabled: !isInTable,
              label: 'Add space below table'
            })
          );
        }),
        React__default.createElement(ToolbarItem, { divider: true }),
        renderIf(canResetColumnWidths)(function () {
          return React__default.createElement(ToolbarItem, {
            onClick: _this2.handleClick(changes.removeColumnWidths),
            disabled: !isInTable,
            label: 'Reset column widths'
          });
        }),
        renderIf(canDeleteRow)(function () {
          return React__default.createElement(ToolbarItem, {
            onClick: _this2.handleClick(changes.removeRows, selectedRowCount || 1),
            disabled: !isInTable,
            label: _this2.showBulkModify(selectedRowCount) ? 'Delete ' + selectedRowCount + ' rows' : 'Delete row'
          });
        }),
        renderIf(canDeleteColumn)(function () {
          return React__default.createElement(ToolbarItem, {
            onClick: _this2.handleClick(changes.removeColumns, selectedColumnCount || 1),
            disabled: !isInTable,
            label: _this2.showBulkModify(selectedColumnCount) ? 'Delete ' + selectedColumnCount + ' columns' : 'Delete column'
          });
        }),
        renderIf(canDeleteTable)(function () {
          return React__default.createElement(ToolbarItem, {
            onClick: _this2.handleClick(changes.removeTable, currentTable && currentTable.key),
            disabled: !isInTable,
            label: 'Delete table'
          });
        }),
        React__default.createElement(ToolbarItem, { divider: true }),
        React__default.createElement(ToolbarItem, {
          onClick: this.handleClick(changes.clearSelectedCells),
          disabled: !hasActiveTableSelection,
          label: 'Clear contents'
        })
      );
    }
  }]);
  return TableMenu;
}(React__default.Component);

TableMenu.propTypes = {
  value: PropTypes.instanceOf(Slate__default.Value).isRequired,
  utils: PropTypes.object.isRequired,
  changes: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  preventTableBlockSurrounding: PropTypes.bool,
  disableTableDelete: PropTypes.bool
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleClick = function (changeFunction) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return function (event) {
      var change = _this3.props.change;

      change(function (change) {
        return change.command.apply(change, [changeFunction].concat(args));
      });
    };
  };

  this.showBulkModify = function (selectionSize) {
    return selectionSize > 1;
  };
};

/* To make eslint happy with jsdoc / proptypes */
/* eslint-disable no-unused-vars */
/* eslint-enable no-unused-vars */

/**
 * @augments {React.Component<{node:Block, editor:Editor, attributes:object, readOnly:boolean, isSelected:boolean, isFocused:boolean, selected:boolean, isLastCellInRow:boolean, onTableWidthChange:function, onCellWidthChange:function}>}
 */

var TableCell = function (_React$Component) {
  inherits(TableCell, _React$Component);

  function TableCell() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TableCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.cell = null, _this.closestTableNode = findParent(function (element) {
      return element.tagName.toLowerCase() === 'table';
    }), _this.onResizeIndicatorMoved = function (x, y) {
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;

      var cell = _this.props.attributes.ref.current;
      var cellRect = cell.getClientRects()[0];
      var table = _this.closestTableNode(cell);
      var tableRect = table.getClientRects()[0];

      if (_this.props.isLastCellInRow) {
        _this.props.onTableWidthChange(editor, node, x - tableRect.left);
      } else {
        var columnWidth = (x - cellRect.left) / tableRect.width;
        _this.props.onCellWidthChange(editor, node, columnWidth * 100);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(TableCell, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          node = _props.node,
          editor = _props.editor,
          attributes = _props.attributes,
          children = _props.children,
          selected = _props.selected,
          isMenuCell = _props.isMenuCell,
          disableResize = _props.disableResize,
          isLastCellInRow = _props.isLastCellInRow;


      var modifiable = editor.isModifiable();

      var span = {};
      var style = {};

      if (node.data.get('rowspan')) {
        span.rowSpan = node.data.get('rowspan');
      }

      if (node.data.get('colspan')) {
        span.colSpan = node.data.get('colspan');
      }

      if (node.data.get('verticalAlign')) {
        style.verticalAlign = node.data.get('verticalAlign');
      }

      if (node.data.get('cellColor')) {
        style.backgroundColor = utils.mapColorFromColorPickerToDarkMode(node.data.get('cellColor'));
      }

      var className = classnames({
        selected: selected
      });

      var draggable = modifiable && !(disableResize && isLastCellInRow);

      return React__default.createElement(
        'td',
        _extends({ className: className, style: style }, span, attributes),
        renderIf(draggable)(function () {
          return React__default.createElement(DragHandle, {
            onMoved: _this2.onResizeIndicatorMoved,
            zoomEnabled: _this2.props.zoomEnabled
          });
        }),
        renderIf(modifiable && isMenuCell)(function () {
          return React__default.createElement(
            'div',
            { contentEditable: false, onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
              } },
            React__default.createElement(
              ToolbarMenu,
              { icon: '', label: '', className: 'aha-editor-context-toolbar-btn' },
              React__default.createElement(TableMenu, {
                utils: _this2.props.utils,
                changes: _this2.props.changes,
                change: _this2.props.editor.command.bind(_this2.props.editor),
                value: _this2.props.editor.value,
                preventTableBlockSurrounding: _this2.props.preventTableBlockSurrounding,
                disableTableDelete: _this2.props.disableTableDelete
              })
            )
          );
        }),
        children
      );
    }
  }]);
  return TableCell;
}(React__default.Component);

TableCell.propTypes = {
  node: PropTypes.instanceOf(Slate.Block).isRequired,
  editor: PropTypes.instanceOf(slateReact.Editor).isRequired,
  attributes: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  isMenuCell: PropTypes.bool,
  isSelected: PropTypes.bool,
  isFocused: PropTypes.bool,
  isLastCellInRow: PropTypes.bool,
  selected: PropTypes.bool,
  preventTableBlockSurrounding: PropTypes.bool,
  disableResize: PropTypes.bool,
  disableTableDelete: PropTypes.bool,
  zoomEnabled: PropTypes.bool,
  onTableWidthChange: PropTypes.func.isRequired,
  onCellWidthChange: PropTypes.func.isRequired
};

var ZERO_WIDTH_ATTRIBUTE = 'data-slate-zero-width';
var ZERO_WIDTH_SELECTOR = '[' + ZERO_WIDTH_ATTRIBUTE + ']';
var DATA_ATTRS_FRAGMENT = 'data-slate-fragment';

var TRANSFER_TYPES = {
  FRAGMENT: 'application/x-slate-fragment',
  HTML: 'text/html',
  NODE: 'application/x-slate-node',
  RICH: 'text/rtf',
  TEXT: 'text/plain'
};

/**
 * Slate's `cloneFragment` adds HTML to the clipboard by attaching all
 * of the elements in the browser's range to a DOM element, selecting
 * the DOM element, and either manually attaching the HTML to the
 * clipboard or allowing the copy to go through normally.
 *
 * When the native selection doesn't match the fragment being passed
 * into `cloneFragment`, you will end up with the clipboard's HTML
 * content being different than the copied Slate content.
 *
 * We've defined a full serializer, so it would be more accurate to
 * take the Slate fragment, put it through the serializer, and copy
 * _that_ HTML.
 *
 * That's what this function does. Unfortunately, that means it's a
 * more-or-less complete rewrite of `cloneFragment.` We also need to
 * copy over some constants, because Slate doesn't export them. Code
 * changed from the original Slate version are marked with `CHANGE:`
 *
 * @param {Event} event
 * @param {Serializer} serializer A Serializer instance to convert fragment into html
 * @param {Editor} editor
 * @param {() => void} callback
 * @param {Document} [fragment]
 * @param {String} [textFragment] The plain text version of fragment to copy
 */
function cloneFragmentBySerializing(event, serializer, editor) {
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return undefined;
  };
  var fragment = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : editor.getFragment();
  var textFragment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

  var window = getWindow(event.target);
  var native = window.getSelection();
  var value = editor.value;
  var document = value.document,
      selection = value.selection;
  var start = selection.start;

  var startVoid = document.getClosestVoid(start.path, editor);

  // Create a fake selection so that we can add a Base64-encoded copy of the
  // fragment to the HTML, to decode on future pastes.
  var encoded = Base64.serializeNode(fragment);
  var range = native.getRangeAt(0);

  // CHANGE: create the selected elements from the fragment, instead
  // of the selection.
  var fragmentValue = new Slate.Value({ document: fragment });
  var html = serializer.serialize(fragmentValue);
  var contents = documentFragmentFromHTMLString(html);
  var attach = contents.childNodes[0];

  // Make sure attach is a non-empty node, since empty nodes will not get copied
  contents.childNodes.forEach(function (node) {
    if (node.textContent && node.textContent.trim() !== '') {
      attach = node;
    }
  });

  // CHANGE: Remove code dealing with end void nodes, because they
  // only adjust the native selection, which we don't care about.
  // --snip--

  // COMPAT: If the start node is a void node, we need to attach the encoded
  // fragment to the void node's content node instead of the spacer, because
  // attaching it to empty `<div>/<span>` nodes will end up having it erased by
  // most browsers. (2018/04/27)
  if (startVoid) {
    attach = contents.childNodes[0].childNodes[1].firstChild;
  }

  // Remove any zero-width space spans from the cloned DOM so that they don't
  // show up elsewhere when pasted.
  [].slice.call(contents.querySelectorAll(ZERO_WIDTH_SELECTOR)).forEach(function (zw) {
    var isNewline = zw.getAttribute(ZERO_WIDTH_ATTRIBUTE) === 'n';
    zw.textContent = isNewline ? '\n' : '';
  });

  // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
  // in the HTML, and can be used for intra-Slate pasting. If it's a text
  // node, wrap it in a `<span>` so we have something to set an attribute on.
  if (attach.nodeType === 3) {
    var span = window.document.createElement('span');

    // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
    // then leading and trailing spaces will be ignored. (2017/09/21)
    span.style.whiteSpace = 'pre';

    span.appendChild(attach);
    contents.appendChild(span);
    attach = span;
  }

  attach.setAttribute(DATA_ATTRS_FRAGMENT, encoded);

  // Add the phony content to a div element. This is needed to copy the
  // contents into the html clipboard register.
  var div = window.document.createElement('div');
  div.appendChild(contents);

  // For browsers supporting it, we set the clipboard registers manually,
  // since the result is more predictable.
  // COMPAT: IE supports the setData method, but only in restricted sense.
  // IE doesn't support arbitrary MIME types or common ones like 'text/plain';
  // it only accepts "Text" (which gets mapped to 'text/plain') and "Url"
  // (mapped to 'text/url-list'); so, we should only enter block if !IS_IE
  if (event.clipboardData && event.clipboardData.setData && !slateDevEnvironment.IS_IE) {
    event.preventDefault();

    // CHANGE: Copy the specified text as text/plain, if it's passed
    // in.
    if (textFragment === null) {
      textFragment = div.textContent;
    }
    event.clipboardData.setData(TRANSFER_TYPES.TEXT, textFragment);
    event.clipboardData.setData(TRANSFER_TYPES.FRAGMENT, encoded);
    event.clipboardData.setData(TRANSFER_TYPES.HTML, div.innerHTML);
    return;
  }

  // COMPAT: For browser that don't support the Clipboard API's setData method,
  // we must rely on the browser to natively copy what's selected.
  // So we add the div (containing our content) to the DOM, and select it.
  var editorEl = event.target.closest('[data-slate-editor]');
  div.setAttribute('contenteditable', true);
  div.style.position = 'absolute';
  div.style.left = '-9999px';
  editorEl.appendChild(div);
  native.selectAllChildren(div);

  // Revert to the previous selection right after copying.
  window.requestAnimationFrame(function () {
    editorEl.removeChild(div);
    removeAllRanges(native);
    native.addRange(range);
    callback();
  });
}

/**
 * Duplicate of the Slate version.
 */
function removeAllRanges(domSelection) {
  // COMPAT: In IE 11, if the selection contains nested tables, then
  // `removeAllRanges` will throw an error.
  if (slateDevEnvironment.IS_IE) {
    var range = window.document.body.createTextRange();
    range.collapse();
    range.select();
  } else {
    domSelection.removeAllRanges();
  }
}

/**
 * Given a string of HTML, returns a DOM DocumentFragment with the DOM
 * tree representing that string.
 */
function documentFragmentFromHTMLString(html) {
  var container = document.createElement('div');
  container.innerHTML = html;
  var contents = document.createDocumentFragment();
  container.childNodes.forEach(function (node) {
    contents.appendChild(node);
  });
  return contents;
}

function Plugin(options, utils, changes, pluginState) {
  var shouldUpdateSelection = true;
  var shouldClearSelection = false;
  var isUpdatingSelection = false;
  var TableContext = React__default.createContext({});
  var TableCellContext = React__default.createContext({});

  var renderBlock = function renderBlock(props, editor, next) {
    var node = props.node;

    switch (node.type) {
      case options.tableType:
        return React__default.createElement(
          TableContext.Consumer,
          null,
          function (tableSelection) {
            return React__default.createElement(Table, _extends({
              columnWidths: utils.getColumnWidths(node),
              selectedKey: tableSelection && tableSelection.key,
              cellContext: TableCellContext,
              selected: tableSelection.isTableSelected(node.key),
              selection: tableSelection,
              onSelectionUpdate: onSelectionUpdate,
              menuIdentifier: options.menuIdentifier
            }, props));
          }
        );
      case options.tableRowType:
        return React__default.createElement(TableRow, _extends({
          tableCellType: options.tableCellType,
          value: props.editor.value,
          utils: utils,
          selection: utils.getTableSelection(props.editor.value)
        }, props));
      case options.tableCellType:
        var document = props.editor.value.document;

        return React__default.createElement(
          TableCellContext.Consumer,
          null,
          function (_ref) {
            var tableSelection = _ref.tableSelection,
                entireTableSelected = _ref.entireTableSelected;
            return React__default.createElement(TableCell, _extends({
              selected: entireTableSelected || tableSelection && tableSelection.isCellSelected(node.key),
              selection: utils.getTableSelection(props.editor.value),
              isFocused: utils.isCellFocused(props.editor.value, node),
              isLastCellInRow: utils.isLastCellInRow(document, node),
              isMenuCell: utils.isTableMenuCell(props.editor.value, node.key),
              onCellWidthChange: onCellWidthChange,
              onTableWidthChange: onTableWidthChange,
              utils: utils,
              changes: changes,
              preventTableBlockSurrounding: document.data.get('preventTableBlockSurrounding'),
              disableResize: options.disableResize,
              disableTableDelete: options.disableTableDelete,
              zoomEnabled: options.zoomEnabled
            }, props));
          }
        );
      default:
    }
    return next();
  };

  // Slate calls onSelect whenever the selection state changes,
  // usually triggered by the browser's onSelectionChange. This
  // includes things like shift-clicking into a table cell, or
  // shift-moving the cursor. However, it will sometimes only trigger
  // after onMouseUp, will only trigger when the selection changes by
  // moving into a different text node (which doesn't help when
  // dragging into cell margins), and will sometimes stop getting
  // called entirely in Firefox, so we can't rely on it for
  // everything.
  function onSelect(event, editor, next) {
    if (shouldClearSelection) {
      editor.command(changes.clearCellSelection);
      shouldClearSelection = false;
    }

    if (!shouldUpdateSelection) return true;
    var native = window.getSelection();

    if (native.rangeCount > 1) {
      // COMPAT: Firefox has its own implementation of grid table
      // selection that interferes with ours. In particular, it gives
      // us multiple ranges, which Slate doesn't handle, and those
      // ranges don't refer to text nodes, which Slate especially
      // doesn't handle well. Here, we block the default Slate
      // onSelect and force the selection to match the table selection
      // instead.
      return utils.getTableSelection(editor.value).select(editor);
    }

    var range = editor.findRange(native);

    // If we don't have a range, it usually means that the browser
    // extended the selection into a node that we don't control. This
    // usually happens during triple-click. The most natural thing to
    // do is to expand it to fill the last block it was in.
    if (!range) {
      return editor.moveToStartOfBlock().moveFocusToEndOfBlock();
    }

    changes.updateSelection(editor, range);
    return next();
  }

  // This method is called, while left-button-dragging, on mouseOver
  // of any child of a table. We need this method to make selection
  // faster and more accurate, because this will get fired for
  // non-text nodes, like dragging into the padding of a cell. It
  // feels _way_ better.
  //
  // Since 2D table selection highlights cells, not the contents
  // within that cell, we don't need to give it a text node, just a
  // cell node. So we prefer to use event.target here, instead of
  // selection.focus.
  //
  // Also, Firefox seems to stop triggering onSelectionChange
  // once we set up a cell selection, which means that it will
  // eventually stop calling onSelect -- this is a way to make sure
  // the selection still gets updated in Firefox.
  function onSelectionUpdate(event, editor) {
    var value = editor.value;

    var range = editor.findRange(window.getSelection()) || value.selection;
    var targetNode = editor.findNode(event.target);
    isUpdatingSelection = true;

    if (!targetNode) {
      return changes.updateSelection(editor, range, range.focus.key);
    }

    var targetText = targetNode.object === 'text' ? targetNode : targetNode.getFirstText();

    if (targetText && targetNode === targetText) {
      return changes.updateSelection(editor, range, targetText.key);
    }

    // Sometimes, the mouseover target node can be a parent of the
    // focus node -- a paragraph block, for example. If that's the
    // case, using offset 0 of the target block will mess with the
    // selection in a way that can lose the selection in Chrome, so
    // we'll defer to the child focus node instead.
    if (targetNode.hasDescendant(range.focus.path)) {
      return changes.updateSelection(editor, range, range.focus.key);
    }

    return changes.updateSelection(editor, range, targetText.key);
  }

  // Whenever our editor is given a changed value, if the selection
  // inside that value would cause a 2D cell selection, we _must_ show
  // the 2D table selection. Otherwise, it's possible to mangle a
  // table. For example, if we don't have a cell selection, then
  // "delete" will actually delete cells entirely, rather than
  // clearing the cell contents. In some cases, this can corrupt
  // documents.
  //
  // Unfortunately, onSelect isn't called for programmatic selection
  // changes, like undo. This means it's very possible for an undo not
  // to restore the table selection properly. onChange is one of the
  // few places we can guarantee will run on every selection
  // change. So, every time Slate performs an operation, we will check
  // to make sure that table selection is up-to-date with the new
  // value.
  function onChange(editor, next) {
    if (editor.operations.size === 0) return next();
    if (isUpdatingSelection) {
      // This onChange was triggered by our own
      // onSelectionUpdate. We've already updated the selection, so no
      // need to do it again. If we do, we may overwrite a better
      // selection (one triggered by the onMouseOver) with a worse one
      // (the one in the Slate value) -- this happens if you drag into
      // a cell, but not a text node within the cell.
      isUpdatingSelection = false;
      return next();
    }

    changes.refreshTableSelection(editor);
    return next();
  }

  function _onMouseDown(event, editor) {
    if (!editor.isModifiable()) return;
    if (event.button === 2) {
      // We want to ignore any selection events that happen because we
      // right-clicked inside a table. Otherwise the selection event
      // conflicts with the popup menu event.
      var value = editor.value;
      var document = value.document;

      var clickedNode = editor.findNode(event.target);
      if (!clickedNode) return;

      // These actions are only relevant when multiple cells are selected, if
      // there is no selection then we can exit early, preventing the cursor
      // from being moved to the start of the node.
      if (!utils.getTableSelection(value).selectedCellKeys.size) return;
      if (utils.getClosestTableByKey(document, clickedNode.key)) {
        shouldUpdateSelection = false;
        setTimeout(function () {
          shouldUpdateSelection = true;
        }, 200);

        var cell = utils.getClosestTableCellByKey(document, clickedNode.key);
        if (cell && !utils.isCellSelected(value, cell.key)) {
          editor.command(changes.clearCellSelection).moveToStartOfNode(cell);
        }
      }
    } else {
      shouldClearSelection = true;
    }
  }

  function onBeforeInput(event, editor, next) {
    if (utils.hasActiveTableSelection(editor.value)) {
      editor.command(changes.clearSelectedCells).command(changes.moveToEndOfCellSelection);
    }
    return next();
  }

  function onTableWidthChange(editor, cell, newWidth) {
    var table = utils.getClosestTableByKey(editor.value.document, cell.key);
    return editor.command(changes.clearCellSelection).command(changes.updateTableWidth, table, newWidth);
  }

  function onCellWidthChange(editor, cell, newWidth) {
    return editor.command(changes.clearCellSelection).moveToStartOfNode(cell).command(changes.updateColumnWidth, cell, newWidth);
  }

  function onCutOrCopy(event, editor) {
    var value = editor.value;

    var fragment = utils.getFragmentAtSelectedCellPositions(value.document, utils.getTableSelection(value));
    if (fragment && options.serializer) {
      var textFragment = utils.getTSVFromTableFragment(fragment);
      cloneFragmentBySerializing(event, options.serializer, editor, function () {
        return undefined;
      }, fragment, textFragment);
      return true;
    }
  }

  function onCopy(event, editor, next) {
    if (onCutOrCopy(event, editor)) {
      return true;
    } else {
      return next();
    }
  }

  function onCut(event, editor, next) {
    if (onCutOrCopy(event, editor)) {
      window.requestAnimationFrame(function () {
        editor.command(changes.clearSelectedCells);
      });
      return true;
    } else {
      return next();
    }
  }

  var EditorWithTableState = function EditorWithTableState(_ref2) {
    var editor = _ref2.editor,
        children = _ref2.children;

    var _useState = React.useState(new TableSelection({ utils: utils })),
        _useState2 = slicedToArray(_useState, 2),
        tableSelection = _useState2[0],
        setTableSelection = _useState2[1];

    var _useState3 = React.useState(tableSelection),
        _useState4 = slicedToArray(_useState3, 2),
        tableContextValue = _useState4[0],
        setTableContextValue = _useState4[1];

    pluginState.tableSelection = tableSelection;
    pluginState.setTableSelection = function (newTableSelection) {
      if (newTableSelection.equals(tableSelection)) return;

      pluginState.tableSelection = tableSelection;
      setTableSelection(newTableSelection);
      setTableContextValue(newTableSelection);
    };

    return React__default.createElement(
      TableContext.Provider,
      { value: tableContextValue },
      children
    );
  };

  function EditorWithTableSelection(_ref3) {
    var editor = _ref3.editor,
        children = _ref3.children;

    return React__default.createElement(
      React__default.Fragment,
      null,
      React__default.createElement(
        'div',
        { onMouseDown: function onMouseDown(event) {
            return _onMouseDown(event, editor);
          } },
        children
      )
    );
  }

  function renderEditor(props, editor, next) {
    return React__default.createElement(
      EditorWithTableState,
      { editor: editor },
      React__default.createElement(
        EditorWithTableSelection,
        { editor: editor },
        next()
      )
    );
  }

  function onCommand(_ref4, editor, next) {
    var type = _ref4.type,
        args = _ref4.args;

    switch (type) {
      case 'delete':
        editor.command(changes.removeTablesAtEdgeOfSelection);
        return next();
      case 'toggleMark':
        var _args = slicedToArray(args, 1),
            markType = _args[0];

        return editor.command(changes.toggleMarkOnSelection, markType);
      case 'setFontSize':
      case 'setFont':
      case 'setLineHeight':
      case 'setAlignment':
        // assumes the functions only take 2 arguments
        var _args2 = slicedToArray(args, 2),
            firstArg = _args2[0],
            _options = _args2[1];

        if (!(_options && _options.ignoreTableSelections)) {
          return editor.command(utils.withCellSelection(function (editor) {
            return editor[type](firstArg, { ignoreTableSelections: true });
          }));
        }
        break;
      default:
    }
    return next();
  }

  var queries = {
    getClone: function getClone(editor) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return new Slate.Editor(options, attrs);
    },
    hasTableSelection: function hasTableSelection(editor) {
      var value = editor.value;


      return utils.hasActiveTableSelection(value) || utils.isEntireTableAtPointSelected(value, value.selection.anchor) || utils.isEntireTableAtPointSelected(value, value.selection.focus);
    },
    getActiveMarks: function getActiveMarks(editor) {
      return utils.getTableSelection(editor.value).reduceSelectedCells(editor, function (acc, tempEditor) {
        if (acc && acc.isEmpty()) return acc;
        var _tempEditor$value = tempEditor.value,
            document = _tempEditor$value.document,
            selection = _tempEditor$value.selection;


        var marks = selection.marks || tempEditor.getActiveMarksAtRange(selection, document);

        if (acc) {
          return acc.intersect(marks);
        } else {
          return Immutable.Set(marks);
        }
      }, null);
    }
  };

  return {
    plugins: [{
      renderBlock: renderBlock,
      renderEditor: renderEditor,
      onBeforeInput: onBeforeInput,
      onChange: onChange,
      onSelect: onSelect,
      onCopy: onCopy,
      onCut: onCut,
      onCommand: onCommand,
      queries: queries
    }].concat(toConsumableArray(Schema(options, utils, changes)), [KeyPresses(options, utils, changes), DisableMarksBetweenCells(options, utils)])
  };
}

var MIN_COLUMN_WIDTH = 3;

function Changes(options, utils, pluginState) {
  function newTableCell() {
    var paragraph = Slate__default.Block.create({
      type: 'paragraph'
    });
    return Slate__default.Block.create({
      type: options.tableCellType,
      nodes: [paragraph],
      data: {}
    });
  }

  function newTableRow(columns) {
    return Slate__default.Block.create({
      type: options.tableRowType,
      nodes: columns
    });
  }

  function newTable(rows) {
    return {
      type: options.tableType,
      nodes: rows
    };
  }

  function insertTable(change) {
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    var rows = Immutable.Range(0, height).map(function (row) {
      var columns = Immutable.Range(0, width).map(function (column) {
        return newTableCell();
      });
      return newTableRow(columns.toList());
    }).toList();

    change.insertBlock(newTable(rows));
    var table = utils.getClosestTable(change);
    change.command(insertSiblingParagraphToTable, table, { below: true });
    return change.moveToStartOfNode(table);
  }

  function insertRow(change, row) {
    var insertOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var table = utils.getClosestTable(change);
    var tableStructure = utils.getStructureOfTable(table);
    var columnNodes = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = tableStructure.cellsInRow(row)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var node = _step.value;

        var startRow = tableStructure.positionOfCell(node).row;
        var colspan = tableStructure.colspan(node);
        var rowspan = tableStructure.rowspan(node);
        var isInsideRowspan = row + insertOffset > startRow && row + insertOffset < startRow + rowspan;

        if (isInsideRowspan) {
          change.setNodeByKey(node.key, {
            data: node.data.set('rowspan', rowspan + 1)
          });
        } else {
          var newCell = newTableCell();
          if (colspan > 1) {
            newCell = newCell.merge({
              data: newCell.data.set('colspan', colspan)
            });
          }
          columnNodes.push(newCell);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return change.insertNodeByKey(table.key, row + insertOffset, newTableRow(columnNodes));
  }

  function insertColumn(change, column) {
    var insertOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var table = utils.getClosestTable(change);
    var tableStructure = utils.getStructureOfTable(table);

    change.withoutNormalizing(function (c) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = tableStructure.cellsInColumn(column)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var node = _step2.value;

          var _tableStructure$posit = tableStructure.positionOfCell(node),
              row = _tableStructure$posit.row,
              startColumn = _tableStructure$posit.column;

          var colspan = tableStructure.colspan(node);
          var rowspan = tableStructure.rowspan(node);
          var isInsideColspan = column + insertOffset > startColumn && column + insertOffset < startColumn + colspan;

          if (isInsideColspan) {
            c.setNodeByKey(node.key, {
              data: node.data.set('colspan', colspan + 1)
            });
          } else {
            var newCell = newTableCell();
            if (rowspan > 1) {
              newCell = newCell.merge({
                data: newCell.data.set('rowspan', rowspan)
              });
            }
            var rowNode = table.nodes.get(row);
            c.insertNodeByKey(rowNode.key, tableStructure.nodeIndex({ row: row, column: column + insertOffset }), newCell);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    });

    return change.command(insertColumnWidth, table.key, column + insertOffset);
  }

  function insertCell(change, table, row, column) {
    var tableStructure = utils.getStructureOfTable(table);
    var insertIndex = tableStructure.nodeIndex({ row: row, column: column });
    var rowNode = change.value.document.getDescendant(table.key).nodes.get(row);

    if (!rowNode) {
      change.insertNodeByKey(table.key, row, newTableRow([]));
      rowNode = change.value.document.getDescendant(table.key).nodes.get(row);
    }

    change.insertNodeByKey(rowNode.key, insertIndex, newTableCell());
  }

  function removeEmptyTable(change, table) {
    if (table.getBlocks().isEmpty() || table.nodes.every(function (row) {
      return row.getBlocks().isEmpty();
    })) {
      change.removeNodeByKey(table.key);
    }
    return change;
  }

  function removeTable(change, tableKey) {
    var table = change.value.document.getDescendant(tableKey);
    if (!table) return;
    return change.removeNodeByKey(table.key);
  }

  function removeRow(change, tableKey, index) {
    var document = change.value.document;

    var table = document.getDescendant(tableKey);
    var tableStructure = utils.getStructureOfTable(table);
    var oldRowSpans = [];

    // Compensate for cells we move into the next row
    var indexCompensation = 0;

    change.withoutNormalizing(function (c) {
      Array.from(tableStructure.cellsInRow(index)).forEach(function (cell) {
        var position = tableStructure.positionOfCell(cell);
        var rowspan = tableStructure.rowspan(cell);

        // record any cells that extend into this row from above,
        // because we will need to shrink their rowspan to account for
        // this row being removed.
        if (position.row !== index) {
          oldRowSpans.push({
            position: { row: index, column: position.column },
            rowspan: rowspan
          });
        } else {
          // move any cells starting at this row with rowspans into
          // the next row
          if (rowspan && rowspan > 1) {
            var newPosition = {
              row: index + 1,
              column: position.column
            };
            var nodeIndex = tableStructure.nodeIndex(newPosition) + indexCompensation;

            c.moveNodeByKey(cell.key, table.nodes.get(newPosition.row).key, nodeIndex);

            indexCompensation++;

            // record it to reset rowspan
            oldRowSpans.push({
              position: position,
              rowspan: rowspan
            });
          }
        }
      });

      // remove the row
      c.removeNodeByKey(table.nodes.get(index).key);

      // restore rowspans for  merged cells
      oldRowSpans.forEach(function (oldRowSpan) {
        var newStructure = utils.getStructureOfTable(c.value.document.getDescendant(table.key));
        var cell = newStructure.cellInPosition(oldRowSpan.position);

        var newSpan = oldRowSpan.rowspan - 1;
        var newData = newSpan > 1 ? cell.data.set('rowspan', newSpan) : cell.data.delete('rowspan');

        c.setNodeByKey(cell.key, {
          data: newData
        });
      });
    });

    table = change.value.document.getDescendant(table.key);
    return change.moveToStartOfNode(table).command(removeEmptyTable, table);
  }

  function removeColumn(change, tableKey, index) {
    var document = change.value.document;

    var table = document.getDescendant(tableKey);
    var tableStructure = utils.getStructureOfTable(table);
    var oldColSpans = [];

    change.withoutNormalizing(function (c) {
      Array.from(tableStructure.cellsInColumn(index)).forEach(function (cell) {
        var position = tableStructure.positionOfCell(cell);
        var colspan = cell.data.get('colspan');

        // record any merged columns in the row
        if (position.column !== index) {
          oldColSpans.push({
            position: { row: position.row, column: position.column },
            colspan: colspan
          });
        } else {
          // special case for cells starting at this col with colspans
          if (colspan && colspan > 1) {
            var newPosition = {
              row: position.row,
              column: position.column + 1
            };
            // add another node to the row as this one will be deleted
            c.insertNodeByKey(table.nodes.get(newPosition.row).key, newPosition.column, JSON.parse(JSON.stringify(cell)));

            // record it to set rowspan
            oldColSpans.push({
              position: position,
              colspan: colspan
            });
          }
        }
      });

      Array.from(tableStructure.cellsInColumn(index)).forEach(function (cell) {
        var position = tableStructure.positionOfCell(cell);
        if (position.column === index) {
          c.removeNodeByKey(cell.key);
        }
      });

      // restore colspans for  merged cells
      oldColSpans.forEach(function (oldColSpan) {
        var newStructure = utils.getStructureOfTable(c.value.document.getDescendant(table.key));
        var cell = newStructure.cellInPosition(oldColSpan.position);

        var newSpan = oldColSpan.colspan - 1;
        var newData = newSpan > 1 ? cell.data.set('colspan', newSpan) : cell.data.delete('colspan');

        c.setNodeByKey(cell.key, {
          data: newData
        });
      });
    });

    table = change.value.document.getDescendant(table.key);
    return change.moveToStartOfNode(table).command(removeColumnWidth, table.key, index).command(removeEmptyTable, table);
  }

  function repeatChangesAtPosition(change, count, changeFunction) {
    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    return change.withoutNormalizing(function (change) {
      Immutable.Range(0, count).forEach(function () {
        change.command.apply(change, [changeFunction].concat(args));
      });
    });
  }

  function findCellPosition(value, startOrEnd) {
    var tableSelection = utils.getTableSelection(value);
    var position = tableSelection[startOrEnd + 'Position'];
    if (!position) {
      position = utils.getPositionOfKeyInTable(value, value.selection[startOrEnd].key);
    }

    // If we're looking for the end of a cell, and the cell has
    // rowspan or colspan, we should use the bottom-right position of
    // it instead of the top-left. For example, if it's a 2x2 cell
    // starting at row 1, column 2, we should use row 2, column 3 as
    // the position. This makes it act more consistently.
    if (startOrEnd === 'end') {
      var table = utils.getClosestTableByKey(value.document, value.selection.end.key);
      var tableStructure = utils.getStructureOfTable(table);
      var cell = tableStructure.cellInPosition(position);

      return tableStructure.rangeOfCell(cell).endPosition;
    }

    return position;
  }

  function insertRowsAbove(change, count) {
    var position = findCellPosition(change.value, 'start');
    change.command(repeatChangesAtPosition, count, insertRow, position.row);
  }

  function insertRowsBelow(change, count) {
    var position = findCellPosition(change.value, 'end');
    change.command(repeatChangesAtPosition, count, insertRow, position.row, 1);
  }

  function insertColumnsLeft(change, count) {
    var position = findCellPosition(change.value, 'start');
    change.command(repeatChangesAtPosition, count, insertColumn, position.column);
  }

  function insertColumnsRight(change, count) {
    var position = findCellPosition(change.value, 'end');
    change.command(repeatChangesAtPosition, count, insertColumn, position.column, 1);
  }

  function removeRows(change, count) {
    var position = findCellPosition(change.value, 'start');
    change.command(clearCellSelection);

    var table = utils.getClosestTable(change);
    var tableStructure = utils.getStructureOfTable(table);

    // If every cell in a row spans multiple rows, we want to fully
    // remove that row, not partially remove it.
    count = Math.max(count, tableStructure.minimumRowspan(position.row));
    change.command(repeatChangesAtPosition, count, removeRow, table.key, position.row);
  }

  function removeColumns(change, count) {
    var position = findCellPosition(change.value, 'start');
    change.command(clearCellSelection);

    var table = utils.getClosestTable(change);
    var tableStructure = utils.getStructureOfTable(table);

    // If every cell in a column spans multiple columns, we want to fully
    // remove that column, not partially remove it.
    count = Math.max(count, tableStructure.minimumColspan(position.column));
    change.command(repeatChangesAtPosition, count, removeColumn, table.key, position.column);
  }

  function insertSiblingParagraph(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var table = utils.getClosestTable(editor);

    var _insertSiblingParagra = insertSiblingParagraphToTable(editor, table, options),
        parent = _insertSiblingParagra.parent,
        index = _insertSiblingParagra.index;

    editor.moveToStartOfNode(editor.reloadNode(parent).nodes.get(index));
  }

  function insertSiblingParagraphToTable(editor, table) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _below$options = _extends({ below: false }, options),
        below = _below$options.below;

    var parent = editor.value.document.getParent(table.key);
    var index = parent.nodes.indexOf(table);
    index = below ? index + 1 : index;
    var paragraph = {
      object: 'block',
      type: 'paragraph',
      nodes: [{
        object: 'text',
        text: ''
      }]
    };

    editor.insertNodeByKey(parent.key, index, paragraph);
    return { parent: parent, index: index };
  }

  function removePreviousParagraph(editor) {
    var table = utils.getClosestTable(editor);
    var document = editor.value.document;

    var previous = document.getPreviousSibling(table.key);

    if (editor.isEmptyBlock(previous)) {
      editor.removeNodeByKey(previous.key);
    }
  }

  function mergeCells(change) {
    var tableSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils.getTableSelection(change.value);

    return change.command(mergeCellsInRange, tableSelection.table, tableSelection.range);
  }

  function mergeCellsInRange(change, table, range) {
    var structure = utils.getStructureOfTable(table);
    var selectedCells = Immutable.List(structure.cellsInRange(range));
    var destinationCell = selectedCells.first();
    var mergedCells = selectedCells.rest();
    var selectionSize = structure.dimensionsOfRange(range);
    var data = destinationCell.data.delete('rowspan').delete('colspan');
    var nodeIndex = destinationCell.nodes.size;

    change.withoutNormalizing(function (c) {
      mergedCells.forEach(function (cell) {
        if (!utils.isEmptyCell(cell)) {
          cell.nodes.forEach(function (node) {
            c.moveNodeByKey(node.key, destinationCell.key, nodeIndex);
            nodeIndex++;
          });
        }
        c.removeNodeByKey(cell.key);
      });

      if (selectionSize.rows > 1) {
        data = data.set('rowspan', selectionSize.rows);
      }

      if (selectionSize.columns > 1) {
        data = data.set('colspan', selectionSize.columns);
      }
      c.setNodeByKey(destinationCell.key, { data: data });
    });

    return change.moveToStartOfNode(destinationCell);
  }

  /**
   * Splits a cell that spans multiple rows or columns into two cells
   * at the specified point. This is useful for removing rows /
   * columns (because we can create an entire row of rowspan: 1 rows,
   * and wipe it out all at once). It will probably also be useful for
   * copy / paste.
   */
  function splitMergedCellAtPoint(change, tableKey, position, index, splitByRowOrColumn) {
    var document = change.value.document;

    var table = document.getDescendant(tableKey);
    var tableStructure = utils.getStructureOfTable(table);
    var cell = tableStructure.cellInPosition(position);
    var startPosition = tableStructure.positionOfCell(cell);
    var startIndex = void 0,
        property = void 0,
        span = void 0;
    if (splitByRowOrColumn === 'row') {
      startIndex = startPosition.row;
      property = 'rowspan';
      span = tableStructure.rowspan(cell);
    } else {
      startIndex = startPosition.column;
      property = 'colspan';
      span = tableStructure.colspan(cell);
    }

    if (span <= 1) return change;
    if (index <= startIndex) return change;
    if (index >= startIndex + span) return change;

    change.withoutNormalizing(function (c) {
      // Split off a new cell, same as the old cell
      c.splitNodeByKey(cell.nodes.last().key, cell.nodes.last().size);
      c.splitNodeByKey(cell.key, cell.nodes.size);

      // Update the rowspan of the original cell
      var updatedSpan = index - startIndex;
      var updatedData = updatedSpan > 1 ? cell.data.set(property, updatedSpan) : cell.data.delete(property);
      c.setNodeByKey(cell.key, { data: updatedData });

      // Update the rowspan of the new cell
      var newCell = c.value.document.getNextSibling(cell.key);
      var newSpan = span - updatedSpan;
      var newData = newSpan > 1 ? cell.data.set(property, newSpan) : cell.data.delete(property);
      c.setNodeByKey(newCell.key, {
        data: newData
      });

      if (splitByRowOrColumn === 'row') {
        // Move the new cell into the correct position in the table
        var indexInRow = tableStructure.nodeIndex({
          row: index,
          column: position.column
        });
        c.moveNodeByKey(newCell.key, table.nodes.get(index).key, indexInRow);
      }
    });
    return change;
  }

  function splitCells(change) {
    return change.withoutNormalizing(function (c) {
      return utils.getMergedCellsInCurrentRange(change.value).forEach(function (cell) {
        return c.command(splitMergedCell, cell);
      });
    });
  }

  function splitMergedCell(change, cell) {
    var colspan = cell.data.get('colspan') || 1;
    var rowspan = cell.data.get('rowspan') || 1;
    var table = utils.getClosestTableByKey(change.value.document, cell.key);
    var tableStructure = utils.getStructureOfTable(table);

    var _tableStructure$posit2 = tableStructure.positionOfCell(cell),
        startRow = _tableStructure$posit2.row,
        startColumn = _tableStructure$posit2.column;

    change.withoutNormalizing(function (change) {
      for (var row = startRow; row < startRow + rowspan; row++) {
        var index = tableStructure.nodeIndex({ row: row, column: startColumn });
        var rowNode = table.nodes.get(row);

        for (var column = index; column < index + colspan; column++) {
          if (row === startRow && column === index) continue;
          change.insertNodeByKey(rowNode.key, column, newTableCell());
        }
      }

      change.setNodeByKey(cell.key, {
        data: cell.data.delete('colspan').delete('rowspan')
      });
    });
    return change;
  }

  function matchSizeOfCell(change, table, position, cell) {
    var structure = utils.getStructureOfTable(table);
    var rowspan = structure.rowspan(cell);
    var colspan = structure.colspan(cell);

    var range = new TableRange({
      anchorPosition: position,
      focusPosition: {
        row: position.row + rowspan - 1,
        column: position.column + colspan - 1
      }
    });

    var startPosition = range.startPosition,
        endPosition = range.endPosition;


    Array.from(structure.cellsInRange(range)).forEach(function (cell) {
      var originalCellPosition = structure.positionOfCell(cell);
      var cellPosition = {
        row: Math.max(originalCellPosition.row, startPosition.row),
        column: Math.max(originalCellPosition.column, startPosition.column)
      };
      change.command(splitMergedCellAtPoint, table.key, cellPosition, startPosition.row, 'row').command(splitMergedCellAtPoint, table.key, cellPosition, endPosition.row + 1, 'row').command(splitMergedCellAtPoint, table.key, cellPosition, range.startPosition.column, 'column').command(splitMergedCellAtPoint, table.key, cellPosition, range.endPosition.column + 1, 'column');
    });

    table = change.value.document.getDescendant(table.key);
    return change.command(mergeCellsInRange, table, range);
  }

  function updateColumnWidthData(change, table, columnWidths) {
    var roundedWidths = utils.roundToTotal(columnWidths);
    return change.setNodeByKey(table.key, {
      data: table.data.merge({ columnWidths: roundedWidths })
    });
  }

  function initializeColumnWidths(change, table) {
    var tableSize = utils.getTableSize(table);
    var defaultColumnSize = 100 / tableSize.columns;
    var columnWidths = Immutable.List();
    Immutable.Range(0, tableSize.columns).forEach(function (index) {
      columnWidths = columnWidths.set(index, defaultColumnSize);
    });
    return change.command(updateColumnWidthData, table, columnWidths);
  }

  function insertColumnWidth(change, tableKey, index) {
    var table = change.value.document.getDescendant(tableKey);
    var columnWidths = utils.getColumnWidths(table);
    if (columnWidths.isEmpty()) return;

    // Use the width of the preceding cell. Might want to take optionally take selection into account here.
    var normalizedColumnWidths = utils.normalizeColumnWidths(columnWidths);
    var targetWidthIndex = index === 0 ? index : index - 1;
    var targetWidth = normalizedColumnWidths.get(targetWidthIndex);
    return change.command(updateColumnWidthData, table, normalizedColumnWidths.insert(index, targetWidth)).command(redistributeColumnWidths, table.key, normalizedColumnWidths);
  }

  function removeColumnWidth(change, tableKey, index) {
    var table = change.value.document.getDescendant(tableKey);
    var columnWidths = utils.getColumnWidths(table);
    if (columnWidths.isEmpty()) return;

    var normalizedColumnWidths = utils.normalizeColumnWidths(columnWidths);
    return change.command(updateColumnWidthData, table, normalizedColumnWidths.delete(index)).command(redistributeColumnWidths, table.key, normalizedColumnWidths);
  }

  function redistributeColumnWidths(change, tableKey, originalColumnWidths) {
    var table = change.value.document.getDescendant(tableKey);
    var columnWidths = utils.getColumnWidths(table);
    var normalizedColumnWidths = utils.normalizeColumnWidths(columnWidths);

    var totalOriginalSize = 100;
    var totalNewSize = normalizedColumnWidths.reduce(function (sum, n) {
      return sum + n;
    }, 0);
    var sizeRatio = totalOriginalSize / totalNewSize;

    return change.command(updateColumnWidthData, table, normalizedColumnWidths.map(function (width) {
      return width * sizeRatio;
    }));
  }

  function removeColumnWidths(change) {
    var table = utils.getClosestTable(change);

    return change.setNodeByKey(table.key, {
      data: table.data.remove('columnWidths')
    });
  }

  function updateColumnWidth(change, cell, newWidth) {
    if (newWidth < MIN_COLUMN_WIDTH) return;
    var table = utils.getClosestTableByKey(change.value.document, cell.key);

    if (utils.getColumnWidths(table).isEmpty()) {
      initializeColumnWidths(change, table);
      table = utils.getClosestTableByKey(change.value.document, cell.key);
    }

    var columnWidths = utils.getColumnWidths(table);
    var structure = utils.getStructureOfTable(table, cell);

    var _structure$rangeOfCel = structure.rangeOfCell(cell),
        startPosition = _structure$rangeOfCel.startPosition,
        endPosition = _structure$rangeOfCel.endPosition;

    // If we're resizing a cell that spans multiple columns, we only want
    // to change the width of the last column in the span.


    var unchangedWidth = columnWidths.slice(startPosition.column, endPosition.column).reduce(function (totalWidth, width) {
      return totalWidth + width;
    }, 0);

    var newColumnWidth = newWidth - unchangedWidth;
    if (newColumnWidth < MIN_COLUMN_WIDTH) return;

    var siblingPosition = endPosition.column + 1;
    var sizeDifference = newColumnWidth - columnWidths.get(endPosition.column);
    var siblingWidth = columnWidths.get(siblingPosition);
    var newSiblingWidth = siblingWidth - sizeDifference;

    // Maybe seed off minWidth
    if (newSiblingWidth < MIN_COLUMN_WIDTH) return;

    return change.command(updateColumnWidthData, table, columnWidths.set(endPosition.column, newColumnWidth).set(siblingPosition, newSiblingWidth));
  }

  function updateTableWidth(change, table, newWidth) {
    return change.setNodeByKey(table.key, {
      data: table.data.merge({ width: newWidth })
    });
  }

  function updateVerticalAlignment(change, newAlignment) {
    var selectedNodes = utils.getSelectedTableCellNodes(change.value);

    return selectedNodes.forEach(function (cell) {
      change.setNodeByKey(cell.key, {
        data: cell.data.set('verticalAlign', newAlignment)
      });
    });
  }

  function moveToRangeOfPreviousCell(change, key) {
    var targetCell = utils.getPreviousCellByKey(change.value.document, key);
    if (!targetCell) return change;
    return change.moveToRangeOfNode(targetCell);
  }

  function moveToRangeOfNextCell(change, key) {
    var targetCell = utils.getNextCellByKey(change.value.document, key);
    if (!targetCell) {
      // If we can't find a target cell, we'll create a new row, and
      // try again. This matches the behavior of Google Docs, Dropbox, etc.
      var table = utils.getClosestTableByKey(change.value.document, key);
      if (!table) return;
      change.command(insertRow, table.nodes.size - 1, 1);
      targetCell = utils.getNextCellByKey(change.value.document, key);
    }
    return change.moveToRangeOfNode(targetCell);
  }

  function extendSelectionToKey(change, range, targetKey) {
    var value = change.value;

    var tableSelection = utils.getTableSelection(value);

    pluginState.setTableSelection(tableSelection.withSelectionExtendedToKey(value.document, range, targetKey));
  }

  function refreshTableSelection(change) {
    return extendSelectionToKey(change, change.value.selection, change.value.selection.focus.key);
  }

  function toggleMark(editor, type, force) {
    var addOrRemove = force ? 'addMark' : 'removeMark';
    return editor[addOrRemove](type);
  }

  function toggleMarkOnSelection(editor, type) {
    var force = !editor.getActiveMarks().some(function (mark) {
      return mark.type === type;
    });

    editor.command(utils.withCellSelection(function (editor) {
      return editor.command(toggleMark, type, force);
    }));
  }

  function updateCellColorOnSelection(change, color) {
    var selectedNodes = utils.getSelectedTableCellNodes(change.value);

    return selectedNodes.forEach(function (cell) {
      change.setNodeByKey(cell.key, {
        data: cell.data.set('cellColor', color)
      });
    });
  }

  function expandTableToFit(change, sourceTableSize, destinationTableSize, destinationCellLocation) {
    var overflowRows = sourceTableSize.rows - (destinationTableSize.rows - destinationCellLocation.row);
    if (overflowRows > 0) {
      change.command(repeatChangesAtPosition, overflowRows, insertRow, destinationTableSize.rows - 1, 1);
    }

    var overflowColumns = sourceTableSize.columns - (destinationTableSize.columns - destinationCellLocation.column);
    if (overflowColumns > 0) {
      change.command(repeatChangesAtPosition, overflowColumns, insertColumn, destinationTableSize.columns - 1, 1);
    }

    return change;
  }

  function reloadCell(change, table, position) {
    table = change.value.document.getDescendant(table.key);
    var structure = utils.getStructureOfTable(table);
    return structure.cellInPosition(position);
  }

  function replaceCells(change, sourceTable, destinationCell, destinationCellLocation) {
    var destinationTable = utils.getClosestTableByKey(change.value.document, destinationCell.key);

    var sourceTableStructure = utils.getStructureOfTable(sourceTable);

    sourceTable.nodes.forEach(function (row, rowIndex) {
      row.nodes.forEach(function (cell, cellIndex) {
        var sourcePosition = sourceTableStructure.positionOfCell(cell);
        var destinationPosition = {
          row: destinationCellLocation.row + sourcePosition.row,
          column: destinationCellLocation.column + sourcePosition.column
        };

        var destinationCell = reloadCell(change, destinationTable, destinationPosition);
        if (!destinationCell) return;

        change.command(matchSizeOfCell, destinationTable, destinationPosition, cell);
        destinationCell = reloadCell(change, destinationTable, destinationPosition);
        change.command(replaceCellContents, destinationCell.key, cell.nodes);
        change.command(mergeCellData, destinationCell, cell);
      });
    });

    var updatedDestinationTable = change.value.document.getDescendant(destinationTable.key);

    return change.moveToStartOfNode(updatedDestinationTable.nodes.get(destinationCellLocation.row).nodes.get(destinationCellLocation.column));
  }

  function mergeCellData(change, destinationNode, sourceNode) {
    // reset node
    change.setNodeByKey(destinationNode.key, {
      data: destinationNode.data.merge(sourceNode.data)
    });

    return change;
  }

  function replaceCellContents(change, tableCellKey, newNodes) {
    var tableCell = change.value.document.getDescendant(tableCellKey);
    change.withoutNormalizing(function (change) {
      tableCell.nodes.forEach(function (node) {
        change.removeNodeByKey(node.key);
      });
      if (newNodes) {
        newNodes.reverse().forEach(function (node) {
          change.insertNodeByKey(tableCellKey, 0, node);
        });
      }
    });

    return change;
  }

  function clearSelectedCells(change) {
    if (utils.hasActiveTableSelection(change.value)) {
      var tableSelection = utils.getTableSelection(change.value);
      var anchorCell = change.value.document.getDescendant(tableSelection.anchorCellKey);
      change.moveToStartOfNode(anchorCell.getFirstText());
      change.snapshotSelection();

      tableSelection.selectedCellKeys.forEach(function (cellKey) {
        return change.command(replaceCellContents, cellKey, Immutable.List([Slate__default.Block.create({
          type: 'paragraph'
        })]));
      });

      var newValue = change.value;
      var newFocusCell = newValue.document.getDescendant(tableSelection.focusCellKey);

      change.moveToEndOfNode(newFocusCell.getLastText());
      return change;
    } else {
      return change.delete();
    }
  }

  function clearCellSelection(change) {
    var tableSelection = utils.getTableSelection(change.value);
    var tableKey = tableSelection.key;
    if (!tableKey) return;

    pluginState.setTableSelection(tableSelection.withEmptyTableSelection());
    return change.moveToAnchor();
  }

  function moveToEndOfCellSelection(change) {
    var tableSelection = utils.getTableSelection(change.value);
    var structure = tableSelection.structure;

    change.moveToStartOfNode(structure.cellInPosition(tableSelection.endPosition));
    pluginState.setTableSelection(tableSelection.withSelectionExtendedToKey(change.value, change.value.selection, change.value.selection.anchor.key));
    return change;
  }

  function removeTablesAtEdgeOfSelection(editor) {
    var tableSelection = utils.getTableSelection(editor.value);

    if (tableSelection.hasMultipleTableSelection) {
      tableSelection.selectedTableKeys.forEach(function (key) {
        return editor.removeNodeByKey(key);
      });
    }
  }

  // Ensures that tableselection and window selection are up-to-date
  // with the Slate selection. Since onSelect doesn't get triggered
  // for programmatic selection changes, you must call this function
  // if your selection change cares about cell / table selection.
  function updateSelection(change, range) {
    var targetKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : range.focus.key;

    change.command(extendSelectionToKey, range, targetKey);
  }

  return {
    insertTable: insertTable,
    insertRow: insertRow,
    insertColumn: insertColumn,
    insertCell: insertCell,
    removeTable: removeTable,
    removeRow: removeRow,
    removeColumn: removeColumn,

    repeatChangesAtPosition: repeatChangesAtPosition,
    insertRowsAbove: insertRowsAbove,
    insertRowsBelow: insertRowsBelow,
    insertColumnsLeft: insertColumnsLeft,
    insertColumnsRight: insertColumnsRight,
    removeRows: removeRows,
    removeColumns: removeColumns,

    insertSiblingParagraph: insertSiblingParagraph,
    insertSiblingParagraphToTable: insertSiblingParagraphToTable,
    removePreviousParagraph: removePreviousParagraph,

    mergeCells: mergeCells,
    mergeCellsInRange: mergeCellsInRange,
    splitCells: splitCells,
    splitMergedCell: splitMergedCell,
    matchSizeOfCell: matchSizeOfCell,

    updateVerticalAlignment: updateVerticalAlignment,

    removeColumnWidths: removeColumnWidths,
    updateColumnWidth: updateColumnWidth,
    updateTableWidth: updateTableWidth,

    moveToRangeOfPreviousCell: moveToRangeOfPreviousCell,
    moveToRangeOfNextCell: moveToRangeOfNextCell,

    extendSelectionToKey: extendSelectionToKey,
    refreshTableSelection: refreshTableSelection,
    toggleMarkOnSelection: toggleMarkOnSelection,
    updateCellColorOnSelection: updateCellColorOnSelection,
    clearSelectedCells: clearSelectedCells,
    moveToEndOfCellSelection: moveToEndOfCellSelection,
    removeTablesAtEdgeOfSelection: removeTablesAtEdgeOfSelection,

    expandTableToFit: expandTableToFit,
    replaceCells: replaceCells,
    replaceCellContents: replaceCellContents,
    mergeCellData: mergeCellData,
    clearCellSelection: clearCellSelection,
    updateSelection: updateSelection
  };
}

var TableToolbarGroup = function (_React$Component) {
  inherits(TableToolbarGroup, _React$Component);

  function TableToolbarGroup() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TableToolbarGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TableToolbarGroup.__proto__ || Object.getPrototypeOf(TableToolbarGroup)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      return _this.menuTrigger.handleContextClick(event);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(TableToolbarGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          plugin = _props.plugin,
          value = _props.value,
          change = _props.change;


      return React__default.createElement(
        ToolbarMenu,
        { icon: 'fa-regular fa-table fa-fw', label: 'Table', name: 'table' },
        React__default.createElement(TableMenu, {
          value: value,
          utils: plugin.utils,
          changes: plugin.changes,
          change: change
        })
      );
    }
  }]);
  return TableToolbarGroup;
}(React__default.Component);

TableToolbarGroup.propTypes = {
  plugin: PropTypes.object.isRequired,
  value: PropTypes.instanceOf(Slate__default.Value).isRequired,
  change: PropTypes.func.isRequired
};

function Components(options) {
  return {
    TableToolbarGroup: TableToolbarGroup
  };
}

/**
 * Represents the structure of a Slate table node. Can get cell keys
 * by coordinates, cell dimensions, and properly handles splitting and
 * merging cells.
 */

var TableStructure = function () {
  function TableStructure(tableNode) {
    classCallCheck(this, TableStructure);

    this.tableNode = tableNode;
    this.buildPositionMap(tableNode);
  }

  createClass(TableStructure, [{
    key: 'buildPositionMap',
    value: function buildPositionMap(tableNode) {
      var _this = this;

      this.positionMap = [];
      var rowOffset = 0;

      this.tableNode.nodes.forEach(function (rowNode, row) {
        var currentColumn = 0;

        if (rowNode.object !== 'block') {
          // If the current row isn't actually a row, it won't have
          // cells, so treat it as an empty row.
          _this.positionMap[rowOffset + row] = [];
          return;
        }

        rowNode.nodes.forEach(function (cellNode) {
          if (cellNode.object !== 'block') {
            // if the cell is a text node, it can't be a table cell
            // node. Skip it. If it causes the table to be
            // non-rectangular, it'll get taken care of later.
            if (!_this.positionMap[rowOffset + row]) {
              _this.positionMap[rowOffset + row] = [];
            }
            return;
          }

          var rowspan = _this.rowspan(cellNode);
          var colspan = _this.colspan(cellNode);
          var emptyColumn = void 0;

          while ((emptyColumn = _this._closestEmptyColumn(row + rowOffset, currentColumn)) === undefined) {
            rowOffset++;
          }

          var startRow = row + rowOffset;

          for (var rowIndex = startRow; rowIndex < startRow + rowspan; rowIndex++) {
            for (var columnIndex = 0; columnIndex < colspan; columnIndex++) {
              _this._setCellForPosition(rowIndex, emptyColumn + columnIndex, cellNode);
            }
          }

          currentColumn = emptyColumn + colspan - 1;
        });
      });
    }
  }, {
    key: 'dimensionsOfRange',


    /**
     * Calculates the dimensions of a rectangular range, taking into
     * account the row and column spans of the selected items. Note that
     * this really only gives sane responses for rectangular
     * selections. That should be OK, because this is really only meant
     * for finding cells to merge or split.
     */
    value: function dimensionsOfRange(_ref) {
      var startPosition = _ref.startPosition,
          endPosition = _ref.endPosition;
      var column = startPosition.column,
          row = startPosition.row;

      var columnSize = 0;
      var rowSize = 0;
      while (column <= endPosition.column) {
        var span = this.colspan(this.cellInPosition({ row: startPosition.row, column: column }));
        columnSize += span;
        column += span;
      }

      while (row <= endPosition.row) {
        var _span = this.rowspan(this.cellInPosition({ row: row, column: startPosition.column }));
        rowSize += _span;
        row += _span;
      }

      return { columns: columnSize, rows: rowSize };
    }
  }, {
    key: 'cellInPosition',
    value: function cellInPosition(_ref2) {
      var row = _ref2.row,
          column = _ref2.column;
      var _dimensions = this.dimensions,
          rows = _dimensions.rows,
          columns = _dimensions.columns;

      if (row < 0 || column < 0 || row >= rows || column >= columns) return;
      return this.positionMap[row][column];
    }
  }, {
    key: 'rangeOfCell',
    value: function rangeOfCell(cellToFind) {
      var startPosition = void 0;
      this.positionMap.findIndex(function (rowList, row) {
        // Could be from an empty <tr>
        if (!rowList) {
          return false;
        }

        rowList.findIndex(function (cellNode, column) {
          if (cellNode === cellToFind) {
            startPosition = { row: row, column: column };
            return true;
          }
          return false;
        });
        if (startPosition) {
          return true;
        }
        return false;
      });

      if (!startPosition) return;

      var endPosition = {
        row: startPosition.row + this.rowspan(cellToFind) - 1,
        column: startPosition.column + this.colspan(cellToFind) - 1
      };

      return {
        startPosition: startPosition,
        endPosition: endPosition
      };
    }
  }, {
    key: 'positionOfCell',
    value: function positionOfCell(cellToFind) {
      var range = this.rangeOfCell(cellToFind);
      if (!range) return;

      return range.startPosition;
    }
  }, {
    key: 'nodeIndex',
    value: function nodeIndex(_ref3) {
      var _this2 = this;

      var row = _ref3.row,
          column = _ref3.column;

      var precedingCells = new Immutable.Set(this.positionMap[row].slice(0, column).filter(function (cell) {
        return _this2.startedInRow(row, cell);
      }));

      return precedingCells.size;
    }
  }, {
    key: 'startedInPosition',
    value: function startedInPosition(cell, _ref4) {
      var row = _ref4.row,
          column = _ref4.column;

      var position = this.positionOfCell(cell);
      if (!position) return false;
      return (row === undefined || row === position.row) && (column === undefined || column === position.column);
    }
  }, {
    key: 'startedInRow',
    value: function startedInRow(row, cell) {
      return this.startedInPosition(cell, { row: row });
    }
  }, {
    key: 'colspan',
    value: function colspan(cell) {
      var colspan = cell.data && cell.data.get('colspan');
      return colspan || 1;
    }
  }, {
    key: 'rowspan',
    value: function rowspan(cell) {
      var rowspan = cell.data && cell.data.get('rowspan');
      return rowspan || 1;
    }
  }, {
    key: 'minimumRowspan',
    value: function minimumRowspan(row) {
      var _this3 = this;

      return Math.min.apply(Math, toConsumableArray(Array.from(this.cellsInRow(row)).map(function (cell) {
        return _this3.rowspan(cell);
      })));
    }
  }, {
    key: 'minimumColspan',
    value: function minimumColspan(row) {
      var _this4 = this;

      return Math.min.apply(Math, toConsumableArray(Array.from(this.cellsInColumn(row)).map(function (cell) {
        return _this4.colspan(cell);
      })));
    }
  }, {
    key: 'cellsInRow',
    value: function cellsInRow(row) {
      var anchorPosition = { row: row, column: 0 };
      var focusPosition = { row: row, column: this.dimensions.columns - 1 };
      return this.cellsInRange(new TableRange({ anchorPosition: anchorPosition, focusPosition: focusPosition }));
    }
  }, {
    key: 'cellsInColumn',
    value: function cellsInColumn(column) {
      var anchorPosition = { row: 0, column: column };
      var focusPosition = { row: this.dimensions.rows - 1, column: column };
      return this.cellsInRange(new TableRange({ anchorPosition: anchorPosition, focusPosition: focusPosition }));
    }
  }, {
    key: 'forEachCellInExpandedRange',
    value: function forEachCellInExpandedRange(range, callback) {
      range = this._expandRangeForMergedCells(range);

      var _range$startPosition = range.startPosition,
          startRow = _range$startPosition.row,
          startColumn = _range$startPosition.column;
      var _range$endPosition = range.endPosition,
          endRow = _range$endPosition.row,
          endColumn = _range$endPosition.column;


      for (var row = startRow; row <= endRow; row++) {
        for (var column = startColumn; column <= endColumn; column++) {
          callback(this.cellInPosition({ row: row, column: column }), row, column);
        }
      }
    }
  }, {
    key: 'cellsInRange',
    value: function cellsInRange(range) {
      var selectedCells = new Immutable.OrderedSet();

      this.forEachCellInExpandedRange(range, function (cell) {
        selectedCells = selectedCells.add(cell);
      });

      return selectedCells;
    }
  }, {
    key: 'cellKeysInRange',
    value: function cellKeysInRange(range) {
      var selectedCells = new Immutable.OrderedSet();

      this.forEachCellInExpandedRange(range, function (cell) {
        selectedCells = selectedCells.add(cell.key);
      });

      return selectedCells;
    }
  }, {
    key: 'canMergeCells',
    value: function canMergeCells(range) {
      if (range.isCollapsed) return;

      var expandedRange = this._expandRangeForMergedCells(range);
      var startPosition = expandedRange.startPosition,
          endPosition = expandedRange.endPosition;

      var selectedCells = this.cellsInRange(range);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = selectedCells.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cell = _step.value;

          var position = this.positionOfCell(cell);
          if (!position) return false;

          if (position.row < startPosition.row || position.column < startPosition.column || position.row + this.rowspan(cell) > endPosition.row + 1 || position.column + this.colspan(cell) > endPosition.column + 1) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }
  }, {
    key: 'fullyExpandedRangeForMergedCells',
    value: function fullyExpandedRangeForMergedCells(range) {
      var _this5 = this;

      var startPosition = range.startPosition,
          endPosition = range.endPosition;

      var expandedStartPosition = {
        row: startPosition.row,
        column: startPosition.column
      };
      var expandedEndPosition = {
        row: endPosition.row,
        column: endPosition.column
      };

      Array.from(this.cellsInRange(range)).forEach(function (cell) {
        var cellRange = _this5.rangeOfCell(cell);
        expandedStartPosition = {
          row: Math.min(expandedStartPosition.row, cellRange.startPosition.row),
          column: Math.min(expandedStartPosition.column, cellRange.startPosition.column)
        };
        expandedEndPosition = {
          row: Math.max(expandedEndPosition.row, cellRange.endPosition.row),
          column: Math.max(expandedEndPosition.column, cellRange.endPosition.column)
        };
      });

      return new TableRange({
        anchorPosition: expandedStartPosition,
        focusPosition: expandedEndPosition
      });
    }

    // When we select cells with a row / colspan, we may need to
    // increase the size of the range depending on the row / colspan of
    // the selected cells. To match Google Docs' behavior, we should
    // expand based on the properties of the cell at the focus position.

  }, {
    key: '_expandRangeForMergedCells',
    value: function _expandRangeForMergedCells(range) {
      var focusPosition = range.focusPosition,
          startPosition = range.startPosition,
          endPosition = range.endPosition;

      var focusCell = this.cellInPosition(focusPosition);
      var focusCellPosition = this.positionOfCell(focusCell);

      var newStartPosition = {
        row: startPosition.row,
        column: Math.min(startPosition.column, focusCellPosition.column)
      };

      var newEndPosition = {
        row: endPosition.row,
        column: Math.max(endPosition.column, focusCellPosition.column + this.colspan(focusCell) - 1)
      };

      return new TableRange({
        anchorPosition: newStartPosition,
        focusPosition: newEndPosition
      });
    }
  }, {
    key: '_setCellForPosition',
    value: function _setCellForPosition(row, column, cell) {
      if (cell.object !== 'block') return;
      if (!this.positionMap[row]) this.positionMap[row] = [];
      this.positionMap[row][column] = cell;
    }
  }, {
    key: '_closestEmptyColumn',
    value: function _closestEmptyColumn(row, column, width) {
      var rowData = this.positionMap[row];
      if (!rowData) return column;

      for (var columnIndex = column; columnIndex < rowData.length; columnIndex++) {
        if (!rowData[columnIndex]) return columnIndex;
      }

      return rowData.length;
    }
  }, {
    key: 'dimensions',
    get: function get$$1() {
      return {
        rows: this.positionMap.length,
        columns: this.positionMap[0] ? this.positionMap[0].length : 0
      };
    }
  }, {
    key: 'isEmpty',
    get: function get$$1() {
      var _dimensions2 = this.dimensions,
          rows = _dimensions2.rows,
          columns = _dimensions2.columns;

      return rows === 0 || columns === 0;
    }
  }, {
    key: 'missingCellPositions',
    get: function get$$1() {
      var maxColumns = Math.max.apply(Math, [0].concat(toConsumableArray(this.positionMap.map(function (row) {
        return row.length;
      }))));
      var missingCellPositions = [];

      this.positionMap.forEach(function (row, rowIndex) {
        if (row.length < maxColumns) {
          for (var i = row.length; i < maxColumns; i++) {
            missingCellPositions.push({ row: rowIndex, column: i });
          }
        }
      });
      return missingCellPositions;
    }
  }]);
  return TableStructure;
}();

/* To make eslint happy with jsdoc / proptypes */
/* eslint-disable no-unused-vars */
/* eslint-enable no-unused-vars */

/**
 * @typedef {Object} Position
 * @property {number} row
 * @property {number} column
 */

/**
 * Utility methods for working with Slate tables. These methods should
 * not make any changes, and should be used mostly for finding and
 * querying parts of tables.
 *
 * @param {{tableCellType:string, tableRowType:string, tableType:string}} options - the options given to the table plugin
 * @param {{tableSelection:TableSelection}} pluginState - the plugin's current state
 */
function Utils(options, pluginState) {
  // returns true if all cells in the current selection have the given alignment
  // if selectOnNull is true it also checks if all alignments in selection are null
  // this is useful for default values
  function selectionMatchesVerticalAlignment(value, alignment, selectOnNull) {
    return everySelectedTableCellNode(value, function (cell) {
      return cell.data.get('verticalAlign') === alignment || selectOnNull && !cell.data.get('verticalAlign');
    });
  }

  // Returns true if testFunction returns true for every
  // TableCell node in the current selection
  function everySelectedTableCellNode(value, testFunction) {
    return getSelectedTableCellNodes(value).every(function (cell) {
      return testFunction(cell);
    });
  }

  // Returns the list of TableCell nodes in the current selection.
  // If there is no selection it will return a list with only the current cell
  // If we are not in a cell it will return an empty list
  function getSelectedTableCellNodes(value) {
    var selectedCells = getTableSelection(value).getSelectedCells();

    if (selectedCells.size === 0) {
      var cell = utils.getClosestTableCellByKey(value.document, value.selection.focus.key);
      if (cell) {
        selectedCells = Immutable.List([cell]);
      }
    }

    return selectedCells;
  }

  var memoizedTableSelection = memoizeOne(function (document, tableSelection) {
    return tableSelection.withDocument(document);
  });

  var getTableSelection = function getTableSelection(value) {
    return memoizedTableSelection(value.document, pluginState.tableSelection);
  };

  /**
   * Returns a TableStructure representing the structure of the
   * current table.
   * @param {Block} tableNode
   * @return TableStructure
   */
  var getStructureOfTable = memoizeOne(function (tableNode) {
    return new TableStructure(tableNode);
  });

  var getFullyExpandedRange = function getFullyExpandedRange(tableSelection) {
    if (tableSelection.table) {
      var tableStructure = getStructureOfTable(tableSelection.table);

      var range = tableStructure.fullyExpandedRangeForMergedCells(tableSelection.range);

      return range;
    }
  };

  /**
   * @param {Block} tableNode
   * @param {Block} cellToFind
   * @return {Position | undefined}
   */
  function getPositionOfCellInTable(tableNode, cellToFind) {
    return getStructureOfTable(tableNode).positionOfCell(cellToFind);
  }

  function getCellInPosition(table, position) {
    return getStructureOfTable(table).cellInPosition(position);
  }

  function getPositionOfKeyInTable(value, key) {
    var document = value.document;

    var currentCell = getClosestTableCellByKey(document, key);
    var currentTable = getClosestTableByKey(document, key);
    if (!currentCell || !currentTable) return;
    return getPositionOfCellInTable(currentTable, currentCell);
  }

  function getVisibleRows(nodes) {
    return nodes.filter(function (node) {
      return node.nodes.some(function (node) {
        return node.type === options.tableCellType;
      });
    });
  }

  function isLastCellInRow(document, cell) {
    var table = getClosestTableByKey(document, cell.key);
    var tableSize = getTableSize(table);
    var cellPosition = getPositionOfCellInTable(table, cell);
    if (!cellPosition) return true; // non-rectangular table, needs to be normalized
    return tableSize.columns - 1 === cellPosition.column;
  }

  // A cell is considered empty if it's in a "default" state. That means:
  //   - it has no nodes (usually only happens in between a validation pass) or
  //   - it has one paragraph node, and
  //     - that node has no children, or
  //     - it has one child, and that child is an empty text node.
  function isEmptyCell(cell) {
    if (cell.nodes.size > 1) return false;

    var node = cell.nodes.first();
    if (!node) return true;

    if (node.type !== 'paragraph') return false;
    if (node.nodes.size > 1) return false;

    var text = node.nodes.first();
    if (!text) return true;
    if (text.object !== 'text') return false;
    if (text.text !== '') return false;

    return true;
  }

  function getTableSize(table) {
    return getStructureOfTable(table).dimensions;
  }

  function getWidthForCell(document, cell) {
    var table = getClosestTableByKey(document, cell.key);
    var structure = getStructureOfTable(table);
    var range = structure.rangeOfCell(cell);
    if (range) {
      return getColumnWidths(table).slice(range.startPosition.column, range.endPosition.column + 1).reduce(function (totalWidth, width) {
        return totalWidth + width;
      }, 0);
    }
  }

  function getColumnWidths(table) {
    return Immutable.List(table.data.get('columnWidths'));
  }

  function getCurrentCellBackgroundColor(document, key) {
    if (!key) return;
    var cell = getClosestTableCellByKey(document, key);
    return cell.data.get('cellColor');
  }

  /**
   * Creates a document fragment containing only a table, with the
   * cells selected by `tableSelection.`
   * @param {Slate.Document} document
   * @param {TableSelection} tableSelection
   * @returns {Slate.Document} a document fragment
   */
  function getFragmentAtSelectedCellPositions(document, tableSelection) {
    if (!tableSelection.hasActiveTableSelection) return;

    var tableNode = document.getDescendant(tableSelection.key);
    var structure = getStructureOfTable(tableNode);
    var selectedCells = structure.cellsInRange(tableSelection.range);
    var expandedRange = structure.fullyExpandedRangeForMergedCells(tableSelection.range);

    tableNode.nodes.forEach(function (row, index) {
      var anchorPosition = {
        row: index,
        column: expandedRange.startPosition.column
      };
      var focusPosition = {
        row: index,
        column: expandedRange.endPosition.column
      };
      var range = new TableRange({ anchorPosition: anchorPosition, focusPosition: focusPosition });

      row = row.set('nodes', Immutable.List(structure.cellsInRange(range)).filter(function (cell) {
        return structure.startedInRow(index, cell);
      }).map(function (cell) {
        return (
          // Empty any cell that isn't actually in the tableSelection
          selectedCells.has(cell) ? cell : cell.set('nodes', Immutable.List([Slate.Block.create({
            type: 'paragraph',
            nodes: Immutable.List([Slate.Text.create('')])
          })]))
        );
      }));
      document = document.replaceNode(row.key, row);
    });

    tableNode = document.getDescendant(tableNode.key);
    tableNode = tableNode.set('nodes', tableNode.nodes.slice(expandedRange.startPosition.row, expandedRange.endPosition.row + 1));
    tableNode = tableNode.set('data', tableNode.data.merge({
      columnWidths: getColumnWidths(tableNode).slice(expandedRange.startPosition.column, expandedRange.endPosition.column + 1)
    }));
    return document.set('nodes', Immutable.List([tableNode]));
  }

  function getTSVFromTableFragment(fragment) {
    var table = fragment.nodes.first();
    if (!isTable(table)) return '';
    var text = '';

    var structure = getStructureOfTable(table);
    var dimensions = structure.dimensions;
    for (var row = 0; row < dimensions.rows; row++) {
      for (var column = 0; column < dimensions.columns; column++) {
        var cell = structure.cellInPosition({ row: row, column: column });
        // If this cell spans multiple columns / rows, only write cell
        // content if we're in the upper-left corner.
        if (structure.startedInPosition(cell, { row: row, column: column })) {
          // Quote the cell if necessary
          if (cell.text.match(/[\n\t]/)) {
            text += '"' + cell.text + '"';
          } else {
            text += cell.text;
          }
        }

        if (column !== dimensions.columns - 1) {
          text += '\t';
        }
      }
      text += '\n';
    }
    return text;
  }

  function isTable(node) {
    return node.type === options.tableType;
  }

  function getClosestParentByType(document, key, type) {
    if (!key) return;
    return document.getClosest(key, function (node) {
      return node.type === type;
    });
  }

  function getClosestTableCellByKey(node, key) {
    if (!key) return;
    var targetNode = node.getDescendant(key);
    if (targetNode && targetNode.type === options.tableCellType) {
      return targetNode;
    }
    return getClosestParentByType(node, key, options.tableCellType);
  }

  // Returns the table parent table cell that's a direct descendant of
  // table. This is useful for finding the table cell parent of a
  // nested table.
  function getTableCellInTableByKey(node, table, key) {
    // Find the parent of key, that's a table cell, and is a grandchild of table.
    return node.getClosest(key, function (parent) {
      return parent.type === options.tableCellType && table.getDepth(parent.key) === 2;
    });
  }

  function getClosestTableRowByKey(node, key) {
    return getClosestParentByType(node, key, options.tableRowType);
  }

  function getClosestTableByKey(node, key) {
    return getClosestParentByType(node, key, options.tableType);
  }

  function getClosestTable(editor) {
    return getClosestTableByKey(editor.value.document, editor.value.selection.start.key);
  }

  function getNextCellByKey(node, key) {
    var currentCell = getClosestTableCellByKey(node, key);
    if (!currentCell) return;

    var nextCell = node.getNextSibling(currentCell.key);
    if (!nextCell) {
      var currentRow = getClosestTableRowByKey(node, key);
      var nextRow = node.getNextSibling(currentRow.key);
      if (!nextRow) return;
      nextCell = nextRow.nodes.first();
    }
    return nextCell;
  }

  function getPreviousCellByKey(node, key) {
    var currentCell = getClosestTableCellByKey(node, key);
    if (!currentCell) return;

    var previousCell = node.getPreviousSibling(currentCell.key);
    if (!previousCell) {
      var currentRow = getClosestTableRowByKey(node, key);
      var previousRow = node.getPreviousSibling(currentRow.key);
      if (!previousRow) return;
      previousCell = previousRow.nodes.last();
    }
    return previousCell;
  }

  function hasActiveTableSelection(value) {
    return getTableSelection(value).hasActiveTableSelection;
  }

  function inTableWithActiveTableSelection(value, key) {
    return hasActiveTableSelection(value) && getTableSelection(value).table.hasDescendant(key);
  }

  function inTable(_ref) {
    var document = _ref.document,
        selection = _ref.selection;

    return utils.getClosestTableCellByKey(document, selection.start.key);
  }

  function getTableSelectionSize(value) {
    return getTableSelection(value).selectionSize;
  }

  function getSelectedRange(value) {
    return getTableSelection(value).range;
  }

  function getMergedCellsInCurrentRange(value) {
    var selectedCells = getSelectedTableCellNodes(value);

    return selectedCells.filter(function (cell) {
      return cell.data && (cell.data.get('rowspan') || cell.data.get('colspan'));
    });
  }

  function getPositionOfCellInDirection(position, direction) {
    switch (direction) {
      case 'left':
        return {
          row: position.row,
          column: position.column - 1
        };
      case 'right':
        return {
          row: position.row,
          column: position.column + 1
        };
      case 'up':
        return {
          row: position.row - 1,
          column: position.column
        };
      case 'down':
        return {
          row: position.row + 1,
          column: position.column
        };
      default:
    }
  }

  function getCellInDirection(value, direction) {
    var tableSelection = getTableSelection(value);
    var focusCellPosition = tableSelection.focusPosition;
    var newPosition = getPositionOfCellInDirection(focusCellPosition, direction);
    if (!newPosition) return;

    var document = value.document;

    var table = document.getDescendant(tableSelection.key);
    return getCellInPosition(table, newPosition);
  }

  function everySelectedCell(editor, testFunction) {
    return getTableSelection(editor.value).everySelectedCell(editor, testFunction);
  }

  /**
   * Transforms a change function into a change function that can
   * apply correctly onto a 2D cell selection.
   */
  function withCellSelection(changeFunction) {
    return function (change) {
      var _getTableSelection;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_getTableSelection = getTableSelection(change.value)).applyChange.apply(_getTableSelection, [change, changeFunction].concat(args));
    };
  }

  /**
   * Transforms a test function into a test function that can
   * apply correctly onto a 2D cell selection.
   */
  function onSelectedCells(testFunction) {
    return function (editor) {
      return everySelectedCell(editor, testFunction);
    };
  }

  function isEntireTableSelected(value, tableKey) {
    return getTableSelection(value).isTableSelected(tableKey);
  }

  function isEntireTableAtPointSelected(value, point) {
    var table = utils.getClosestTableByKey(value.document, point.path);
    return table && utils.isEntireTableSelected(value, table.key);
  }

  function isCellSelected(value, cellKey) {
    return getTableSelection(value).isCellSelected(cellKey);
  }

  function isCellFocused(value, key) {
    var focusKey = value.selection.focus.key;
    var cell = getClosestTableCellByKey(value.document, focusKey);
    if (!cell) return false;

    return cell.key === key;
  }

  function isTableMenuCell(value, key) {
    // The editor is not focused
    if (!value.selection.isFocused) return false;

    var document = value.document;

    var tableSelection = getTableSelection(value);

    // Single cell is focused
    if (isCellFocused(value, key) && !tableSelection.range) {
      return true;
    }

    // Range is selected
    if (isCellSelected(value, key) && tableSelection && tableSelection.range) {
      var table = getClosestTableByKey(document, key);

      if (isEntireTableSelected(value, table.key)) return false;

      var currentTable = tableSelection.table;
      var tableStructure = getStructureOfTable(currentTable);

      var fullyExpandedRange = getFullyExpandedRange(tableSelection);

      var menuCell = tableStructure.cellInPosition({
        row: fullyExpandedRange.startPosition.row,
        column: fullyExpandedRange.endPosition.column
      });

      if (menuCell.key === key) {
        return true;
      } else {
        return false;
      }
    }
  }

  // We found that sometimes a column width get set to `null`. We haven't found
  // the root cause yet (maybe pasting), but in order to resolve the issue
  // consistently, this method normalizes any `null` values to be an actual number.
  function normalizeColumnWidths(columnWidths) {
    if (columnWidths.size === 0) return columnWidths;

    var totalNumericWidth = columnWidths.reduce(function (sum, n) {
      return typeof n === 'number' ? sum + n : sum;
    }, 0);
    var nonNumericColumnCount = columnWidths.filter(function (width) {
      return typeof width !== 'number';
    }).size;

    var defaultColumnWidth = totalNumericWidth > 100 ? 0 : (100 - totalNumericWidth) / nonNumericColumnCount;

    return columnWidths.map(function (width) {
      return typeof width === 'number' ? width : defaultColumnWidth;
    });
  }

  function roundToTotal(values) {
    if (values.length === 0) return values;

    values = normalizeColumnWidths(Immutable.List(values)).toArray();
    var total = values.reduce(function (sum, n) {
      return sum + n;
    }, 0);
    var rounded = values.map(function (value) {
      return Math.round(value);
    });
    var roundedTotal = rounded.reduce(function (sum, n) {
      return sum + n;
    }, 0);
    var diff = total - roundedTotal;

    rounded[-1] += diff;

    return rounded;
  }

  var utils = {
    selectionMatchesVerticalAlignment: selectionMatchesVerticalAlignment,
    getTableSelection: getTableSelection,
    getStructureOfTable: getStructureOfTable,
    getFullyExpandedRange: getFullyExpandedRange,
    getPositionOfCellInTable: getPositionOfCellInTable,
    getPositionOfKeyInTable: getPositionOfKeyInTable,
    getVisibleRows: getVisibleRows,
    isLastCellInRow: isLastCellInRow,
    isEmptyCell: isEmptyCell,
    getTableSize: getTableSize,
    getWidthForCell: getWidthForCell,
    getColumnWidths: getColumnWidths,
    normalizeColumnWidths: normalizeColumnWidths,
    getCurrentCellBackgroundColor: getCurrentCellBackgroundColor,

    isTable: isTable,

    getClosestTableByKey: getClosestTableByKey,
    getClosestTable: getClosestTable,
    getClosestTableRowByKey: getClosestTableRowByKey,
    getClosestTableCellByKey: getClosestTableCellByKey,
    getTableCellInTableByKey: getTableCellInTableByKey,

    getFragmentAtSelectedCellPositions: getFragmentAtSelectedCellPositions,
    getTSVFromTableFragment: getTSVFromTableFragment,

    getNextCellByKey: getNextCellByKey,
    getPreviousCellByKey: getPreviousCellByKey,

    hasActiveTableSelection: hasActiveTableSelection,
    inTableWithActiveTableSelection: inTableWithActiveTableSelection,
    inTable: inTable,

    getSelectedTableCellNodes: getSelectedTableCellNodes,

    getTableSelectionSize: getTableSelectionSize,
    getMergedCellsInCurrentRange: getMergedCellsInCurrentRange,
    getSelectedRange: getSelectedRange,
    getCellInDirection: getCellInDirection,
    everySelectedCell: everySelectedCell,
    withCellSelection: withCellSelection,
    onSelectedCells: onSelectedCells,
    isEntireTableSelected: isEntireTableSelected,
    isEntireTableAtPointSelected: isEntireTableAtPointSelected,
    isCellSelected: isCellSelected,
    isCellFocused: isCellFocused,
    isTableMenuCell: isTableMenuCell,

    roundToTotal: roundToTotal
  };

  return utils;
}

var defaultOptions = {
  tableType: 'table',
  tableRowType: 'table-row',
  tableCellType: 'table-cell',
  menuIdentifier: 'table-menu',
  serializer: null,
  disableResize: false,
  disableTableDelete: false,
  disableHotkeys: false,
  zoomEnabled: false
};

function TablePlugin(options) {
  options = _extends({}, defaultOptions, options);
  var state = {};
  var utils = Utils(options, state);
  var changes = Changes(options, utils, state);
  state.tableSelection = new TableSelection({ utils: utils });
  state.setTableSelection = function (value) {
    state.tableSelection = value;
  };

  return _extends({
    options: options,
    utils: utils,
    components: Components(options),
    changes: changes
  }, Plugin(options, utils, changes, state));
}

var ListContext = React__default.createContext({});

var List = function (_React$Component) {
  inherits(List, _React$Component);

  function List() {
    classCallCheck(this, List);
    return possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          attributes = _props.attributes,
          children = _props.children;

      var className = classnames({
        checklist: type === 'checklist'
      });

      return React__default.createElement(
        this.tag,
        _extends({ className: className }, attributes),
        React__default.createElement(
          ListContext.Provider,
          { value: type },
          children
        )
      );
    }
  }, {
    key: 'tag',
    get: function get$$1() {
      return this.props.type === 'ol' ? 'ol' : 'ul';
    }
  }]);
  return List;
}(React__default.Component);

var defaultFontList = [{ displayName: 'Arial', styleName: 'arial', fontFamily: 'Arial, sans-serif' }, { displayName: 'Courier New', styleName: 'courier_new', fontFamily: 'Courier New, monospace' }, { displayName: 'Georgia', styleName: 'georgia', fontFamily: 'Georgia, serif' }, { displayName: 'Impact', styleName: 'impact', fontFamily: 'Impact, sans-serif' }, { displayName: 'Sans Serif', styleName: 'sans-serif', fontFamily: 'sans-serif', isDefault: true }, { displayName: 'Times New Roman', styleName: 'times_new_roman', fontFamily: 'Times New Roman, Times, serif' }, { displayName: 'Trebuchet MS', styleName: 'trebuchet_ms', fontFamily: 'Trebuchet MS, sans-serif' }, { displayName: 'Verdana', styleName: 'verdana', fontFamily: 'Verdana, Geneva, sans-serif' }];

// Maintains a list of fonts that are used by the serializer. When updating fonts
// in aha-app, add a record here. Maintained here so it can be included in faye.
var serializerFontList = [].concat(defaultFontList, [{ styleName: 'lato', fontFamily: 'Lato, sans-serif' }, { styleName: 'montserrat', fontFamily: 'Montserrat, sans-serif' }, { styleName: 'noto_sans', fontFamily: 'Noto Sans, sans-serif' }, { styleName: 'open_sans', fontFamily: 'Open Sans, sans-serif' }, { styleName: 'quicksand', fontFamily: 'Quicksand, sans-serif' }, { styleName: 'rubik', fontFamily: 'Rubik, sans-serif' }, { styleName: 'roboto', fontFamily: 'Roboto, sans-serif' }, { styleName: 'shadows_into_light', fontFamily: 'Shadows Into Light, sans-serif' }]);

function getFirstTextChildMarks(node) {
  var text = node.getFirstText();
  if (!text) return Immutable.List();
  return text.marks;
}

function getStyleFromChildMarks(node) {
  var style = {};

  var firstText = node.getFirstText();
  if (firstText) {
    var firstTextParentBlock = node.getClosestBlock(firstText.key);
    if (firstTextParentBlock) {
      var lineHeight = firstTextParentBlock.data.get('lineHeight');
      if (lineHeight) {
        style.lineHeight = lineHeight;
      }
    }
  }

  return getFirstTextChildMarks(node).reduce(function (style, mark) {
    switch (mark.type) {
      case 'color':
        var colorStyle = utils.getStyleFromMark(mark);
        // Background doesn't feel right on lists. Remove it.
        delete colorStyle['backgroundColor'];
        style = _extends({}, style, colorStyle);
        break;
      // No case for textHighlight, see "background doesn't feel right on lists" above.
      case 'textColor':
        style = _extends({}, style, { color: mark.data.get('textColor') });
        break;
      case 'fontSize':
        style = _extends({}, style, { fontSize: mark.data.get('fontSize') });
        break;
      case 'fontFamily':
        var markData = mark.data.get('fontFamily');
        var fontItem = serializerFontList.find(function (font) {
          return font.styleName === markData;
        });
        var fontFamily = fontItem ? fontItem.fontFamily : markData.split('_').join(' ');

        style = _extends({}, style, { fontFamily: fontFamily });
        break;
      default:
        break;
    }
    return _extends({}, style);
  }, style);
}

var ListItem = function (_React$Component) {
  inherits(ListItem, _React$Component);

  function ListItem() {
    classCallCheck(this, ListItem);
    return possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  createClass(ListItem, [{
    key: 'onChecked',
    value: function onChecked(event) {
      event.stopPropagation();
      var _props = this.props,
          node = _props.node,
          editor = _props.editor;

      var checked = event.target.checked;

      var result = editor.moveAnchorToStartOfNode(node).moveFocusToStartOfNode(node);

      setTimeout(function () {
        result.setNodeByKey(node.key, {
          data: { checked: checked }
        });
      });

      return result;
    }
  }, {
    key: 'classesFromChildMarks',
    value: function classesFromChildMarks() {
      var node = this.props.node;

      return getFirstTextChildMarks(node).map(function (e) {
        return e.type + '-child';
      }).join(' ');
    }
  }, {
    key: 'classesFromChildBlock',
    value: function classesFromChildBlock() {
      var node = this.props.node;

      return node.getClosestBlock(node.getFirstText().key).type + '-child';
    }
  }, {
    key: 'renderListItem',
    value: function renderListItem(type) {
      var _this2 = this;

      var _props2 = this.props,
          node = _props2.node,
          editor = _props2.editor;


      var classes = classnames({
        checkbox: type === 'checklist'
      }, this.classesFromChildMarks(), this.classesFromChildBlock());

      var style = getStyleFromChildMarks(node);

      var checked = node.data.get('checked');
      var attributes = void 0;
      if (editor.isModifiable()) {
        attributes = {
          onChange: function onChange(event) {
            return _this2.onChecked(event);
          }
        };
      } else {
        attributes = {
          disabled: true
        };
      }

      return React__default.createElement(
        'li',
        _extends({ className: classes, style: style }, this.props.attributes),
        renderIf(type === 'checklist')(function () {
          return React__default.createElement(
            'span',
            { contentEditable: false, className: 'checkbox-container' },
            React__default.createElement('input', _extends({ type: 'checkbox', checked: !!checked }, attributes))
          );
        }),
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        ListContext.Consumer,
        null,
        function (type) {
          return _this3.renderListItem(type);
        }
      );
    }
  }]);
  return ListItem;
}(React__default.Component);

function IndentOutdentSelection(options, pluginChanges) {
  var increaseItemDepth = pluginChanges.increaseItemDepth,
      decreaseItemDepth = pluginChanges.decreaseItemDepth;


  var utils = {
    /**
     * Returns all of the bottom-most list items in `value`'s selection.
     *
     * @param {Slate.Value} value
     * @returns {Immutable.OrderedSet<Slate.Block>} The collection of list item blocks in the selection.
     */
    getSelectedItems: function getSelectedItems(value) {
      var document = value.document,
          selection = value.selection;

      return utils.getBottomListItemsFromBlocks(document, document.getLeafBlocksAtRange(selection));
    },

    /**
     * Gets all of the bottom-most list items that contain a block in
     * `blocks`. If any block isn't a child of a list item, this
     * function will return an empty list, so a caller can always assume
     * any set returned will only contain list_items.
     *
     * @param {Slate.Document} document The document or document fragment containing blocks
     * @param {Immutable.List<Slate.Block>} blocks A list of blocks wrapped by list_items.
     * @returns {Immutable.OrderedSet<Slate.Block>} The collection of list item blocks containing `blocks`.
     */
    getBottomListItemsFromBlocks: function getBottomListItemsFromBlocks(document, blocks) {
      var nodes = blocks.map(function (block) {
        return document.getParent(block.key);
      }).filter(function (item) {
        return item.type === options.typeItem;
      }).toOrderedSet();
      if (nodes.some(function (node) {
        return !node;
      })) return Immutable.OrderedSet();
      return nodes.filter(function (node) {
        return !nodes.some(function (parentNode) {
          return parentNode.hasDescendant(node.key);
        });
      });
    }
  };

  var changes = {
    indentSelectedItems: function indentSelectedItems(change, items) {
      var listItems = items || utils.getSelectedItems(change.value);
      return listItems.reduce(function (change, item) {
        return change.command(increaseItemDepth, item);
      }, change);
    },
    outdentSelectedItems: function outdentSelectedItems(change, items) {
      var listItems = items || utils.getSelectedItems(change.value);
      return listItems.reduce(function (change, item) {
        return change.command(decreaseItemDepth, item);
      }, change);
    }
  };

  return {
    utils: utils,
    changes: changes,
    onKeyDown: function onKeyDown(event, editor, next) {
      if (event.key !== 'Tab') return next();
      var isCollapsed = editor.value.selection.isCollapsed;


      var listItems = utils.getSelectedItems(editor.value);

      if (isCollapsed || listItems.isEmpty()) {
        return next();
      } else {
        event.preventDefault();
        if (event.shiftKey) {
          return editor.command(changes.outdentSelectedItems, listItems);
        } else {
          return editor.command(changes.indentSelectedItems, listItems);
        }
      }
    }
  };
}

function UncheckNewCheckboxes(options, utils) {
  return {
    onKeyDown: function onKeyDown(event, editor, next) {
      if (event.key !== 'Enter') return next();
      editor = options.editListPlugin.onKeyDown(event, editor, next);
      if (editor) {
        var newListItem = utils.getCurrentItem(editor.value);
        if (newListItem) {
          editor = editor.setNodeByKey(newListItem.key, {
            data: newListItem.data.remove('checked')
          });
        }
        return editor;
      }
      return next();
    }
  };
}

// Returns true if the node's descendants contain no text, and no void nodes, false otherwise.
function isEmpty(editor, node) {
  if (!node) {
    return true;
  } else if (node.object === 'text') {
    return node.text === '';
  } else {
    return !editor.isVoid(node) && !node.nodes.some(function (child) {
      return !isEmpty(editor, child);
    });
  }
}

var isTab = isHotkey__default('tab');
var isShiftTab = isHotkey__default('shift+tab');

function Plugin$2(options, utils, changes) {
  var indentOutdentSelectionPlugin = IndentOutdentSelection(options, changes);

  var renderBlock = function renderBlock(props, editor, next) {
    var children = props.children,
        node = props.node;

    switch (node.type) {
      case 'ul_list':
        return React__default.createElement(
          List,
          _extends({ type: 'ul' }, props),
          children
        );
      case 'ol_list':
        return React__default.createElement(
          List,
          _extends({ type: 'ol' }, props),
          children
        );
      case 'checklist':
        return React__default.createElement(
          List,
          _extends({ type: 'checklist' }, props),
          children
        );
      case 'list_item':
        return React__default.createElement(
          ListItem,
          props,
          children
        );
      default:
    }
    return next();
  };

  function onEnter(event, editor, next) {
    var value = editor.value;

    var currentItem = utils.getCurrentItem(value);
    if (!currentItem) return next();

    if (value.selection.isCollapsed && value.selection.anchor.isAtStartOfNode(currentItem) && !isEmpty(editor, currentItem)) {
      return editor.command(changes.splitListItem);
    }
    return next();
  }

  function onTab(event, editor, next) {
    var value = editor.value;

    if (value.selection.isCollapsed && utils.getCurrentItem(value)) {
      event.preventDefault();

      if (isShiftTab(event)) {
        return editor.command(changes.decreaseItemDepth);
      } else {
        return editor.command(changes.increaseItemDepth);
      }
    }
    return next();
  }

  function onKeyDown(event, editor, next) {
    if (isTab(event) || isShiftTab(event)) {
      return onTab(event, editor, next);
    }
    if (event.key === 'Enter' && !event.shiftKey) {
      return onEnter(event, editor, next);
    }
    return next();
  }

  return {
    plugins: [{
      renderBlock: renderBlock,
      onKeyDown: onKeyDown
    }, UncheckNewCheckboxes(options, utils), indentOutdentSelectionPlugin, options.editListPlugin]
  };
}

function Utils$1(options) {
  var editListPlugin = options.editListPlugin;


  function isListItem(block) {
    return block && block.type === options.typeItem;
  }

  function isList(block) {
    return block && options.types.includes(block.type);
  }

  function getListForBlock(document, block) {
    var listItem = document.getParent(block.key);
    if (!isListItem(listItem)) return;

    var list = document.getParent(listItem.key);
    if (!isList(list)) return;

    return list;
  }

  function inListOfType(value, listType) {
    var utils = editListPlugin.utils;

    var isInList = utils.isSelectionInList(value);
    var currentList = utils.getCurrentList(value);
    return isInList && currentList && currentList.type === listType;
  }

  function inListItem(value) {
    return editListPlugin.utils.getCurrentItem(value);
  }

  return {
    isList: isList,
    isListItem: isListItem,
    getListForBlock: getListForBlock,
    inListOfType: inListOfType,
    inListItem: inListItem
  };
}

var Changes$2 = (function (options, utils) {
  var editListChanges = options.editListPlugin.changes;


  function wrapNodeInListItem(node) {
    if (node.type === options.typeItem || utils.isList(node)) return node;
    return Slate.Block.create({ type: options.typeItem, nodes: [node] });
  }

  // The slate-edit-list change functions will not always normalize
  // after running their changes. These wrappers ensure that
  // normalization always happens.
  function wrapInList(change, type, data) {
    change.command(editListChanges.wrapInList, type, data).normalize();
  }

  function unwrapList(change, block) {
    change.command(editListChanges.unwrapList, block).normalize();
  }

  function splitListItem(change) {
    change.command(editListChanges.splitListItem).normalize();
  }

  function increaseItemDepth(change, block) {
    change.command(editListChanges.increaseItemDepth, block).normalize();
  }

  function decreaseItemDepth(change, block) {
    change.command(editListChanges.decreaseItemDepth, block).normalize();
  }

  return {
    wrapNodeInListItem: wrapNodeInListItem,
    wrapInList: wrapInList,
    unwrapList: unwrapList,
    splitListItem: splitListItem,
    increaseItemDepth: increaseItemDepth,
    decreaseItemDepth: decreaseItemDepth
  };
});

function translateKey(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _isMac$options = _extends({ isMac: slateDevEnvironment.IS_MAC }, options),
      isMac = _isMac$options.isMac;

  var translatedKey = key;
  if (isMac) {
    switch (key) {
      case 'tab':
        translatedKey = '⇥';
        break;
      case 'enter':
        translatedKey = '↩';
        break;
      default:
        translatedKey = key.toUpperCase();
        break;
    }
  } else {
    switch (key) {
      case 'tab':
        translatedKey = 'Tab';
        break;
      case 'enter':
        translatedKey = 'Enter';
        break;
      default:
        translatedKey = key.toUpperCase();
        break;
    }
  }

  return translatedKey;
}

function hotkeyLabel(hotkey, options) {
  var _isMac$options2 = _extends({ isMac: slateDevEnvironment.IS_MAC }, options),
      isMac = _isMac$options2.isMac;

  var parsedHotkey = typeof hotkey === 'string' ? isHotkey.parseHotkey(hotkey, { byKey: true }) : hotkey;

  var label = [];
  if (isMac) {
    if (parsedHotkey.ctrlKey) {
      label.push('⌃');
    }

    if (parsedHotkey.altKey) {
      label.push('⌥');
    }

    if (parsedHotkey.shiftKey) {
      label.push('⇧');
    }

    if (parsedHotkey.metaKey) {
      label.push('⌘');
    }

    label.push(translateKey(parsedHotkey.key, options));

    return label.join('');
  } else {
    label = [];
    if (parsedHotkey.ctrlKey || parsedHotkey.metaKey) {
      label.push('Ctrl');
    }

    if (parsedHotkey.altKey) {
      label.push('Alt');
    }

    if (parsedHotkey.shiftKey) {
      label.push('Shift');
    }

    label.push(translateKey(parsedHotkey.key, options));

    return label.join('+');
  }
}

// The option key affects the "key" value received in the event object,
// in order for the formatting hotkeys to work as expected, we need to
// translate the modified keys back to their face value.
function translateMacFormattingHotkeys(key) {
  var keyMapping = {
    π: 'p',
    '¡': '1',
    '™': '2',
    '£': '3',
    '¢': '4',
    '∞': '5',
    '§': '6',
    '÷': '/',
    æ: "'"
  };

  return keyMapping[key] || key;
}

function bindHotkey(hotkey, createChange, changeFunction, toolbarItem) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var onClick = function onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    createChange(changeFunction);
  };

  var checkHotkey = isHotkey.isKeyHotkey(hotkey);
  var label = hotkeyLabel(hotkey);
  var item = {
    plugin: {
      onKeyDown: function onKeyDown(event, editor, next) {
        var eventWithTranslatedKeys = _extends({}, event, {
          key: translateMacFormattingHotkeys(event.key)
        });

        if (checkHotkey(eventWithTranslatedKeys)) {
          event.preventDefault();
          return editor.command(changeFunction);
        }
        return next();
      }
    },
    item: toolbarItem(onClick, label),
    changeFunction: changeFunction
  };

  if (options.name) {
    item.name = options.name;
  }

  return item;
}

var clickHandler = function clickHandler(change) {
  return function (changeFunction) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    change.apply(undefined, [changeFunction].concat(args));
  };
};

/**
 * @typedef WrapListButtonProps
 * @prop {string} label
 * @prop {*} plugin
 * @prop {*} listType
 * @prop {*} iconClass
 * @prop {*} editor
 * @prop {*} enabled
 * @prop {*} handleClick
 */

var wrapInListFn = function wrapInListFn(_ref) {
  var plugin = _ref.plugin,
      listType = _ref.listType;
  return function (editor) {
    var isInList = plugin.utils.inListOfType(editor.value, listType);
    return isInList ? editor.command(plugin.changes.unwrapList) : editor.command(plugin.changes.wrapInList, listType);
  };
};

/**
 * @augments {React.Component<WrapListButtonProps, {}>}
 */

var WrapListButton = function (_React$Component) {
  inherits(WrapListButton, _React$Component);

  function WrapListButton() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, WrapListButton);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = WrapListButton.__proto__ || Object.getPrototypeOf(WrapListButton)).call.apply(_ref2, [this].concat(args))), _this), _this.wrapInList = function (change) {
      return change.command(_this.props.plugin.changes.wrapInList, _this.props.listType);
    }, _this.onClick = function (event) {
      event.preventDefault();
      event.stopPropagation();

      trackToolbarAnalytics({
        eventName: 'User selects toolbar list',
        properties: { List: _this.props.label }
      });

      return _this.props.handleClick(_this.isInList ? _this.props.plugin.changes.unwrapList : _this.wrapInList);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(WrapListButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iconClass = _props.iconClass,
          label = _props.label;

      var className = 'fa-regular ' + iconClass + ' fa-fw';

      return React__default.createElement(
        ToolbarItem,
        {
          label: label,
          onClick: this.onClick,
          active: this.isActive,
          disabled: this.isDisabled
        },
        React__default.createElement('i', { className: className })
      );
    }
  }, {
    key: 'isInList',
    get: function get$$1() {
      var _props2 = this.props,
          plugin = _props2.plugin,
          editor = _props2.editor,
          listType = _props2.listType;

      return plugin.utils.inListOfType(editor.value, listType);
    }
  }, {
    key: 'isActive',
    get: function get$$1() {
      return this.isInList;
    }
  }, {
    key: 'isDisabled',
    get: function get$$1() {
      return !this.props.enabled(this.props.editor.value);
    }
  }]);
  return WrapListButton;
}(React__default.Component);

/**
 * @typedef IndentOutdentButtonProps
 * @prop {string} label
 * @prop {string} [hotkey]
 * @prop {*} plugin
 * @prop {*} iconClass
 * @prop {*} editor
 * @prop {*} handleClick
 * @prop {*} changeFunction
 */

/**
 * @augments {React.Component<IndentOutdentButtonProps, {}>}
 */


var IndentOutdentButton = function (_React$Component2) {
  inherits(IndentOutdentButton, _React$Component2);

  function IndentOutdentButton() {
    var _ref3;

    var _temp2, _this2, _ret2;

    classCallCheck(this, IndentOutdentButton);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref3 = IndentOutdentButton.__proto__ || Object.getPrototypeOf(IndentOutdentButton)).call.apply(_ref3, [this].concat(args))), _this2), _this2.onClick = function () {
      return _this2.props.handleClick(_this2.props.changeFunction);
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(IndentOutdentButton, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          label = _props3.label,
          hotkey = _props3.hotkey,
          iconClass = _props3.iconClass;

      var className = 'fa-regular ' + iconClass + ' fa-fw';

      return React__default.createElement(
        ToolbarItem,
        {
          label: label,
          hotkey: hotkey,
          onClick: this.onClick,
          disabled: this.isDisabled
        },
        React__default.createElement('i', { className: className })
      );
    }
  }, {
    key: 'isDisabled',
    get: function get$$1() {
      return !this.props.plugin.utils.isSelectionInList(this.props.editor.value);
    }
  }]);
  return IndentOutdentButton;
}(React__default.Component);

function ListIndentToolbarGroup(_ref4) {
  var plugin = _ref4.plugin,
      change = _ref4.change;
  var _plugin$changes = plugin.changes,
      indentSelectedItems = _plugin$changes.indentSelectedItems,
      outdentSelectedItems = _plugin$changes.outdentSelectedItems;

  var handleClick = clickHandler(change);

  return [function () {
    return React__default.createElement(ToolbarItem, { divider: true });
  }, function (_ref5) {
    var editor = _ref5.editor,
        handleClick = _ref5.handleClick;
    return React__default.createElement(IndentOutdentButton, {
      label: 'Decrease indent',
      hotkey: hotkeyLabel('shift+tab'),
      changeFunction: outdentSelectedItems,
      iconClass: 'fa-outdent',
      plugin: plugin,
      editor: editor,
      handleClick: handleClick
    });
  }, function (_ref6) {
    var editor = _ref6.editor,
        handleClick = _ref6.handleClick;
    return React__default.createElement(IndentOutdentButton, {
      label: 'Increase indent',
      hotkey: hotkeyLabel('tab'),
      changeFunction: indentSelectedItems,
      iconClass: 'fa-indent',
      plugin: plugin,
      editor: editor,
      handleClick: handleClick
    });
  }].map(function (Button) {
    return {
      item: function item(_ref7) {
        var editor = _ref7.editor;
        return React__default.createElement(Button, { handleClick: handleClick, editor: editor });
      }
    };
  });
}

function ListCreateToolbarGroup(_ref8) {
  var plugin = _ref8.plugin,
      wrappingEnabled = _ref8.wrappingEnabled,
      change = _ref8.change;

  var handleClick = clickHandler(change);
  return [{
    name: 'Bulleted list',
    changeFunction: wrapInListFn({ plugin: plugin, listType: 'ul_list' }),
    item: function item(_ref9) {
      var editor = _ref9.editor;
      return React__default.createElement(WrapListButton, {
        label: 'Bulleted list',
        listType: 'ul_list',
        iconClass: 'fa-list-ul',
        plugin: plugin,
        editor: editor,
        enabled: wrappingEnabled,
        handleClick: handleClick
      });
    }
  }, {
    name: 'Numbered list',
    changeFunction: wrapInListFn({ plugin: plugin, listType: 'ol_list' }),
    item: function item(_ref10) {
      var editor = _ref10.editor;
      return React__default.createElement(WrapListButton, {
        label: 'Numbered list',
        listType: 'ol_list',
        iconClass: 'fa-list-ol',
        plugin: plugin,
        editor: editor,
        enabled: wrappingEnabled,
        handleClick: handleClick
      });
    }
  }, {
    name: 'Checkboxes',
    changeFunction: wrapInListFn({ plugin: plugin, listType: 'checklist' }),
    item: function item(_ref11) {
      var editor = _ref11.editor;
      return React__default.createElement(WrapListButton, {
        label: 'Checkboxes',
        listType: 'checklist',
        iconClass: 'fa-square-check',
        plugin: plugin,
        editor: editor,
        enabled: wrappingEnabled,
        handleClick: handleClick
      });
    }
  }];
}

function ListToolbarGroup(_ref12) {
  var plugin = _ref12.plugin,
      wrappingEnabled = _ref12.wrappingEnabled,
      change = _ref12.change;

  return [].concat(toConsumableArray(ListCreateToolbarGroup({ plugin: plugin, wrappingEnabled: wrappingEnabled, change: change })), toConsumableArray(ListIndentToolbarGroup({ plugin: plugin, change: change })));
}

function Components$2(options) {
  return {
    ListToolbarGroup: ListToolbarGroup,
    ListCreateToolbarGroup: ListCreateToolbarGroup,
    ListIndentToolbarGroup: ListIndentToolbarGroup
  };
}

function ListPlugin(options) {
  var editListPlugin = EditList(options);
  options = _extends({}, options, { editListPlugin: editListPlugin });

  var utils = _extends({}, Utils$1(options), editListPlugin.utils);
  var ownChanges = Changes$2(options, utils);
  var indentOutdentSelectionPlugin = IndentOutdentSelection(options, ownChanges);

  var changes = _extends({}, editListPlugin.changes, ownChanges, indentOutdentSelectionPlugin.changes);

  return _extends({
    components: Components$2(options),
    changes: changes,
    utils: utils
  }, Plugin$2(options, utils, changes));
}

var DocumentState = {
  NOT_CONNECTED: 'Not connected',
  ERROR: 'Error',
  BLOCKED: 'Waiting',
  SAVING: 'Saving',
  SAVED: 'All changes saved'
};

/**
 * Remove any embedded keys in the operation. This is necessary when
 * you save an operation to apply later, because the keys may
 * legitimately not be valid at the time the operation is run.
 * @param {Slate.Operation} op an operation to remove keys from
 * @returns {Slate.Operation} the operation without keys
 */
function withoutOperationKeys(op) {
  if (['set_selection', 'set_annotation'].includes(op.type)) {
    var _arr = ['properties', 'newProperties'];

    for (var _i = 0; _i < _arr.length; _i++) {
      var properties = _arr[_i];
      var _loop = function _loop(point) {
        if (op[properties][point]) {
          op = op.update(properties, function (props) {
            props[point] = props[point].set('key', null);
            return props;
          });
        }
      };

      var _arr2 = ['anchor', 'focus'];

      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var point = _arr2[_i2];
        _loop(point);
      }
    }
  }
  return op;
}

var UndoEntry = function () {
  function UndoEntry(value) {
    var operations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { invert: false };
    classCallCheck(this, UndoEntry);
    this.operations = [];
    this.pendingRemoteOperations = [];
    this.startValue = null;

    if (options.invert) {
      operations = this._invertOperations(value, operations);
      operations = operations.map(function (op) {
        if (op.type !== 'set_selection') return op;
        return op.set('properties', omit(op.properties, 'isFocused'));
      });
    }

    this.operations = operations;
  }

  createClass(UndoEntry, [{
    key: 'apply',
    value: function apply(editor) {
      var _this = this;

      editor.withoutUndoTransforming(function (editor) {
        editor.withoutSaving(function (editor) {
          return _this.operations.forEach(function (op) {
            return editor.applyOperation(op);
          });
        });
      });
      return new UndoEntry(editor.value, this._invertOperations(editor.value, this.operations));
    }
  }, {
    key: 'tryCompose',
    value: function tryCompose(op, otSlateType) {
      if (this.hasRemoteOperations) return false;

      var prevOperation = this.operations[0];
      if (!prevOperation) return false;

      var mergedOp = otSlateType.composeComponent(prevOperation, op);

      if (mergedOp === prevOperation) {
        return false;
      } else {
        this.operations[0] = mergedOp;
        return true;
      }
    }
  }, {
    key: 'append',
    value: function append(op) {
      if (this.hasRemoteOperations) return false;
      this.operations.unshift(op);
      return true;
    }
  }, {
    key: 'head',
    value: function head() {
      return this.operations[0];
    }
  }, {
    key: 'transform',
    value: function transform(createEditor, otSlateType) {
      if (this.pendingRemoteOperations.length === 0) {
        return { value: this.startValue, remoteOperations: [] };
      }

      var editor = createEditor({ value: this.startValue }, { normalize: false });

      // Let's not get into a recursive transforming loop
      editor = editor.withoutUndoTransforming();

      var intermediateValues = {
        editor: editor
      };

      var _otSlateType$transfor = otSlateType.transformX(this.operations, this.pendingRemoteOperations, intermediateValues),
          _otSlateType$transfor2 = slicedToArray(_otSlateType$transfor, 2),
          left = _otSlateType$transfor2[0],
          right = _otSlateType$transfor2[1];

      intermediateValues.editor.flush();
      this.clearRemoteOperations();
      this.operations = left;

      return {
        value: intermediateValues.leftValue,
        remoteOperations: right
      };
    }
  }, {
    key: 'appendRemoteOperations',
    value: function appendRemoteOperations(startValue, ops) {
      if (ops.length === 0) return;

      if (!this.startValue && startValue) {
        this.startValue = startValue;
      }

      this.pendingRemoteOperations = this.pendingRemoteOperations.concat(ops);
    }
  }, {
    key: 'clearRemoteOperations',
    value: function clearRemoteOperations() {
      this.pendingRemoteOperations = [];
      this.startValue = null;
    }

    // Invert an item in an undo or redo stack, to prepare it for
    // pushing onto the other stack.

  }, {
    key: '_invertOperations',
    value: function _invertOperations(startValue, operations) {
      var _this2 = this;

      var value = startValue;
      return operations.reverse().map(function (operation) {
        var invertedOp = _this2._invertOperation(value, operation);
        value = invertedOp.apply(value);
        return invertedOp;
      });
    }
  }, {
    key: '_invertOperation',
    value: function _invertOperation(value, op) {
      op = withoutOperationKeys(op);
      return op.invert();
    }
  }, {
    key: 'isEmpty',
    get: function get$$1() {
      return this.operations.length === 0;
    }
  }, {
    key: 'hasRemoteOperations',
    get: function get$$1() {
      return this.pendingRemoteOperations.length !== 0;
    }
  }]);
  return UndoEntry;
}();

var debug = Debug('slate-collaboration:group-undo');

var GroupUndoStack = function () {
  // Stacks would be more natural here, but Immutable Stacks have a
  // problem -- mapping over them yields the elements in reverse order
  // (that is, least recently pushed to most recently pushed). When we
  // transform remote operations against them, we have to map in
  // natural order (most recently pushed to least recently
  // pushed). That's because we transform both the local and the
  // remote op, because the remote op for undo op 2 has to take into
  // account the result of undo op 1. For example, if undo op 1
  // removes a character before the remote op's offset, the remote
  // op's offset has to be decremented before we transform undo op 2
  // against it.
  function GroupUndoStack(collaborativeDocument, createEditor) {
    var _this = this;

    classCallCheck(this, GroupUndoStack);
    this.undoEntries = new Immutable.List();
    this.redoEntries = new Immutable.List();

    this.collaborativeDocument = collaborativeDocument;
    this.collaborativeDocument.onRemoteOperationsReceived(function (operations, startValue, _endValue) {
      _this._handleRemoteOperations(operations, startValue);
    });
    this.createEditor = createEditor;
    this.otSlateType = this.collaborativeDocument.otSlateType;
  }

  createClass(GroupUndoStack, [{
    key: 'save',
    value: function save(editor, operation) {
      var _this2 = this;

      var _editor$tmp = editor.tmp,
          save = _editor$tmp.save,
          merge = _editor$tmp.merge,
          transformUndo = _editor$tmp.transformUndo;

      if (save === false) {
        // If we don't save to the undo stack, the undo stack still
        // needs to take into account the effect of our operations.
        // This works exactly the same way as if the ignored operations
        // were remote, so they can go through that same path.
        if (transformUndo !== false) {
          editor.withoutUndoTransforming(function () {
            _this2._handleRemoteOperations(Immutable.List([operation]), editor.value);
          });
        }

        return this;
      }

      var value = operation.apply(editor.value);
      var undoEntry = new UndoEntry(value, [operation], {
        invert: true
      });
      this._pushOperations(editor, undoEntry, { save: save, merge: merge });

      if (debug.enabled) {
        debug('undo stack: ' + JSON.stringify(this.undoEntries));
      }

      return this;
    }
  }, {
    key: 'undo',
    value: function undo(editor) {
      var operation = this.undoEntries.first();
      if (!operation) return;
      this.undoEntries = this.undoEntries.shift();

      var _operation$transform = operation.transform(this.createEditor, this.otSlateType),
          value = _operation$transform.value,
          remoteOperations = _operation$transform.remoteOperations;

      if (this.undoEntries.first()) {
        this.undoEntries.first().appendRemoteOperations(value, remoteOperations);
      }

      var inverseOperation = operation.apply(editor);

      this.redoEntries = this.redoEntries.unshift(inverseOperation);
      return editor;
    }
  }, {
    key: 'redo',
    value: function redo(editor) {
      var operation = this.redoEntries.first();
      if (!operation) return;
      this.redoEntries = this.redoEntries.shift();

      var _operation$transform2 = operation.transform(this.createEditor, this.otSlateType),
          value = _operation$transform2.value,
          remoteOperations = _operation$transform2.remoteOperations;

      if (this.redoEntries.first()) {
        this.redoEntries.first().appendRemoteOperations(value, remoteOperations);
      }

      var inverseOperation = operation.apply(editor);

      this.undoEntries = this.undoEntries.unshift(inverseOperation);
      return editor;
    }

    // Port of the save/merge logic in Slate's `History` model.

  }, {
    key: '_pushOperations',
    value: function _pushOperations(editor, newUndoEntry, options) {
      var _this3 = this;

      var merge = options.merge;

      // We'll always try to compose, unless we've specifically been told
      // not to.

      var shouldCompose = merge !== false;

      // If `merge` is non-commital, and this is not the first
      // operation in a new editor, then append. This will create a
      // single undo step for a group of operations in a single change.
      var shouldAppend = merge;
      if (merge === null || merge === undefined) {
        shouldAppend = editor.operations.size !== 0;
      }

      var allSetSelection = newUndoEntry.operations.every(function (op) {
        return op.type === 'set_selection';
      });

      var prevUndoEntry = this.undoEntries.first();
      var currentUndoEntry = new UndoEntry();
      var allSkipped = true;

      newUndoEntry.operations.forEach(function (op) {
        if ((merge === null || merge === undefined) && _this3._shouldSkip(op, prevUndoEntry && prevUndoEntry.head())) {
          return;
        }

        allSkipped = false;

        var composed = false;
        var appended = false;

        if (shouldCompose && prevUndoEntry) {
          composed = prevUndoEntry.tryCompose(op, _this3.otSlateType);
        }

        if (!composed) {
          if (shouldAppend && prevUndoEntry) {
            // We unsuccessfully merged, but we've been asked to combine
            // ops into a single undo step anyway.
            appended = prevUndoEntry.append(op);
          }

          if (!appended) {
            currentUndoEntry.append(op);
            _this3.undoEntries = _this3.undoEntries.unshift(currentUndoEntry);
            prevUndoEntry = currentUndoEntry;
            currentUndoEntry = new UndoEntry();
          }
        }
      });

      if (allSkipped) return;

      if (!currentUndoEntry.isEmpty) {
        this.undoEntries = this.undoEntries.unshift(currentUndoEntry);
      }

      if (this.undoEntries.size > 100) {
        this.undoEntries = this.undoEntries.take(100);
      }

      // Don't clear the redo stack if we've only moved the selection
      if (!allSetSelection) {
        this.redoEntries = this.redoEntries.clear();
      }
    }
  }, {
    key: '_handleRemoteOperations',
    value: function _handleRemoteOperations(operations, startValue) {
      operations = operations.toArray();
      if (operations.length === 0) {
        return;
      }

      var firstUndo = this.undoEntries.first();
      if (firstUndo) {
        firstUndo.appendRemoteOperations(startValue, operations);
        // in order to allow composing onto the undo stack, we'll
        // pre-transform the head of the stack. If we don't do this, we
        // won't be able to make changes, get a remote operation, and
        // compose new changes onto those original changes, because
        // they'll have been sourced from different document states. One
        // before the remote operations, and one afterward.

        var _firstUndo$transform = firstUndo.transform(this.createEditor, this.otSlateType),
            value = _firstUndo$transform.value,
            remoteOperations = _firstUndo$transform.remoteOperations;

        if (this.undoEntries.size > 1) {
          this.undoEntries.get(1).appendRemoteOperations(value, remoteOperations);
        }
      }

      var firstRedo = this.redoEntries.first();
      if (firstRedo) {
        firstRedo.appendRemoteOperations(startValue, operations);
      }
    }
  }, {
    key: '_shouldSkip',
    value: function _shouldSkip(operation, previousOperation) {
      return previousOperation && operation.type === 'set_selection' && previousOperation.type === 'set_selection';
    }
  }]);
  return GroupUndoStack;
}();

var debug$1 = Debug('slate-collaboration:collaboration');
var SAVE_DELAY = 500;

ShareDB.types.register(otSlate.type);

var CollaborativeDocument = function () {
  function CollaborativeDocument(connection, groupName, documentId, createEditor) {
    var _this = this;

    classCallCheck(this, CollaborativeDocument);
    this.doc = null;
    this.snapshot = null;
    this.editor = null;

    this._checkDocumentState = function () {
      var newState = null;
      if (!_this.doc || !_this.doc.connection.canSend) {
        newState = DocumentState.NOT_CONNECTED;
      } else if (_this.needsCatchup) {
        newState = DocumentState.BLOCKED;
      } else if (_this.hasPendingWrites()) {
        newState = DocumentState.SAVING;
      } else if (_this.documentState === DocumentState.SAVING && !_this.hasPendingWrites()) {
        newState = DocumentState.SAVED;
      }

      _this._runCallbacks(_this.documentStateChangedCallbacks, newState);
      _this.documentState = newState;
    };

    this._debouncedRollback = debounce(this._rollback, 10);

    this._throttleOps = function () {
      var timer = null;
      return function () {
        if (timer) return;

        if (_this.doc) {
          _this.doc.pause();
          timer = setTimeout(function () {
            if (_this.doc) {
              _this.doc.resume();
            }
            clearTimeout(timer);
            timer = null;
          }, SAVE_DELAY);
        }
      };
    }();

    this._debouncedOperationsAcknowledged = function () {
      var operationsAcknowledged = function operationsAcknowledged(snapshot) {
        return snapshot;
      };
      var previousVersion = null;
      return function (version, value) {
        if (previousVersion !== version) {
          previousVersion = version;
          // We've already seen a newer doc version. We should let our
          // callbacks know immediately, so they can lock down previous
          // versions if necessary. For selections, for example, we
          // can't guarantee that we can transform them against our
          // pending ops -- those ops could have been cleared out in the
          // last 10ms.
          _this._runCallbacks(_this.versionChangedCallbacks, version);

          operationsAcknowledged = debounce(function (value) {
            _this._runCallbacks(_this.operationsAcknowledgedCallbacks, value, version);
          }, 10);
        }
        operationsAcknowledged(value);
      };
    }();

    this.groupName = groupName;
    this.documentId = documentId;
    this.connection = connection;
    this.createEditor = createEditor;
    this.isClosing = false;
    this.isConnected = false;
    this.remoteOperationsRecievedCallbacks = [];
    this.operationsAcknowledgedCallbacks = [];
    this.versionChangedCallbacks = [];
    this.loadCallbacks = [];
    this.updateCallbacks = [];
    this.rollbackCallbacks = [];
    this.documentStateChangedCallbacks = [];
    this.documentState = null;
    this._checkDocumentState();
  }

  createClass(CollaborativeDocument, [{
    key: 'load',
    value: function load(initialValue, initialVersion) {
      var _this2 = this;

      this.doc = this.connection.get(this.groupName, this.documentId);
      this.editor = this.createEditor();

      if (initialValue && typeof initialVersion === 'number') {
        this.loadSnapshot(Slate.Value.fromJSON(initialValue));
        this.doc.ingestSnapshot({
          data: initialValue,
          v: initialVersion,
          type: otSlate.type
        }, function (err) {
          _this2._onIngest(_this2.doc, err);
        });
      }
      this.doc.on('nothing pending', this._checkDocumentState);
      this.connection.on('state', this._checkDocumentState);
    }
  }, {
    key: 'connect',
    value: function connect(onSubscribed) {
      var _this3 = this;

      if (!this.doc) {
        this.doc = this.connection.get(this.groupName, this.documentId);
      }
      this.doc.subscribe(function (err) {
        _this3.isConnected = true;
        _this3._onSubscribe(_this3.doc, err, [onSubscribed]);
      });
      return this;
    }
  }, {
    key: 'close',
    value: function close(callback) {
      var _this4 = this;

      this.isClosing = true;
      this.isConnected = false;
      this.flushOperations();

      if (this.doc) {
        this.doc.destroy(function (err) {
          _this4.snapshot = null;
          _this4.editor.setValue(Slate.Value.create());
          callback && callback(err);
          _this4._checkDocumentState();
        });
      }
      this.connection.off('state', this._checkDocumentState);
    }
  }, {
    key: 'submitChange',
    value: function submitChange(change) {
      var _this5 = this;

      // Apply all of change's operations to our own editor to generate
      // the new snapshot. We don't use the change's snapshot, because
      // slate-react could have overwritten it. We don't trust that
      // it's consistent with its operations.
      this.editor.withoutSaving(function (editor) {
        editor.withoutUndoTransforming(function (editor) {
          editor.withoutNormalizing(function (editor) {
            change.operations.forEach(function (op) {
              return editor.applyOperation(withoutOperationKeys(op));
            });
          });
        });
      });

      this.editor.flush();
      this.snapshot = this.editor.value;

      var ops = this.filterOperations(change.operations);
      if (ops.size > 0) {
        this.doc.submitOp(ops.toArray(), {}, function (err) {
          if (err) {
            console.error(err);
            _this5._debouncedRollback(err, _this5.doc);
            return;
          }

          _this5._debouncedOperationsAcknowledged(_this5.version, _this5.snapshot);
        });
        this._checkDocumentState();
        this._throttleOps();

        if (debug$1.enabled) {
          debug$1('submitted ops: ' + JSON.stringify(ops));
        }
      }
      this._runCallbacks(this.updateCallbacks, this.snapshot, this.version);
    }

    /** There are some operations that we only want to run locally, not
     *  distribute or persist long-term. Selections, for example. This
     *  excludes those from the list of operations sent to the
     *  collaborative server.
     *
     *  NOTE: Any operation you exclude here should not affect content,
     *  offsets, node paths, etc.! If you don't send those, other clients
     *  will break in very strange ways.
     */

  }, {
    key: 'filterOperations',
    value: function filterOperations(operations) {
      return operations.filter(function (op) {
        if (['set_value', 'set_selection'].includes(op.type)) return false;

        // Temporary annotations are useful for creating selections that
        // automatically transform, but we don't want to sync those. If
        // a key starts with _local, we won't sync or save it.
        if (['add_annotation', 'remove_annotation'].includes(op.type) && op.annotation.key.startsWith('_local')) {
          return false;
        }

        if (op.type === 'set_annotation' && (op.properties.key.startsWith('_local') || op.newProperties.key && op.newProperties.key.startsWith('_local'))) {
          return false;
        }

        return op;
      });
    }
  }, {
    key: 'hasPendingWrites',
    value: function hasPendingWrites() {
      if (!this.doc) return false;
      return this.doc.hasWritePending();
    }
  }, {
    key: 'flushOperations',
    value: function flushOperations() {
      if (this.doc) {
        this.doc.resume();
        this._checkDocumentState();
      }
    }
  }, {
    key: 'loadSnapshot',
    value: function loadSnapshot(newSnapshot) {
      var _this6 = this;

      if (this.snapshot === newSnapshot) return;
      if (this.snapshot && newSnapshot && this.snapshot.document === newSnapshot.document && this.snapshot.selection !== newSnapshot.selection) {
        // If the document body hasn't changed, preserve the previous
        // selection (so it doesn't get reset by the server on
        // subscribe)
        newSnapshot = newSnapshot.set('selection', this.snapshot.selection);
      }

      // setSnapshot may normalize the value, in which case it will try
      // to add items to an undo stack that may not be correctly set
      // up. When setting an initial value, we don't care about those
      // operations, since an undo would do nothing anyway. Skip them.
      this.editor.withoutSaving(function (editor) {
        editor.withoutUndoTransforming(function (editor) {
          _this6.setSnapshot(newSnapshot, { normalize: true });
        });
      });
    }
  }, {
    key: 'setSnapshot',
    value: function setSnapshot(newSnapshot, options) {
      options = _extends({ normalize: false }, options);

      if (!newSnapshot.data.get('history')) {
        newSnapshot = newSnapshot.setIn(['data', 'history'], new GroupUndoStack(this, this.createEditor));
      }

      this.editor.setValue(newSnapshot, options);
      this.editor.flush();
      this.snapshot = this.editor.value;
    }
  }, {
    key: 'rollback',
    value: function rollback(callback) {
      var _this7 = this;

      if (!this.isConnected) {
        console.warn('Tried to rollback a document before initial connection, ignoring');
        return;
      }

      console.error('Forcing document rollback');
      this._reset();

      // Reload the latest version of the doc from the server and
      // resubscribe
      this.doc.subscribe(function (error) {
        _this7._debouncedRollback(error, _this7.doc);
        if (callback) callback(error);
      });
    }

    // callback: (operations: [Slate.Operation], startValue: Slate.Value, endValue: Slate.Value)

  }, {
    key: 'onRemoteOperationsReceived',
    value: function onRemoteOperationsReceived(callback) {
      this.remoteOperationsRecievedCallbacks.push(callback);
    }

    // callback: (value: Slate.Value, version)

  }, {
    key: 'onOperationsAcknowledged',
    value: function onOperationsAcknowledged(callback) {
      this.operationsAcknowledgedCallbacks.push(callback);
    }

    // callback: (newVersion)

  }, {
    key: 'onVersionChanged',
    value: function onVersionChanged(callback) {
      this.versionChangedCallbacks.push(callback);
    }

    // callback: (newState: string)

  }, {
    key: 'onDocumentStateChange',
    value: function onDocumentStateChange(callback) {
      this.documentStateChangedCallbacks.push(callback);
    }

    // callback: ()

  }, {
    key: 'onLoad',
    value: function onLoad(callback) {
      this.loadCallbacks.push(callback);
    }

    // callback: (value: Slate.Value)

  }, {
    key: 'onUpdate',
    value: function onUpdate(callback) {
      this.updateCallbacks.push(callback);
    }

    // callback: (error: ShareDBError, value: Slate.Value, version)

  }, {
    key: 'onRollback',
    value: function onRollback(callback) {
      this.rollbackCallbacks.push(callback);
    }
  }, {
    key: '_onIngest',
    value: function _onIngest(doc, err) {
      if (err) throw err;
      if (this.isClosing) return;

      var snapshot = Slate.Value.fromJSON(doc.data);
      this.loadSnapshot(snapshot);

      this._runCallbacks(this.loadCallbacks);
      this._runCallbacks(this.versionChangedCallbacks, this.version);
      this._runCallbacks(this.updateCallbacks, this.snapshot, this.version);
      this._checkDocumentState();
    }
  }, {
    key: '_onSubscribe',
    value: function _onSubscribe(doc, err, callbacks) {
      var _this8 = this;

      if (err) throw err;
      if (this.isClosing) return;

      doc.on('op', function (ops, source) {
        return _this8._receivedOperations(ops, source);
      });
      this._onIngest(doc, err);
      this._runCallbacks(callbacks);
    }
  }, {
    key: '_receivedOperations',


    // Called every time a local operation is submitted, or a remote
    // operation is received.
    value: function _receivedOperations(ops, source) {
      // We apply all local ops synchronously, so we don't need to
      // apply them again here.
      if (source) return;

      if (debug$1.enabled) {
        debug$1('received ops: ' + JSON.stringify(ops));
      }

      var startValue = this.editor.value;

      this.editor.withoutSaving(function (editor) {
        editor.withoutUndoTransforming(function (editor) {
          editor.withoutNormalizing(function (editor) {
            ops.forEach(function (op) {
              return editor.applyOperation(op);
            });
          });
        });
      });

      this._runCallbacks(this.remoteOperationsRecievedCallbacks, this.editor.operations, startValue, this.editor.value);

      this.editor.flush();

      this.snapshot = this.editor.value;

      this._runCallbacks(this.versionChangedCallbacks, this.version);
      this._runCallbacks(this.updateCallbacks, this.snapshot, this.version);
    }
  }, {
    key: '_runCallbacks',
    value: function _runCallbacks(callbackList) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.isClosing) return;

      callbackList.forEach(function (callback) {
        // eslint-disable-next-line standard/no-callback-literal
        if (callback) callback.apply(undefined, args);
      });
    }
  }, {
    key: '_reset',
    value: function _reset() {
      // Reset the document to an empty state
      this.doc._setType(null);
      this.doc.version = null;
      this.doc.inflightOp = null;
      this.doc.pendingOps = [];
    }
  }, {
    key: '_rollback',
    value: function _rollback(error, doc) {
      console.info('Recovering from forced rollback');

      if (doc && doc.data) {
        this.loadSnapshot(Slate.Value.fromJSON(doc.data));

        // An error will almost always rollback the document. If
        // that happens, we want the editor to take on the rolled
        // back state of the document, as weird as it feels.
        this._runCallbacks(this.rollbackCallbacks, error, this.snapshot, this.version);
        this._runCallbacks(this.versionChangedCallbacks, this.version);
        this._runCallbacks(this.updateCallbacks, this.snapshot, this.version);
      } else {
        console.error('Error loading document during rollback caused by', error);
        this._reset();
        this.close();
      }
    }

    // Throttles operations being sent to the server to once every
    // SAVE_DELAY milliseconds.


    // operationsAcknowledged should run after all of our operations
    // have been acknowledged by the server, and we have a new doc
    // version. But we only want to run this once, after all ops have
    // been acknowledged, not once per Slate operation. Otherwise, we
    // might do things like sending intermediate selections that might
    // not apply to the final version of the doc that other clients see.

  }, {
    key: 'otSlateType',
    get: function get$$1() {
      return this.doc.type;
    }

    // An identifier for this document that removes any user-specific
    // information from the end of the documentId.

  }, {
    key: 'identifier',
    get: function get$$1() {
      return this.groupName + '/' + this.documentId.split('--')[0];
    }
  }, {
    key: 'version',
    get: function get$$1() {
      if (!this.doc) return null;
      return this.doc.version;
    }
  }, {
    key: 'pendingOperations',
    get: function get$$1() {
      if (!this.doc) return [];
      var pendingOps = [];
      if (this.doc.inflightOp) pendingOps.push(this.doc.inflightOp);

      pendingOps = pendingOps.concat(this.doc.pendingOps);
      pendingOps = pendingOps.map(function (op) {
        return op.op;
      }).filter(function (op) {
        return op;
      });
      return pendingOps;
    }
  }, {
    key: 'value',
    get: function get$$1() {
      return this.snapshot;
    }

    /**
     * True if we have been processing changes at a reasonable rate,
     * false if changes have been backed up and there is a risk of
     * losing inflight changes.
     */

  }, {
    key: 'needsCatchup',
    get: function get$$1() {
      if (!this.doc) return true;

      var op = this.doc.inflightOp || this.doc.pendingOps[0];

      if (!op) return false;
      if (op.retries > 1) return true;
      if (Date.now() - op.sentAt > 15000) return true;

      return false;
    }
  }, {
    key: 'canAcceptChanges',
    get: function get$$1() {
      return !!this.doc && !this.needsCatchup;
    }
  }]);
  return CollaborativeDocument;
}();

var debug$2 = Debug('slate-collaboration:selection-synchronizer');

var SelectionSynchronizer = function () {
  // Some object envy here. I wonder if I can come up with a better pattern.
  function SelectionSynchronizer(_ref) {
    var _this = this;

    var fayeClient = _ref.fayeClient,
        onSelectionUpdate = _ref.onSelectionUpdate,
        documentPath = _ref.documentPath,
        userInfo = _ref.userInfo;
    classCallCheck(this, SelectionSynchronizer);

    this.fayeClient = fayeClient;
    this.selections = new Immutable__default.List();
    this.userInfo = userInfo;
    this.selectionId = userInfo.selectionId;
    this.documentPath = documentPath;
    this.onSelectionUpdate = onSelectionUpdate;
    this.docVersion = null;
    this.lastSentSelection = null;

    this.subscription = this.fayeClient.subscribe('/selections/' + documentPath, function (message) {
      if (message.selectionId === _this.selectionId) return;
      if (message.docVersion < _this.docVersion) return;

      message.receivedAt = Date.now();
      message.selection = Slate.Selection.create(message.selection);

      if (message.docVersion === _this.docVersion) {
        _this.onSelectionUpdate(message);
        if (debug$2.enabled) debug$2('received ' + JSON.stringify(message));
      } else if (debug$2.enabled) {
        debug$2('received and queued ' + JSON.stringify(message));
      }
      _this.selections = _this.selections.push(message);
    });
  }

  createClass(SelectionSynchronizer, [{
    key: 'setUserInfo',
    value: function setUserInfo(newUserInfo) {
      this.userInfo = _extends({}, this.userInfo, newUserInfo);
      if (this.lastSentSelection) {
        this.lastSentSelection.userInfo = this.userInfo;
        this.resendSelection();
      }
    }
  }, {
    key: 'didUpdateDocumentToVersion',
    value: function didUpdateDocumentToVersion(newDocVersion) {
      var _this2 = this;

      if (newDocVersion === this.docVersion) return;

      this.docVersion = newDocVersion;
      if (debug$2.enabled) debug$2('accepting version ' + this.docVersion);

      this.selections = this.selections.filterNot(function (message) {
        return message.docVersion < newDocVersion;
      });

      this.selections.filter(function (message) {
        return message.docVersion === newDocVersion;
      }).forEach(function (message) {
        if (debug$2.enabled) debug$2('releasing ' + JSON.stringify(message));
        _this2.onSelectionUpdate(message);
      });
    }
  }, {
    key: 'sendSelection',
    value: function sendSelection(value, docVersion) {
      if (typeof docVersion !== 'number') return;
      if (!value.selection.isSet) return;
      if (debug$2.enabled && this.docVersion !== docVersion) {
        debug$2('sending & accepting version ' + docVersion);
      }
      this.docVersion = docVersion;
      var selection = {
        selectionId: this.selectionId,
        userInfo: this.userInfo,
        selection: value.selection.toJSON(),
        docVersion: docVersion
      };
      this.lastSentSelection = selection;
      this._publishSelection(selection);
    }
  }, {
    key: 'refreshSelections',
    value: function refreshSelections(docVersion) {
      var _this3 = this;

      this.selections.filter(function (message) {
        return message.docVersion === docVersion;
      }).forEach(function (message) {
        return _this3.onSelectionUpdate(message);
      });
    }
  }, {
    key: 'transformSelection',
    value: function transformSelection(selectionData, transformFunction) {
      return _extends({}, selectionData, {
        selection: transformFunction(selectionData.selection)
      });
    }
  }, {
    key: 'resendSelection',
    value: function resendSelection() {
      if (this.lastSentSelection) this._publishSelection(this.lastSentSelection);
    }
  }, {
    key: 'stopSynchronizing',
    value: function stopSynchronizing() {
      this.subscription.cancel();
    }
  }, {
    key: '_publishSelection',
    value: function _publishSelection(selection) {
      if (debug$2.enabled) debug$2('publishing ' + JSON.stringify(selection));
      this.fayeClient.publish('/selections/' + this.documentPath, selection);
    }
  }]);
  return SelectionSynchronizer;
}();

var debug$3 = Debug('slate-collaboration:presence');

var DocumentWithPresence = function () {
  function DocumentWithPresence(_ref) {
    var _this = this;

    var collaborativeDocument = _ref.collaborativeDocument,
        fayeClient = _ref.fayeClient,
        userInfo = _ref.userInfo,
        onUpdate = _ref.onUpdate,
        onRollback = _ref.onRollback;
    classCallCheck(this, DocumentWithPresence);

    this._transformAndUpdateSelection = function (selection) {
      var doc = _this.collaborativeDocument;

      if (selection.selection.isFocused) {
        var transformedSelection = _this._transformSelection(selection, doc.pendingOperations, doc.snapshot);
        _this.selections = _this.selections.set(transformedSelection.selectionId, transformedSelection);
      } else {
        _this.selections = _this.selections.delete(selection.selectionId);
      }
      if (_this.onUpdate) {
        _this.onUpdate(doc.snapshot, doc.version, _this.selections);
      }
    };

    this._clearExpiredSelections = function () {
      var totalSelectionCount = _this.selections.size;
      _this.selections = _this.selections.filter(function (selection) {
        return selection.receivedAt > Date.now() - 30000;
      });
      if (totalSelectionCount === _this.selections.size) return;

      if (_this.onUpdate) {
        _this.onUpdate(_this.collaborativeDocument.snapshot, _this.collaborativeDocument.version, _this.selections);
      }
    };

    this._resendCurrentSelection = function () {
      _this.selectionSynchronizer.resendSelection();
    };

    this.collaborativeDocument = collaborativeDocument;
    this.onUpdate = onUpdate;
    this.onRollback = onRollback;
    this.selections = Immutable.Map({});
    this.intervals = {};
    this.selectionSynchronizer = new SelectionSynchronizer({
      fayeClient: fayeClient,
      onSelectionUpdate: this._transformAndUpdateSelection,
      documentPath: collaborativeDocument.identifier,
      userInfo: userInfo
    });
    this._setupCollaborationCallbacks(this.collaborativeDocument);
  }

  createClass(DocumentWithPresence, [{
    key: 'setUserInfo',
    value: function setUserInfo(userInfo) {
      this.selectionSynchronizer.setUserInfo(userInfo);
    }
  }, {
    key: 'load',
    value: function load(initialValue, initialVersion) {
      this.collaborativeDocument.load(initialValue, initialVersion);
    }
  }, {
    key: 'connect',
    value: function connect(onSubscribed) {
      var _this2 = this;

      this.collaborativeDocument.connect(function () {
        _this2.intervals.clearExpired = setInterval(_this2._clearExpiredSelections, 10000);
        if (onSubscribed) onSubscribed();
      });

      return this;
    }
  }, {
    key: 'close',
    value: function close(callback) {
      clearInterval(this.intervals.clearExpired);
      clearInterval(this.intervals.resendSelection);
      this.selectionSynchronizer.stopSynchronizing();
      this.collaborativeDocument.close(callback);
    }
  }, {
    key: 'submitChange',
    value: function submitChange(change) {
      var ops = change.operations.filterNot(function (op) {
        return op.type === 'set_selection' || op.type === 'set_value';
      });

      if (ops.size > 0) {
        this._transformSelections(ops, this.collaborativeDocument.snapshot);
      }

      this.collaborativeDocument.submitChange(change);
    }
  }, {
    key: 'flushOperations',
    value: function flushOperations() {
      this.collaborativeDocument.flushOperations();
    }
  }, {
    key: 'rollback',
    value: function rollback() {
      this.collaborativeDocument.rollback();
    }
  }, {
    key: 'onRemoteOperationsReceived',
    value: function onRemoteOperationsReceived(callback) {
      this.collaborativeDocument.onRemoteOperationsReceived(callback);
    }

    // Transforms incoming selections as they're received, and updates the UI.

  }, {
    key: '_transformSelection',
    value: function _transformSelection(selectionData, ops, value) {
      var _this3 = this;

      var transformedSelectionData = this.selectionSynchronizer.transformSelection(selectionData, function (selection) {
        return _this3.collaborativeDocument.otSlateType.transformSelection(selection, ops, value);
      });

      if (debug$3.enabled) {
        debug$3('transformed selection ' + JSON.stringify(selectionData) + '\n\nagainst ' + JSON.stringify(ops) + '\n\ninto ' + JSON.stringify(transformedSelectionData));
      }
      return transformedSelectionData;
    }
  }, {
    key: '_setupCollaborationCallbacks',
    value: function _setupCollaborationCallbacks(doc) {
      var _this4 = this;

      doc.onUpdate(function (snapshot, version) {
        if (_this4.onUpdate) _this4.onUpdate(snapshot, version, _this4.selections);
        if (!doc.hasPendingWrites()) {
          _this4._sendSelection(snapshot, version);
        }
      });

      doc.onRollback(function (error, snapshot, version) {
        _this4.selections = Immutable.Map({});
        if (_this4.onRollback) _this4.onRollback(error, snapshot, version);
      });

      doc.onVersionChanged(function (newVersion) {
        _this4.selectionSynchronizer.didUpdateDocumentToVersion(newVersion);
      });

      doc.onOperationsAcknowledged(function (snapshot, version) {
        // In order for a selection we send to be valid, it has to be:
        //
        //   - On a version of the document that has all remote changes
        //   - On a version of the document that has *only* our changes
        //     that have been acknowledged by the server
        //
        // Since there's no good way I can find to create a document
        // like that at this point, we'll wait until our doc is
        // completely up-to-date with the server before sending our
        // current selection. This delays our selections, but since
        // remote clients will be transforming them anyway as they
        // receive our changes, it's not all that noticeable.

        // TODO: Some other possible options:
        //
        //   Still use change.value when sending operations, but transform
        //   the value as ops come in, or queue the ops as the selection
        //   goes out. I don't think this will actually work, because the
        //   ops I'm yielded have already been transformed against pending ops.
        //
        //   I could invert all the queued / pending ops, apply the
        //   inverses to the snapshot, and send the resulting
        //   selection. This only works if the pending ops have been
        //   transformed against the incoming ops so that they're
        //   invertable on the new snapshot, which I think they should be.
        //
        //   A slightly hackier way would be to see if any remote ops came
        //   in (through doc version, maybe) and only send with pending
        //   writes if no reads have come in. Then I can still use change.value.
        if (!doc.hasPendingWrites()) {
          _this4._sendSelection(snapshot, version);
        }
      });

      doc.onRemoteOperationsReceived(function (operations, _startValue, endValue) {
        _this4._transformSelections(operations, endValue);
      });
    }
  }, {
    key: '_sendSelection',
    value: function _sendSelection(snapshot, version) {
      this.selectionSynchronizer.sendSelection(snapshot, version);

      if (snapshot.selection.isFocused && !this.intervals.resendSelection) {
        // If the selection is focused, send heartbeat updates.
        this.intervals.resendSelection = setInterval(this._resendCurrentSelection, 15000);
      } else if (!snapshot.selection.isFocused) {
        // Otherwise, the selection won't get displayed anyway, so don't
        // send updates.
        clearInterval(this.intervals.resendSelection);
        this.intervals.resendSelection = null;
      }
    }
  }, {
    key: '_transformSelections',
    value: function _transformSelections(operations, value) {
      var _this5 = this;

      this.selections = this.selections.map(function (selection) {
        return _this5._transformSelection(selection, [operations], value);
      });
    }
  }, {
    key: 'groupName',
    get: function get$$1() {
      return this.collaborativeDocument.groupName;
    }
  }, {
    key: 'documentId',
    get: function get$$1() {
      return this.collaborativeDocument.documentId;
    }
  }, {
    key: 'otSlateType',
    get: function get$$1() {
      return this.collaborativeDocument.otSlateType;
    }
  }, {
    key: 'value',
    get: function get$$1() {
      return this.collaborativeDocument.value;
    }
  }, {
    key: 'canAcceptChanges',
    get: function get$$1() {
      return this.collaborativeDocument.canAcceptChanges;
    }
  }]);
  return DocumentWithPresence;
}();

var Schema$2 = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var schema = {
    document: {
      nodes: [{
        match: [{
          object: 'block'
        }],
        min: 1
      }],
      normalize: function normalize(change, error) {
        if (error.code === 'child_min_invalid') {
          return change.insertNodeByKey(error.node.key, 0, Slate.Block.create({
            type: options.defaultBlock || 'paragraph',
            nodes: [Slate.Text.create()]
          })).moveToStart();
        }
      }
    }
  };
  return [{
    schema: schema
  }];
});

var SelectionName = (function (props) {
  var backgroundColor = props.color,
      top = props.top,
      left = props.left,
      name = props.name;


  var style = {
    position: 'absolute',
    top: top,
    left: left,
    backgroundColor: backgroundColor
  };

  return React__default.createElement(
    'div',
    { style: style, className: 'selection-name' },
    name
  );
});

/**
 * Finds the first parent who's position is not static.
 * It will return the initial element if it is positioned.
 * @param {Element} DOM element from where to start the search for a positioned/non-static DOM element.
 * @returns {Element} The first positioned/non-static DOM element in the given element's hierarchy.
 */
var findPositionedContainer = findParent(function (el) {
  return window.getComputedStyle(el).position !== 'static';
});

function transformRectAgainstContainer(rect, containerRect) {
  var top = rect.top,
      left = rect.left,
      width = rect.width,
      height = rect.height;

  if (!containerRect) {
    return {
      top: top + window.pageYOffset,
      left: left + window.pageXOffset,
      width: width,
      height: height
    };
  }

  return {
    top: rect.top - containerRect.top,
    left: rect.left - containerRect.left,
    width: rect.width,
    height: rect.height
  };
}

function positionOfCursorInDocument(editor, document, selection) {
  var anchorNode = document.getDescendant(selection.anchor.path);
  var focusNode = document.getDescendant(selection.focus.path);

  if (!anchorNode) {
    console.error('Couldn\'t draw a selection at path: ' + JSON.stringify(selection.anchor.path));
    return Immutable.List();
  }

  if (!focusNode) {
    console.error('Couldn\'t draw a selection at path: ' + JSON.stringify(selection.focus.path));
    return Immutable.List();
  }

  var slateSelection = document.createSelection(selection);
  var domRange = editor.findDOMRange(slateSelection);
  if (!domRange) return;
  var clientRects = textNodeRects(domRange);
  return Immutable.List(clientRects);
}

// domRange.getClientRects() returns the rects for every element,
// but we only want to show the text nodes that are highlighted (to
// avoid overlapping selections).
function textNodeRects(domRange) {
  var selectionRects = domRange.getClientRects();
  if (selectionRects.length === 0) {
    return selectionRects;
  }

  if (domRange.startContainer === domRange.endContainer) {
    return selectionRects;
  }

  var rects = [];
  var inSelection = false;

  var parentNode = domRange.commonAncestorContainer;

  function acceptNode() {
    return NodeFilter.FILTER_ACCEPT;
  }

  // COMPAT: IE11 wants a function, not an object. We can give them both.
  var safeFilter = acceptNode;
  safeFilter.acceptNode = acceptNode;

  var treeWalker = document.createTreeWalker(parentNode, NodeFilter.SHOW_TEXT, safeFilter, false);

  while (treeWalker.nextNode() && treeWalker.currentNode !== domRange.endContainer) {
    if (treeWalker.currentNode === domRange.startContainer) {
      inSelection = true;
      rects.push(selectionRects[0]);
    } else if (inSelection && treeWalker.currentNode.parentNode && treeWalker.currentNode.parentNode.nodeType === treeWalker.currentNode.ELEMENT_NODE) {
      var clientRects = treeWalker.currentNode.parentNode.getClientRects();
      for (var i = 0; i < clientRects.length; i++) {
        rects.push(clientRects[i]);
      }
    }
  }

  if (domRange.startContainer !== domRange.endContainer) {
    rects.push(selectionRects[selectionRects.length - 1]);
  }

  return rects;
}

// S=0.5, V=0.99
var COLORS$1 = ['#98fdc1', '#fda398', '#98a9fd', '#c7fd98', '#fd98e5', '#98fdf8', '#fdda98', '#bd98fd', '#98fd9f', '#fd98ae', '#98cbfd', '#e9fd98', '#f398fd', '#98fdd6', '#fdb898', '#9b98fd', '#b2fd98', '#fd98d0', '#98edfd', '#fdef98', '#d298fd', '#98fdb4', '#fd9899', '#98b6fd', '#d4fd98', '#fd98f1'];

function fetchExtraUserInfo(userInfo, fetchUserInfo, setExtraUserInfo, cancelToken) {
  if (fetchUserInfo) {
    fetchUserInfo(userInfo, cancelToken).then(setExtraUserInfo);
  }
}

// clientRect includes borders, but absolute positioning
// doesn't. This function returns a rect that's suitable for
// absolute positioning.
function getPaddingBox(container) {
  var containerRect = container.getBoundingClientRect();
  if (!containerRect) return;

  var style = window.getComputedStyle(container);
  var border = {
    left: parseInt(style.borderLeftWidth, 10),
    top: parseInt(style.borderTopWidth, 10),
    right: parseInt(style.borderRightWidth, 10),
    bottom: parseInt(style.borderBottomWidth, 10)
  };

  return {
    left: containerRect.left + border.left,
    top: containerRect.top + border.top,
    width: containerRect.width - (border.left + border.right),
    height: containerRect.height - (border.top + border.bottom)
  };
}

function updateContainerRect(selectionOverlay, setContainerRect) {
  var container = findPositionedContainer(selectionOverlay);
  if (container) {
    setContainerRect(getPaddingBox(container));
  }
}

function SelectionOverlay(_ref) {
  var fetchUserInfo = _ref.fetchUserInfo,
      editor = _ref.editor,
      document = _ref.document,
      selection = _ref.selection;

  var _useState = React.useState(Immutable.List()),
      _useState2 = slicedToArray(_useState, 2),
      rects = _useState2[0],
      setRects = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      containerRect = _useState4[0],
      setContainerRect = _useState4[1];

  var _useState5 = React.useState({}),
      _useState6 = slicedToArray(_useState5, 2),
      extraUserInfo = _useState6[0],
      setExtraUserInfo = _useState6[1];

  var selectionOverlay = React.useRef(null);

  var updateSelectionRects = React.useCallback(function (selectionOverlay) {
    var rects = positionOfCursorInDocument(editor, document, selection.selection);
    if (rects) {
      setRects(rects);
      updateContainerRect(selectionOverlay, setContainerRect);
    }
  }, [editor, document, selection, setRects]);

  React.useEffect(function () {
    if (!selection) return;
    updateSelectionRects(selectionOverlay.current);
  }, [document, selection, updateSelectionRects]);

  React.useEffect(function () {
    var cancelToken = {};
    fetchExtraUserInfo(selection.userInfo, fetchUserInfo, setExtraUserInfo, cancelToken);

    return function () {
      if (cancelToken.cancel) {
        cancelToken.cancel();
      }
    };
  }, [selection.userInfo, fetchUserInfo]);

  React.useEffect(function () {
    if (!selection) return;

    var boundUpdateSelectionRects = function boundUpdateSelectionRects() {
      return updateSelectionRects(selectionOverlay.current);
    };
    var debouncedUpdateSelectionRects = debounce(boundUpdateSelectionRects, 100);
    var observer = null;

    window.addEventListener('resize', boundUpdateSelectionRects);
    window.addEventListener('scroll', debouncedUpdateSelectionRects);

    if (window.MutationObserver) {
      observer = new MutationObserver(boundUpdateSelectionRects);

      observer.observe(findPositionedContainer(selectionOverlay.current), {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    return function () {
      window.removeEventListener('resize', boundUpdateSelectionRects);
      window.removeEventListener('scroll', debouncedUpdateSelectionRects);
      observer && observer.disconnect();
      debouncedUpdateSelectionRects.cancel();
    };
  });

  var userInfo = _extends({}, selection.userInfo, extraUserInfo);
  var displayName = userInfo.displayName;

  var cursorWidth = 2;

  if (!containerRect || !displayName || displayName.length === 0 || !rects || rects.size === 0) {
    // Return an empty div, so we can find the parent container we're
    // relative to in componentDidMount/Update
    return React__default.createElement('div', { ref: selectionOverlay });
  }

  var backgroundColor = COLORS$1[selection.selectionId % COLORS$1.length];

  var selectionRects = rects.map(function (rect, i) {
    var _transformRectAgainst = transformRectAgainstContainer(rect, containerRect),
        top = _transformRectAgainst.top,
        left = _transformRectAgainst.left,
        width = _transformRectAgainst.width,
        height = _transformRectAgainst.height;

    if (width === 0) return null;

    var style = {
      position: 'absolute',
      top: top,
      left: left,
      width: width,
      height: height,
      backgroundColor: backgroundColor,
      opacity: 0.3
    };
    return React__default.createElement('div', { key: i, style: style, className: 'selection-overlay' });
  });

  var cursor = {
    position: 'absolute',
    backgroundColor: backgroundColor,
    width: cursorWidth
  };

  if (selection.selection.isBackward) {
    var rect = transformRectAgainstContainer(rects.first(), containerRect);
    cursor.top = rect.top;
    cursor.left = rect.left - cursorWidth / 2;
    cursor.height = rect.height;
  } else {
    var _rect = transformRectAgainstContainer(rects.last(), containerRect);
    cursor.top = _rect.top;
    cursor.left = _rect.left + _rect.width - cursorWidth / 2;
    cursor.height = _rect.height;
  }

  return React__default.createElement(
    'div',
    { ref: selectionOverlay },
    React__default.createElement(SelectionName, {
      name: displayName,
      top: cursor.top,
      left: cursor.left,
      color: backgroundColor
    }),
    selectionRects,
    React__default.createElement('div', { style: cursor, className: 'selection-cursor' })
  );
}

SelectionOverlay.propTypes = {
  fetchUserInfo: PropTypes.func,
  document: PropTypes.instanceOf(Slate.Document).isRequired,
  selection: PropTypes.object.isRequired
};

/**
 * @param {{editor: Slate.Editor, document: Slate.Document, selections: Object, fetchUserInfo: Function}} props
 */
var Selections = function Selections(_ref) {
  var editor = _ref.editor,
      document = _ref.document,
      selections = _ref.selections,
      fetchUserInfo = _ref.fetchUserInfo;

  if (!selections) return null;
  var style = { overflow: 'visible' };
  return React__default.createElement(
    'div',
    { style: style, className: 'selections' },
    selections.valueSeq().map(function (selection) {
      return React__default.createElement(SelectionOverlay, {
        key: selection.selectionId,
        editor: editor,
        document: document,
        selection: selection,
        fetchUserInfo: fetchUserInfo
      });
    })
  );
};

// ShareDB is pretty good at handling actual errors, but not great at
// handling recoverable errors, like invalid or expired tokens. In
// order to give an editor client the hooks they need to recover from
// errors, we need to be able to intercept them before ShareDB can get
// ahold of them. The best place to do this is in `connection`'s
// `handleMessage`, so we'll monkey-patch that here.
//
// @param connection a ShareDB Connection object
// @param onError an error handler. This handler should immediately
//        return true if it can recover from the error, and is passed
//        a callback it should call once it's successfully recovered
//        from the error.
function handleErrors(connection, errorHandlers) {
  var oldHandleMessage = connection.handleMessage.bind(connection);
  var findHandler = function findHandler(collection, id) {
    if (errorHandlers[collection]) {
      return errorHandlers[collection][id];
    }
  };

  var handleSubscribeError = function handleSubscribeError(error, collection, documentId) {
    var doc = connection.getExisting(collection, documentId);
    var onError = findHandler(collection, documentId);

    // If we failed on a 'subscribe' operation, we want to send
    // all of our pending operations and resubscribe once we've
    // recovered.
    return onError && onError(error, function () {
      doc.flush();
      doc._resubscribe();
    });
  };

  connection.handleMessage = function (message) {
    if (message.error) {
      var err = new Error(message.error.message);
      err.code = message.error.code;
      err.data = message;

      if (message.a === 'op') {
        var doc = this.getExisting(message.c, message.d);
        var onError = findHandler(message.c, message.d);

        // If we failed on an 'op' operation, we want to immediately
        // disconnect from the document, and reconnect once we've
        // recovered.
        if (onError && onError(err, function () {
          if (doc.inflightOp) {
            doc.pendingOps.unshift(doc.inflightOp);
            doc.inflightOp = null;
          }
          doc.flush();
          doc.subscribe();
        })) {
          doc.unsubscribe();
          return;
        }
      } else if (message.a === 's') {
        if (handleSubscribeError(err, message.c, message.d)) return;
      } else if (message.a === 'bs') {
        var handled = [];

        if (message.data) {
          for (var id in message.data) {
            handled.push(handleSubscribeError(err, message.c, id));
          }
        } else if (Array.isArray(message.b)) {
          message.b.forEach(function (id) {
            handled.push(handleSubscribeError(err, message.c, id));
          });
        } else if (message.b) {
          for (var _id in message.b) {
            handled.push(handleSubscribeError(err, message.c, _id));
          }
        }

        if (handled.length > 0 && handled.every(function (e) {
          return e;
        })) return;
      }
      console.error('Unhandled collaboration error during action \'' + err.data.a + '\': (' + err.code + ') ' + err.message);
    }

    // If we can't recover from the error, defer to the original
    // handleMessage.
    oldHandleMessage(message);
  };
}

var insecureRandomId = function insecureRandomId() {
  return Math.floor(Math.random() * 10000000);
};

var connections = new WeakMap();
var userInfo = {};
var errorHandlers = {};

function addErrorHandler(collection, id, handler) {
  if (!handler) return;
  if (!errorHandlers[collection]) {
    errorHandlers[collection] = {};
  }

  errorHandlers[collection][id] = handler;
}

function removeErrorHandler(collection, id) {
  if (errorHandlers[collection]) {
    delete errorHandlers[collection][id];
  }
}

// Available options:
//  - getCollaborationServer: A function that returns a WebSocket connected to the ShareDB server
//  - getFayeClient: A function that returns a faye client, for syncing cursors
//  - defaultBlock: The default block type to use for invalid documents  (defaults to 'paragraph')
var CollaborationPlugin = (function (options) {
  options = options || {};
  var connection = null;
  var fayeClient = null;
  var socket = null;
  var onError = null;
  var onConnect = options.onConnect || function () {};
  var openDocumentOnConnect = null;

  var init = function init() {
    if (options.onError) {
      onError = options.onError;
    }

    fayeClient = options.getFayeClient();
    socket = options.getCollaborationServer();

    connection = connections.get(socket);

    if (connection) {
      onConnect();
      return;
    }

    connection = new ShareDB.Connection(socket);
    connections.set(socket, connection);

    // These IDs don't need to be private, since they're part of the
    // selection broadcast to other users. They just need a low
    // chance of collision.
    userInfo = { selectionId: insecureRandomId() };
    handleErrors(connection, errorHandlers);
    onConnect();
  };

  var disconnect = function disconnect() {
    connection.close();
    connection = null;
    connections.delete(socket);
    socket = null;
  };

  var openDocument = function openDocument(documentCollection, documentId, initialValue, initialVersion, createEditor, onDocumentStateChange, onUpdate, callback) {
    addErrorHandler(documentCollection, documentId, onError);
    var doc = new CollaborativeDocument(connection, documentCollection, documentId, createEditor);

    if (onDocumentStateChange) {
      doc.onDocumentStateChange(onDocumentStateChange);
    }

    var collaborativeDocument = new DocumentWithPresence({
      collaborativeDocument: doc,
      fayeClient: fayeClient,
      userInfo: userInfo,
      onUpdate: onUpdate,
      onRollback: function onRollback(error, snapshot, version) {
        if (options.onRollback) options.onRollback(error, snapshot);
      }
    });

    collaborativeDocument.load(initialValue, initialVersion);
    return collaborativeDocument;
  };

  var connectDocument = function connectDocument(collaborativeDocument, callback) {
    if (openDocumentOnConnect) {
      connection.removeListener('connected', openDocumentOnConnect);
    }

    openDocumentOnConnect = function openDocumentOnConnect() {
      collaborativeDocument.connect(function () {
        if (callback) callback();
      });
    };

    if (connection.state === 'connected') {
      openDocumentOnConnect();
    } else {
      connection.once('connected', openDocumentOnConnect);
    }
  };

  var closeDocument = function closeDocument(collaborativeDocument, callback) {
    var groupName = collaborativeDocument.groupName,
        documentId = collaborativeDocument.documentId;


    if (connection && openDocumentOnConnect) {
      connection.removeListener('connected', openDocumentOnConnect);
    }

    collaborativeDocument.close(function (err) {
      removeErrorHandler(groupName, documentId);
      callback && callback(err);
    });
  };

  var changes = {
    apply: function apply(collaborativeDocument, change) {
      if (collaborativeDocument && collaborativeDocument.canAcceptChanges) {
        collaborativeDocument.submitChange(change);
      }
    }
  };

  /**
   * When changes are prevented from reaching the undo stack, the undo
   * stack needs to act as if those changes have happened in order to
   * undo themselves correcly. Transforming the undo stack to take those
   * changes into account is the correct behavior most of the time.
   *
   * Sometimes we just want to apply operations directly to the value,
   * as if the undo stack doesn't exist. For example, collaborative
   * editing applying operations to bring its version of the value up to
   * date, or during OT to prevent recursive transformation.
   *
   * This prevents transforming the undo stack when running a change
   * that's prevented from reaching the stack.
   *
   * @param {Editor} editor
   * @param {Block} [fn] A function to run. If inside this function an operation skips the undo stack, the undo stack will not transform based on it.
   */
  var withoutUndoTransforming = function withoutUndoTransforming(editor, fn) {
    var value = editor.tmp.transformUndo;
    editor.tmp.transformUndo = false;
    if (fn) {
      fn(editor);
      editor.tmp.transformUndo = value;
    }
    return editor;
  };

  var plugins = [].concat(toConsumableArray(Schema$2()), [{
    commands: {
      withoutUndoTransforming: withoutUndoTransforming
    },
    onCommand: function onCommand(_ref, editor, next) {
      var type = _ref.type,
          args = _ref.args;

      var undoStack = editor.value.data.get('history');
      if (!undoStack) {
        return next();
      }

      switch (type) {
        case 'save':
          undoStack.save.apply(undoStack, [editor].concat(toConsumableArray(args)));
          break;
        case 'undo':
          undoStack.undo(editor);
          break;
        case 'redo':
          undoStack.redo(editor);
          break;
        default:
          return next();
      }
    }
  }]);

  var components = {
    Selections: Selections
  };

  return {
    plugins: plugins,
    changes: changes,
    components: components,
    init: init,
    disconnect: disconnect,
    openDocument: openDocument,
    connectDocument: connectDocument,
    closeDocument: closeDocument,
    DocumentState: DocumentState
  };
});

var styles$5 = { "dropShadow": "ResizableMediaElement-module_dropShadow__3tUiD" };

var styles$6 = { "selection": "Resizer-module_selection__1RXDR", "selected": "Resizer-module_selected__2zBI9", "resizerPad": "Resizer-module_resizerPad__18k99", "resizer": "Resizer-module_resizer__1a2VU", "resizing": "Resizer-module_resizing__WVvyX", "handle": "Resizer-module_handle__2fqM4", "dragging": "Resizer-module_dragging__4NvxO", "active": "Resizer-module_active__2lhE_", "pixelSize": "Resizer-module_pixelSize__26qcS", "width": "Resizer-module_width__31wMR" };

var HANDLE_SIZE = 10;
var halfHandle = HANDLE_SIZE / 2;
var cursorPos = {
  top: 'n',
  bottom: 's',
  left: 'w',
  right: 'e'
};

var DragHandle$2 = function (_Component) {
  inherits(DragHandle, _Component);

  function DragHandle() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, DragHandle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DragHandle.__proto__ || Object.getPrototypeOf(DragHandle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false
    }, _this.onMouseMove = function (event) {
      if (_this.state.dragging) {
        event.stopPropagation();
        event.preventDefault();

        var x = event.clientX,
            y = event.clientY;


        _this.props.onMove(x, y);
        _this.lastMove = { x: x, y: y };
      }
    }, _this.onMouseDown = function (event) {
      _this.setState({ dragging: true });
      document.addEventListener('mousemove', _this.onMouseMove);
      document.addEventListener('mouseup', _this.onMouseUp);

      if (_this.props.onMoveStart) {
        _this.props.onMoveStart();
      }

      event.stopPropagation();
    }, _this.onMouseUp = function (event) {
      _this.setState({ dragging: false });
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('mouseup', _this.onMouseUp);

      if (_this.lastMove) {
        _this.props.onMoved(_this.lastMove.x, _this.lastMove.y);
        _this.lastMove = null;
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(DragHandle, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ dragging: false });
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _style, _classnames;

      var position = this.props.position;

      var style = (_style = {}, defineProperty(_style, position.includes('top') ? 'top' : 'bottom', '-' + halfHandle + 'px'), defineProperty(_style, position.includes('left') ? 'left' : 'right', '-' + halfHandle + 'px'), defineProperty(_style, 'cursor', position.split(/\s+/).map(function (p) {
        return cursorPos[p];
      }).join('') + '-resize'), _style);

      var classNames = classnames((_classnames = {}, defineProperty(_classnames, styles$6.handle, true), defineProperty(_classnames, styles$6.dragging, this.state.dragging), _classnames));

      return React__default.createElement('span', {
        className: classNames,
        style: style,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp
      });
    }
  }]);
  return DragHandle;
}(React.Component);

DragHandle$2.propTypes = {
  onMove: PropTypes.func.isRequired,
  onMoved: PropTypes.func.isRequired,
  onMoveStart: PropTypes.func
};

function PixelSize(_ref) {
  var width = _ref.width,
      height = _ref.height;

  width = Math.round(width);
  height = Math.round(height);

  return React__default.createElement(
    'span',
    { className: styles$6.pixelSize },
    React__default.createElement(
      'span',
      { className: styles$6.width },
      width
    ),
    React__default.createElement(
      'span',
      { className: styles$6.height },
      height
    )
  );
}

/**
 * Component that draws the image selection box around given children
 */
function Selection(_ref) {
  var _classnames;

  var isFocused = _ref.isFocused,
      readOnly = _ref.readOnly,
      children = _ref.children,
      inline = _ref.inline;

  var Tag = inline ? 'span' : 'div';

  return React__default.createElement(
    Tag,
    {
      className: classnames((_classnames = {}, defineProperty(_classnames, styles$6.selection, true), defineProperty(_classnames, styles$6.selected, !readOnly && isFocused), _classnames))
    },
    children
  );
}

var BORDER_WIDTH = 2;
var MIN_SIZE = 20;

var Resizer = function (_Component) {
  inherits(Resizer, _Component);

  function Resizer(props) {
    classCallCheck(this, Resizer);

    var _this = possibleConstructorReturn(this, (Resizer.__proto__ || Object.getPrototypeOf(Resizer)).call(this, props));

    _this.calculateMaxWidth = function () {
      var element = ReactDOM.findDOMNode(_this);
      var oldWidth = element.style.width;
      element.style.width = '100%';
      var elementWidth = element.clientWidth;
      element.style.width = oldWidth;

      // If we couldn't compute the max width, don't set it.
      if (elementWidth === 0) {
        return;
      }

      _this.setState({ maxWidth: elementWidth });

      _this.setDimensions(_this.state.resizedWidth, _this.state.resizedHeight, false, elementWidth);
    };

    _this.onWindowResize = debounce(_this.calculateMaxWidth, 100);

    _this.onResize = function (commit, position) {
      return function (x, y) {
        if (!_this.element) {
          return;
        }

        var rect = _this.element.getBoundingClientRect();
        var width = void 0,
            height = void 0;

        if (position.includes('left')) {
          width = rect.width - (x - rect.left);
        } else {
          width = x - rect.left;
        }

        if (position.includes('top')) {
          height = rect.height - (y - rect.top);
        } else {
          height = y - rect.top;
        }

        _this.setDimensions(width, height, commit);
      };
    };

    _this.setDimensions = function (width, height, commit) {
      var maxWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this.maxWidth;

      // Don't clamp to maxWidth in readOnly mode or when in a knowledge base.
      // Elements have CSS max-width: 100% anyway and this will clamp the width to
      // the puppeteer window size, resulting in these objects being smaller than
      // the user intended.
      if (!_this.props.readOnly || window.isKnowledgeBase) {
        width = _this.clampSize(width, maxWidth);
      }
      width = Math.max(Math.round(width), MIN_SIZE);

      if (_this.props.keepRatio) {
        height = width * _this.ratio;
        if (!_this.props.readOnly || window.isKnowledgeBase) {
          height = _this.clampSize(height, _this.maxHeight);
        }
      } else {
        height = Math.max(height, MIN_SIZE);
      }
      height = Math.round(height);

      if (commit) {
        _this.skipOut = true;
        _this.props.onResized(width, height);
        _this.setState({
          resizing: false,
          height: height,
          width: width,
          resizedWidth: width,
          resizedHeight: height
        });
      } else {
        if (_this.props.liveResize && _this.props.onResize) {
          _this.props.onResize(width, height);
        }
        _this.setState({ width: width, height: height });
      }
    };

    _this.onResizeStart = function (position) {
      return function () {
        _this.calculateMaxWidth();
        if (_this.props.onResizeStart) {
          _this.props.onResizeStart();
        }
        _this.setState({ resizing: true });
      };
    };

    _this.state = {
      active: false,
      resizing: false,
      width: props.width,
      maxWidth: 0,
      maxHeight: 0,
      height: props.height,
      resizedWidth: props.width,
      resizedHeight: props.height
    };
    return _this;
  }

  createClass(Resizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onWindowResize);
      this.onWindowResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onWindowResize);
      this.onWindowResize.cancel();
    }
  }, {
    key: 'clampSize',
    value: function clampSize(currentSize, maxSize) {
      return Math.min(isNaN(currentSize) ? 0 : currentSize, isNaN(maxSize) ? Infinity : maxSize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.isFocused && !this.state.active) {
        // On selection check the max width so we draw the correct selection
        // rectangle. This solves a problem where an image in a table cell has
        // the table cell reduced in size, so the `max-width` style is controlling.
        this.calculateMaxWidth();
      }
      this.setState({ active: newProps.isFocused });
      if (newProps.width !== this.props.width || newProps.height !== this.props.height) {
        this.setState({
          width: newProps.width,
          height: newProps.height,
          resizedWidth: newProps.width,
          resizedHeight: newProps.height
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classnames;

      var _state = this.state,
          width = _state.width,
          height = _state.height;

      var Tag = this.props.inline ? 'span' : 'div';
      var outerStyle = {
        width: width + BORDER_WIDTH * 2,
        height: height + BORDER_WIDTH * 2
      };

      if (this.props.keepRatio) {
        outerStyle.height = 'auto';
      }

      if (this.props.readOnly) {
        return React__default.createElement(
          Tag,
          {
            className: styles$6.resizerPad,
            style: outerStyle,
            ref: function ref(element) {
              return _this2.element = element;
            }
          },
          React__default.createElement(
            Selection,
            { isFocused: false, readOnly: true, inline: this.props.inline },
            this.props.children
          )
        );
      }

      var handles = ['bottom right'].map(function (position) {
        return React__default.createElement(DragHandle$2, {
          key: position,
          position: position,
          onMoveStart: _this2.onResizeStart(position),
          onMove: _this2.onResize(false, position),
          onMoved: _this2.onResize(true, position)
        });
      });

      var child = void 0;
      if (!this.state.resizing || this.props.liveResize) {
        child = this.props.children;
      } else {
        child = null;
      }

      var pixelSize = this.props.showPixelSize && this.state.resizing ? React__default.createElement(PixelSize, { width: width, height: height }) : null;

      return React__default.createElement(
        Tag,
        {
          className: classnames(styles$6.resizerPad, (_classnames = {}, defineProperty(_classnames, styles$6.resizer, true), defineProperty(_classnames, styles$6.resizing, this.state.resizing), defineProperty(_classnames, styles$6.active, this.state.active), _classnames)),
          style: outerStyle,
          ref: function ref(element) {
            return _this2.element = element;
          }
        },
        React__default.createElement(
          Selection,
          { isFocused: this.state.active, readOnly: this.props.readOnly, inline: this.props.inline },
          child
        ),
        this.props.isResizeable ? handles : null,
        pixelSize
      );
    }
  }, {
    key: 'ratio',
    get: function get$$1() {
      return this.props.height / this.props.width;
    }
  }, {
    key: 'maxWidth',
    get: function get$$1() {
      return this.state.maxWidth;
    }
  }, {
    key: 'maxHeight',
    get: function get$$1() {
      var maxHeight = this.state.maxWidth * this.ratio;
      if (!Number.isNaN(maxHeight)) {
        return maxHeight;
      }
    }
  }]);
  return Resizer;
}(React.Component);

Resizer.propTypes = {
  onResizeStart: PropTypes.func,
  onResize: PropTypes.func,
  onResized: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  keepRatio: PropTypes.bool,
  showPixelSize: PropTypes.bool,
  isFocused: PropTypes.bool.isRequired,
  isResizeable: PropTypes.bool,
  readOnly: PropTypes.bool,
  liveResize: PropTypes.bool,
  inline: PropTypes.bool
};

function getClosestScrollParent(element) {
  if (!element) return;
  if (element === document.body) return document.body;

  var _window$getComputedSt = window.getComputedStyle(element),
      overflowX = _window$getComputedSt.overflowX,
      overflowY = _window$getComputedSt.overflowY;

  var isScrollableX = overflowX !== 'visible' && overflowX !== 'hidden';
  var isScrollableY = overflowY !== 'visible' && overflowY !== 'hidden';

  if ((isScrollableX || isScrollableY) && element.scrollHeight > element.clientHeight) {
    return element;
  }

  return getClosestScrollParent(element.parentElement);
}

var styles$7 = { "form": "MediaToolbar-module_form__17dRY", "input": "MediaToolbar-module_input__3wqYs" };

// @ts-ignore
var AltTextForm = function AltTextForm(_ref) {
  var onDone = _ref.onDone,
      altText = _ref.altText,
      visible = _ref.visible;

  var _useState = React.useState(altText || ''),
      _useState2 = slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  React.useEffect(function () {
    if (!visible) {
      onDone(value);
    }
  }, [visible]);

  return React__default.createElement(
    'div',
    {
      className: styles$7.form,
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          onDone(value);
        }
      }
    },
    React__default.createElement('input', {
      className: styles$7.input,
      type: 'text',
      placeholder: 'Add alt text',
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      }
    })
  );
};

var MediaToolbar = function MediaToolbar(props) {
  // pull `onDismiss` from props
  var node = props.node,
      editor = props.editor,
      visible = props.visible,
      popup = props.popup,
      setHiddenByScroll = props.setHiddenByScroll;

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      showAltTextForm = _useState4[0],
      setShowAltTextForm = _useState4[1];

  var popupElem = popup && popup.el;
  var wrappedElem = popup && popup.wrappedEl;

  var scrollParent = getClosestScrollParent(popupElem);

  // If the popup is visible and the user scrolls, hide the alt text popup.
  React.useEffect(function () {
    var scrollHandler = function scrollHandler() {
      if (visible) setHiddenByScroll(true);
    };

    if (scrollParent) {
      scrollParent.addEventListener('scroll', scrollHandler);
    }

    return function () {
      if (scrollParent) {
        scrollParent.removeEventListener('scroll', scrollHandler);
      }
    };
  }, [scrollParent, setHiddenByScroll, visible, wrappedElem]);

  // If the user hovers over the wrappedElem, make it possible to show the alt text popup. We do this because if the user has scrolled but has not de-selected the image they will not be able to see the alt-text popup again _until_ they have de-selected it. By listening for the mousenter event we can show the alt-text popup again as long as the user is hovering over the image.
  React.useEffect(function () {
    var hoverHandler = function hoverHandler() {
      setHiddenByScroll(false);
    };
    if (wrappedElem) {
      wrappedElem.addEventListener('mouseenter', hoverHandler);
    }

    return function () {
      if (wrappedElem) {
        wrappedElem.removeEventListener('mouseenter', hoverHandler);
      }
    };
  }, [wrappedElem, setHiddenByScroll]);

  if (showAltTextForm) {
    return React__default.createElement(AltTextForm, {
      visible: visible,
      altText: node.data.get('alt'),
      onDone: function onDone(value) {
        if (value !== node.data.get('alt')) {
          editor.setNodeByKey(node.key, {
            data: node.data.set('alt', value)
          });
        }

        setShowAltTextForm(false);
        props.scheduleUpdate();
      }
    });
  } else {
    return React__default.createElement(
      PopupToolbar,
      { className: 'aha-editor-link-popup aha-editor-link-popup--alt-text' },
      React__default.createElement(
        PopupToolbarItem,
        {
          className: 'aha-editor-link-popup__item',
          onClick: function onClick(e) {
            setShowAltTextForm(true);
          }
        },
        'Add alt text'
      )
    );
  }
};

var ResizableMediaElement = function (_Component) {
  inherits(ResizableMediaElement, _Component);

  function ResizableMediaElement() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ResizableMediaElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ResizableMediaElement.__proto__ || Object.getPrototypeOf(ResizableMediaElement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onResize = function (commit) {
      return function (width, height) {
        height = width / _this.ratio;
        _this.setState({ width: width, height: height });

        if (commit) {
          setTimeout(function () {
            return _this.setSize(width, height);
          }, 0);
        }
      };
    }, _this.setDetectedElementSize = function () {
      // If we don't get all the image size details when converting from
      // HTML, we can fetch them now that the image has been
      // loaded. We'll use any data we have, in case someone passed in
      // width but not height. We'll also just use state to store this
      // data until someone actively resizes it, because we have a
      // standard not to force document saves until the user takes some
      // kind of action.
      var naturalWidth = _this.props.tag === 'img' ? _this.element.naturalWidth : _this.element.videoWidth;
      var naturalHeight = _this.props.tag === 'img' ? _this.element.naturalHeight : _this.element.videoHeight;

      var originalDimensions = {
        originalHeight: naturalHeight,
        originalWidth: naturalWidth
      };
      if (!_this.height && _this.width) {
        _this.setState(_extends({}, originalDimensions, {
          height: naturalHeight * _this.width / naturalWidth
        }));
      } else if (_this.height && !_this.width) {
        _this.setState(_extends({}, originalDimensions, {
          width: naturalWidth * _this.height / naturalHeight
        }));
      } else {
        _this.setState(_extends({}, originalDimensions, {
          height: naturalHeight,
          width: naturalWidth
        }));
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ResizableMediaElement, [{
    key: 'setSize',
    value: function setSize(width, height) {
      var _props = this.props,
          node = _props.node,
          editor = _props.editor;

      editor.setNodeByKey(node.key, {
        data: this.data.set('width', width).set('height', height).set('originalWidth', this.originalWidth).set('originalHeight', this.originalHeight)
      });
    }
  }, {
    key: 'detectElementSize',
    value: function detectElementSize() {
      if (!this.element) return;
      if (this.width && this.height) return;

      if (this.props.tag === 'img') {
        this.element.complete ? this.setDetectedElementSize() : this.element.addEventListener('load', this.setDetectedElementSize);
      }

      if (this.props.tag === 'video') {
        this.element.addEventListener('loadedmetadata', this.setDetectedElementSize);
      }
    }

    // Allow for undo and re-render after collaborative changes

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var data = newProps.node.data;


      var newPropsObject = data !== this.props.data;
      if (!newPropsObject) return;
      var newPropsHasDimensions = data.get('width') || data.get('height');
      if (!newPropsHasDimensions) return;

      // Do not set state when props have changed but the new props have the same width and height
      // so that a recently calculated size is not overridden causing the image to jump
      var newPropsHasNewDimensions = data.get('width') !== this.props.node.data.get('width') || data.get('height') !== this.props.node.data.get('height');
      if (newPropsHasNewDimensions) {
        this.setState({
          width: data.get('width') || data.get('height') * this.ratio,
          height: data.get('height') || data.get('width') / this.ratio
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.detectElementSize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.element) {
        if (this.props.tag === 'img') {
          this.element.removeEventListener('load', this.setDetectedElementSize);
        }
        if (this.props.tag === 'video') {
          this.element.removeEventListener('loadedmetadata', this.setDetectedElementSize);
        }
      }
    }
  }, {
    key: 'renderWithWrapper',
    value: function renderWithWrapper(children) {
      var _this2 = this;

      var Wrapper = this.props.wrapper;
      if (Wrapper) {
        return React__default.createElement(
          Wrapper,
          {
            src: this.src,
            isSelected: this.props.isSelected,
            deselect: function deselect() {
              return _this2.props.editor.deselect();
            }
          },
          children
        );
      } else {
        return children;
      }
    }
  }, {
    key: 'renderResizableMediaElement',
    value: function renderResizableMediaElement() {
      var attributes = this.props.attributes;

      var element = this.renderWithWrapper(React__default.createElement(this.props.tag, _extends({}, attributes, {
        src: this.src,
        controls: this.props.tag === 'video' ? true : undefined,
        width: this.width,
        height: this.height,
        className: classnames(defineProperty({}, styles$5.dropShadow, this.dropShadow))
      }, this.altAttributes)));

      return React__default.createElement(
        Resizer,
        {
          width: this.width,
          height: this.height,
          onResize: this.onResize(false),
          onResized: this.onResize(true),
          isFocused: this.props.isFocused,
          isResizeable: !this.fullWidth,
          readOnly: !this.props.editor.isModifiable(),
          keepRatio: true,
          showPixelSize: true,
          liveResize: true,
          inline: true
        },
        element
      );
    }
  }, {
    key: 'renderFullWidthMediaElement',
    value: function renderFullWidthMediaElement() {
      var attributes = this.props.attributes;

      var style = {
        width: '100%',
        maxWidth: this.data.get('originalWidth')
      };

      return React__default.createElement(
        Selection,
        {
          isFocused: this.props.isFocused,
          readOnly: !this.props.editor.isModifiable()
        },
        React__default.createElement(this.props.tag, _extends({}, attributes, {
          src: this.src,
          controls: this.props.tag === 'video' ? true : undefined,
          style: style,
          className: classnames(defineProperty({}, styles$5.dropShadow, this.dropShadow))
        }, this.altAttributes))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.fullWidth ? this.renderFullWidthMediaElement() : this.renderResizableMediaElement();
    }
  }, {
    key: 'data',
    get: function get$$1() {
      return this.props.node.data;
    }
  }, {
    key: 'width',
    get: function get$$1() {
      return this.state.width || this.data.get('width');
    }
  }, {
    key: 'originalWidth',
    get: function get$$1() {
      return this.state.originalWidth || this.data.get('originalWidth');
    }
  }, {
    key: 'height',
    get: function get$$1() {
      return this.state.height || this.data.get('height');
    }
  }, {
    key: 'originalHeight',
    get: function get$$1() {
      return this.state.originalHeight || this.data.get('originalHeight');
    }
  }, {
    key: 'ratio',
    get: function get$$1() {
      if (this.originalWidth && this.originalHeight) {
        return this.originalWidth / this.originalHeight;
      } else {
        return 1;
      }
    }
  }, {
    key: 'src',
    get: function get$$1() {
      return this.data.get('src');
    }
  }, {
    key: 'dropShadow',
    get: function get$$1() {
      return this.data.get('dropShadow');
    }
  }, {
    key: 'fullWidth',
    get: function get$$1() {
      return this.data.get('fullWidth');
    }
  }, {
    key: 'element',
    get: function get$$1() {
      return this.props.attributes.ref.current;
    }
  }, {
    key: 'altAttributes',
    get: function get$$1() {
      var _props2 = this.props,
          node = _props2.node,
          tag = _props2.tag;


      if (tag === 'img') {
        return { alt: node.data.get('alt') || '' };
      } else {
        return { 'aria-label': node.data.get('alt') || '' };
      }
    }
  }]);
  return ResizableMediaElement;
}(React.Component);

ResizableMediaElement.propTypes = {
  node: PropTypes.instanceOf(Slate.Inline).isRequired,
  editor: PropTypes.instanceOf(slateReact.Editor).isRequired
};


var ResizableMediaElement$1 = componentWithPopup(ResizableMediaElement, MediaToolbar);

var uploads = new Map();

var Placeholder = function (_Component) {
  inherits(Placeholder, _Component);

  function Placeholder() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Placeholder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Placeholder, [{
    key: 'renderEmptyPlaceholder',
    value: function renderEmptyPlaceholder() {
      return React__default.createElement('i', { className: 'fa-regular fa-spinner fa-spin' });
    }
  }, {
    key: 'render',
    value: function render() {
      var src = uploads.get(this.props.node.key);
      if (!src) {
        return this.renderEmptyPlaceholder();
      }

      var img = src ? React__default.createElement('img', { src: src, width: this.width, height: this.height, alt: '' }) : null;

      return React__default.createElement(
        'div',
        { style: { width: this.width, height: this.height } },
        img,
        React__default.createElement(
          'span',
          { className: 'progress progress-striped active' },
          React__default.createElement(
            'span',
            { className: 'bar' },
            'Uploading...'
          )
        )
      );
    }
  }, {
    key: 'data',
    get: function get$$1() {
      return this.props.node.data;
    }
  }, {
    key: 'width',
    get: function get$$1() {
      return this.state.width || this.data.get('width');
    }
  }, {
    key: 'height',
    get: function get$$1() {
      return this.state.height || this.data.get('height');
    }
  }]);
  return Placeholder;
}(React.Component);

function findSize(src) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      var width = img.naturalWidth;
      var height = img.naturalHeight;
      document.body.removeChild(img);
      resolve({ width: width, height: height });
    };
    img.onerror = function (err) {
      return reject(err);
    };
    img.src = src;
    img.style.display = 'none';
    document.body.appendChild(img);
  });
}

function clampDimensions(_ref) {
  var width = _ref.width,
      height = _ref.height,
      maxWidth = _ref.maxWidth;

  if (maxWidth) {
    var ratio = height / width;
    var maxHeight = maxWidth * ratio;
    if (!Number.isNaN(height) && width > maxWidth) {
      width = maxWidth;
      height = maxHeight;
    }
  }
  return {
    width: width,
    height: height
  };
}

var serverUpload = function serverUpload(file, options) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append('file', file);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', options.uploadPath, true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var obj = JSON.parse(xhr.responseText);
        var src = obj.path;

        if (options.uploadPath.includes('://') && !src.includes('://')) {
          src = (options.uploadPath + '/' + src).replace(/(\w)\/\/(\w)/, '$1/$2');
        }

        resolve(src);
      } else {
        console.error('Request failed!', xhr.status);
        reject(new Error('Upload failed'));
      }
    };
    xhr.onerror = function () {
      console.error('Request failed');
      reject(new Error('Upload failed'));
    };
    xhr.send(formData);
  });
};

var attributeAsNumberIfExists = function attributeAsNumberIfExists(element, attributeName, defaultValue) {
  return element.hasAttribute(attributeName) ? parseInt(element.getAttribute(attributeName), 10) : defaultValue;
};

function createPlaceholder(_ref) {
  var width = _ref.width,
      height = _ref.height,
      maxWidth = _ref.maxWidth;

  return Slate.Inline.create({
    data: clampDimensions({ width: width, height: height, maxWidth: maxWidth }),
    type: 'image-placeholder'
  });
}

function createEmptyPlaceholder() {
  return Slate.Inline.create({
    type: 'image-placeholder'
  });
}

function createImage(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      maxWidth = _ref2.maxWidth,
      src = _ref2.src;

  var originalWidth = width;
  var originalHeight = height;

  return Slate.Inline.create({
    type: 'image',
    data: _extends({
      originalWidth: originalWidth,
      originalHeight: originalHeight,
      src: src
    }, clampDimensions({ width: width, height: height, maxWidth: maxWidth }))
  });
}

function fetchImageDimensions(src) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.addEventListener('load', function () {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
        src: src
      });
    });
    img.src = src;
  });
}

function replacePlaceholderWithImage(change, key, _ref3) {
  var width = _ref3.width,
      height = _ref3.height,
      maxWidth = _ref3.maxWidth,
      src = _ref3.src;

  if (!change.value.document.getDescendant(key)) return;

  // When someone hits undo, we want the undo to do "remove node", not
  // "replace node by key", which will replace the image with a
  // placeholder again. Skipping save here will cause an undo to do
  // "remove the placeholder node (which is now the image node),"
  // which is exactly what we want.
  change.withoutSaving(function (change) {
    return change.replaceNodeByKey(key, createImage({ width: width, height: height, maxWidth: maxWidth, src: src }));
  });
  return change;
}

function insertImageNode(change, node) {
  return change.insertInline(node);
}

function insertImage(change, editor, src) {
  var block = createEmptyPlaceholder();

  fetchImageDimensions(src).then(function (node) {
    // Ensure that the placeholder node has been added to the document
    // before we replace it
    setTimeout(function () {
      replacePlaceholderWithImage(editor, block.key, node);
    }, 0);
  });

  // By default, our cursor will end up inside the inline, which
  // prevents us from inserting multiple images. Instead, we
  // should move right 1 position, to take us out of it.
  change.command(insertImageNode, block).moveForward();
}

function toggleDropShadow(change, node) {
  if (!node && node.key) {
    return;
  }

  var key = node.key,
      data = node.data;

  return change.setNodeByKey(key, {
    data: data.set('dropShadow', !data.get('dropShadow'))
  });
}

function toggleFullWidth(change, node) {
  if (!node && node.key) {
    return;
  }

  var key = node.key,
      data = node.data;

  return change.setNodeByKey(key, {
    data: data.set('fullWidth', !data.get('fullWidth'))
  });
}



var changes = Object.freeze({
	createPlaceholder: createPlaceholder,
	createEmptyPlaceholder: createEmptyPlaceholder,
	createImage: createImage,
	replacePlaceholderWithImage: replacePlaceholderWithImage,
	insertImageNode: insertImageNode,
	insertImage: insertImage,
	toggleDropShadow: toggleDropShadow,
	toggleFullWidth: toggleFullWidth
});

function insertImage$1 (getEditor, options) {
  return function (transform, file) {
    var editor = getEditor();

    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      var maxWidth = options.maxWidth;

      reader.onload = function () {
        findSize(reader.result).then(function (_ref) {
          var width = _ref.width,
              height = _ref.height;

          var block = createPlaceholder({ width: width, height: height, maxWidth: maxWidth });
          uploads.set(block.key, reader.result);

          // Upload is started and then insert of placeholder is immediately resolved.
          options.uploadImage(file, options).then(function (src) {
            // Set timeout is here so that even if upload executes immediately the replaceNode
            // change will happen after insertBlock
            setTimeout(function () {
              replacePlaceholderWithImage(editor, block.key, {
                width: width,
                height: height,
                maxWidth: maxWidth,
                src: src
              });
              uploads.delete(block.key);
            }, 0);
          }, function (error) {
            console.error(error);
          });

          resolve(insertImageNode(transform, block));
        });
      };
      reader.readAsDataURL(file);
    });
  };
}

// Some apps (looking at you, Microsoft) copy both HTML and an image
// representation of that HTML. In most cases, if we get both HTML and
// an image, we should favor the image. But in those cases, we want to
// favor the HTML instead.
function preferHTMLContent(transfer) {
  if (!transfer.html) return false;

  // Check for metadata indicating this is HTML copied from OneNote.
  if (transfer.html.match('OneNote.File')) return true;

  // Check for a class that Excel puts in its table HTML.
  // Latest versions of Excel on Mac don't seem to include ", make it optional
  if (transfer.html.match('class="?xl')) return true;

  return false;
}

/**
 * Insert media on drop or paste.
 *
 * @param {Object} options
 *   @property {Function} insertMedia
 *   @property {Array} extensions (optional)
 * @return {Object} plugin
 */
function DropOrPasteMedia() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var insertMedia = options.insertMedia,
      extensions = options.extensions;


  if (!insertMedia) {
    throw new Error('You must supply an `insertMedia` function.');
  }

  /**
   * Apply the change for a given file and update the editor with the result.
   *
   * @param {Editor} editor
   * @param {Blob} file
   * @return {Promise}
   */

  function asyncApplyChange(editor, file) {
    return Promise.resolve(insertMedia(editor, file)).then(function () {
      editor.onChange(editor);
    });
  }

  /**
   * On drop or paste.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   * @return {State}
   */

  function onInsert(event, editor, next) {
    var transfer = slateReact.getEventTransfer(event);
    var range = editor.findEventRange(event);
    if (transfer.type !== 'files') return next();

    var changeApplied = false;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = transfer.files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var file = _step.value;

        if (extensions) {
          var _ret = function () {
            var type = file.type;

            var _type$split = type.split('/'),
                _type$split2 = slicedToArray(_type$split, 2),
                ext = _type$split2[1];

            if (!extensions.some(function (validExt) {
              return ext.includes(validExt);
            })) return 'continue';
          }();

          if (_ret === 'continue') continue;
        }

        if (range) {
          editor.select(range);
        }

        asyncApplyChange(editor, file);
        changeApplied = true;
      }

      // If no changes are applied, return next() so the next plugin
      // can check for relevant files
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (!changeApplied) {
      return next();
    }
  }

  /**
   * Return the plugin.
   *
   * @type {Object}
   */
  return {
    onDrop: onInsert,
    onPaste: onInsert
  };
}

function Plugin$4(options) {
  options = _extends({
    maxWidth: 500,
    uploadImage: serverUpload
  }, options);

  var renderInline = function renderInline(props, editor, next) {
    var node = props.node;


    switch (node.type) {
      case 'image':
        return React__default.createElement(ResizableMediaElement$1, _extends({}, props, {
          tag: 'img',
          wrapper: options.wrapper
        }));
      case 'image-placeholder':
        return React__default.createElement(Placeholder, props);
      default:
    }
    return next();
  };

  var currentEditor = void 0;

  var insertImages = DropOrPasteMedia({
    extensions: ['png', 'gif', 'jpg', 'jpeg'],
    insertMedia: insertImage$1(function () {
      return currentEditor;
    }, options)
  });

  var onPaste = function onPaste(event, editor, next) {
    // The way that slate-drop-or-paste-images converts urls to
    // data-uris is incompatible with our file uploader, which
    // requires there to be a filename. So for paste, we'll ignore
    // everything except pasted file data.
    var transfer = slateReact.getEventTransfer(event);
    if (transfer.type !== 'files') return next();
    if (preferHTMLContent(transfer)) return next();

    return onInsert(event, editor, next);
  };

  var onInsert = function onInsert(event, editor, next) {
    currentEditor = editor;
    return insertImages.onDrop(event, editor, next);
  };

  var schema = {
    inlines: {
      image: { isVoid: true },
      'image-placeholder': { isVoid: true }
    }
  };

  return {
    options: options,
    changes: changes,
    plugins: options.disabled ? [] : [{
      schema: schema,
      renderInline: renderInline
    }, {
      onDrop: onInsert,
      onPaste: onPaste
    }]
  };
}

function ImagePlugin(options) {
  return _extends({}, Plugin$4(options));
}

var VideoPlaceholder = function VideoPlaceholder(_ref) {
  var node = _ref.node;

  var src = node.data.get('src');
  var width = node.data.get('width');
  var height = node.data.get('height');

  if (!src) {
    return React__default.createElement('i', { className: 'fa-regular fa-spinner fa-spin' });
  }

  return React__default.createElement(
    'div',
    { style: { width: width, height: height, maxWidth: '100%' } },
    React__default.createElement('video', { src: src, controls: true }),
    React__default.createElement(
      'span',
      { className: 'progress progress-striped active' },
      React__default.createElement(
        'span',
        { className: 'bar' },
        'Uploading...'
      )
    )
  );
};

var uploads$2 = new Map();

function findVideoSize(src) {
  return new Promise(function (resolve, reject) {
    var video = document.createElement('video');

    // Hack: video events (such as loadedmetadata) won't fire for video/quicktime
    // data URLs. Replace with mp4 so we can get dimensions.
    if (src.startsWith('data:video/quicktime')) {
      src = src.replace('data:video/quicktime', 'data:video/mp4');
    }

    video.addEventListener('loadedmetadata', function () {
      var height = this.videoHeight;
      var width = this.videoWidth;
      resolve({ width: width, height: height });
    }, false);

    video.src = src;
  });
}

function createPlaceholder$1(_ref) {
  var width = _ref.width,
      height = _ref.height,
      maxWidth = _ref.maxWidth;

  return Slate.Inline.create({
    data: clampDimensions({ width: width, height: height, maxWidth: maxWidth }),
    type: 'video-placeholder'
  });
}

function createEmptyPlaceholder$1() {
  return Slate.Inline.create({
    type: 'video-placeholder'
  });
}

function createVideo(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      maxWidth = _ref2.maxWidth,
      src = _ref2.src;

  var originalWidth = width;
  var originalHeight = height;

  return Slate.Inline.create({
    type: 'video',
    data: _extends({
      originalWidth: originalWidth,
      originalHeight: originalHeight,
      src: src
    }, clampDimensions({ width: width, height: height, maxWidth: maxWidth }))
  });
}

function replacePlaceholderWithVideo(change, key, _ref3) {
  var width = _ref3.width,
      height = _ref3.height,
      maxWidth = _ref3.maxWidth,
      src = _ref3.src;

  if (!change.value.document.getDescendant(key)) return;

  // When someone hits undo, we want the undo to do "remove node", not
  // "replace node by key", which will replace the image with a
  // placeholder again. Skipping save here will cause an undo to do
  // "remove the placeholder node (which is now the image node),"
  // which is exactly what we want.
  change.withoutSaving(function (change) {
    return change.replaceNodeByKey(key, createVideo({ width: width, height: height, maxWidth: maxWidth, src: src }));
  });
  return change;
}

function insertVideoNode(change, node) {
  return change.insertInline(node);
}

function insertVideo(change, editor, src) {
  var block = createEmptyPlaceholder$1();

  findVideoSize(src).then(function (_ref4) {
    var width = _ref4.width,
        height = _ref4.height;

    // Ensure that the placeholder node has been added to the document
    // before we replace it
    setTimeout(function () {
      replacePlaceholderWithVideo(editor, block.key, { width: width, height: height, src: src });
    }, 0);
  });

  // Move right 1 position, to take cursor outside of the inline.
  change.command(insertVideoNode, block).moveForward();
}



var changes$1 = Object.freeze({
	createPlaceholder: createPlaceholder$1,
	createEmptyPlaceholder: createEmptyPlaceholder$1,
	createVideo: createVideo,
	replacePlaceholderWithVideo: replacePlaceholderWithVideo,
	insertVideoNode: insertVideoNode,
	insertVideo: insertVideo
});

function insertVideo$1(getEditor, options) {
  return function (transform, file) {
    var editor = getEditor();

    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      var maxWidth = options.maxWidth;

      reader.onload = function () {
        findVideoSize(reader.result).then(function (_ref) {
          var width = _ref.width,
              height = _ref.height;

          var block = createPlaceholder$1({ width: width, height: height, maxWidth: maxWidth });
          uploads$2.set(block.key, reader.result);

          // Upload is started and then insert of placeholder is immediately resolved.
          options.uploadVideo(file, options).then(function (src) {
            // Set timeout is here so that even if upload executes immediately the replaceNode
            // change will happen after insertBlock
            setTimeout(function () {
              replacePlaceholderWithVideo(editor, block.key, {
                width: width,
                height: height,
                maxWidth: maxWidth,
                src: src
              });
              uploads$2.delete(block.key);
            }, 0);
          }, function (error) {
            console.error(error);
          });

          resolve(insertVideoNode(transform, block));
        });
      };
      reader.readAsDataURL(file);
    });
  };
}

function Plugin$5(options) {
  options = _extends({
    maxWidth: 500,
    uploadVideo: serverUpload,
    onVideoURL: onVideoURL
  }, options);

  var renderInline = function renderInline(props, editor, next) {
    var node = props.node;


    switch (node.type) {
      case 'video':
        return React__default.createElement(ResizableMediaElement$1, _extends({}, props, {
          tag: 'video',
          wrapper: options.wrapper
        }));
      case 'video-placeholder':
        return React__default.createElement(VideoPlaceholder, props);
      default:
    }
    return next();
  };

  var currentEditor = void 0;

  var insertVideos = DropOrPasteMedia({
    extensions: ['quicktime', 'mp4', 'webm', 'ogg'],
    insertMedia: insertVideo$1(function () {
      return currentEditor;
    }, options)
  });

  function onVideoURL(editor, changes, src) {
    return editor.command(changes.insertVideo, editor, src);
  }

  var onPaste = function onPaste(event, editor, next) {
    // Ignore everything except pasted file data.
    var transfer = slateReact.getEventTransfer(event);
    if (transfer.type !== 'files') return next();

    return onInsert(event, editor, next);
  };

  var onInsert = function onInsert(event, editor, next) {
    currentEditor = editor;
    return insertVideos.onDrop(event, editor, next);
  };

  var schema = {
    inlines: {
      video: { isVoid: true },
      'video-placeholder': { isVoid: true }
    }
  };

  return {
    options: options,
    changes: changes$1,
    plugins: options.disabled ? [] : [{
      schema: schema,
      renderInline: renderInline
    }, {
      onDrop: onInsert,
      onPaste: onPaste
    }]
  };
}

function VideoPlugin(options) {
  return _extends({}, Plugin$5(options));
}

var AudioPlaceholder = function AudioPlaceholder(_ref) {
  var node = _ref.node;

  var src = node.data.get('src');

  if (!src) {
    return React__default.createElement('i', { className: 'fa-regular fa-spinner fa-spin' });
  }

  return React__default.createElement(
    'div',
    null,
    React__default.createElement('audio', { src: src, controls: true }),
    React__default.createElement(
      'span',
      { className: 'progress progress-striped active' },
      React__default.createElement(
        'span',
        { className: 'bar' },
        'Uploading...'
      )
    )
  );
};

var uploads$4 = new Map();

function createPlaceholder$2() {
  return Slate.Inline.create({
    type: 'audio-placeholder'
  });
}

function createEmptyPlaceholder$2() {
  return createPlaceholder$2();
}

function createAudio(_ref) {
  var src = _ref.src;

  return Slate.Inline.create({
    type: 'audio',
    data: {
      src: src
    }
  });
}

function replacePlaceholderWithAudio(change, key, _ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      maxWidth = _ref2.maxWidth,
      src = _ref2.src;

  if (!change.value.document.getDescendant(key)) return;

  // When someone hits undo, we want the undo to do "remove node", not
  // "replace node by key", which will replace the image with a
  // placeholder again. Skipping save here will cause an undo to do
  // "remove the placeholder node (which is now the image node),"
  // which is exactly what we want.
  change.withoutSaving(function (change) {
    return change.replaceNodeByKey(key, createAudio({ src: src }));
  });
  return change;
}

function insertAudioNode(change, node) {
  return change.insertInline(node);
}

function insertAudio(change, editor, src) {
  var block = createEmptyPlaceholder$2();

  setTimeout(function () {
    replacePlaceholderWithAudio(editor, block.key, { src: src });
  }, 0);

  // Move right 1 position, to take cursor outside of the inline.
  change.command(insertAudioNode, block).moveForward();
}

var changes$2 = Object.freeze({
	createPlaceholder: createPlaceholder$2,
	createEmptyPlaceholder: createEmptyPlaceholder$2,
	createAudio: createAudio,
	replacePlaceholderWithAudio: replacePlaceholderWithAudio,
	insertAudioNode: insertAudioNode,
	insertAudio: insertAudio
});

function insertAudio$1(getEditor, options) {
  return function (transform, file) {
    var editor = getEditor();

    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var block = createPlaceholder$2();
        uploads$4.set(block.key, reader.result);

        // Upload is started and then insert of placeholder is immediately resolved.
        options.uploadAudio(file, options).then(function (src) {
          // Set timeout is here so that even if upload executes immediately the replaceNode
          // change will happen after insertBlock
          setTimeout(function () {
            replacePlaceholderWithAudio(editor, block.key, {
              src: src
            });
            uploads$4.delete(block.key);
          }, 0);
        }, function (error) {
          console.error(error);
        });

        resolve(insertAudioNode(transform, block));
      };
      reader.readAsDataURL(file);
    });
  };
}

var Audio = function Audio(_ref) {
  var node = _ref.node;

  var src = node.data.get('src');

  return React__default.createElement(
    'span',
    null,
    React__default.createElement('audio', { src: src, controls: true })
  );
};

function Plugin$6(options) {
  options = _extends({
    maxWidth: 500,
    uploadAudio: serverUpload,
    onAudioURL: onAudioURL
  }, options);

  var renderInline = function renderInline(props, editor, next) {
    var node = props.node;


    switch (node.type) {
      case 'audio':
        return React__default.createElement(Audio, props);
      case 'audio-placeholder':
        return React__default.createElement(AudioPlaceholder, props);
      default:
    }
    return next();
  };

  var currentEditor = void 0;

  var insertAudios = DropOrPasteMedia({
    extensions: ['mpeg', 'wav', 'ogg', 'm4a'],
    insertMedia: insertAudio$1(function () {
      return currentEditor;
    }, options)
  });

  function onAudioURL(editor, changes, src) {
    return editor.command(changes.insertAudio, editor, src);
  }

  var onPaste = function onPaste(event, editor, next) {
    // Ignore everything except pasted file data.
    var transfer = slateReact.getEventTransfer(event);
    if (transfer.type !== 'files') return next();

    return onInsert(event, editor, next);
  };

  var onInsert = function onInsert(event, editor, next) {
    currentEditor = editor;
    return insertAudios.onDrop(event, editor, next);
  };

  var schema = {
    inlines: {
      audio: { isVoid: true },
      'audio-placeholder': { isVoid: true }
    }
  };

  return {
    options: options,
    changes: changes$2,
    plugins: options.disabled ? [] : [{
      schema: schema,
      renderInline: renderInline
    }, {
      onDrop: onInsert,
      onPaste: onPaste
    }]
  };
}

function AudioPlugin(options) {
  return _extends({}, Plugin$6(options));
}

var styles$8 = { "hidden": "Link-module_hidden__2tiH4", "placeholder": "Link-module_placeholder__3V0Nr" };

/**
 * Unwraps a link, rewraps it, and pops up the link edit toolbar. This
 * is the behavior that should be triggered by the link toolbar item
 * and the keyboard shortcut.
 *
 * @param {Change} change
 * @return {Change}
 */
function createLink(change) {
  LinkToolbar.nextEditing = true;
  return change.command(unwrapLink).command(wrapOrInsertLink, '', '');
}

function wrapOrInsertLink(change, href) {
  var labelIfBlank = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (change.value.selection.isCollapsed) {
    insertLink(change, { label: labelIfBlank, href: href });
  } else {
    wrapLink(change, href);
  }
}

function wrapLink(change, href) {
  change.wrapInline({
    type: 'link',
    data: { href: href }
  });
}

function unwrapLink(change) {
  change.unwrapInline('link');
}

function unwrapLinkByKey(change, key) {
  change.unwrapInlineByKey(key, 'link');
}

function insertLink(change, _ref) {
  var label = _ref.label,
      href = _ref.href;

  var link = Slate.Inline.create({
    type: 'link',
    nodes: [],
    data: { href: href }
  });
  return change.withoutNormalizing(function (change) {
    return change.insertInlineAtRange(change.value.selection, link).command(updateLinkLabel, link, label);
  });
}

function updateLinkLabel(change, node, label) {
  if (label.length > 0 && label === node.text) return change;

  change.withoutNormalizing(function (change) {
    node.nodes.forEach(function (child) {
      return change.removeNodeByKey(child.key);
    });

    if (label.length === 0) {
      var text = Slate.Text.create('');
      change.insertNodeByKey(node.key, 0, text);

      // We can't use isVoid for this, because that will reparent the
      // React component with the menu when we switch from non-void to
      // void, which loses our state (and causes some ugly flickering).
      change.setNodeByKey(node.key, {
        type: 'link-placeholder'
      });
    } else {
      var _text = Slate.Text.create(label);
      change.insertNodeByKey(node.key, 0, _text);
      change.setNodeByKey(node.key, {
        type: 'link'
      });
    }
  });

  node = change.value.document.getNode(node.key);
  change.moveToEndOfNode(node);

  return change;
}

function updateLinkHref(change, node, href) {
  if (href === node.data.get('href')) return change;
  return change.setNodeByKey(node.key, {
    data: node.data.set('href', href)
  });
}

var isPlaceholderLink = function isPlaceholderLink(link) {
  return link.type === 'link-placeholder';
};

// There are two character classes: one for characters allowed inside
// a URL, and one for character classes allowed to end a URL. This
// way, you can end a URL with a '.', and have that not be a part of
// the link.
var LINK_REGEXP = new RegExp('((?:https?:\\/\\/|www\\.)[-A-Z0-9+&@#/%=~_|$?!:,.]*[A-Z0-9+&@#/%=~_|$])[^\\s]*$', 'i');

// https://github.com/angular/angular/blob/916487a873244503d17372761d4b7b577498ac17/packages/core/src/sanitization/url_sanitizer.ts#L36
var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;

var normalizeHref = function normalizeHref(href) {
  if (href === null || href === undefined) return '';
  if (href.includes(':') || href[0] === '#') {
    if (href.match(SAFE_URL_PATTERN)) {
      return href;
    } else {
      return 'unsafe:' + href;
    }
  }
  return 'http://' + href;
};

var detectLink = function detectLink(string) {
  var match = string.match(LINK_REGEXP);
  if (match) {
    return {
      link: match[1],
      offset: string.length - match[0].length
    };
  }
};

// Returns true if href is an anchor link to the current page, false otherwise.
var isLinkToSelf = function isLinkToSelf(href) {
  if (href.indexOf('#') === -1) {
    return false;
  }

  try {
    var url = new URL(href, window.location.href);
    return window.location.origin === url.origin && window.location.pathname === url.pathname;
  } catch (e) {
    console.error(e);
  }

  return false;
};

// Links to KB articles should be updated when displayed within a KB.
var updateKnowledgeBaseLinks = function updateKnowledgeBaseLinks(href) {
  // Bail out if we're not in a KB
  if (!window.isKnowledgeBase || !window.knowledgeBasePageData) {
    return null;
  }

  // See if the link looks like a document.
  var referenceMatch = href.match(/\/pages\/([^/?#]+)/);
  if (!referenceMatch) {
    return null;
  }

  var reference = referenceMatch[1];
  var data = window.knowledgeBasePageData;
  var pageId = [data.references[reference], reference].find(function (pageId) {
    return data.pages[pageId];
  });
  if (!pageId) {
    return null;
  }
  var page = data.pages[pageId];

  if (!page) {
    return null;
  }

  var hash = '';
  try {
    hash = new URL(href).hash;
  } catch (e) {
    console.error(e);
  }

  var kbRoot = document.querySelector('meta[name=knowledge-base-path]').content;

  return kbRoot + '/' + page.path + '~' + pageId + hash;
};

var linkUtils = Object.freeze({
	isPlaceholderLink: isPlaceholderLink,
	normalizeHref: normalizeHref,
	detectLink: detectLink,
	isLinkToSelf: isLinkToSelf,
	updateKnowledgeBaseLinks: updateKnowledgeBaseLinks
});

/**
 * We want to keep focus in the editor as much as possible. If you
 * attach an onClick to something outside the editor, it will grab
 * focus when the onMouseDown fires. If that thing disappears when the
 * editor loses focus, like a popup menu, it will hide before the
 * click event fires on it, and the click will never happen.
 *
 * On the other hand, if you use onMouseDown to take an action, and
 * the onMouseDown causes the menu to disappear, the mouseUp /
 * mouseOver / click events will happen on the thing _behind_ the
 * menu, which is probably also not what you want. Besides that, it
 * feels like the menu disappears too quickly.
 *
 * This function wraps an "onClick" handler to disable focus-stealing
 * in the onMouseDown and trigger on mouseup instead.
 *
 * Usage: <div className="something" {...onClickWithoutFocus((e) => console.log("clicked!"))} />
 */
function onClickWithoutFocus(onClick) {
  return {
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
    },
    onMouseUp: onClick
  };
}

var styles$9 = { "linkForm": "LinkToolbar-module_linkForm__N3S-H", "field": "LinkToolbar-module_field__Ub1Ml" };

// @ts-ignore
var LinkForm = function (_Component) {
  inherits(LinkForm, _Component);

  function LinkForm(props) {
    classCallCheck(this, LinkForm);

    var _this = possibleConstructorReturn(this, (LinkForm.__proto__ || Object.getPrototypeOf(LinkForm)).call(this, props));

    _this.onKeyPress = function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        _this.props.onDone();
      }
    };

    _this.updateLabel = function (event) {
      _this.setState({ label: event.target.value });
    };

    _this.updateHref = function (event) {
      _this.setState({ href: event.target.value });
    };

    _this.labelField = null;
    _this.hrefField = null;

    var node = props.node;


    _this.state = {
      href: node.data.get('href'),
      label: isPlaceholderLink(node) ? '' : node.text
    };
    return _this;
  }

  createClass(LinkForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        // If we're going straight from Slate to link edit mode, we need
        // a small delay. This is because Slate won't realize that it's
        // lost the selection until after it finishes the rendering pass
        // caused by inserting the link component. It thinks that its
        // selection is more recent than the window's, so it will steal
        // it back.
        _this2.props.editor.blur();
        if (_this2.hrefField) {
          _this2.hrefField.focus();
        }
      }, 10);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.updateLink();
    }
  }, {
    key: 'updateLink',
    value: function updateLink() {
      var editor = this.props.editor;
      var node = this.props.node;
      var _state = this.state,
          label = _state.label,
          href = _state.href;

      // There are a few different behaviors we want when the popup closes:
      //
      // - If we have a label and an href, we should create or update the link node.
      // - If we only have a label, we should insert the label as plain text.
      // - If we only have an href, we should make the label equal to the href.
      // - If we have neither a label nor an href, we should remove the link node.

      node = editor.value.document.getDescendant(node.key);
      if (!node) return;

      if (label) {
        editor.command(updateLinkLabel, node, label);
        node = editor.value.document.getDescendant(node.key);
      }

      if (href) {
        editor.command(updateLinkHref, node, href);
        node = editor.value.document.getDescendant(node.key);
      }

      if (label && !href) {
        editor.command(unwrapLinkByKey, node.key);
      }

      if (!label && href) {
        editor.command(updateLinkLabel, node, href);
      }

      if (!label && !href) {
        editor.removeNodeByKey(node.key);
      }

      node = editor.value.document.getDescendant(node.key);
      if (node) {
        editor.moveToEndOfNode(node).moveToStartOfNextText();
      }

      editor.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          href = _state2.href,
          label = _state2.label;


      var placeholder = href ? undefined : 'Paste or enter a link';

      return React__default.createElement(
        'div',
        { onKeyPress: this.onKeyPress, className: styles$9.linkForm },
        React__default.createElement(
          'div',
          { className: styles$9.field },
          React__default.createElement(
            'label',
            null,
            'Text'
          ),
          React__default.createElement('input', {
            ref: function ref(_ref) {
              return _this3.labelField = _ref;
            },
            type: 'text',
            value: label,
            onChange: this.updateLabel
          })
        ),
        React__default.createElement(
          'div',
          { className: styles$9.field },
          React__default.createElement(
            'label',
            null,
            'URL'
          ),
          React__default.createElement('input', {
            ref: function ref(_ref2) {
              return _this3.hrefField = _ref2;
            },
            type: 'text',
            value: href,
            placeholder: placeholder,
            onChange: this.updateHref
          })
        )
      );
    }
  }]);
  return LinkForm;
}(React.Component);

var LinkToolbar = function (_Component2) {
  inherits(LinkToolbar, _Component2);

  function LinkToolbar(props) {
    classCallCheck(this, LinkToolbar);

    var _this4 = possibleConstructorReturn(this, (LinkToolbar.__proto__ || Object.getPrototypeOf(LinkToolbar)).call(this, props));

    _this4.onOpen = function (event) {
      // Allow users to link around within a document if they put a hash
      // in the href. The replaceState call is a bit of a hack to not
      // key the hash in the URL so it can be called multipe times.
      if (_this4.href === '#top') {
        event.target.closest('.aha-editor').scrollIntoView(true);
        _this4.props.popup.blur();
      } else if (_this4.href && isLinkToSelf(_this4.href)) {
        try {
          window.location.href = new URL(_this4.href).hash;
        } catch (e) {
          console.error(e);
        }
      } else if (_this4.href && _this4.href.trim()) {
        var newWindow = window.open(normalizeHref(_this4.href), '_blank');

        // window.open could have failed because of popup blockers, etc.
        if (newWindow) {
          newWindow.focus();
        }
      }

      _this4.props.popup.blur();
    };

    _this4.onUnlink = function (event) {
      event.preventDefault();
      _this4.editor.command(unwrapLink);
    };

    _this4.onEdit = function (event) {
      return _this4.setState({ editing: true });
    };

    _this4.onFormDone = function (event) {
      return _this4.setState({ editing: false });
    };

    _this4.state = { editing: LinkToolbar.nextEditing };
    LinkToolbar.nextEditing = false;
    return _this4;
  }

  createClass(LinkToolbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // Switch out of editing mode when popup is hidden
      if (this.state.editing && !newProps.visible) {
        this.setState({ editing: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var onFormDone = this.onFormDone,
          editor = this.editor,
          node = this.node,
          onOpen = this.onOpen,
          onEdit = this.onEdit,
          onUnlink = this.onUnlink,
          editing = this.state.editing;


      if (editing) {
        return React__default.createElement(LinkForm, { onDone: onFormDone, editor: editor, node: node });
      } else {
        return React__default.createElement(
          PopupToolbar,
          { className: 'aha-editor-link-popup' },
          React__default.createElement(
            PopupToolbarItem,
            {
              className: 'aha-editor-link-popup__item',
              onClick: onOpen
            },
            'Open link'
          ),
          React__default.createElement(
            PopupToolbarItem,
            {
              className: 'aha-editor-link-popup__item',
              onClick: onEdit
            },
            'Edit link'
          ),
          React__default.createElement(
            PopupToolbarItem,
            _extends({
              className: 'aha-editor-link-popup__item'
            }, onClickWithoutFocus(onUnlink)),
            'Unlink'
          )
        );
      }
    }
  }, {
    key: 'node',
    get: function get$$1() {
      return this.props.node;
    }
  }, {
    key: 'data',
    get: function get$$1() {
      return this.node.data;
    }
  }, {
    key: 'href',
    get: function get$$1() {
      return this.data.get('href');
    }
  }, {
    key: 'editor',
    get: function get$$1() {
      return this.props.editor;
    }
  }]);
  return LinkToolbar;
}(React.Component);

LinkToolbar.nextEditing = false;

var Link = function (_Component) {
  inherits(Link, _Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.internalLinkHandler = function (event) {
      var link = event.currentTarget;

      // When a user sets an internal link to `#Top` (capital letter), clicking it will now take a user to the top of the editor.
      if (link && link.hash && link.hash === '#Top') {
        var parent = link.offsetParent;
        if (parent) parent.scrollIntoView(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          node = _props.node;

      var className = classnames(defineProperty({}, styles$8.placeholder, isPlaceholderLink(node)));
      var href = normalizeHref(this.props.node.data.get('href'));
      var kbHref = updateKnowledgeBaseLinks(href);

      var extraAttrs = {};
      if (href[0] !== '#' && !isLinkToSelf(href) && !kbHref) {
        extraAttrs.target = '_blank';
        extraAttrs.rel = 'noopener noreferrer';
      }

      if (href) {
        return React__default.createElement(
          'a',
          _extends({ href: kbHref || href, className: className }, extraAttrs, { onMouseDown: this.internalLinkHandler }),
          children
        );
      } else {
        return React__default.createElement(
          'span',
          { className: className },
          children
        );
      }
    }
  }]);
  return Link;
}(React.Component);

var Link$1 = componentWithPopup(Link, LinkToolbar);

var component = function component(onClick, hotkeyLabel$$1) {
  return function () {
    var clickHandler = function clickHandler() {
      trackToolbarAnalytics({
        eventName: 'User selects toolbar + menu',
        properties: { 'Toolbar + menu': 'Link' }
      });
      if (onClick) onClick.apply(undefined, arguments);
    };

    return React__default.createElement(
      ToolbarItem,
      { label: 'Link', hotkey: hotkeyLabel$$1, onClick: clickHandler },
      React__default.createElement('i', { className: 'fa-regular fa-link fa-fw' })
    );
  };
};

var LinkToolbarItem = function LinkToolbarItem(performChange) {
  return bindHotkey('mod+k', performChange, createLink, component, { name: 'Link' });
};

function Plugin$7(options) {
  options.menuIdentifier = shortid();

  var schema = {
    inlines: {
      link: {
        text: /^.+$/ // remove empty links
      }
    },
    rules: [{
      match: { type: 'link' },
      nodes: [{
        match: [{ object: 'text' }, { type: 'aha_reference' }, { type: 'user_reference' }]
      }],
      normalize: function normalize(change, error) {
        if (error.code === 'child_object_invalid') {
          return change.unwrapNodeByKey(error.child.key);
        } else {
          return change;
        }
      }
    }]
  };

  function renderInline(props, editor, next) {
    var node = props.node;


    switch (node.type) {
      case 'link':
        return React__default.createElement(Link$1, _extends({}, props, {
          popupPlacementAdjuster: options.popupPlacementAdjuster,
          popupParent: options.popupParent
        }));
      case 'link-placeholder':
        return React__default.createElement(Link$1, _extends({}, props, {
          popupPlacementAdjuster: options.popupPlacementAdjuster,
          popupParent: options.popupParent
        }));
      default:
    }
    return next();
  }

  function onPaste(event, editor, next) {
    var transfer = slateReact.getEventTransfer(event);
    var value = editor.value;
    var text = transfer.text;

    if (transfer.type !== 'text' && transfer.type !== 'html') {
      return next();
    }
    if (!isUrl(text)) {
      return next();
    }

    var _value$selection = value.selection,
        start = _value$selection.start,
        end = _value$selection.end;


    if (value.selection.isCollapsed) {
      // If there is no selection, insert a link at the cursor.
      editor.insertText(text).moveAnchorTo(start.key, start.offset).moveFocusTo(start.key, start.offset + text.length).command(wrapLink, text);

      // This node will have been split by adding the link, so the link
      // will be the next sibling of the node we started on.
      var linkNode = editor.value.document.getNextSibling(start.path);
      if (linkNode) {
        var parentBlock = editor.value.document.getClosestBlock(linkNode.key);

        editor.moveToStartOfNode(parentBlock.getNextText(linkNode.nodes.last().key));
      }
    } else {
      // If there is a selection, wrap it in a link.
      editor.moveAnchorTo(start.key, start.offset).moveFocusTo(end.key, end.offset).command(wrapLink, text);
    }

    return editor;
  }

  function onKeyDown(event, editor, next) {
    if (event.key !== ' ' && event.key !== 'Enter') return next();
    if (!editor.value.selection.isCollapsed) return next();
    if (editor.value.startInline && editor.value.startInline.type === 'link') {
      return next();
    }

    var _editor$value = editor.value,
        startText = _editor$value.startText,
        selection = _editor$value.selection;
    var start = selection.start;
    var text = startText.text;


    var string = text.slice(0, start.offset);
    var match = detectLink(string);
    if (!match) return next();
    event.preventDefault();

    var link = match.link,
        offset = match.offset;


    var linkStartOffset = start.offset - (string.length - offset);

    // Account for any punctuation after the link
    var lengthAfterLinkEnd = string.length - offset - link.length;

    // Insert the space first, so undo will just unlink the text, and
    // you can keep typing without autolinking again.
    if (event.key === ' ') {
      editor.insertText(' ');
      editor.snapshotSelection();
      lengthAfterLinkEnd += 1;
    }

    editor.moveAnchorTo(start.key, linkStartOffset).moveFocusTo(start.key, linkStartOffset + link.length);
    editor.command(wrapLink, link);
    editor.moveToStartOfNextText().moveForward(lengthAfterLinkEnd);

    if (event.key === 'Enter') {
      editor.splitBlock();
    }
    return editor;
  }

  function onCommand(_ref, editor, next) {
    var type = _ref.type,
        args = _ref.args;

    switch (type) {
      case 'splitBlock':
        // When splitting a link, if the cursor is at the end of the
        // link, we will split the link into a link with all the text
        // and an empty link. This empty link gets normalized out, and
        // because the cursor was inside that node that no longer
        // exists, it gets moved back to the end of the previous link.
        //
        // To prevent this, we should treat a splitBlock at the end of
        // the link, but still inside the link, as if it happened
        // outside the link.
        var _editor$value2 = editor.value,
            endInline = _editor$value2.endInline,
            selection = _editor$value2.selection;

        if (endInline && endInline.type === 'link' && selection.end.isAtEndOfNode(endInline)) {
          editor.moveEndToStartOfNextText();
        }
        break;
      default:
    }
    return next();
  }

  return {
    options: options,
    components: { LinkToolbarItem: LinkToolbarItem },
    changes: { wrapOrInsertLink: wrapOrInsertLink, createLink: createLink },
    plugins: [{
      schema: schema,
      renderInline: renderInline,
      onPaste: onPaste,
      onKeyDown: onKeyDown,
      onCommand: onCommand
    }, StickyInlines({
      allowedTypes: ['link', 'link-placeholder'],
      canBeEmpty: false
    })]
  };
}

function LinksPlugin(options) {
  return _extends({}, Plugin$7(options));
}

// Custom handling for the different types of embeds we support.
var EmbedType = function () {
  function EmbedType() {
    classCallCheck(this, EmbedType);
  }

  createClass(EmbedType, null, [{
    key: 'matches',
    value: function matches(url) {
      return this.regex.test(url);
    }
  }, {
    key: 'getIframeAttributes',
    value: function getIframeAttributes(url) {
      var matches = url.match(this.regex);
      if (!matches) {
        return {};
      }

      // Substitute the URL into the iframe src attribute.
      var localAttributes = _extends({}, this.iframeAttributes);
      for (var key in localAttributes) {
        if (typeof localAttributes[key] === 'string') {
          localAttributes[key] = localAttributes[key].replace(/%\{(\w+)\}/g, function (_, replacementKey) {
            if (replacementKey === 'url') {
              return url;
            } else {
              var index = parseInt(replacementKey, 10);
              if (index >= 1 && index < matches.length) {
                return matches[index];
              }
            }
          });
        }
      }

      return localAttributes;
    }
  }, {
    key: 'getProportionalResize',
    value: function getProportionalResize() {
      return this.proportionalResize;
    }
  }]);
  return EmbedType;
}();

EmbedType.proportionalResize = true;

var EmbedYouTube = function (_EmbedType) {
  inherits(EmbedYouTube, _EmbedType);

  function EmbedYouTube() {
    classCallCheck(this, EmbedYouTube);
    return possibleConstructorReturn(this, (EmbedYouTube.__proto__ || Object.getPrototypeOf(EmbedYouTube)).apply(this, arguments));
  }

  return EmbedYouTube;
}(EmbedType);

// https://vimeo.com/398668925
// https://www.vimeo.com/398668925
// https://player.vimeo.com/video/398668925


EmbedYouTube.title = 'YouTube';
EmbedYouTube.regex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
EmbedYouTube.iframeAttributes = {
  src: 'https://www.youtube.com/embed/%{1}',
  allow: 'accelerometer; encrypted-media; gyroscope; picture-in-picture; web-share',
  allowFullScreen: true
};

var EmbedVimeo = function (_EmbedType2) {
  inherits(EmbedVimeo, _EmbedType2);

  function EmbedVimeo() {
    classCallCheck(this, EmbedVimeo);
    return possibleConstructorReturn(this, (EmbedVimeo.__proto__ || Object.getPrototypeOf(EmbedVimeo)).apply(this, arguments));
  }

  return EmbedVimeo;
}(EmbedType);

// https://www.loom.com/share/3a4f548e6afa4a49b8db616c1a61d353?sid=cb1d52ae-1414-4e68-9ea8-d76991987193
// Params available: https://support.loom.com/hc/en-us/articles/360002208317-How-to-embed-your-video-into-a-webpage


EmbedVimeo.title = 'Vimeo';
EmbedVimeo.regex = /^https?:\/\/(?:www\.|player\.)?vimeo\.com(?:\/video)?\/(\d+)/;
EmbedVimeo.iframeAttributes = {
  src: 'https://player.vimeo.com/video/%{1}',
  allow: 'encrypted-media',
  allowFullScreen: true
};

var EmbedLoom = function (_EmbedType3) {
  inherits(EmbedLoom, _EmbedType3);

  function EmbedLoom() {
    classCallCheck(this, EmbedLoom);
    return possibleConstructorReturn(this, (EmbedLoom.__proto__ || Object.getPrototypeOf(EmbedLoom)).apply(this, arguments));
  }

  return EmbedLoom;
}(EmbedType);

// https://www.figma.com/file/LKQ4FJ4bTnCSjedbRpk931/Sample-File


EmbedLoom.title = 'Loom';
EmbedLoom.regex = /^https?:\/\/(?:.*).loom\.com\/(?:share|embed)\/(\w+)/;
EmbedLoom.iframeAttributes = {
  src: 'https://www.loom.com/embed/%{1}?hide_share=true&hideEmbedTopBar=true',
  allow: 'encrypted-media',
  allowFullScreen: true
};

var EmbedFigma = function (_EmbedType4) {
  inherits(EmbedFigma, _EmbedType4);

  function EmbedFigma() {
    classCallCheck(this, EmbedFigma);
    return possibleConstructorReturn(this, (EmbedFigma.__proto__ || Object.getPrototypeOf(EmbedFigma)).apply(this, arguments));
  }

  return EmbedFigma;
}(EmbedType);

// https://gist.github.com/percyhanna/fbf8bfcae8676917fa31f1f030af1953


EmbedFigma.title = 'Figma';
EmbedFigma.regex = /https:\/\/[\w.-]+\.?figma.com\/([\w-]+)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/;
EmbedFigma.iframeAttributes = {
  src: 'https://www.figma.com/embed?embed_host=www.aha.io&url=%{url}',
  allowFullScreen: true
};
EmbedFigma.proportionalResize = false;

var EmbedGist = function (_EmbedType5) {
  inherits(EmbedGist, _EmbedType5);

  function EmbedGist() {
    classCallCheck(this, EmbedGist);
    return possibleConstructorReturn(this, (EmbedGist.__proto__ || Object.getPrototypeOf(EmbedGist)).apply(this, arguments));
  }

  return EmbedGist;
}(EmbedType);

EmbedGist.title = 'GitHub Gist';
EmbedGist.regex = /https:\/\/gist\.github\.com\/([\w-]+)\/([\w-]+)/;
EmbedGist.iframeAttributes = {
  src: 'https://gist.github.com/%{1}/%{2}.pibb?scroll=true'
};
EmbedGist.proportionalResize = false;

var EmbedCommon = function () {
  function EmbedCommon() {
    classCallCheck(this, EmbedCommon);
  }

  createClass(EmbedCommon, null, [{
    key: 'embedTypeForUrl',


    // Check which embed type our URL matches.
    value: function embedTypeForUrl(url) {
      return this.embedTypes.find(function (embedType) {
        return embedType.matches(url);
      });
    }
  }]);
  return EmbedCommon;
}();

EmbedCommon.embedTypes = [EmbedYouTube, EmbedFigma, EmbedVimeo, EmbedLoom, EmbedGist];

var Embed = function (_Component) {
  inherits(Embed, _Component);

  function Embed() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Embed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      allowInteraction: false
    }, _this.onResize = function (commit) {
      return function (width, height) {
        height = width / _this.ratio;
        _this.setState({ width: width, height: height });

        if (commit) {
          setTimeout(function () {
            return _this.setSize(width, height);
          }, 0);
        }
      };
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Embed, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var data = newProps.node.data;

      // This allows for undo and re-render after collaborative changes.

      if (data !== this.props.data && (data.get('width') || data.get('height'))) {
        this.setState({
          width: data.get('width') || data.get('height') * this.ratio,
          height: data.get('height') || data.get('width') / this.ratio
        });
      }
    }
  }, {
    key: 'setSize',
    value: function setSize(width, height) {
      var _props = this.props,
          node = _props.node,
          editor = _props.editor;

      editor.setNodeByKey(node.key, {
        data: this.data.set('width', width).set('height', height).set('originalWidth', this.originalWidth).set('originalHeight', this.originalHeight)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var embedType = EmbedCommon.embedTypeForUrl(this.src);

      if (!embedType) {
        return React__default.createElement(
          'span',
          null,
          'Embed URL not supported'
        );
      } else {
        return React__default.createElement(
          Resizer,
          {
            width: this.width,
            height: this.height,
            onResize: this.onResize(false),
            onResized: this.onResize(true),
            isFocused: this.props.isFocused,
            readOnly: !this.props.editor.isModifiable(),
            isResizeable: true,
            keepRatio: embedType.proportionalResize,
            showPixelSize: true,
            liveResize: true,
            inline: true
          },
          React__default.createElement('iframe', _extends({
            title: embedType.title,
            style: {
              width: this.originalWidth,
              maxWidth: '100%',
              aspectRatio: this.ratio + ' / 1',
              border: 'none',
              boxShadow: '0 0 10px #ddd'
            }
          }, embedType.getIframeAttributes(this.src))),
          this.props.editor.isModifiable() && !this.state.allowInteraction && React__default.createElement(
            'span',
            {
              contentEditable: false,
              style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'end',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              },
              onDoubleClick: function onDoubleClick() {
                return _this2.setState({ allowInteraction: true });
              }
            },
            React__default.createElement(
              'span',
              {
                style: {
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '60%',
                  height: '30px',
                  borderRadius: 5,
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  fontSize: 12,
                  marginBottom: 20
                }
              },
              'Double click to interact'
            )
          )
        );
      }
    }
  }, {
    key: 'data',
    get: function get$$1() {
      return this.props.node.data;
    }
  }, {
    key: 'src',
    get: function get$$1() {
      return this.data.get('embed_src');
    }
  }, {
    key: 'width',
    get: function get$$1() {
      return this.state.width || this.data.get('width');
    }
  }, {
    key: 'originalWidth',
    get: function get$$1() {
      return this.state.originalWidth || this.data.get('originalWidth');
    }
  }, {
    key: 'height',
    get: function get$$1() {
      return this.state.height || this.data.get('height');
    }
  }, {
    key: 'originalHeight',
    get: function get$$1() {
      return this.state.originalHeight || this.data.get('originalHeight');
    }
  }, {
    key: 'ratio',
    get: function get$$1() {
      if (this.originalWidth && this.originalHeight) {
        return this.originalWidth / this.originalHeight;
      } else {
        return 1;
      }
    }
  }]);
  return Embed;
}(React.Component);

function EmbedPlugin (_ref) {
  var linkPlugin = _ref.linkPlugin;

  function renderInline(props, editor, next) {
    if (props.node.type === 'embed') {
      return React__default.createElement(Embed, _extends({
        contentEditable: false,
        editor: editor
      }, props));
    }
    return next();
  }

  function onPaste(event, editor, next) {
    var transfer = slateReact.getEventTransfer(event);
    var text = transfer.text;

    if (typeof text !== 'string') {
      return next();
    }

    if (transfer.type !== 'text' && transfer.type !== 'html') {
      return next();
    }

    text = text.trim();

    if (!isUrl(text)) {
      return next();
    }

    if (!EmbedCommon.embedTypeForUrl(text)) {
      return next();
    }

    if (!editor.value.selection.isCollapsed) {
      return next();
    }

    // First, insert a link, so a user can hit undo to change the
    // embed back into a link
    var startPath = editor.value.selection.start.path;
    var startOffset = editor.value.selection.start.offset;
    editor.command(linkPlugin.changes.wrapOrInsertLink, text, text);
    editor.moveFocusTo(startPath, startOffset);

    editor.insertInline({
      type: 'embed',
      nodes: [],
      data: {
        embed_src: text,
        width: 500,
        height: 500 / (16 / 9),
        originalWidth: 2048,
        originalHeight: 2048 / (16 / 9)
      }
    });

    return editor;
  }

  var schema = {
    inlines: {
      embed: {
        isVoid: true
      }
    }
  };

  return {
    plugins: [{
      schema: schema,
      renderInline: renderInline,
      onPaste: onPaste
    }]
  };
}

/**
 * Returns a node with `block` (and all of the ancestors that depend
 * on it) removed.
 *
 * @param {Slate.Document} document a fragment containing `block`
 * @param {Slate.Block} block the block to remove
 * @returns {Slate.Document} the document with `block` excluded.
 */
function removeTree(document, block) {
  var unusedTree = block;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = document.ancestors(block.key)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = slicedToArray(_ref, 1);

      var node = _ref2[0];

      if (node.nodes.size > 1) {
        break;
      } else {
        unusedTree = node;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (unusedTree === document) {
    unusedTree = document.nodes.get(0);
  }
  return document.removeNode(unusedTree.key);
}

/**
 * Merges the contents of `mergeBlock` into `keepBlock`.
 *
 * @param {Slate.Editor} editor
 * @param {Slate.Block} keepBlock the block that will contain `mergeBlock`'s nodes
 * @param {Slate.Block} mergeBlock the block whose nodes should move to `keepBlock`
 * @param {number} offset the index in `keepBlock` where we should place the moved nodes
 * @returns {Slate.Change}
 */
function mergeContentsOfBlock(editor, keepBlock, mergeBlock, offset) {
  return editor.withoutNormalizing(function (e) {
    mergeBlock.nodes.forEach(function (node, i) {
      e.insertNodeByKey(keepBlock.key, offset + i, node);
    });
  });
}

/**
 * Merges sourceBlock into destBlock, merging all parents of destBlock
 * into parents of sourceBlock, until the two are siblings of each
 * other. This is needed when, for example, we've split a list item,
 * and want to merge it back together. In this case, we need to merge
 * the list items and the child paragraphs.
 * @param {Slate.Editor} editor
 * @param {Slate.Block} sourceBlock the block to merge
 * @param {Slate.Block} destBlock the block to merge sourceBlock into
 * @returns {Slate.Change}
 */
function mergeIntoBlock(editor, sourceBlock, destBlock) {
  var document = editor.value.document;

  var parentBlocks = [sourceBlock];
  var parent = document.getParent(sourceBlock.key);

  while (parent && !parent.hasDescendant(destBlock.key)) {
    parentBlocks.unshift(parent);
    parent = document.getParent(parent.key);
  }

  if (!parent) return editor;

  parentBlocks.forEach(function (block) {
    editor.mergeNodeByKey(block.key);
  });

  return editor;
}

/**
 * @typedef {Object} DocumentBoundary
 * @property {Slate.Node} startBlock the first block of the boundary
 * @property {Slate.Node} endBlock the first block of the boundary
 */

/**
 * @typedef {Object} MergeOptions
 * @property {boolean} [shouldMergeWithStartBlock] True if we allow merging the start of the boundaries together, false otherwise.
 * @property {boolean} [shouldMergeWithEndBlock] True if we allow merging the start of the boundaries together, false otherwise.
 */

/**
 * Merges the boundaries of a fragment into the text before and after
 * the current selection. For example, if a fragment contains three
 * paragraphs, this function will merge the text of the first
 * paragraph into the paragraph in the document containing the start
 * of the selection, and the text of the last paragraph into the
 * paragraph in the document containing the end of the selection,
 * before returning a new fragment containing only the second
 * paragraph. This matches the paste behavior in most other editors.
 *
 * @param {Slate.Change} change
 * @param {Slate.Document} fragment
 * @param {DocumentBoundary} documentBoundary the boundaries of the selection in the destination document
 * @param {DocumentBoundary} fragmentBoundary the start and end blocks in the pasted fragment
 * @param {MergeOptions} mergeOptions options controlling whether we should allow merging boundaries
 * @returns {Slate.Document} a fragment with merged boundaries removed
 */
function mergeFragmentBoundaries(editor, fragment, documentBoundary, fragmentBoundary, mergeOptions) {
  if (mergeOptions.shouldMergeWithStartBlock) {
    // If we're merging into an empty block, it's more natural to
    // convert that block than replace it.
    if (isEmpty(editor, documentBoundary.startBlock)) {
      var _fragmentBoundary$sta = fragmentBoundary.startBlock,
          type = _fragmentBoundary$sta.type,
          data = _fragmentBoundary$sta.data;

      editor.setNodeByKey(documentBoundary.startBlock.key, {
        type: type,
        data: data
      });
    }

    mergeContentsOfBlock(editor, documentBoundary.startBlock, fragmentBoundary.startBlock, documentBoundary.startBlock.nodes.size);

    var mergedStartBlock = editor.value.document.getDescendant(documentBoundary.startBlock.key);
    editor.moveToEndOfNode(mergedStartBlock);

    fragment = removeTree(fragment, fragmentBoundary.startBlock);
  }

  if (mergeOptions.shouldMergeWithEndBlock) {
    if (isEmpty(editor, fragment)) {
      // We only had one block to merge, so merge the end block back
      // in. That way, everything remains a single block, which is how
      // splicing a single block should work.
      var document = editor.value.document;

      var startBlock = document.getDescendant(documentBoundary.startBlock.key);
      editor.command(mergeIntoBlock, documentBoundary.endBlock, startBlock);
    } else {
      editor.moveToStartOfNode(documentBoundary.endBlock);

      mergeContentsOfBlock(editor, documentBoundary.endBlock, fragmentBoundary.endBlock, 0);
      fragment = removeTree(fragment, fragmentBoundary.endBlock);
    }
  }

  return fragment;
}

/**
 * Pastes a normal Slate document fragment into another document,
 * merging boundaries as necessary.
 *
 * @param {Slate.Editor} editor
 * @param {Slate.Document} fragment the fragment being pasted
 * @param {MergeOptions} mergeOptions options controlling whether we should merge document boundaries
 * @param {object} pluginOptions the options passed into the paste plugin.
 * @returns {Slate.Change}
 */
function pasteBasicFragment(editor, fragment, mergeOptions, pluginOptions) {
  var defaultOptions = {
    shouldMergeWithStartBlock: true,
    shouldMergeWithEndBlock: true
  };
  mergeOptions = _extends({}, defaultOptions, mergeOptions);

  var blocks = fragment.getBlocks();
  if (editor.value.selection.isExpanded) {
    editor.delete();
  }

  var value = editor.value;
  var selection = value.selection;
  var document = value.document,
      startBlock = value.startBlock,
      endBlock = value.endBlock;
  var blockPlugins = pluginOptions.blockPlugins;

  var destinationBlockPlugin = blockPlugins[startBlock.type];
  var isDestinationMultiline = destinationBlockPlugin && destinationBlockPlugin.isMultiline;

  var shouldMergeWithStartBlock = mergeOptions.shouldMergeWithStartBlock;

  var shouldMergeWithEndBlock = mergeOptions.shouldMergeWithEndBlock && !selection.anchor.isAtEndOfNode(endBlock);

  var shouldSplitBlock = !selection.anchor.isAtEndOfNode(endBlock);

  if (shouldSplitBlock) {
    editor.splitBlock();
  }

  // Because we may have split the block, our start / endBlocks may
  // have changed. So we need to find them again in the changed document.
  document = editor.value.document;
  startBlock = document.getDescendant(startBlock.key);
  endBlock = shouldSplitBlock ? document.getNextSibling(startBlock.key) : startBlock;

  var blockAfterPaste = document.getNextBlock(startBlock.key);
  if (shouldMergeWithEndBlock && blockAfterPaste) {
    editor.moveToStartOfNode(blockAfterPaste);
  }

  var parent = document.getParent(startBlock.key);
  var index = parent.nodes.indexOf(startBlock) + 1;

  var remainingFragment = mergeFragmentBoundaries(editor, fragment, { startBlock: startBlock, endBlock: endBlock }, { startBlock: blocks.first(), endBlock: blocks.last() }, { shouldMergeWithStartBlock: shouldMergeWithStartBlock, shouldMergeWithEndBlock: shouldMergeWithEndBlock });

  editor.withoutNormalizing(function (e) {
    e.insertFragmentByKey(parent.key, index, remainingFragment);
  });

  editor.normalize();

  if (!shouldMergeWithEndBlock || !blockAfterPaste) {
    editor.moveToEndOfNode(fragment.getLastText());
  }

  if (shouldMergeWithStartBlock && isDestinationMultiline) {
    editor.moveFocusToStartOfNode(startBlock).command(destinationBlockPlugin.changes.toggleBlock, true).moveToEnd();
  }

  return editor;
}

/**
 * Insert the content in `fragment` into the list the cursor is
 * in. The first list items in `fragment` containing text will be
 * added at the same level as the selected list item. Any other blocks
 * will each be wrapped in a list item and added at the same level as
 * the selected list item.
 *
 * @param {Slate.Editor} editor
 * @param {object} listPlugin an instance of the List plugin
 * @param {Slate.Document} fragment the fragment to be merged with the list
 * @param {MergeOptions} mergeOptions options controlling whether we should merge the first and last nodes of `fragment` into the nodes around the cursor
 * @returns
 */
function spliceFragmentIntoList(editor, listPlugin, fragment, mergeOptions) {
  var defaultOptions = {
    shouldMergeWithStartBlock: true,
    shouldMergeWithEndBlock: true
  };
  mergeOptions = _extends({}, defaultOptions, mergeOptions);

  var value = editor.value;


  var index = getCurrentListItemIndex(listPlugin, value);
  if (index === undefined) return;

  var _listPlugin$utils = listPlugin.utils,
      getCurrentItem = _listPlugin$utils.getCurrentItem,
      getCurrentList = _listPlugin$utils.getCurrentList;
  var splitListItem = listPlugin.changes.splitListItem;


  var currentList = getCurrentList(value);

  var blocks = fragment.getBlocks();
  var _value = value,
      selection = _value.selection;
  var start = selection.start,
      end = selection.end;
  var _value2 = value,
      document = _value2.document;

  var endText = document.getDescendant(end.key);
  var startBlock = document.getClosestBlock(start.key);

  var shouldMergeWithStartBlock = mergeOptions.shouldMergeWithStartBlock;
  var shouldMergeWithEndBlock = mergeOptions.shouldMergeWithEndBlock && end.offset !== endText.text.length;

  var shouldSplitBlock = shouldMergeWithStartBlock && shouldMergeWithEndBlock;

  if (editor.value.selection.isExpanded) {
    editor.delete();
  }

  if (shouldSplitBlock) {
    editor.command(splitListItem);
  }

  // update with our new value
  value = editor.value;
  document = value.document;
  startBlock = document.getDescendant(startBlock.key);

  var remainingFragment = fragment;
  // The start block may have been deleted alongside the selection. When this
  // happens, the merging processing is not necessary.
  if (startBlock) {
    var startItem = getCurrentItem(value, startBlock);
    var endItem = shouldSplitBlock ? document.getNextSibling(startItem.key) : startItem;
    var endBlock = void 0;

    if (endItem) {
      endBlock = endItem.nodes.first();
    } else {
      shouldMergeWithEndBlock = false;
    }

    remainingFragment = mergeFragmentBoundaries(editor, fragment, { startBlock: startBlock, endBlock: endBlock }, { startBlock: blocks.first(), endBlock: blocks.last() }, { shouldMergeWithStartBlock: shouldMergeWithStartBlock, shouldMergeWithEndBlock: shouldMergeWithEndBlock });

    // If we've merged all the blocks, there's nothing left to do.
    if (remainingFragment.getBlocks().size === 0) return;

    // If we merged the first block of the pasted text, and that block
    // was a direct child of a list item, make all of its siblings
    // siblings of the block it merged with. This allows subtrees to
    // stay at the same relative depth as they were before.
    var firstPastedBlock = blocks.first();
    if (firstPastedBlock && !remainingFragment.hasDescendant(firstPastedBlock.key)) {
      if (listPlugin.utils.getListForBlock(fragment, blocks.first())) {
        var sourceParent = fragment.getParent(firstPastedBlock.key);
        var sourceIndex = sourceParent.nodes.findIndex(function (node) {
          return node.key === firstPastedBlock.key;
        });
        var siblings = sourceParent.nodes.slice(sourceIndex + 1);

        var destParent = editor.value.document.getParent(startBlock.key);
        var destIndex = destParent.nodes.size;

        siblings.forEach(function (node) {
          editor.insertNodeByKey(destParent.key, destIndex, node);
          remainingFragment = removeTree(remainingFragment, node);
          destIndex++;
        });

        editor.moveToEndOfNode(editor.value.document.getDescendant(destParent.key));
      }
    }

    index = shouldMergeWithStartBlock ? index + 1 : index;
  }

  editor.command(spliceItemsIntoList, currentList, prepareFragmentForListSplicing(listPlugin, remainingFragment).nodes, index);
}

function getCurrentListItemIndex(listPlugin, value) {
  var _listPlugin$utils2 = listPlugin.utils,
      getCurrentItem = _listPlugin$utils2.getCurrentItem,
      getCurrentList = _listPlugin$utils2.getCurrentList;

  var currentItem = getCurrentItem(value);
  if (!currentItem) return;

  var currentList = getCurrentList(value);
  return currentList.nodes.indexOf(currentItem);
}

function spliceItemsIntoList(editor, list, blocks, index) {
  if (blocks.isEmpty()) return;

  if (editor.value.selection.isExpanded) {
    editor.delete();
  }

  blocks.forEach(function (block) {
    editor.insertNodeByKey(list.key, index, block);
    index++;
  });

  return editor.moveToEndOfNode(blocks.last());
}

function wrapChildrenInListItems(listPlugin, fragment) {
  fragment.nodes.forEach(function (node, index) {
    var listItem = listPlugin.changes.wrapNodeInListItem(node);
    fragment = fragment.removeNode([index]);
    fragment = fragment.insertNode([index], listItem);
  });
  return fragment;
}

function prepareFragmentForListSplicing(listPlugin, fragment) {
  var firstBottomBlock = fragment.getBlocks().first();
  var firstNode = fragment.nodes.get(0);
  if (!firstBottomBlock || !firstNode) return fragment;

  if (listPlugin.utils.isList(firstNode)) {
    // Paste a fragment that's just a list containing list items?
    // The fragment should unwrap it, so the lis are topmost items.
    var firstList = listPlugin.utils.getListForBlock(fragment, firstBottomBlock);
    if (firstList) {
      firstList.nodes.forEach(function (node, index) {
        fragment = fragment.moveNode(node.key, [index]);
      });
      fragment = removeTree(fragment, firstList);
    }
  }

  // Paste a fragment that's a set of blocks? Wrap them in list
  // items for future splicing.
  return wrapChildrenInListItems(listPlugin, fragment);
}

/**
 * Pastes a group of table cells into another table, overwriting cells
 * and expanding the table's size as needed to fit the pasted cells.
 *
 * @param {Slate.Editor} editor
 * @param {object} tablePlugin an instance of the Table plugin
 * @param {Slate.Document} fragment the fragment containing the table we're pasting
 * @returns {Slate.Change}
 */
function pasteTableIntoTable(editor, tablePlugin, fragment) {
  var utils = tablePlugin.utils,
      changes = tablePlugin.changes;
  var _editor$value = editor.value,
      document = _editor$value.document,
      selection = _editor$value.selection;

  var destinationCell = utils.getClosestTableCellByKey(document, selection.start.key);
  var sourceTable = fragment.nodes.first();

  var destinationTable = utils.getClosestTableByKey(document, destinationCell.key);
  var sourceTableSize = utils.getTableSize(sourceTable);
  var destinationTableSize = utils.getTableSize(destinationTable);
  var destinationCellLocation = utils.getPositionOfCellInTable(destinationTable, destinationCell);

  editor.snapshotSelection();

  return editor.command(changes.expandTableToFit, sourceTableSize, destinationTableSize, destinationCellLocation).command(changes.replaceCells, sourceTable, destinationCell, destinationCellLocation);
}

/**
 * Returns true if `fragment` is a table and the current selection is
 * inside a table cell, false otherwise.
 *
 * @param {object} tablePlugin an instance of the Table plugin
 * @param {Slate.Document} fragment the document fragment to insert into the document
 * @param {Slate.Value} value the value containing the current selection
 * @returns {boolean}
 */
function isPastingTableIntoTable(tablePlugin, fragment, value) {
  return fragment.nodes.size === 1 && tablePlugin.utils.isTable(fragment.nodes.first()) && tablePlugin.utils.inTable(value);
}

/**
 * If every block in a fragment is part of a single table cell, we
 * want to insert just the children of that cell, so it shows up as
 * normal text -- the default is to paste the fragment as a one-cell
 * table. This takes a fragment, and returns a new fragment with that
 * transformation, if applicable.
 *
 * @param {object} tableUtils the Table plugin's utils object
 * @param {Slate.Document} fragment the document fragment to insert into the document
 * @returns {Slate.Document} either the original fragment, or a new fragment containing only cell descendants if all blocks descend from a single table cell.
 */
function extractBlocksFromSingleCellPaste(tableUtils, fragment) {
  var blocks = fragment.getBlocks();
  if (blocks.size === 0) return fragment;

  var parentCell = tableUtils.getClosestTableCellByKey(fragment, blocks.first().key);
  if (!parentCell) return fragment;

  if (blocks.every(function (block) {
    return parentCell.getDescendant(block.key);
  })) {
    return fragment.set('nodes', parentCell.nodes);
  }

  return fragment;
}

/**
 * Top-level pasting logic goes in here. This is the function that
 * decides how `fragment` should affect `change.`
 *
 * @param {object} pluginOptions the options passed into this plugin.
 * @param {Slate.Editor} editor
 * @param {Slate.Document} fragment part of a Slate document that should
 * @returns {Slate.Change}
 */
function pasteFragment(pluginOptions, editor, fragment) {
  // Regenerate all the keys -- otherwise, copy and paste can cause collisions.
  fragment = fragment.mapDescendants(function (child) {
    return child.object === 'character' ? child : child.regenerateKey();
  });

  var pasteTransforms = pluginOptions.pasteTransforms;

  if (pasteTransforms && Object.keys(pasteTransforms).length) {
    fragment = fragment.mapDescendants(function (child) {
      var transformFunctions = pasteTransforms[child.type] || [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = transformFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var transformFunction = _step.value;

          child = transformFunction(child, editor);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return child;
    });
  }

  var listPlugin = pluginOptions.listPlugin,
      tablePlugin = pluginOptions.tablePlugin,
      blockPlugins = pluginOptions.blockPlugins;
  var isTable = tablePlugin.utils.isTable;
  var inListItem = listPlugin.utils.inListItem;
  var value = editor.value;

  var mergeOptions = {};

  // If there's a active table selection, disable pasting. We don't
  // really have defined behavior for that case.
  if (tablePlugin.utils.hasActiveTableSelection(editor.value)) return editor;

  // If all of the blocks in a fragment belong to the same table cell,
  // unwrap the blocks from the table so they paste as normal text.
  fragment = extractBlocksFromSingleCellPaste(tablePlugin.utils, fragment);

  // special treatment for pasting into a single empty block that is not a list
  var startBlock = value.startBlock,
      endBlock = value.endBlock;

  // Race conditions can get us into a state where you can paste when there is
  // no content yet.

  if (!startBlock || !endBlock) {
    return editor;
  }

  var selection = value.selection;

  var willEmptyAfterDelete = selection.start.isAtStartOfNode(startBlock) && selection.end.isAtEndOfNode(endBlock);

  // is this a single empty block
  if (willEmptyAfterDelete || startBlock === endBlock && startBlock.nodes.size <= 1 && startBlock.text === '') {
    var destinationBlockPlugin = blockPlugins[startBlock.type];
    var isDestinationMultiline = destinationBlockPlugin && destinationBlockPlugin.isMultiline;

    // lists and multilines should not be replaced
    // also, pasting cells into a table has it's own semantics so  we don't replace
    if (!inListItem(value) && !isDestinationMultiline && !isPastingTableIntoTable(tablePlugin, fragment, value)) {
      // if it is or will be empty we replace it with the pasted fragment
      return editor.withoutNormalizing(function (e) {
        e.delete();
        var parent = value.document.getParent(startBlock.key);
        var parentIndex = parent.nodes.indexOf(startBlock);
        e.insertFragmentByKey(parent.key, parentIndex, fragment);

        e.removeNodeByKey(startBlock.key);
      });
    }
  }

  var blocks = fragment.getBlocks();
  if (blocks.size <= 1) {
    if (inListItem(value)) {
      return editor.command(spliceFragmentIntoList, listPlugin, fragment, {});
    } else if (startBlock.type === 'code') {
      // If we are pasting into a codeblock, we need to make sure that the pasted fragment
      // gets wrapped in a codeblock / blocks are removed
      // Fixes bug where pasting into entire codeblock removed the block formatting
      var _blockPlugins = pluginOptions.blockPlugins;

      var codeBlockPlugin = _blockPlugins['code'];
      return editor.withoutNormalizing(function (e) {
        e.insertFragment(fragment);
        e.moveFocusToStartOfNode(e.value.startBlock).command(codeBlockPlugin.changes.toggleBlock, true).moveToEnd();
      });
    } else {
      return editor.insertFragment(fragment);
    }
  }

  if (isPastingTableIntoTable(tablePlugin, fragment, value)) {
    return editor.command(pasteTableIntoTable, tablePlugin, fragment);
  }

  // Tables don't merge. They always stay as full tables.
  if (isTable(fragment.nodes.first())) {
    mergeOptions.shouldMergeWithStartBlock = false;
  }

  if (isTable(fragment.nodes.last())) {
    mergeOptions.shouldMergeWithEndBlock = false;
  }

  // If we don't make any more complicated decisions than this, it
  // would be worth using the basic Slate plugin fallback logic
  // instead.
  if (inListItem(value)) {
    return editor.command(spliceFragmentIntoList, listPlugin, fragment, mergeOptions);
  }

  return editor.command(pasteBasicFragment, fragment, mergeOptions, pluginOptions);
}

/**
 * Inserts `html` into a Slate document.
 *
 * @param {Slate.Editor} editor
 * @param {string} html a string of HTML to insert into the document
 * @returns {Slate.Editor}
 */
function pasteHTML(pluginOptions, editor, html) {
  var serializer = pluginOptions.serializer;

  var _serializer$deseriali = serializer.deserialize(html),
      document = _serializer$deseriali.document;

  return editor.pasteFragment(document);
}

/**
 * Inserts `text` into a Slate document.
 *
 * @param {Slate.Editor} editor
 * @param {string} text a string of text to insert into the document
 * @returns {Slate.Editor}
 */
function pasteText(pluginOptions, editor, text) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var defaultMarks = editor.getInsertMarksAtRange(selection, document);

  var _PlainSerializer$dese = PlainSerializer.deserialize(text, {
    defaultBlock: { type: 'paragraph' },
    defaultMarks: defaultMarks
  }),
      fragment = _PlainSerializer$dese.document;

  return editor.pasteFragment(fragment);
}

var changes$3 = Object.freeze({
	pasteFragment: pasteFragment,
	pasteHTML: pasteHTML,
	pasteText: pasteText
});

var Plugin$8 = (function (options, changes) {
  var _pasteHTML = changes.pasteHTML,
      _pasteText = changes.pasteText;


  function pasteFragment(editor, fragment) {
    changes.pasteFragment(options, editor, fragment);
  }

  function onPaste(event, editor, next) {
    var transfer = slateReact.getEventTransfer(event);

    if (preferHTMLContent(transfer)) {
      return _pasteHTML(options, editor, transfer.html);
    }

    switch (transfer.type) {
      case 'fragment':
        return editor.pasteFragment(transfer.fragment);
      case 'html':
        return _pasteHTML(options, editor, transfer.html);
      case 'text':
        return _pasteText(options, editor, transfer.text);
      default:
        return next();
    }
  }

  return {
    onPaste: onPaste,
    commands: {
      pasteFragment: pasteFragment,
      pasteHTML: function pasteHTML(editor, html) {
        return _pasteHTML(options, editor, html);
      },
      pasteText: function pasteText(editor, text) {
        return _pasteText(options, editor, text);
      }
    }
  };
});

var PastePlugin = (function (options) {
  return {
    plugins: [Plugin$8(options, changes$3)]
  };
});

function hasFormatting(document) {
  var found = document.findDescendant(function (node) {
    return node.object === 'text' && !node.marks.isEmpty() || node.object === 'inline' || node.object === 'block' && node.type !== 'paragraph';
  });

  return found;
}

var PasteMarkdownPlugin = (function () {
  function onPaste(event, editor, next) {
    var transfer = slateReact.getEventTransfer(event);

    switch (transfer.type) {
      case 'text':
        {
          try {
            var html = marked.marked.parse(transfer.text, {
              breaks: true
            });

            var _editor$deserialize = editor.deserialize(html),
                document = _editor$deserialize.document;

            if (hasFormatting(document)) {
              editor.pasteFragment(document);
            } else {
              return next();
            }
          } catch (e) {
            console.error(e);
            return next();
          }

          break;
        }
      default:
        return next();
    }
  }

  return {
    plugins: [{
      onPaste: onPaste
    }]
  };
});

function findAttachmentsInHTML(html) {
  var ids = new Set();

  // Label in list mode
  var namePattern = /attachment-name-(\d+)/g;
  var nameMatches = html.matchAll(namePattern);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = nameMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var match = _step.value;

      ids.add(match[1]);
    }

    // Grid mode or Icon in list mode
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var pathPattern = /\/attachments\/(\d+)/g;
  var pathMatches = html.matchAll(pathPattern);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = pathMatches[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _match = _step2.value;

      ids.add(_match[1]);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var attachments = Array.from(ids).map(function (id) {
    var img = document.body.querySelector('#attachment-' + id + ' img.attachment-thumbnail-image');

    if (img.style.display !== 'none') {
      return {
        href: img.getAttribute('data-original-src') || img.src,
        label: img.getAttribute('title') || 'Unnamed file',
        isImage: img.hasAttribute('data-is-image')
      };
    }

    return null;
  }).filter(function (_ref) {
    var href = _ref.href;
    return href;
  });

  return attachments;
}

function DropHtmlAttachments(_ref2) {
  var imagePlugin = _ref2.imagePlugin,
      linkPlugin = _ref2.linkPlugin;

  var insertAttachementFromDroppedHTML = function insertAttachementFromDroppedHTML(event, editor, next) {
    var transfer = slateReact.getEventTransfer(event);
    var html = void 0;

    if (transfer.type === 'html') {
      html = transfer.html;
    } else if (!slateDevEnvironment.IS_IE && // COMPAT: IE 11 will throw an error using getData('text/uri-list'). This is not detectable before trying it.
    event && event.nativeEvent && event.nativeEvent.dataTransfer.getData('text/uri-list')) {
      // COMPAT: Safari will sometimes only give us a URL. In that
      // case, we can search the document for the link it came from,
      // and use that link's HTML instead.
      var element = document.querySelector('a[href="' + event.nativeEvent.dataTransfer.getData('text/uri-list') + '"]');
      if (!element) return next();
      html = element.outerHTML;
    } else {
      return next();
    }

    var range = editor.findEventRange(event);
    var attachments = findAttachmentsInHTML(html);

    if (attachments && attachments.length > 0) {
      if (range) {
        editor.select(range);
      }

      attachments.forEach(function (_ref3) {
        var href = _ref3.href,
            label = _ref3.label,
            isImage = _ref3.isImage;

        if (isImage) {
          editor.command(imagePlugin.changes.insertImage, editor, href);
        } else {
          editor.command(linkPlugin.changes.wrapOrInsertLink, href, label);
        }
      });
      return true;
    }
    return next();
  };

  return {
    plugins: [{
      onDrop: insertAttachementFromDroppedHTML
    }]
  };
}

var SerializationPlugin = (function (_ref) {
  var serializer = _ref.serializer;

  return {
    plugins: [{
      queries: {
        serialize: function serialize(_editor, value) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return serializer.serialize(value, options);
        },
        deserialize: function deserialize(_editor, html) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return serializer.deserialize(html, options);
        }
      }
    }]
  };
});

var FontSizeList = React__default.memo(function (_ref) {
  var fontSizes = _ref.fontSizes,
      handleClick = _ref.handleClick,
      currentFontSizeName = _ref.currentFontSizeName;

  var currentFontSize = currentFontSizeName ? fontSizes.find(function (e) {
    return e.styleName === currentFontSizeName;
  }) : undefined;
  return React__default.createElement(
    React__default.Fragment,
    null,
    fontSizes.map(function (_ref2) {
      var displayName = _ref2.displayName,
          styleName = _ref2.styleName,
          isDefault = _ref2.isDefault;

      var onClick = handleClick(styleName);
      var active = currentFontSizeName ? currentFontSize && currentFontSize.styleName === styleName : isDefault;

      return React__default.createElement(
        ToolbarItem,
        {
          key: styleName,
          onClick: onClick,
          active: active
        },
        React__default.createElement(
          'span',
          null,
          displayName
        )
      );
    })
  );
});

var Icon = function Icon() {
  return React__default.createElement('i', { className: 'fa-regular fa-text-size' });
};

var FontSizeToolbarGroup = (function (plugin) {
  return function (change) {
    var handleClick = function handleClick(editor) {
      return function (fontSize) {
        return function () {
          var foundFontSize = plugin.fontSizes.find(function (fs) {
            return fs.styleName === fontSize;
          });
          var fontSizeName = foundFontSize ? foundFontSize.displayName : fontSize;
          trackToolbarAnalytics({
            eventName: 'User selects toolbar font size',
            properties: { 'Font size': fontSizeName }
          });
          editor.setFontSize(fontSize);
        };
      };
    };

    var handleClearClick = function handleClearClick(editor) {
      return function () {
        editor.clearFontSize();
      };
    };

    return [{
      item: function item(_ref3) {
        var editor = _ref3.editor;

        var currentFontSizeName = editor.getCurrentFontSize();

        return React__default.createElement(
          ToolbarMenu,
          {
            label: 'Font size',
            name: 'fontSize',
            icon: Icon
          },
          React__default.createElement(FontSizeList, {
            fontSizes: plugin.fontSizes,
            handleClick: handleClick(editor),
            handleClearClick: handleClearClick(editor),
            currentFontSizeName: currentFontSizeName
          })
        );
      }
    }];
  };
});

var defaultFontSizeList = [{ displayName: '10', styleName: '10px' }, { displayName: '12', styleName: '12px' }, { displayName: '13', styleName: '13px', isDefault: true }, { displayName: '14', styleName: '14px' }, { displayName: '16', styleName: '16px' }, { displayName: '18', styleName: '18px' }, { displayName: '20', styleName: '20px' }, { displayName: '22', styleName: '22px' }, { displayName: '24', styleName: '24px' }, { displayName: '30', styleName: '30px' }, { displayName: '36', styleName: '36px' }, { displayName: '48', styleName: '48px' }];

function getFontSizeFromMark(mark) {
  return mark.data.get('fontSize');
}

function getStyleFromMark(mark) {
  if (mark.type !== 'fontSize') {
    return {};
  }

  var fontSize = getFontSizeFromMark(mark);

  return removeUndefined({
    fontSize: fontSize
  });
}

var FontSizePlugin = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fontSizes: null },
      fontSizes = _ref.fontSizes;

  var fontSizeList = fontSizes || defaultFontSizeList;
  return {
    components: {
      FontSizeToolbarGroup: FontSizeToolbarGroup
    },
    plugins: [{
      renderMark: function renderMark(_ref2, editor, next) {
        var children = _ref2.children,
            mark = _ref2.mark,
            attributes = _ref2.attributes;
        var type = mark.type;

        if (type === 'fontSize') {
          var style = getStyleFromMark(mark);
          return React__default.createElement(
            'span',
            _extends({ style: style }, attributes),
            children
          );
        }
        return next();
      },
      commands: {
        setFontSize: function setFontSize(editor, fontSize) {
          editor.clearFontSize();

          editor.addMark({
            type: 'fontSize',
            data: { fontSize: fontSize }
          });
        },
        clearFontSize: function clearFontSize(editor) {
          editor.getMarks().forEach(function (mark) {
            if (mark.type === 'fontSize') {
              editor.removeMark(mark);
            }
          });
        }
      },
      queries: {
        getCurrentFontSize: function getCurrentFontSize(editor) {
          var fontSizeMarks = editor.getActiveMarks().filter(function (mark) {
            return mark.type === 'fontSize';
          });

          if (fontSizeMarks.size === 0) return;

          var fontSize = getFontSizeFromMark(fontSizeMarks.first());

          if (fontSizeMarks.every(function (mark) {
            return fontSize === getFontSizeFromMark(mark);
          })) {
            return fontSize;
          }
        },
        getCurrentFontSizeInPixels: function getCurrentFontSizeInPixels(editor) {
          var fontSize = editor.getCurrentFontSize(editor);
          if (!fontSize) {
            return;
          }
          return parseInt(fontSize, 10);
        }
      }
    }],
    fontSizes: fontSizeList
  };
});

var FontList = React__default.memo(function (_ref) {
  var fonts = _ref.fonts,
      handleClick = _ref.handleClick,
      handleClearClick = _ref.handleClearClick,
      currentFont = _ref.currentFont;

  return React__default.createElement(
    React__default.Fragment,
    null,
    fonts.map(function (_ref2) {
      var displayName = _ref2.displayName,
          styleName = _ref2.styleName,
          isDefault = _ref2.isDefault,
          previewImg = _ref2.previewImg;

      var onClick = handleClick(styleName);
      var active = currentFont ? currentFont.styleName === styleName : isDefault;

      return React__default.createElement(
        ToolbarItem,
        {
          key: styleName,
          onClick: onClick,
          active: active
        },
        previewImg ? React__default.createElement('img', { src: previewImg, alt: displayName, className: 'aha-editor__font-family-preview-img' }) : React__default.createElement(
          'span',
          { style: { fontFamily: styleName } },
          displayName
        )
      );
    })
  );
});

var Icon$1 = function Icon() {
  return React__default.createElement('i', { className: 'fa-regular fa-text' });
};

var FontToolbarGroup = (function (plugin) {
  return function (change) {
    var handleClick = function handleClick(editor) {
      return function (font) {
        return function () {
          var foundFont = plugin.fonts.find(function (fontItem) {
            return fontItem.styleName === font;
          });
          var fontName = foundFont ? foundFont.displayName : font;
          trackToolbarAnalytics({
            eventName: 'User selects toolbar font',
            properties: { 'Font': fontName }
          });
          return editor.setFont(font);
        };
      };
    };

    var handleClearClick = function handleClearClick(editor) {
      return function () {
        editor.clearFont();
      };
    };

    return [{
      item: function item(_ref3) {
        var editor = _ref3.editor;

        var currentFontStyleName = editor.getCurrentFontFamily();
        var currentFont = plugin.fonts.find(function (font) {
          return font.styleName === currentFontStyleName;
        }) || plugin.fonts.find(function (font) {
          return font.isDefault;
        });

        return React__default.createElement(
          ToolbarMenu,
          {
            label: 'Font',
            name: 'fontFamily',
            icon: Icon$1
          },
          React__default.createElement(FontList, {
            fonts: plugin.fonts,
            handleClick: handleClick(editor),
            handleClearClick: handleClearClick(editor),
            currentFont: currentFont
          })
        );
      }
    }];
  };
});

function getFontFamilyFromMark(mark) {
  return mark.data.get('fontFamily');
}

function getStyleFromMark$1(mark, fontList) {
  if (mark.type !== 'fontFamily') {
    return {};
  }

  var fontFromMark = getFontFamilyFromMark(mark);
  var foundFont = serializerFontList.find(function (font) {
    return font.styleName === fontFromMark;
  });
  var fontFamily = foundFont ? foundFont.fontFamily : fontFromMark;

  return removeUndefined({
    fontFamily: fontFamily
  });
}

var FontFamilyPlugin = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fonts: null },
      fonts = _ref.fonts;

  var fontList = fonts || defaultFontList;

  return {
    components: {
      FontToolbarGroup: FontToolbarGroup
    },
    plugins: [{
      renderMark: function renderMark(_ref2, editor, next) {
        var children = _ref2.children,
            mark = _ref2.mark,
            attributes = _ref2.attributes;
        var type = mark.type;

        if (type === 'fontFamily') {
          var style = getStyleFromMark$1(mark, fontList);

          return React__default.createElement(
            'span',
            _extends({ style: style }, attributes),
            children
          );
        }
        return next();
      },
      commands: {
        setFont: function setFont(editor, fontFamily) {
          editor.clearFont();

          editor.addMark({
            type: 'fontFamily',
            data: { fontFamily: fontFamily }
          });
        },
        clearFont: function clearFont(editor) {
          editor.getMarks().forEach(function (mark) {
            if (mark.type === 'fontFamily') {
              editor.removeMark(mark);
            }
          });
        }
      },
      queries: {
        getCurrentFontFamily: function getCurrentFontFamily(editor) {
          var fontFamilyMarks = editor.getActiveMarks().filter(function (mark) {
            return mark.type === 'fontFamily';
          });

          if (fontFamilyMarks.size === 0) return;

          var fontFamily = getFontFamilyFromMark(fontFamilyMarks.first());

          if (fontFamilyMarks.every(function (mark) {
            return fontFamily === getFontFamilyFromMark(mark);
          })) {
            return fontFamily;
          }
        }
      }
    }],
    fonts: fontList
  };
});

var lineHeightOptions = [{ displayName: 'Single', styleName: '1' }, { displayName: '1.15', styleName: '1.15' }, { displayName: '1.3', styleName: '1.35' }, { displayName: '1.5', styleName: '1.5' }, { displayName: 'Double', styleName: '2' }];

var LineHeightList = React__default.memo(function (_ref) {
  var handleClick = _ref.handleClick,
      handleClearClick = _ref.handleClearClick,
      currentLineHeight = _ref.currentLineHeight;

  return React__default.createElement(
    React__default.Fragment,
    null,
    lineHeightOptions.map(function (_ref2, index) {
      var displayName = _ref2.displayName,
          styleName = _ref2.styleName;

      var onClick = handleClick(styleName);
      var active = currentLineHeight && currentLineHeight.styleName === styleName;

      return React__default.createElement(
        ToolbarItem,
        {
          key: 'lineHeight-' + index,
          onClick: onClick,
          active: active
        },
        React__default.createElement(
          'span',
          null,
          displayName
        )
      );
    })
  );
});

var Icon$2 = function Icon() {
  return React__default.createElement('i', { className: 'fa-regular fa-line-height' });
};

var LineHeightToolbarGroup = (function (plugin) {
  return function (change) {
    var handleClick = function handleClick(editor) {
      return function (lineHeight) {
        return function () {
          var foundLineHeight = lineHeightOptions.find(function (lh) {
            return lh.styleName === lineHeight;
          });
          var lineHeightName = foundLineHeight ? foundLineHeight.displayName : lineHeight;
          trackToolbarAnalytics({
            eventName: 'User selects toolbar line height',
            properties: { 'Line height': lineHeightName }
          });
          editor.setLineHeight(lineHeight);
        };
      };
    };

    var handleClearClick = function handleClearClick(editor) {
      return function () {
        editor.clearLineHeight();
      };
    };

    return [{
      item: function item(_ref3) {
        var editor = _ref3.editor;

        var currentLineHeightName = editor.getCurrentLineHeight() || '1.4';
        var currentLineHeight = lineHeightOptions.find(function (e) {
          return e.styleName === currentLineHeightName;
        });

        return React__default.createElement(
          ToolbarMenu,
          {
            label: 'Line height',
            name: 'lineHeight',
            icon: Icon$2
          },
          React__default.createElement(LineHeightList, {
            handleClick: handleClick(editor),
            handleClearClick: handleClearClick(editor),
            currentLineHeight: currentLineHeight
          })
        );
      }
    }];
  };
});

var LineHeightPlugin = (function (options) {
  return {
    components: {
      LineHeightToolbarGroup: LineHeightToolbarGroup
    },
    plugins: [{
      commands: {
        setLineHeight: function setLineHeight(editor, lineHeight) {
          var blocks = editor.value.document.getLeafBlocksAtRange(editor.value.selection);
          blocks.forEach(function (block) {
            editor.setNodeByKey(block.key, {
              data: block.data.set('lineHeight', lineHeight)
            });
          });
        },
        clearLineHeight: function clearLineHeight(editor) {
          var blocks = editor.value.document.getLeafBlocksAtRange(editor.value.selection);
          blocks.forEach(function (block) {
            editor.setNodeByKey(block.key, {
              data: block.data.delete('lineHeight')
            });
          });
        }
      },
      queries: {
        getCurrentLineHeight: function getCurrentLineHeight(editor) {
          var key = editor.value.selection.end.key;
          if (key) {
            var block = editor.value.document.getClosestBlock(key);
            return block.data.get('lineHeight');
          }
        }
      }
    }]
  };
});

var Block = React__default.forwardRef(function (props, ref) {
  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      linkCopied = _useState2[0],
      setLinkCopied = _useState2[1];

  var className = props.alignmentUtils && props.alignmentUtils.alignmentClassForData(props.node.data);

  var style = {};
  if (props.node.data.get('lineHeight')) {
    style.lineHeight = 'calc(var(--aha-editor--user-line-height) * ' + props.node.data.get('lineHeight') + ')';
  }
  if (props.node.data.get('fontSize')) {
    style.fontSize = props.node.data.get('fontSize');
  }

  var extraAttributes = {};
  if (props.node.data.get('hashLookupKey')) {
    extraAttributes['data-hash-key-lookup'] = props.node.data.get('hashLookupKey');
  }

  if (props.hasAnchor && props.node.text) {
    extraAttributes.id = generateId(props.node.text);
  }

  var anchorLink = null;
  if (extraAttributes.id) {
    var baseUrl = props.baseUrl || '';
    anchorLink = React__default.createElement(
      'span',
      { className: 'aha-editor__anchor-copy-link-wrapper' },
      React__default.createElement('a', {
        className: 'aha-editor__anchor-copy-link',
        'aria-label': 'Copy link to heading',
        href: baseUrl + '#' + extraAttributes.id,
        onClick: function onClick(e) {
          e.preventDefault();

          try {
            navigator.clipboard.writeText(e.currentTarget.href);
            setLinkCopied(true);
          } catch (e) {
            console.error(e);
          }
        }
      }),
      React__default.createElement(
        'aha-tooltip',
        { 'click-show': true, 'click-hide': null, 'hover-show': false },
        linkCopied ? 'Link copied to clipboard' : 'Copy link to heading'
      )
    );
  }

  return React__default.createElement(
    props.tag,
    _extends({
      className: classnames(className, {
        'aha-editor__anchor-copy-link-container': extraAttributes.id
      }),
      node: props.node,
      ref: ref,
      onMouseLeave: function onMouseLeave(e) {
        setLinkCopied(false);
      }
    }, props.attributes, extraAttributes, {
      style: style
    }),
    props.children,
    anchorLink
  );
});

var DEFAULT_BLOCK_TYPE = 'paragraph';

var DEFAULT_OPTIONS = {
  type: DEFAULT_BLOCK_TYPE,
  isMultiline: false,
  clearFormattingAtEnd: true,
  exitOnBackspace: false,
  allowTab: false,
  internalSoftBreak: false,
  hasAnchor: false,
  baseUrl: ''
};

var isEnter = isHotkey.isKeyHotkey('enter');
var isNonShiftEnter = function isNonShiftEnter(event) {
  return !event.shiftKey && isEnter(event);
};
var isShiftEnter = isHotkey.isKeyHotkey('shift+enter');
var isTab$1 = isHotkey.isKeyHotkey('tab');

var BlockFormatPlugin = (function (options) {
  options = _extends({}, DEFAULT_OPTIONS, options);
  options = _extends({ tag: options.type, title: options.type }, options);

  var components = {
    Block: Block
  };

  var utils = {
    isBlock: function isBlock(_ref) {
      var value = _ref.value;
      return value.blocks.every(function (block) {
        return block.type === options.type;
      });
    },
    inBlock: function inBlock(value) {
      return value.selection.end.key && value.document.getClosestBlock(value.selection.end.key).type === options.type;
    }
  };

  var changes = {
    // Wrap a set of blocks in the current type. If it's a multiline
    // type, it will convert the block to using soft breaks, and wrap
    // all of the content into a single block.
    wrapBlocks: function wrapBlocks(change) {
      if (options.isMultiline || options.internalSoftBreak) {
        var blocks = change.value.blocks;

        if (blocks.isEmpty()) return;

        var parentBlock = blocks.first();
        change.withoutNormalizing(function (change) {
          change.setNodeByKey(parentBlock.key, options.type);
          blocks.slice(1).forEach(function (block) {
            parentBlock = change.value.document.getDescendant(parentBlock.key);
            var index = parentBlock.nodes.size;
            var lastTextNode = parentBlock.nodes.get(index - 1);
            if (!lastTextNode) return;
            change.insertTextByKey(lastTextNode.key, lastTextNode.text.length, '\n');

            block.nodes.forEach(function (node) {
              change.moveNodeByKey(node.key, parentBlock.key, index);
              index++;
            });

            var unusedTree = block;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = change.value.document.ancestors(block.key)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref2 = _step.value;

                var _ref3 = slicedToArray(_ref2, 1);

                var node = _ref3[0];

                if (node.nodes.size > 1) {
                  break;
                } else {
                  unusedTree = node;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            change.removeNodeByKey(unusedTree.key);
          });
        });
        return change;
      } else {
        return change.setBlocks(options.type);
      }
    },
    toggleBlock: function toggleBlock(change, force) {
      if (force === undefined) {
        force = !utils.isBlock(change.value);
      }

      // Clear font sizes for certain block types
      if (['paragraph', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code', 'quote'].includes(options.type)) {
        var blocks = [].concat(toConsumableArray(change.value.blocks));

        if (blocks.length > 0) {
          var range = Slate.Range.create().moveStartToStartOfNode(blocks[0]).moveEndToEndOfNode(blocks[blocks.length - 1]);

          range.normalize(change.value.document);

          var marks = change.value.document.getMarksAtRange(range);

          marks.forEach(function (mark) {
            if (mark.type === 'fontSize') {
              change.removeMarkAtRange(range, mark);
            }
          });
        }
      }

      if (force) {
        change.command(changes.wrapBlocks, options.type);
      } else {
        return change.setBlocks(DEFAULT_BLOCK_TYPE);
      }
    },
    resetBlock: function resetBlock(change) {
      return change.setBlocks({ type: DEFAULT_BLOCK_TYPE, data: {} });
    },
    escapeBlock: function escapeBlock(change, position) {
      if (!utils.inBlock(change.value)) return;

      var _change$value = change.value,
          document = _change$value.document,
          selection = _change$value.selection;

      if (!selection.isCollapsed) return;

      var block = document.getClosestBlock(selection.end.key);

      if (position === 'above') {
        var textNode = document.getPreviousText(selection.anchor.key);
        if (!textNode) {
          change.splitBlock().moveToEndOfNode(change.value.document.getDescendant(block.key)).command(changes.resetBlock);
        }
      } else if (position === 'below') {
        var _textNode = document.getNextText(selection.anchor.key);
        if (!_textNode) {
          change.splitBlock().command(changes.resetBlock);
        }
      }
    }
  };

  var isHardBreak = options.isMultiline ? isShiftEnter : isNonShiftEnter;
  var isSoftBreak = options.isMultiline ? isNonShiftEnter : isShiftEnter;

  var onKeyDown = function onKeyDown(event, editor, next) {
    if (!utils.inBlock(editor.value)) return next();

    if (handleTab(event, editor)) {
      return editor;
    }

    if (handleBlockEscape(event, editor)) {
      return editor;
    }

    var _editor$value = editor.value,
        document = _editor$value.document,
        selection = _editor$value.selection;

    if (selection.isCollapsed && editor.isVoid(document.getParent(selection.start.key))) {
      return next();
    }

    if (handleBlockExit(event, editor)) {
      return editor;
    }

    if (handleBlockSplits(event, editor)) {
      return editor;
    }

    return next();
  };

  var handleTab = function handleTab(event, editor) {
    if (!options.allowTab) return;
    if (!isTab$1(event)) return;
    event.preventDefault();
    return editor.insertText('\t');
  };

  var handleBlockExit = function handleBlockExit(event, editor) {
    var value = editor.value;
    var selection = value.selection;

    if (!options.exitOnBackspace) return;
    if (Hotkeys.isDeleteBackward(event) && selection.isCollapsed && selection.anchor.isAtStartOfNode(value.startBlock)) {
      return editor.command(changes.resetBlock);
    }
  };

  var handleBlockSplits = function handleBlockSplits(event, editor) {
    var value = editor.value;

    if (isHardBreak(event)) {
      if (!value.selection.anchor.isAtEndOfNode(value.endBlock) && options.internalSoftBreak) {
        editor.insertText('\n');
      } else {
        editor.splitBlock();

        if (options.clearFormattingAtEnd && value.selection.isCollapsed && value.selection.anchor.isAtEndOfNode(value.endBlock)) {
          editor.command(changes.resetBlock);
        }
      }

      return editor;
    }

    if (isSoftBreak(event)) {
      return editor.insertText('\n');
    }
  };

  var handleBlockEscape = function handleBlockEscape(event, editor) {
    var value = editor.value;
    var selection = value.selection;

    if (!options.isMultiline) return;
    if (!selection.isCollapsed) return;

    if (event.key === 'ArrowUp' && selection.isCollapsed && selection.anchor.isAtStartOfNode(value.startBlock)) {
      return editor.command(changes.escapeBlock, 'above');
    } else if (event.key === 'ArrowDown' && selection.isCollapsed && selection.anchor.isAtEndOfNode(value.endBlock)) {
      return editor.command(changes.escapeBlock, 'below');
    }
  };

  var renderBlock = function renderBlock(props, editor, next) {
    if (props.node.type === options.type) {
      if (options.type === 'code') {
        return React__default.createElement(
          Block,
          _extends({}, options, props),
          React__default.createElement(
            'code',
            null,
            props.children
          )
        );
      } else {
        return React__default.createElement(Block, _extends({}, options, props));
      }
    }
    return next();
  };

  return {
    title: options.title,
    tag: options.tag,
    type: options.type,
    isMultiline: options.isMultiline,
    utils: utils,
    changes: changes,
    components: components,
    plugins: [{
      onKeyDown: onKeyDown,
      renderBlock: renderBlock
    }]
  };
});

function setAlignment(change, alignment) {
  var blocks = change.value.document.getLeafBlocksAtRange(change.value.selection);
  blocks.forEach(function (block) {
    change.setNodeByKey(block.key, {
      data: block.data.set('alignment', alignment)
    });
  });
}

var AlignmentPlugin = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options = _extends({
    alignmentMap: {
      left: 'align-left',
      center: 'align-center',
      right: 'align-right',
      justify: 'align-justify'
    }
  }, options);

  var utils = {
    alignmentStyleForData: function alignmentStyleForData(data) {
      data = Immutable.Map(data);
      var style = {};
      if (data.get('alignment')) {
        style.textAlign = data.get('alignment');
      }
      return style;
    },
    alignmentClassForData: function alignmentClassForData(data) {
      if (!data) return;
      data = Immutable.Map(data);
      return options.alignmentMap[data.get('alignment')];
    },
    alignmentDataFromElement: function alignmentDataFromElement(el) {
      var data = {};
      if (el.style.textAlign) {
        data.alignment = el.style.textAlign;
      } else {
        for (var alignment in options.alignmentMap) {
          if (options.alignmentMap.hasOwnProperty(alignment)) {
            var alignmentClass = options.alignmentMap[alignment];
            if (el.classList.contains(alignmentClass)) {
              data.alignment = alignment;
              break;
            }
          }
        }
      }
      return data;
    },


    getAlignment: function getAlignment(_ref) {
      var value = _ref.value;
      return value.document.getLeafBlocksAtRange(value.selection).map(function (block) {
        return block.data.get('alignment');
      }).reduce(function (acc, a) {
        if (acc !== a) {
          return null;
        }
        return acc;
      });
    }
  };

  return {
    utils: utils,
    plugins: [{
      commands: {
        setAlignment: setAlignment
      }
    }]
  };
});

var changes$4 = {
  setColor: function setColor(change, _ref) {
    var foreground = _ref.foreground,
        background = _ref.background,
        gradient = _ref.gradient;

    change.command(changes$4.clearColor);

    change.addMark({
      type: 'color',
      data: removeUndefined({
        foreground: foreground,
        background: background,
        gradient: gradient
      })
    });
  },
  clearColor: function clearColor(change) {
    change.getMarks().forEach(function (mark) {
      if (mark.type === 'color') {
        change.removeMark(mark);
      }
    });
  }
};

var ColorToolbarIcon = React__default.memo(function (_ref) {
  var foreground = _ref.foreground,
      background = _ref.background,
      gradient = _ref.gradient;

  if (!foreground) {
    foreground = 'var(--theme-primary-text)';
  } else {
    foreground = utils.mapTextColor(foreground);
  }
  if (!utils.darkMode() && foreground === '#FFFFFF') {
    // Force the background to gray, so it shows up well
    background = '#999999';
  }

  if (!background) {
    // Force the background to white, so it shows up well with the
    // blue menu selection bar
    background = 'var(--theme-primary-background)';
  } else {
    background = utils.mapHighlightColor(background);
  }

  var gradientSettings = {};
  if (gradient) {
    gradientSettings = {
      backgroundImage: '-webkit-linear-gradient(left, ' + gradient.gradientStart + ' 10%, ' + gradient.gradientEnd + ' 80%)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundColor: 'transparent',
      color: gradient.gradientStart
    };
  }

  var style = _extends({
    color: foreground,
    backgroundColor: background
  }, gradientSettings);

  return React__default.createElement('i', { className: 'aha-editor-text-color', style: style });
});

var defaultColors$1 = {
  Gray: { foreground: '#999999' },
  Orange: { foreground: '#F9931A' },
  Green: { foreground: '#64B80B' },
  Blue: { foreground: '#0073CF' },
  Red: { foreground: '#D50000' },
  White: { foreground: '#FFFFFF' },
  'Yellow highlight': { background: '#FFFF9D' },
  'Gray highlight': { background: '#F1F1F1' },
  'Green highlight': { background: '#E5F3D6' },
  'Blue highlight': { background: '#D4E8F7' },
  'Red highlight': { background: '#FBEBEB' }
};

var ColorList = React__default.memo(function (_ref) {
  var plugin = _ref.plugin,
      handleClick = _ref.handleClick,
      handleClearClick = _ref.handleClearClick,
      currentColor = _ref.currentColor;

  var colors = plugin.colors || defaultColors$1;

  return React__default.createElement(
    React__default.Fragment,
    null,
    React__default.createElement(
      ToolbarItem,
      {
        key: 'color-black',
        label: utils.darkMode() ? 'Default' : 'Black',
        onClick: handleClearClick,
        active: !currentColor
      },
      React__default.createElement(ColorToolbarIcon, null)
    ),
    Object.keys(colors).map(function (label, index) {
      var color = colors[label];
      var onClick = handleClick(color);

      var active = currentColor && plugin.utils.isSameColor(currentColor, color);

      return React__default.createElement(
        ToolbarItem,
        {
          key: 'color-' + index,
          label: label,
          onClick: onClick,
          active: active
        },
        React__default.createElement(ColorToolbarIcon, {
          foreground: color.foreground,
          background: color.background,
          gradient: color.gradient
        })
      );
    })
  );
});

var ColorToolbarGroup = (function (plugin) {
  var icon = function icon(_ref2) {
    var color = _ref2.color;
    return React__default.createElement(ColorToolbarIcon, {
      foreground: color ? color.foreground : null,
      background: color ? color.background : null,
      gradient: color ? color.gradient : null
    });
  };

  return function (change) {
    var handleClick = function handleClick(color) {
      return function () {
        return change(plugin.changes.setColor, color);
      };
    };

    var handleClearClick = function handleClearClick() {
      change(plugin.changes.clearColor);
    };

    return [{
      item: function item(_ref3) {
        var editor = _ref3.editor;

        var currentColor = plugin.utils.getCurrentColor(editor);

        return React__default.createElement(
          ToolbarMenu,
          {
            icon: icon,
            color: currentColor,
            label: 'Text color',
            name: 'color'
          },
          React__default.createElement(ColorList, {
            plugin: plugin,
            handleClick: handleClick,
            handleClearClick: handleClearClick,
            currentColor: currentColor
          })
        );
      }
    }];
  };
});

var ColorFormattingPlugin = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { colors: null },
      colors = _ref.colors;

  var plugin = {
    renderMark: function renderMark(_ref2, editor, next) {
      var children = _ref2.children,
          mark = _ref2.mark,
          attributes = _ref2.attributes;
      var type = mark.type;

      if (type === 'color') {
        var style = utils.getStyleFromMark(mark);
        return React__default.createElement(
          'span',
          _extends({ style: style }, attributes),
          children
        );
      }
      return next();
    }
  };

  return {
    components: {
      ColorToolbarGroup: ColorToolbarGroup
    },
    changes: changes$4,
    utils: utils,
    plugins: [plugin],
    colors: colors
  };
});

var ColorPickerContainer$1 = React__default.memo(function (_ref) {
  var currentColor = _ref.currentColor,
      handleColorChange = _ref.handleColorChange,
      handleClearColor = _ref.handleClearColor;

  return React__default.createElement(ColorPicker, {
    currentColor: currentColor,
    handleColorChange: handleColorChange,
    handleClearColor: handleClearColor,
    showCustomColorInput: true
  });
});

var TextColorIcon = function TextColorIcon(_ref2) {
  var color = _ref2.color;

  return React__default.createElement(
    'span',
    { className: 'aha-editor__color-picker-menu-icon-wrapper' },
    React__default.createElement(
      'span',
      { className: 'aha-editor__color-picker-menu-icon' },
      React__default.createElement(
        'span',
        { className: 'aha-editor__color-picker-menu-icon--upper' },
        React__default.createElement('i', { className: 'fa fa-font' })
      ),
      React__default.createElement('span', { className: 'aha-editor__color-picker-menu-icon--lower', style: { backgroundColor: color } })
    )
  );
};

var TextColorToolbarGroup = function TextColorToolbarGroup(plugin) {
  return function (change) {
    var handleColorChange = function handleColorChange(editor) {
      return function (color) {
        return function () {
          trackToolbarAnalytics({
            eventName: 'User selects toolbar formatting',
            properties: { 'Formatting': 'Text color' }
          });
          return plugin.setTextColor(editor, color);
        };
      };
    };

    var handleClearColor = function handleClearColor(editor) {
      return function () {
        return plugin.clearTextColor(editor);
      };
    };

    return [{
      item: function item(_ref3) {
        var editor = _ref3.editor;

        var currentColor = plugin.getCurrentTextColor(editor) || '#000000';

        return React__default.createElement(
          ToolbarMenu,
          {
            icon: TextColorIcon,
            color: currentColor,
            label: 'Text color',
            name: 'textColor',
            className: 'aha-editor__color-picker-menu'
          },
          React__default.createElement(ColorPickerContainer$1, {
            currentColor: currentColor,
            handleColorChange: handleColorChange(editor),
            handleClearColor: handleClearColor(editor)
          })
        );
      }
    }];
  };
};

var ColorPickerContainer$2 = React__default.memo(function (_ref) {
  var currentColor = _ref.currentColor,
      handleColorChange = _ref.handleColorChange,
      handleClearColor = _ref.handleClearColor;

  return React__default.createElement(ColorPicker, {
    currentColor: currentColor,
    handleColorChange: handleColorChange,
    handleClearColor: handleClearColor,
    showClearButton: true,
    showCustomColorInput: true
  });
});

var TextHighlightIcon = function TextHighlightIcon(_ref2) {
  var color = _ref2.color;

  if (color && color.toLowerCase() === '#ffffff') {
    return React__default.createElement('i', { className: 'fa-regular fa-highlighter' });
  }

  return React__default.createElement(
    'span',
    { className: 'aha-editor__color-picker-menu-icon-wrapper' },
    React__default.createElement(
      'span',
      { className: 'aha-editor__color-picker-menu-icon' },
      React__default.createElement(
        'span',
        { className: 'aha-editor__color-picker-menu-icon--upper' },
        React__default.createElement('i', { className: 'fa-regular fa-highlighter' })
      ),
      React__default.createElement('span', { className: 'aha-editor__color-picker-menu-icon--lower', style: { backgroundColor: color } })
    )
  );
};

var TextHighlightToolbarGroup = function TextHighlightToolbarGroup(plugin) {
  return function (change) {
    var handleColorChange = function handleColorChange(editor) {
      return function (color) {
        return function () {
          trackToolbarAnalytics({
            eventName: 'User selects toolbar formatting',
            properties: { 'Formatting': 'Text highlight' }
          });
          return plugin.setTextHighlight(editor, color);
        };
      };
    };
    var handleClearColor = function handleClearColor(editor) {
      return function () {
        return plugin.clearTextHighlight(editor);
      };
    };

    return [{
      item: function item(_ref3) {
        var editor = _ref3.editor;

        var currentColor = plugin.getCurrentTextHighlight(editor) || '#ffffff';

        return React__default.createElement(
          ToolbarMenu,
          {
            icon: TextHighlightIcon,
            color: currentColor,
            label: 'Text highlight',
            name: 'textHighlight',
            className: 'aha-editor__color-picker-menu'
          },
          React__default.createElement(ColorPickerContainer$2, {
            currentColor: currentColor,
            handleColorChange: handleColorChange(editor),
            handleClearColor: handleClearColor(editor)
          })
        );
      }
    }];
  };
};

function getTextColorFromMark(mark) {
  return mark.data.get('textColor');
}
function getTextHighlightFromMark(mark) {
  return mark.data.get('textHighlight');
}

function getTextColorStyleFromMark(mark) {
  if (mark.type === 'textColor') {
    var color = getTextColorFromMark(mark);
    return removeUndefined({
      color: color ? utils.mapColorFromColorPickerToDarkMode(color) : undefined
    });
  }
  return {};
}

function getTextHighlightStyleFromMark(mark) {
  if (mark.type === 'textHighlight') {
    var color = getTextHighlightFromMark(mark);
    return removeUndefined({
      backgroundColor: color ? utils.mapColorFromColorPickerToDarkMode(color) : undefined
    });
  }
  return {};
}

var TextColorAndHighlightPlugin = (function (options) {
  return {
    components: {
      TextColorToolbarGroup: TextColorToolbarGroup,
      TextHighlightToolbarGroup: TextHighlightToolbarGroup
    },
    plugins: [{
      renderMark: function renderMark(_ref, editor, next) {
        var children = _ref.children,
            mark = _ref.mark,
            attributes = _ref.attributes,
            marks = _ref.marks;

        if (mark.type === 'textColor') {
          var style = getTextColorStyleFromMark(mark);
          return React__default.createElement(
            'span',
            _extends({ style: style }, attributes),
            children
          );
        }
        if (mark.type === 'textHighlight') {
          var _style = getTextHighlightStyleFromMark(mark);

          // If there is a sibling fontSize mark, we need to apply it here
          // to ensure the background color covers the entire height of the text.
          marks.forEach(function (siblingMark) {
            if (siblingMark.type === 'fontSize') {
              _style.fontSize = siblingMark.data.get('fontSize');
            }
          });

          return React__default.createElement(
            'span',
            _extends({ style: _style }, attributes),
            children
          );
        }
        return next();
      },
      commands: {
        setTextColor: function setTextColor(editor, color) {
          var textColor = utils.mapColorFromColorPickerFromDarkMode(color);

          editor.clearTextColor();
          editor.addMark({
            type: 'textColor',
            data: { textColor: textColor }
          });
        },
        setTextHighlight: function setTextHighlight(editor, color) {
          var textHighlight = utils.mapColorFromColorPickerFromDarkMode(color);

          editor.clearTextHighlight();
          editor.addMark({
            type: 'textHighlight',
            data: { textHighlight: textHighlight }
          });
        },
        clearTextColor: function clearTextColor(editor) {
          editor.getMarks().forEach(function (mark) {
            if (mark.type === 'textColor') {
              editor.removeMark(mark);
            }
            if (mark.type === 'color') {
              editor.removeMark(mark);
            }
          });
        },
        clearTextHighlight: function clearTextHighlight(editor) {
          editor.getMarks().forEach(function (mark) {
            if (mark.type === 'textHighlight') {
              editor.removeMark(mark);
            }
            if (mark.type === 'color') {
              editor.removeMark(mark);
            }
          });
        }
      },
      queries: {
        getCurrentTextColor: function getCurrentTextColor(editor) {
          var textColorMarks = editor.getActiveMarks().filter(function (_ref2) {
            var type = _ref2.type;
            return type === 'textColor';
          });

          if (textColorMarks.size === 0) return;

          var textColor = getTextColorFromMark(textColorMarks.first());

          if (textColorMarks.every(function (mark) {
            return textColor === getTextColorFromMark(mark);
          })) {
            return textColor;
          }
        },
        getCurrentTextHighlight: function getCurrentTextHighlight(editor) {
          var textHighlightMarks = editor.getActiveMarks().filter(function (_ref3) {
            var type = _ref3.type;
            return type === 'textHighlight';
          });

          if (textHighlightMarks.size === 0) return;

          var textHighlight = getTextHighlightFromMark(textHighlightMarks.first());

          if (textHighlightMarks.every(function (mark) {
            return textHighlight === getTextHighlightFromMark(mark);
          })) {
            return textHighlight;
          }
        }
      }
    }]
  };
});

var CommandMenu = function CommandMenu(_ref) {
  var editor = _ref.editor,
      groups = _ref.groups,
      selectedItem = _ref.selectedItem,
      setSelectedItem = _ref.setSelectedItem;

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      blockMouseSelect = _useState2[0],
      setBlockMouseSelect = _useState2[1];

  var items = groups.reduce(function (acc, g) {
    return acc.concat(g.items).concat({ item: function item() {
        return React__default.createElement(ToolbarItem, { divider: true });
      } });
  }, Immutable__default.List()).butLast();

  // When you change the selected item using the keyboard and we need
  // to scroll the command menu to show it, `scrollIntoView` will
  // trigger `onMouseEnter`, which causes any item under the mouse
  // cursor to be selected instead. We can avoid this by temporarily
  // blocking mouse selection when using the keyboard.
  React.useEffect(function () {
    var element = document.querySelector('.aha-editor__command-menu-item--focused');
    var timer = void 0;

    if (element) {
      setBlockMouseSelect(true);
      element.scrollIntoView({ block: 'nearest' });

      // requestAnimationFrame isn't enough time in Firefox
      timer = setTimeout(function () {
        setBlockMouseSelect(false);
      }, 10);
    }
    return function () {
      if (timer) clearTimeout(timer);
    };
  }, [selectedItem]);

  return React__default.createElement(
    MenuItems,
    null,
    React__default.createElement(
      'div',
      { className: 'react-contextmenu-title' },
      'Insert'
    ),
    items.map(function (item, i) {
      return React__default.createElement(
        'div',
        {
          key: i,
          className: item === selectedItem ? 'aha-editor__command-menu-item--focused' : '',
          onMouseEnter: function onMouseEnter() {
            if (!blockMouseSelect) {
              setSelectedItem(item);
            }
          }
        },
        React__default.createElement(item.item, { key: i, editor: editor })
      );
    })
  );
};

var CommandMenuInput = function CommandMenuInput(_ref) {
  var editor = _ref.editor,
      query = _ref.query,
      onSelect = _ref.onSelect,
      children = _ref.children;

  var _useState = React.useState(1),
      _useState2 = slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  React.useEffect(function () {
    setSelectedIndex(0);
  }, [query]);

  var filteredGroups = editor.commandMenuFilteredGroups(query);
  var flattenedItems = filteredGroups.map(function (g) {
    return g.items;
  }).flatten();

  var onKeyDown = React.useCallback(function (event) {
    switch (event.key) {
      case 'ArrowUp':
        setSelectedIndex(selectedIndex > 0 ? selectedIndex - 1 : flattenedItems.size - 1);
        return false;
      case 'ArrowDown':
        setSelectedIndex(selectedIndex < flattenedItems.size - 1 ? selectedIndex + 1 : 0);
        return false;
      case 'Enter':
        var item = flattenedItems.get(selectedIndex);
        return !onSelect(editor, item && item.changeFunction);
      default:
        return true;
    }
  }, [editor, flattenedItems, onSelect, selectedIndex]);

  var setSelectedItem = React.useCallback(function (item) {
    var index = flattenedItems.indexOf(item);
    if (index !== -1) {
      setSelectedIndex(index);
    }
  }, [flattenedItems]);

  return React__default.createElement(
    PortalPopup,
    {
      placement: 'bottom-start',
      visible: true,
      zIndex: 20,
      modifiers: {
        flip: { enabled: true },
        preventOverflow: { enabled: true },
        hide: { enabled: true }
      }
    },
    function (_ref2) {
      var scheduleUpdate = _ref2.scheduleUpdate;
      return React__default.createElement(
        'div',
        { className: 'aha-editor__command-menu' },
        children({ onKeyDown: onKeyDown }),
        flattenedItems.size > 0 && React__default.createElement(CommandMenu, {
          editor: editor,
          groups: filteredGroups,
          selectedItem: flattenedItems.get(selectedIndex),
          setSelectedItem: setSelectedItem
        })
      );
    }
  );
};

/**
 * A Slate plugin to show a command menu when hitting '/' or the specified trigger.
 */

function atStartOfBlock(value) {
  return value.selection.isCollapsed && value.selection.start.isAtStartOfNode(value.startBlock);
}

/**
 * Export.
 *
 * @type {Function}
 */
function CommandMenuPlugin() {
  var state = {
    canShow: false,
    setCanShow: function setCanShow(value) {
      state.canShow = value;
    }
  };
  var commandMenuKeyDown = null;
  var configuration = null;

  var queries = {
    /**
     * Returns whether the command menu should be shown.
     * @param {Editor} editor
     * @return {boolean}
     */
    commandMenuVisible: function commandMenuVisible(editor) {
      return configuration && state.canShow && editor.commandMenuQuery() !== null;
    },


    /**
     * Returns text after the closest `/` in the block, for filtering
     * the command menu.
     * @param {Editor} editor
     * @return {string}
     */
    commandMenuQuery: function commandMenuQuery(editor) {
      var value = editor.value;

      if (!value.selection.isCollapsed) return null;
      if (!value.selection.isFocused) return null;

      var text = editor.getPreviousTextInBlock();
      var pos = text.lastIndexOf('/');
      if (pos === -1) return null;

      return text.substring(pos + 1);
    },
    commandMenuFilteredGroups: function commandMenuFilteredGroups(editor, query) {
      var groups = configuration.commandGroups;
      return groups.map(function (g) {
        return _extends({}, g, {
          items: g.items.filter(function (i) {
            return i.name.toLowerCase().includes(query.toLowerCase()) && i.enabled(editor);
          })
        });
      }).filter(function (g) {
        return g.items.size > 0;
      });
    }
  };

  var commands = {
    deleteCommandMenuQuery: function deleteCommandMenuQuery(editor) {
      var query = editor.commandMenuQuery();
      if (query) {
        editor.deleteBackward(query.length);
      }
      if (!atStartOfBlock(editor.value)) {
        editor.deleteBackward(1);
      }
    }
  };

  function setConfiguration(value) {
    configuration = value;
  }

  function onCommandSelected(editor, command) {
    hideCommandMenu();

    if (command) {
      editor.deleteCommandMenuQuery();
      editor.command(command);
      return true;
    }
    return false;
  }

  function showCommandMenu() {
    state.setCanShow(true);
  }

  function hideCommandMenu() {
    state.setCanShow(false);
  }

  function cancelCommandMenu(editor) {
    if (editor && !editor.commandMenuVisible()) {
      commandMenuKeyDown = null;
    } else if (editor.commandMenuVisible()) {
      editor.insertText(' ');
      editor.deleteBackward(1);
    }
    hideCommandMenu();
  }

  function onMouseDown(event, editor, next) {
    if (state.canShow) {
      cancelCommandMenu(editor);
    }
    return next();
  }

  function onKeyDown(event, editor, next) {
    var canShow = state.canShow;


    switch (event.key) {
      case '/':
        if (!canShow) {
          var previousText = editor.getPreviousTextInBlock();

          if (previousText === '' || previousText[previousText.length - 1] === ' ') {
            showCommandMenu();
          }
        }
        break;
      case ' ':
        if (canShow && editor.commandMenuFilteredGroups(editor.commandMenuQuery() + ' ').isEmpty()) {
          hideCommandMenu();
        }
        break;
      case 'Backspace':
        if (canShow && editor.commandMenuQuery() === '') {
          cancelCommandMenu(editor);
        }
        break;
      case 'Escape':
        cancelCommandMenu(editor);
        // Make sure the Slate document selection stays consistent, even
        // if the browser cursor position changes because the HTML document
        // structure changes.
        editor.snapshotSelection();
        break;
      case 'ArrowUp':
      case 'ArrowDown':
      case 'Enter':
        if (commandMenuKeyDown) {
          if (!commandMenuKeyDown(event)) {
            event.preventDefault();
            event.stopPropagation();
            commandMenuKeyDown = null;
            return false;
          }
        }
        break;
      default:
        break;
    }
    return next();
  }

  function decorateNode(node, editor, next) {
    var others = next() || [];
    var value = editor.value;
    var selection = value.selection;


    if (node.object !== 'block') return others;
    if (!selection.isCollapsed || value.startBlock !== node) {
      return others;
    }
    if (!editor.commandMenuVisible()) return others;

    var text = editor.getPreviousTextInBlock();
    var pos = text.lastIndexOf('/');

    var anchorText = node.getTextAtOffset(pos);
    var anchorOffset = pos - node.getOffset(anchorText.key);

    var decoration = {
      type: 'command-menu-query',
      data: { startKey: anchorText.key },
      anchor: {
        key: anchorText.key,
        path: node.getPath(anchorText.key),
        offset: anchorOffset
      },
      focus: {
        key: selection.focus.key,
        path: node.getPath(selection.focus.key),
        offset: selection.focus.offset
      }
    };

    return [].concat(toConsumableArray(others), [decoration]);
  }

  function renderDecoration(props, editor, next) {
    var children = props.children,
        decoration = props.decoration,
        attributes = props.attributes;

    if (decoration.type !== 'command-menu-query') return next();
    if (decoration.data.get('startKey') !== props.node.key) return next();
    if (!editor.commandMenuVisible()) return next();

    return React__default.createElement(
      reactPopper.Manager,
      null,
      React__default.createElement(
        reactPopper.Reference,
        null,
        function (_ref) {
          var ref = _ref.ref;
          return React__default.createElement(
            'span',
            _extends({}, attributes, { ref: ref }),
            children
          );
        }
      ),
      React__default.createElement(
        CommandMenuInput,
        {
          editor: editor,
          query: editor.commandMenuQuery(),
          onSelect: onCommandSelected,
          parent: this
        },
        function (_ref2) {
          var onKeyDown = _ref2.onKeyDown;

          commandMenuKeyDown = onKeyDown;
        }
      )
    );
  }

  return {
    setConfiguration: setConfiguration,
    onCommandSelected: onCommandSelected,
    plugins: [{
      commands: commands,
      queries: queries,
      decorateNode: decorateNode,
      onKeyDown: onKeyDown,
      onMouseDown: onMouseDown,
      renderDecoration: renderDecoration
    }]
  };
}

var ClearFormattingPlugin = (function (options) {
  var changes = {
    clearFormatting: function clearFormatting(change) {
      var _change$value = change.value,
          document = _change$value.document,
          selection = _change$value.selection;


      document.getMarksAtRange(selection).forEach(function (mark) {
        change.removeMark(mark);
      });

      change.clearLineHeight();
    }
  };

  return {
    changes: changes
  };
});

var component$1 = function component(onClick) {
  return function () {
    return React__default.createElement(
      ToolbarItem,
      { label: 'Divider line', onClick: onClick },
      React__default.createElement('i', { className: 'fa-regular fa-minus fa-fw' })
    );
  };
};

var DividerLineToolbarItem = function DividerLineToolbarItem(performChange) {
  var onClick = function onClick(event) {
    event.preventDefault();
    trackToolbarAnalytics({
      eventName: 'User selects toolbar + menu',
      properties: { 'Toolbar + menu': 'Divider line' }
    });
    performChange(function (editor) {
      return editor.insertDividerLine();
    });
  };
  return {
    name: 'Divider line',
    item: component$1(onClick),
    changeFunction: function changeFunction(editor) {
      return editor.insertDividerLine();
    }
  };
};

var styles$10 = { "dividerLine": "dividerLine-module_dividerLine__Uy8rT", "selected": "dividerLine-module_selected__1L0ee" };

var DividerLinePlugin = (function (options) {
  var schema = {
    blocks: {
      'divider-line': { isVoid: true }
    }
  };

  function renderBlock(props, editor, next) {
    if (props.node.type === 'divider-line') {
      var _classnames;

      var attributes = props.attributes;

      return React__default.createElement('hr', _extends({}, attributes, {
        className: classnames((_classnames = {}, defineProperty(_classnames, styles$10.dividerLine, true), defineProperty(_classnames, styles$10.selected, props.isSelected), _classnames))
      }));
    }
    return next();
  }

  function onKeyDown(event, editor, next) {
    if (event.key === 'Enter' && !event.shiftKey) {
      editor.insertBlock({ type: 'paragraph', data: {} });
      return editor;
    }
    return next();
  }

  return {
    components: {
      DividerLineToolbarItem: DividerLineToolbarItem
    },
    plugins: [{
      commands: {
        insertDividerLine: function insertDividerLine(editor) {
          var block = Slate.Block.create({ type: 'divider-line' });
          return editor.insertBlock(block).moveForward();
        }
      },
      schema: schema,
      renderBlock: renderBlock,
      onKeyDown: onKeyDown
    }]
  };
});

// We use this editor to temporarily generate values and grab
// operations during undo and collaborative editing. Since you can
// think of these editors as temporary, we don't want onChange
// handlers to get called -- those should only be called when
// we're committing changes for real, which will happen on the
// editor created by the Slate Editor component. This plugin
// prevents onChange methods from being called.
var blockOnChange = {
  onChange: function onChange() {}
};

function createStubbedEditor(plugins) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new Slate.Editor(_extends({
    plugins: [blockOnChange].concat(toConsumableArray(plugins))
  }, attrs), options);
}

function CloneEditorPlugin () {
  var lastRenderedPlugins = [];

  var queries = {
    getClone: function getClone(editor) {
      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return createStubbedEditor(lastRenderedPlugins, attrs, options);
    }
  };

  function renderEditor(props, editor, next) {
    lastRenderedPlugins = props.plugins;
    return next();
  }

  return {
    plugins: [{
      queries: queries,
      renderEditor: renderEditor
    }]
  };
}

var isBackspace = isHotkey.isKeyHotkey('backspace');
var isShiftTab$1 = isHotkey.isKeyHotkey('shift+tab');
var isEnter$1 = isHotkey.isKeyHotkey('enter');

var TRIGGER_CHARACTERS = [' ', '.', ',', '!', '?'];

/**
 * @typedef ShortcutOptions
 * @prop {(value: import('slate').Value) => boolean} [testFunction] If testFunction returns false, will not replace text even if the regular expression matches.
 * @prop {boolean} [ignoreUncaptured] When true, will act as if any text uncaptured by the trigger regular expression doesn't exist. Useful for emulating lookbehind, without replacing too much.
 * @prop {boolean} [allowEnter] When true, allow Enter to trigger a replacement.
 * @prop {(change: import('slate').Change) => void} [afterEnter] A function to run after the default Enter behavior occurs.
 * @prop {boolean} [ignoreSameCharString] When true, will not replace markdown strings that are composed entirely of the same character.
 */

/**
 * Generates a Slate plugin that recognizes a trigger regex, ending at
 * the current point and performs a change on matching text.
 *
 * @param {RegExp} trigger the trigger that, when matching, will call changeFunction
 * @param {(change: import('slate').Change, matchData: array, key: string) => void} changeFunction a change function that converts the matched text
 * @param {(change: import('slate').Change, matchData: array, key: string) => void} revertFunction a function to revert changeFunction if backspace is hit
 * @param {ShortcutOptions} [options]
 * @returns {object}
 *
 */
function MarkdownShortcut(trigger, changeFunction, revertFunction) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var justChanged = false;

  /**
   * @typedef LastMatchProperties
   * @prop {string} [text] The text replaced during the most recent conversion, including the trigger character
   * @prop {array} [matchData] The last matchData for the most recent conversion
   * @prop {string} [triggerKey] The key that, when pressed, triggered the most recent conversion
   * @prop {string} [startKey] The key for the text node the cursor was in during the most recent conversion
   */

  /**
   * @type {LastMatchProperties}
   */
  var previous = {};
  var _options = options,
      _options$triggerChara = _options.triggerCharacters,
      triggerCharacters = _options$triggerChara === undefined ? TRIGGER_CHARACTERS : _options$triggerChara;


  options = _extends({ testFunction: function testFunction() {
      return true;
    } }, options);

  function handleConvert(event, editor, next) {
    var value = editor.value;
    var selection = value.selection;
    var isCollapsed = selection.isCollapsed,
        start = selection.start;
    var key = event.key;


    if (!triggerCharacters.includes(key)) {
      key = '';
    }

    if (!isCollapsed || !start.key || !options.testFunction(value)) {
      return next();
    }

    var text = editor.getPreviousTextInBlock();

    var matchData = text.match(trigger);

    if (!matchData) {
      return next();
    }

    if (options.ignoreSameCharString) {
      var baseText = matchData[0].trim();
      var isAllSameChar = baseText.trim().split('').every(function (c) {
        return c === baseText[0];
      });

      if (isAllSameChar) {
        return next();
      }
    }

    event.preventDefault();
    previous = {
      text: '' + (options.ignoreUncaptured ? matchData[1] : matchData[0]) + key,
      matchData: matchData,
      triggerKey: key
    };

    if (key.length > 0) {
      editor.insertText(key);
    }

    editor.deleteBackward(previous.text.length).command(changeFunction, matchData, key);

    editor.getActiveMarks().forEach(function (mark) {
      editor.addMark(mark);
    });

    if (isEnter$1(event)) {
      previous.startKey = editor.value.selection.start.key;
    }

    justChanged = true;

    return true;
  }

  function handleRevert(event, editor, next) {
    var _previous = previous,
        text = _previous.text,
        startKey = _previous.startKey,
        matchData = _previous.matchData,
        triggerKey = _previous.triggerKey;

    if (!text) return next();

    event.preventDefault();

    if (startKey) {
      var _editor$value = editor.value,
          document = _editor$value.document,
          selection = _editor$value.selection;

      var node = document.getDescendant(startKey);
      if (!node) return next();

      return editor.moveToEndOfNode(node).command(revertFunction, matchData, triggerKey).insertText(text).select(selection);
    } else {
      return editor.command(revertFunction, matchData, triggerKey).insertText(text);
    }
  }

  return {
    onChange: function onChange(editor, next) {
      if (justChanged) {
        justChanged = false;
      } else if (previous.text && editor.operations.size > 0) {
        previous = {};
      }
      return next();
    },
    onKeyDown: function onKeyDown(event, editor, next) {
      if (triggerCharacters.includes(event.key)) {
        return handleConvert(event, editor, next);
      }

      if (options.allowEnter && isEnter$1(event)) {
        if (handleConvert(event, editor, next) === true) {
          // Even thought we did a conversion, don't halt plugin
          // processing, because we still want blocks / lists to
          // split, etc.
          var result = next();
          if (options.afterEnter) {
            editor.command(options.afterEnter);
          }
          return result;
        }
        return editor;
      }

      if (isBackspace(event) || isShiftTab$1(event)) {
        return handleRevert(event, editor, next);
      }
      return next();
    }
  };
}

function makeListShortcut(listPlugin, trigger, type) {
  return MarkdownShortcut(new RegExp('^' + trigger + '$'), function (change) {
    return listPlugin.changes.wrapInList(change, type);
  }, function (change) {
    return listPlugin.changes.unwrapList(change);
  }, { testFunction: function testFunction(value) {
      return !listPlugin.utils.isSelectionInList(value);
    } });
}

function makeBlockShortcut(blockPlugin, trigger) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return MarkdownShortcut(new RegExp('^' + trigger + '$'), function (change) {
    return change.command(blockPlugin.changes.toggleBlock, true);
  }, function (change) {
    return change.command(blockPlugin.changes.toggleBlock, false);
  }, options);
}

function makeDividerLineShortcut(trigger) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return MarkdownShortcut(new RegExp('^' + trigger + '$'), function (change) {
    return change.insertDividerLine();
  }, function (change) {
    return change;
  }, options);
}

/**
 * Makes a regex-like string that matches content surrounded by specific characters.
 * For example, `makeSurroundingRegExpString('*', '*')` would match "*text*"", capturing "text".
 *
 * @param {string} leftTrigger the string that should exist to the left of the content
 * @param {string} rightTrigger the string that should exist to the right of the content
 * @returns {string}
 */
function makeSurroundingRegExpString(leftTrigger, rightTrigger) {
  var matchLeftSide = leftTrigger;
  var matchContent = '(?:(?!\\s' + leftTrigger + ').)+';
  var matchRightSide = rightTrigger;

  return matchLeftSide + '(' + matchContent + ')' + matchRightSide;
}

function makeMarkShortcut(leftTrigger, mark) {
  var rightTrigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : leftTrigger;

  var markContentIndex = 2;

  var checkBeginning = '(?:^|\\s)';
  var regexp = new RegExp(checkBeginning + '(' + makeSurroundingRegExpString(leftTrigger, rightTrigger) + ')$');
  return MarkdownShortcut(regexp, function (change, matchData, triggerKey) {
    change.insertText('' + matchData[markContentIndex], [mark]).removeMark(mark);

    if (triggerKey.length > 0) {
      change.insertText(triggerKey);
    }
  }, function (change, matchData, triggerKey) {
    return change.deleteBackward(matchData[markContentIndex].length + triggerKey.length);
  }, {
    ignoreSameCharString: true,
    ignoreUncaptured: true,
    allowEnter: true,
    afterEnter: function afterEnter(change) {
      // When the node gets split, it takes the marks from the
      // previous text. Even though we call `removeMark`, that only
      // removes marks from the selection, for future characters we
      // type -- the text node in the new block still has the mark
      // set. We need to force it to be removed using the
      // lower-level `removeMarkByPath`.
      var start = change.value.selection.start;

      change.removeMarkByPath(start.path, start.offset, 0, mark);
    }
  });
}

function makeLinkShortcut(linkPlugin) {
  var checkBeginning = '(?:^|\\s)';
  var matchLinkName = makeSurroundingRegExpString('\\[', '\\]');
  var matchLinkURL = makeSurroundingRegExpString('\\(', '\\)');
  var linkNameIndex = 2;
  var linkURLIndex = 3;

  return MarkdownShortcut(new RegExp(checkBeginning + '(' + matchLinkName + matchLinkURL + ')$'), function (change, matchData, triggerKey) {
    return change.command(linkPlugin.changes.wrapOrInsertLink, matchData[linkURLIndex], matchData[linkNameIndex]).moveToStartOfNextText().insertText(triggerKey);
  }, function (change, matchData, triggerKey) {
    return change.deleteBackward(matchData[linkNameIndex].length + triggerKey.length);
  }, {
    ignoreUncaptured: true,
    allowEnter: true
  });
}

function Markdown() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var linkPlugin = options.linkPlugin,
      listPlugin = options.listPlugin,
      blockFormatPlugins = options.blockFormatPlugins;

  return {
    plugins: [makeBlockShortcut(blockFormatPlugins.code, '``', {
      triggerCharacters: ['`']
    }), makeDividerLineShortcut('--', {
      triggerCharacters: ['-']
    }), makeLinkShortcut(linkPlugin), makeMarkShortcut('__', 'bold'), makeMarkShortcut('\\*\\*', 'bold'), makeMarkShortcut('_', 'italic'), makeMarkShortcut('\\*', 'italic'), makeMarkShortcut('`', 'code'), makeMarkShortcut('~~', 'strikethrough'), makeMarkShortcut('~', 'strikethrough'), makeListShortcut(listPlugin, '\\*', 'ul_list'), makeListShortcut(listPlugin, '-', 'ul_list'), makeListShortcut(listPlugin, '1\\.', 'ol_list'), makeListShortcut(listPlugin, '\\[\\]', 'checklist'), makeBlockShortcut(blockFormatPlugins.h4, '####'), makeBlockShortcut(blockFormatPlugins.h3, '###'), makeBlockShortcut(blockFormatPlugins.h2, '##'), makeBlockShortcut(blockFormatPlugins.h1, '#'), makeBlockShortcut(blockFormatPlugins.quote, '>')]
  };
}

// in certain contexts (e.g. when using AhaEditor in Monet) we
// do not want the default undo/redo hotkey behavior to occur
// as it needs to be handled specially by the monet redux store.
// Including this plugin will disable the default undo/redo
// hotkeys. It's pretty simple right now, but there's room
// for expansion in the future.
var HotkeyOverridePlugin = (function (options) {
  return {
    plugins: [{
      onKeyDown: function onKeyDown(event, editor, next) {
        if (isHotkey__default('mod+z', event)) {
          return editor;
        }

        if (isHotkey__default('mod+shift+z', event)) {
          return editor;
        }

        return next();
      }
    }]
  };
});

/**
 * When pasting information from other Slate-based editors, Slate will
 * paste nodes instead of HTML. This means we could try to serialize
 * nodes we don't know exist, which will cause errors in the
 * serializer and broken formatting.
 *
 * https://github.com/ianstormtaylor/slate/issues/1024 will fix this
 * problem for good. Until then, this file will handle the most common
 * cases we've seen in the wild.
 *
 * TODO: Once that fix lands, we can remove this plugin entirely.
 *
 */
function convertNodesFromOtherEditors() {
  function fixupNodesFromOtherSlateEditors(node, editor, next) {
    // Aha! equation editor
    if (node.object === 'block' && node.type === 'line') {
      return function (change) {
        change.setNodeByKey(node.key, 'paragraph');
      };
    }

    // ProductBoard - Begin

    // Convert list_* into lists
    if (node.object === 'block' && ['list_ordered', 'list_unordered'].includes(node.type)) {
      return function (change) {
        change.withoutNormalizing(function (change) {
          var listParent = change.value.document.getDescendant(node.key);
          var type = node.type === 'list_ordered' ? 'ol_list' : 'ul_list';
          change.setNodeByKey(listParent.key, type);
          listParent.nodes.forEach(function (node) {
            return change.wrapNodeByKey(node.key, Slate.Block.create({ type: 'list_item' }));
          });
        });
      };
    }

    // Convert heading into h*
    if (node.object === 'block' && node.type === 'heading') {
      var newType = 'h1';
      var level = node.data.get('level');
      if (level > 0 && level < 6) {
        newType = 'h' + level;
      }

      return function (change) {
        return change.setNodeByKey(node.key, { type: newType, data: {} });
      };
    }

    // Convert strong into bold
    if (node.object === 'text') {
      if (!node.marks.find(function (mark) {
        return mark.type === 'strong';
      })) return next();

      return function (change) {
        change.withoutNormalizing(function (change) {
          change.addMarkByKey(node.key, 0, node.text.length, 'bold');
          change.removeMarkByKey(node.key, 0, node.text.length, 'strong');
        });
      };
    }
    // ProductBoard - End

    // Sharepoint? - Begin
    if (node.object === 'block' && node.type === 'heading-1') {
      return function (change) {
        change.setNodeByKey(node.key, 'h1');
      };
    }
    // Sharepoint? - End

    // Other - Begin
    if (node.object === 'block' && node.type === 'p') {
      return function (change) {
        change.setNodeByKey(node.key, 'paragraph');
      };
    }
    // Other - End

    return next();
  }

  return { plugins: [{ normalizeNode: fixupNodesFromOtherSlateEditors }] };
}

/**
 * When selecting formatted text and typing over it, it feels natural
 * for the typed text to use the marks from the first character of the
 * highlighted text. This plugin enforces that behavior.
 */

function PreserveMarksOnOverwritePlugin () {
  function insertText(editor, next, text, marks) {
    var _editor$value = editor.value,
        document = _editor$value.document,
        selection = _editor$value.selection;


    if (selection.isExpanded && !marks) {
      var detectedMarks = selection.marks || editor.getInsertMarksAtRange(selection, document);
      if (detectedMarks) {
        return editor.insertText(text, detectedMarks);
      }
    }

    return next();
  }

  function onCommand(_ref, editor, next) {
    var type = _ref.type,
        args = _ref.args;

    switch (type) {
      case 'insertText':
        return insertText.apply(undefined, [editor, next].concat(toConsumableArray(args)));
      default:
    }
    next();
  }

  return { plugins: [{ onCommand: onCommand }] };
}

function sortRanges(ranges) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';

  return ranges.filter(function (r) {
    return r.isSet;
  }).sort(function (a, b) {
    var compare = Slate.PathUtils.compare(a[property].path, b[property].path);
    if (compare === 0) {
      if (a[property].offset > b[property].offset) {
        return 1;
      } else if (a[property].offset < b[property].offset) {
        return -1;
      } else {
        return 0;
      }
    } else {
      return compare;
    }
  });
}

var SortRangesPlugin = (function (options) {
  return {
    plugins: [{
      queries: {
        sortedRanges: function sortedRanges(editor, ranges) {
          var property = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'start';
          return sortRanges(ranges, property);
        }
      }
    }]
  };
});

var ANNOTATION_MARK_TYPE = 'marked-annotation';

/**
 * Returns a range of just the overlapping parts of `range` and
 * `otherRange`. Returns `null` if there is no overlap, or if the
 * ranges only overlap at a single point.
 *
 * @param {Range} range
 * @param {Range} otherRange
 * @returns {Range|null}
 */
function intersectRange(range, otherRange) {
  if (range.isUnset || otherRange.isUnset) return null;

  if (range.end.isBeforeRange(otherRange) || range.end.isAtStartOfRange(otherRange)) {
    return null;
  }

  if (range.start.isAfterRange(otherRange) || range.start.isAtEndOfRange(otherRange)) {
    return null;
  }

  var startRange = range.start.isBeforeRange(otherRange) ? otherRange : range;
  var endRange = range.end.isAfterRange(otherRange) ? otherRange : range;

  return range.merge({
    anchor: startRange.start,
    focus: endRange.end
  });
}

/**
 * Returns an updated Map of annotations created from the marks in a
 * text node. If an annotation already exists in `annotations`, this
 * will extend the annotation's range to the end of the mark.
 *
 * @param {Map} annotations
 * @param {Text} node A text node, possibly with marks
 * @param {Path} path The path to `node` in the document
 * @returns {Map}
 */
function updateAnnotationsFromMarks(annotations, node, path) {
  return node.marks.reduce(function (acc, mark) {
    if (mark.type !== ANNOTATION_MARK_TYPE) return acc;
    if (node.text.length === 0) return acc;

    var annotationData = mark.data.get('annotation');
    var annotation = acc.get(annotationData.key);

    if (!annotation) {
      annotation = Slate.Annotation.fromJSON(annotationData);
      annotation = annotation.set('anchor', annotation.anchor.setPath(path).setOffset(0));
    }

    annotation = annotation.set('focus', annotation.focus.setPath(path).setOffset(node.text.length));

    return acc.set(annotation.key, annotation);
  }, annotations);
}

/**
 * Provides queries / commands adding extra functionality to
 * annotations.
 */
var AnnotationsPlugin = (function (options) {
  return {
    plugins: [{
      commands: {
        /**
         * Saves the properties of all of the annotations in the document
         * to the undo stack so they can be restored after a change / undo.
         *
         * @param {Editor} editor
         */
        snapshotAnnotations: function snapshotAnnotations(editor) {
          editor.value.annotations.forEach(function (ann) {
            editor.setAnnotation(ann, ann);
          });
        },

        /**
         * Adds marks containing annotation data for each annotation in
         * the range.
         *
         * @param {Editor} editor
         * @param {Range} range
         */
        markAnnotationsAtRange: function markAnnotationsAtRange(editor, range) {
          var annotations = editor.getAnnotationsAtRange(range);
          annotations.forEach(function (annotation) {
            editor.addMarkAtRange(annotation, {
              type: ANNOTATION_MARK_TYPE,
              data: {
                annotation: annotation.toJS()
              }
            });
          });
        },

        /**
         * Removes marks referring to any annotation in
         * `annotations` from text nodes under `path`.
         *
         * @param {Editor} editor
         * @param {Path} path
         * @param {Map} annotations
         */
        removeAnnotationMarksAtPath: function removeAnnotationMarksAtPath(editor, path, annotations) {
          if (annotations.isEmpty()) return;

          var texts = editor.value.document.texts({
            path: path
          });

          editor.withoutNormalizing(function () {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = texts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = slicedToArray(_ref, 2);

                var textNode = _ref2[0];
                var textPath = _ref2[1];

                editor.removeMarksByPath(textPath, 0, textNode.text.length, textNode.marks.filter(function (mark) {
                  return mark.type === ANNOTATION_MARK_TYPE && annotations.has(mark.data.get('annotation').key);
                }));
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
        }
      },
      queries: {
        /**
         * Returns a Map of Slate Annotation objects represented
         * by marks on text nodes under `path`.
         *
         * @param {Editor} editor
         * @param {Path} path
         * @returns {Map}
         */
        getAnnotationsFromMarksAtPath: function getAnnotationsFromMarksAtPath(editor, path) {
          var annotations = Immutable.Map();

          var texts = editor.value.document.texts({
            path: path
          });

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = texts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _ref3 = _step2.value;

              var _ref4 = slicedToArray(_ref3, 2);

              var textNode = _ref4[0];
              var textPath = _ref4[1];

              annotations = updateAnnotationsFromMarks(annotations, textNode, textPath);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          return annotations;
        },

        /**
         * Returns a list of annotations that extend into the given
         * range. All annotation paths / offsets will be rewritten to
         * not extend past the range, cropping edges as necessary.
         *
         * @param {Editor} editor
         * @param {Range} range
         * @returns {Map}
         */
        getAnnotationsAtRange: function getAnnotationsAtRange(editor, range) {
          if (range.isUnset || range.isCollapsed) return Immutable.Map();

          return editor.value.annotations.map(function (annotation) {
            return intersectRange(annotation, range);
          }).filter(function (annotation) {
            return annotation;
          });
        }
      },
      onCommand: function onCommand(_ref5, editor, next) {
        var type = _ref5.type,
            args = _ref5.args;

        switch (type) {
          case 'snapshotSelection':
            // Save annotations whenever we save the selection. We'd
            // want to undo them both in the same scenarios. We do
            // this afterward because snapshotSelection forces a new
            // undo step, so you would otherwise have to undo twice
            // to get your annotations back.
            var ret = next();
            editor.snapshotAnnotations();
            return ret;

          default:
        }
        return next();
      }
    }]
  };
});

function TableOfContentsPlugin(options) {
  return {
    plugins: [{
      commands: {
        toggleTableOfContentsVisibility: function toggleTableOfContentsVisibility(editor) {
          options.toggleTableOfContentsVisibility(editor);
        }
      },
      queries: {
        tableOfContentsVisible: function tableOfContentsVisible(editor) {
          return editor.value.document.data.get('tableOfContentsVisible');
        }
      }
    }]
  };
}

var alignmentUtils = AlignmentPlugin().utils;

function InfoBlock(_ref) {
  var type = _ref.type,
      node = _ref.node,
      children = _ref.children;

  var alignmentClass = alignmentUtils.alignmentClassForData(node.data);

  return React__default.createElement(
    InfoBlockComponent,
    { type: type, textClasses: alignmentClass },
    children
  );
}

function InfoBlockComponent(_ref2) {
  var type = _ref2.type,
      children = _ref2.children,
      _ref2$textStyle = _ref2.textStyle,
      textStyle = _ref2$textStyle === undefined ? null : _ref2$textStyle,
      _ref2$textClasses = _ref2.textClasses,
      textClasses = _ref2$textClasses === undefined ? null : _ref2$textClasses,
      _ref2$includeLineBrea = _ref2.includeLineBreak,
      includeLineBreak = _ref2$includeLineBrea === undefined ? false : _ref2$includeLineBrea,
      _ref2$anchor = _ref2.anchor,
      anchor = _ref2$anchor === undefined ? null : _ref2$anchor;

  var paragraphProps = {};
  if (anchor) {
    paragraphProps['data-anchor'] = anchor;
  }

  var _blockStyleMap$type = blockStyleMap[type],
      alertType = _blockStyleMap$type.alertType,
      icon = _blockStyleMap$type.icon;

  var iconName = icon ? 'fa-' + icon : null;

  return React__default.createElement(
    'aha-alert',
    { type: alertType },
    icon && React__default.createElement('i', { className: classnames('fa-regular fa-fw', defineProperty({}, iconName, true)), slot: 'icon' }),
    React__default.createElement(
      'p',
      _extends({}, paragraphProps, {
        'data-callout-box-type': type
      }),
      React__default.createElement(
        'span',
        { style: textStyle, className: textClasses },
        children
      ),
      includeLineBreak && React__default.createElement('br', null)
    )
  );
}



var blockStyleMap = {
  infoBlock: {
    alertType: 'info',
    icon: 'info-circle'
  },
  noteBlock: {
    alertType: 'warning',
    icon: 'pencil'
  },
  warningBlock: {
    alertType: 'danger',
    icon: 'exclamation-triangle'
  },
  tipBlock: {
    alertType: 'success',
    icon: 'magic-wand-sparkles'
  }
};

function AhaInfoBlock(type) {
  var selection = blockStyleMap[type];

  return function (props) {
    return React__default.createElement(InfoBlock, _extends({
      type: type
    }, props, selection));
  };
}

var InfoBlockPlugin = (function (_ref3) {
  var title = _ref3.title,
      type = _ref3.type;
  return BlockFormatPlugin({
    title: title,
    type: type,
    tag: AhaInfoBlock(type),
    isMultiline: false,
    allowTab: true,
    exitOnBackspace: true,
    clearFormattingAtEnd: true,
    internalSoftBreak: true,
    alignmentUtils: alignmentUtils
  });
});

var styles$11 = { "labelMenuContainer": "LabelPill-module_labelMenuContainer___dtdd", "labelPreviews": "LabelPill-module_labelPreviews__2Rhun", "labelPillPreview": "LabelPill-module_labelPillPreview__2JIUl", "labelMenuInput": "LabelPill-module_labelMenuInput__VL_8t", "labelPill": "LabelPill-module_labelPill__3zKBR", "labelPill__gray": "LabelPill-module_labelPill__gray__fqp1X", "labelPill__blue": "LabelPill-module_labelPill__blue__1zJvz", "labelPill__green": "LabelPill-module_labelPill__green__3n0Lq", "labelPill__yellow": "LabelPill-module_labelPill__yellow__2uRhm", "labelPill__red": "LabelPill-module_labelPill__red__2lov7" };

var availableColors = ['gray', 'blue', 'green', 'yellow', 'red'];
var DEFAULT_COLOR_SCHEME = 'gray';

function LabelPillPreview(props) {
  var editor = props.editor,
      node = props.node,
      color = props.color,
      active = props.active;


  var updateColorSceheme = function updateColorSceheme() {
    var updatedNode = node.setIn(['data', 'colorScheme'], color);

    editor.replaceNodeByKey(node.key, updatedNode);
  };

  return React__default.createElement(
    'span',
    {
      onMouseDown: updateColorSceheme,
      className: classnames(styles$11.labelPillPreview, styles$11['labelPill__' + color])
    },
    active && React__default.createElement('i', { className: 'fa-regular fa-check' })
  );
}

var LabelPillMenu = function (_Component) {
  inherits(LabelPillMenu, _Component);

  function LabelPillMenu(props) {
    classCallCheck(this, LabelPillMenu);

    var _this = possibleConstructorReturn(this, (LabelPillMenu.__proto__ || Object.getPrototypeOf(LabelPillMenu)).call(this, props));

    _this.updateNode = function () {
      var text = _this.state.text;
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;


      if (text === '') {
        editor.removeNodeByKey(node.key);
      } else {
        var nodeText = node.getFirstText();
        var newNodeText = Slate.Text.create(text);
        var extraNodes = node.nodes.filter(function (n) {
          return n.key !== nodeText.key;
        });
        editor.withoutNormalizing(function () {
          extraNodes.forEach(function (n) {
            return editor.removeNodeByKey(n.key);
          });
          editor.replaceNodeByKey(nodeText.key, newNodeText);
        });

        // Add a small delay so the editor doesn't do it's work before
        // the enter key is processed. Without the delay, we unintentionally
        // create a line break in the pill itself.
        if (_this.updateTimeout) {
          clearTimeout(_this.updateTimeout);
        }

        _this.updateTimeout = setTimeout(function () {
          _this.updateTimeout = null;
          var document = editor.value.document;
          var nextNode = document.getNextText(newNodeText.key);

          editor.moveTo(nextNode.key);

          if (nextNode.text[0] !== ' ') {
            editor.insertText(' ');
          }

          editor.focus();
        }, 10);
      }
    };

    _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        _this.updateNode();
        e.preventDefault();
        e.stopPropagation();
      }

      if (e.key === 'Escape') {
        _this.props.onDismiss();
        e.preventDefault();
        e.stopPropagation();
      }
    };

    _this.update = function (e) {
      _this.setState({ text: e.target.value });
    };

    _this.inputRef = React__default.createRef();
    _this.focusTimeout = null;
    _this.updateTimeout = null;

    _this.state = {
      text: props.node.text,
      visible: props.visible
    };
    return _this;
  }

  createClass(LabelPillMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInputRef();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.focusTimeout);
      clearTimeout(this.updateTimeout);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var visibilityChanged = this.state.firstLoad || this.state.visible !== newProps.visible;

      if (visibilityChanged && newProps.visible) {
        this.focusInputRef();
      }

      this.setState({ visible: newProps.visible, firstLoad: false });

      if (visibilityChanged && !newProps.visible) {
        this.updateNode();
      }
    }
  }, {
    key: 'focusInputRef',
    value: function focusInputRef() {
      var _this2 = this;

      if (!this.inputRef.current) return;

      // Add small delay so slate doesn't retake focus
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }

      this.focusTimeout = setTimeout(function () {
        _this2.focusTimeout = null;
        _this2.inputRef.current.select();
      }, 10);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          editor = _props.editor,
          node = _props.node;


      return React__default.createElement(
        'div',
        { className: styles$11.labelMenuContainer },
        React__default.createElement(
          'div',
          { className: styles$11.labelPreviews },
          availableColors.map(function (color) {
            return React__default.createElement(LabelPillPreview, {
              editor: editor,
              node: node,
              active: _this3.colorScheme === color,
              key: color,
              color: color
            });
          })
        ),
        React__default.createElement(
          'div',
          null,
          React__default.createElement('input', {
            ref: this.inputRef,
            className: styles$11.labelMenuInput,
            onKeyDown: this.onKeyDown,
            onChange: this.update,
            onBlur: this.update,
            value: this.state.text
          })
        )
      );
    }
  }, {
    key: 'colorScheme',
    get: function get$$1() {
      return this.props.node.getIn(['data', 'colorScheme']) || DEFAULT_COLOR_SCHEME;
    }
  }]);
  return LabelPillMenu;
}(React.Component);

var LabelPill = function (_Component) {
  inherits(LabelPill, _Component);

  function LabelPill() {
    classCallCheck(this, LabelPill);
    return possibleConstructorReturn(this, (LabelPill.__proto__ || Object.getPrototypeOf(LabelPill)).apply(this, arguments));
  }

  createClass(LabelPill, [{
    key: 'render',
    value: function render() {
      return React__default.createElement(
        'span',
        {
          className: classnames(styles$11.labelPill, styles$11['labelPill__' + this.colorScheme]),
          contentEditable: false
        },
        this.props.children
      );
    }
  }, {
    key: 'colorScheme',
    get: function get$$1() {
      return this.props.node.getIn(['data', 'colorScheme']) || DEFAULT_COLOR_SCHEME;
    }
  }]);
  return LabelPill;
}(React.Component);

var LabelPill$1 = componentWithPopup(LabelPill, LabelPillMenu);

function PillPlugin () {
  var utils = {
    isPill: function isPill(value) {
      return value.inlines.size > 0 && value.inlines.every(function (inline) {
        return inline.type === 'pill';
      });
    },
    inPill: function inPill(value) {
      if (value.selection.end.key) {
        var closestInline = value.document.getClosestInline(value.selection.end.key);

        return closestInline && closestInline.type === 'pill';
      }
    }
  };

  var changes = {
    insertPill: function insertPill(change) {
      var pill = Slate.Inline.create({
        type: 'pill',
        nodes: [],
        data: {}
      });

      change.insertInlineAtRange(change.value.selection, pill);

      var text = Slate.Text.create('');
      change.insertNodeByKey(pill.key, 0, text);
      change.setNodeByKey(pill.key, {
        type: 'pill'
      });

      pill = change.value.document.getNode(pill.key);
      change.moveTo(text.key);
    },

    unwrapInline: function unwrapInline(change) {
      change.unwrapInline('pill');
    },
    wrapInline: function wrapInline(change) {
      if (!utils.isPill(change.value)) {
        change.wrapInline({ type: 'pill' });
      }
    },

    togglePill: function togglePill(change) {
      if (utils.isPill(change.value)) {
        change.command(changes.unwrapInline);
      } else {
        if (change.value.selection.isCollapsed) {
          change.command(changes.insertPill);
        } else {
          change.command(changes.wrapInline);
        }
      }
    }
  };

  function popupPlacementAdjuster(style, wrappedEl) {
    style.left -= 5;

    return style;
  }

  function renderInline(props, editor, next) {
    if (props.node.type === 'pill') {
      return React__default.createElement(LabelPill$1, _extends({
        contentEditable: false,
        editor: editor,
        utils: utils,
        popupPlacementAdjuster: popupPlacementAdjuster
      }, props));
    }
    return next();
  }

  function onKeyDown(event, editor, next) {
    var _editor$value = editor.value,
        selection = _editor$value.selection,
        document = _editor$value.document;


    var previousNode = document.getPreviousSibling(selection.end.key);
    var previousIsPill = selection.isCollapsed && selection.anchor.offset === 0 && previousNode && previousNode.type === 'pill';

    // Don't allow typing within the pill
    if (utils.inPill(editor.value)) {
      event.preventDefault();
      event.stopPropagation();
      if (event.key === 'ArrowLeft') {
        editor.moveToEndOfPreviousText();
      } else if (event.key === 'ArrowRight') {
        editor.moveToStartOfNextText();
      }
    } else if (event.key === 'Backspace' && previousIsPill) {
      editor.moveToEndOfNode(previousNode);
      editor.command(changes.unwrapInline);
    } else {
      next();
    }
  }

  return {
    utils: utils,
    changes: changes,
    plugins: [{
      renderInline: renderInline,
      onKeyDown: onKeyDown
    }, StickyInlines({
      allowedTypes: ['pill'],
      canBeEmpty: false
    })]
  };
}

var LANGUAGES = {
  clike: 'C/C++/C#',
  css: 'CSS',
  html: 'HTML',
  java: 'Java',
  tsx: 'JavaScript/TypeScript',
  python: 'Python',
  rb: 'Ruby',
  'shell-session': 'Shell'
};

/**
 * Component for selecting a language for a code block.
 */
function LanguageDropdown(_ref) {
  var editor = _ref.editor,
      node = _ref.node;

  if (!editor.value.selection.isFocused || !editor.value.selection.isCollapsed || !editor.value.startBlock || editor.value.startBlock.key !== node.key) {
    return null;
  }

  var language = node.data.get('language');

  function selectLanguage(value) {
    if (value === '') {
      editor.setNodeByKey(node.key, {
        data: node.data.delete('language')
      });
    } else {
      editor.setNodeByKey(node.key, {
        data: node.data.set('language', value)
      });
    }
  }

  return React__default.createElement(
    'div',
    { className: 'aha-editor__language-dropdown', contentEditable: false },
    React__default.createElement(
      ToolbarMenu,
      { icon: '', label: '', className: 'aha-editor-context-toolbar-btn' },
      React__default.createElement(ToolbarItem, {
        active: !language,
        onClick: function onClick() {
          return selectLanguage('');
        },
        label: 'None'
      }),
      Object.entries(LANGUAGES).map(function (_ref2) {
        var _ref3 = slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        return React__default.createElement(ToolbarItem, {
          active: language === k,
          key: k,
          onClick: function onClick() {
            return selectLanguage(k);
          },
          label: v
        });
      })
    )
  );
}

var SyntaxHighlightPlugin = (function (options) {
  /**
   * Overrides the default renderBlock for code nodes to show the
   * language selector.
   */
  function renderBlock(props, editor, next) {
    switch (props.node.type) {
      case 'code':
        return React__default.createElement(
          'div',
          { className: 'aha-editor__pre-container', spellCheck: false },
          React__default.createElement(LanguageDropdown, props),
          next()
        );
      default:
        return next();
    }
  }

  /**
   * Renders syntax highlighting decorations as spans with all of the
   * token types as prism classes.
   */
  function renderDecoration(props, editor, next) {
    var children = props.children,
        decoration = props.decoration,
        attributes = props.attributes;


    if (decoration.type === 'syntax-highlight') {
      return React__default.createElement(
        'span',
        _extends({}, attributes, {
          className: 'token ' + decoration.data.get('tokens').join(' ')
        }),
        children
      );
    } else {
      return next();
    }
  }

  /**
   * Creates decorations for a Prism token parse tree. Only leaves
   * generate decorations. Called recursively so the leaf nodes can
   * include all of their ancestors' tokens.
   */
  function createDecorations(token, activeTokens, state) {
    // We're an inner node of the parse tree. Add our token to the
    // active list and recurse over the children.
    if (typeof token.content === 'string') {
      return createDecorations(token.content, activeTokens.concat(token.type), state);
    } else if (Array.isArray(token.content)) {
      activeTokens = activeTokens.concat(token.type);
      return token.content.flatMap(function (newToken) {
        return createDecorations(newToken, activeTokens, state);
      });
    }

    // We're a leaf. Add a new decoration with all of the token types
    // from our ancestors.
    var endEntry = state.entry;

    var _state$entry = slicedToArray(state.entry, 2),
        startText = _state$entry[0],
        startPath = _state$entry[1];

    var content = token;
    var length = content.length;

    var available = startText.text.length - state.offset;
    var remaining = length;

    var endOffset = state.offset + remaining;
    var decorations = [];

    // The parse tree leaf could span multiple Slate nodes. Consume
    // Slate text nodes until we've reached the length of the token
    // content. After this loop, `startText` will be the starting text
    // node and `endText` will be the last text node reached by the
    // current Prism token.
    while (available < remaining && state.texts.length > 0) {
      endEntry = state.texts.shift();

      var _endEntry = endEntry,
          _endEntry2 = slicedToArray(_endEntry, 1),
          _endText = _endEntry2[0];

      remaining -= available;
      available = _endText.text.length;
      endOffset = remaining;
    }

    var _endEntry3 = endEntry,
        _endEntry4 = slicedToArray(_endEntry3, 2),
        endText = _endEntry4[0],
        endPath = _endEntry4[1];

    if (activeTokens.length > 0) {
      var dec = {
        type: 'syntax-highlight',
        data: { tokens: activeTokens },
        anchor: {
          key: startText.key,
          path: startPath,
          offset: state.offset
        },
        focus: {
          key: endText.key,
          path: endPath,
          offset: endOffset
        }
      };
      decorations.push(dec);
    }

    state.entry = endEntry;
    state.offset = endOffset;
    return decorations;
  }

  /**
   * Decorates code nodes using Prism. This uses the low-level
   * Prism.tokenize method so that we can control the translation into
   * decorations so Slate handles real-time highlighting during
   * editing.
   */
  function decorateNode(node, editor, next) {
    var others = next() || [];
    if (node.type !== 'code') return others;

    var language = node.data.get('language');
    if (!language) return others;

    var texts = Array.from(node.texts());
    var string = texts.map(function (_ref4) {
      var _ref5 = slicedToArray(_ref4, 1),
          n = _ref5[0];

      return n.text;
    }).join('');
    var grammar = Prism.languages[language];
    if (!grammar) return others;

    var tokens = Prism.tokenize(string, grammar);

    var state = {
      entry: texts.shift(),
      offset: 0,
      texts: texts
    };

    var decorations = tokens.flatMap(function (token) {
      return createDecorations(token, [], state);
    });

    return [].concat(toConsumableArray(others), toConsumableArray(decorations));
  }

  return {
    plugins: [{
      renderBlock: renderBlock,
      renderDecoration: renderDecoration,
      decorateNode: decorateNode
    }]
  };
});

/**
 * Provides a Slate plugin that handles inserting characters added
 * through composition events like Option-e, e on Mac
 *
 * @param {object} [options]
 * @returns {object}
 *
 */
function Composition() {
  var lastComposition = null;
  return {
    plugins: [{
      onBeforeInput: function onBeforeInput(event, editor, next) {
        if (event.nativeEvent) return next();

        if (['insertCompositionText', 'insertFromComposition'].includes(event.inputType)) {
          lastComposition = {
            text: event.data
          };

          // The simplest option would be to cancel the beforeinput
          // and update the Value with the current partial
          // composition, but these events are not cancelable and
          // the DOM will be updated by the browser, resulting in
          // duplicate text.
          //
          // Second-best would be updating the Value after the input
          // event fires to bring it up-to-date with what's in the
          // DOM. Unfortunately, the rerender seems to cancel the
          // composition event, preventing further compositions of
          // the character.
          //
          // A last option is to stash the information we have and
          // insert it all at once in the compositionend event. If
          // someone is collaboratively editing the same part, it
          // might cause issues (because the intermediate composed
          // states aren't sent to other clients), but because the
          // onCompositionEnd should fire anyway in that case, it
          // should resolve itself.
        }
        return next();
      },
      onCompositionEnd: function onCompositionEnd(event, editor, next) {
        if (!lastComposition) return next();

        editor.insertText(lastComposition.text);
        lastComposition = null;
      }
    }]
  };
}

/**
 * Handles certain insertReplacementText/deleteContentBackward events
 * that are incorrectly passed without a target range. This is a
 * workaround for Grammarly specifically, but may help with other
 * plugins that construct their own input events.
 *
 * This is handled much more cleanly in current Slate, and this plugin
 * can be removed during the upgrade.
 *
 * @param {object} [options]
 * @returns {object}
 *
 */
function GrammarlyFix() {
  return {
    plugins: [{
      onBeforeInput: function onBeforeInput(event, editor, next) {
        // Ignore synthetic events
        if (event.nativeEvent) return next();

        // Ignore browser-initiated events (Grammarly events are
        // manually constructed and therefore "untrusted")
        if (event.isTrusted) return next();
        if (event.dataTransfer) return next();
        if (event.getTargetRanges().length > 0) return next();

        switch (event.inputType) {
          case 'deleteContentBackward':
            return editor.delete();
          case 'insertReplacementText':
            return editor.insertText(event.data);
          default:
            return next();
        }
      }
    }]
  };
}

var Rules = function () {
  function Rules() {
    classCallCheck(this, Rules);
    this.rules = [];
  }

  createClass(Rules, [{
    key: 'insertRules',
    value: function insertRules(rules) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.rules.splice(index, 0, rules);
      return this;
    }
  }, {
    key: 'resolve',
    value: function resolve(options, plugin, context) {
      context.deserializeStack = [];
      context.treeDepth = 0;
      context.preDepth = 0;
      context.inGoogleSheetCell = false;

      /**
       * This method wraps all deserialization from given rules and counts the depth in the tree and
       * counts the number of PRE tags. This is used by text deserialization to decide text rules.
       *
       * @param {*} wrapped The deserialize function from a rule
       */
      var deserialize = function deserialize(wrapped) {
        return function (el, next) {
          context.deserializeStack.push(el.nodeName);
          context.treeDepth += 1;
          if (el.nodeName === 'PRE') context.preDepth += 1;
          if (el.dataset && el.dataset.sheetsValue) context.inGoogleSheetCell = true;

          var ret = wrapped(el, next);

          if (el.dataset && el.dataset.sheetsValue) context.inGoogleSheetCell = false;
          if (el.nodeName === 'PRE') context.preDepth -= 1;
          context.treeDepth -= 1;
          context.deserializeStack.pop();
          return ret;
        };
      };

      return this.rules.reduce(function (resolvedRules, rules) {
        var resolvedRule = rules(options, plugin, context).map(function (rule) {
          if (rule.deserialize) {
            return _extends({}, rule, { deserialize: deserialize(rule.deserialize) });
          } else {
            return rule;
          }
        });

        return resolvedRules.concat(resolvedRule);
      }, []);
    }
  }]);
  return Rules;
}();

var tagAndTypeSerializer = (function (object, tags, types) {
  return {
    serialize: function serialize(obj, children) {
      if (obj.object !== object) return;
      var makeElement = types[obj.type];
      if (!makeElement) return;
      return makeElement(children, obj);
    },
    deserialize: function deserialize(el, next) {
      var type = tags[el.tagName.toLowerCase()];
      if (!type) return;
      return {
        object: object,
        type: type,
        nodes: next(el.childNodes)
      };
    }
  };
});

var annotationSerializers = (function (options, utils, context) {
  return [tagAndTypeSerializer('mark', {}, {
    'marked-annotation': function markedAnnotation(children) {
      return React__default.createElement(
        React__default.Fragment,
        null,
        children
      );
    }
  })];
});

// Serializers that can be defined with simple hashes, functions, and
// strings -- no complex behavior.

var basicSerializers = (function (options, utils, context) {
  return [tagAndTypeSerializer('mark', {
    strong: 'bold',
    b: 'bold',
    em: 'italic',
    i: 'italic',
    u: 'underline',
    ins: 'underline',
    s: 'strikethrough',
    del: 'strikethrough',
    strike: 'strikethrough',
    code: 'code'
  }, {
    bold: function bold(children) {
      return React__default.createElement(
        'strong',
        null,
        children
      );
    },
    italic: function italic(children) {
      return React__default.createElement(
        'em',
        null,
        children
      );
    },
    strikethrough: function strikethrough(children) {
      // See comment on line 84 of src/serialization/styleSerializers.js for explanation.
      var style = context.textFontSize ? { fontSize: context.textFontSize } : undefined;
      return React__default.createElement(
        'del',
        { style: style },
        children
      );
    },
    underline: function underline(children) {
      return React__default.createElement(
        'u',
        null,
        children
      );
    },
    code: function code(children) {
      return React__default.createElement(
        'code',
        null,
        children
      );
    }
  })];
});

var nodeText = function nodeText(node) {
  return node.text;
};

var emptyTextNode = function emptyTextNode(node) {
  return node.object === 'text' && /^\s*$/.test(nodeText(node));
};

/**
 * We require all children of list items and table cells to be block
 * nodes, but TinyMCE (and some other editors) use raw text nodes
 * instead. So we'll look for all runs of non-block nodes, and wrap
 * them in `wrapperType` tags.
 *
 * @param {Array<import('slate').Node>} nodeList the children of the block
 * @param {string} wrapperType the node type to wrap inline / text nodes in
 * @returns {import('immutable').Iterable<number, Object>} nodes that can be used as valid children of the block
 */
function wrapNonBlocksInContainer(nodeList, wrapperType) {
  return nodeList.reduce(function (acc, node, idx) {
    var currentContainer = acc.currentContainer,
        nodes = acc.nodes;

    if (node.object === 'block' && node.type === wrapperType && node.insertNode) {
      return { currentContainer: node, nodes: nodes.concat(node) };
    }

    if (node.object === 'block') {
      return { currentContainer: null, nodes: nodes.concat(node) };
    }

    if ((idx === 0 || idx === nodeList.length - 1) && emptyTextNode(node)) {
      return { currentContainer: currentContainer, nodes: nodes };
    }

    if (currentContainer) {
      currentContainer.nodes = currentContainer.nodes.concat(node);

      return {
        currentContainer: currentContainer,
        nodes: nodes.slice(0, -1).concat(currentContainer)
      };
    }

    var newContainer = {
      object: 'block',
      type: wrapperType,
      nodes: [node]
    };

    return {
      currentContainer: newContainer,
      nodes: nodes.push(newContainer)
    };
  }, { currentContainer: null, nodes: Immutable.List([]) }).nodes;
}

/**
 * Determine if a node only contains an empty text node so we
 * can correctly serialize a trailing break just like slate does
 * in its leaf node:
 * https://github.com/aha-app/slate/blob/0-47-merged-backports/packages/slate-react/src/components/leaf.js#L89
 * @param {<import('slate').Node>} Node that represents the current block
 */
function isLineBreak(node) {
  if (node.nodes.size === 1) {
    var child = node.nodes.first();
    if (child.object === 'text' && child.text === '') return true;
  }
  return false;
}

var BlockElements = {
  p: 'paragraph',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  blockquote: 'quote'
};

var blockSerializers = (function (options, utils, context) {
  var blockSerializer = function blockSerializer(type) {
    var Tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : type;
    return {
      serialize: function serialize(obj, children) {
        if (obj.object !== 'block' || obj.type !== type) return;

        var style = utils.alignment.alignmentStyleForData(obj.data);
        var anchor = obj.data.get('anchor');

        return React__default.createElement(
          Tag,
          { style: style, 'data-anchor': anchor },
          children,
          isLineBreak(obj) && React__default.createElement('br', null)
        );
      },
      deserialize: function deserialize(el, next) {
        if (el.tagName.toLowerCase() !== Tag) return;
        var nodes = next(el.childNodes);
        var data = utils.alignment.alignmentDataFromElement(el);
        var anchor = el.getAttribute('data-anchor');

        if (anchor && anchor !== '') {
          data.anchor = anchor;
        }

        // If our child nodes are a mix of blocks and text nodes, the
        // default Slate normalizers will strip out any block children
        // of this node. We don't want that, because it will cause us to
        // lose content. So, if we have a block child, we should wrap
        // runs of non-block children in blocks.
        if (nodes.some(function (node) {
          return node.object === 'block';
        })) {
          nodes = wrapNonBlocksInContainer(nodes, 'paragraph').toJS();
        }

        if (nodes.length === 0) {
          nodes.push({
            object: 'text',
            text: ''
          });
        }

        return { object: 'block', type: type, data: data, nodes: nodes };
      }
    };
  };

  return Object.keys(BlockElements).map(function (key) {
    return blockSerializer(BlockElements[key], key);
  });
});

var infoBlockSerializers = (function (options, utils, context) {
  return [{
    deserialize: function deserialize(el, next) {
      if (!el.dataset || !el.dataset.calloutBoxType) return;

      return {
        object: 'block',
        type: el.dataset.calloutBoxType,
        nodes: next(el.childNodes)
      };
    },
    serialize: function serialize(obj, children) {
      if (obj.object !== 'block' || !Object.keys(blockStyleMap).includes(obj.type)) return;

      return React__default.createElement(
        'p',
        { 'data-callout-box-type': obj.type },
        React__default.createElement(
          'span',
          null,
          children
        ),
        isLineBreak(obj) && React__default.createElement('br', null)
      );
    }
  }];
});

var PILL_COLOR_SCHEME_REGEX = /labelPill__(?<color>\w+)/;

var pillSerializers = (function (_options, _utils, _context) {
  return [{
    serialize: function serialize(obj, children) {
      if (obj.object !== 'inline' || obj.type !== 'pill') return;

      var colorScheme = obj.data.get('colorScheme') || DEFAULT_COLOR_SCHEME;

      return React__default.createElement(
        'span',
        { className: 'labelPill labelPill__' + colorScheme },
        React__default.createElement(
          'span',
          null,
          children
        )
      );
    },
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'span') return;

      var classes = el.getAttribute('class');
      if (!classes || !classes.includes('labelPill')) return;

      var colorScheme = DEFAULT_COLOR_SCHEME;
      var colorSchemeMatch = classes.match(PILL_COLOR_SCHEME_REGEX);

      if (colorSchemeMatch && availableColors.includes(colorSchemeMatch.groups.color)) {
        colorScheme = colorSchemeMatch.groups.color;
      }

      return {
        object: 'inline',
        type: 'pill',
        data: { colorScheme: colorScheme },
        nodes: next(el.childNodes)
      };
    }
  }];
});

function isTopLevelNode(el) {
  if (!el.parentNode) return true;
  if (!el.parentNode.tagName) return true;

  return el.parentNode.tagName.toLowerCase() === 'body' || el.parentNode.id.startsWith('docs-internal-guid');
}

var cleanupSerializers = (function (options, utils, context) {
  /**
   * Gmail represents empty lines in plain text emails as
   * `<div><br></div>`. We should convert them to `<p />`.
   */
  var emptyDivBrToParagraphSerializer = {
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'div') return;
      if (el.childNodes.length !== 1) return;
      if (el.children.length !== 1) return;
      if (el.firstElementChild.tagName.toLowerCase() !== 'br') return;
      return {
        object: 'block',
        type: 'paragraph'
      };
    }
  };

  /**
   * Unwrapped <br /> tags in the top-level of the document will get
   * wrapped in <p> tags, resulting in <p><br /></p>, or one too many
   * newlines. If we detect that we're a <br /> in the top level of
   * the document, we'll wrap ourselves -- without the <br />.
   */
  var cleanupTopLevelBrSerializer = {
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'br') return;
      if (!isTopLevelNode(el)) return;
      return {
        object: 'block',
        type: 'paragraph'
      };
    }
  };

  /**
   * We get `\n`s followed by `br`s when we receive mail from Mandrill
   * and convert it to HTML. HTML ignores any whitespace surrounding a
   * <br /> tag, so we should remove it to more closely match how it
   * would normally be rendered.
   */
  var cleanupNewlinesAroundBrsSerializer = {
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'p') return;

      Array.from(el.childNodes).forEach(function (node) {
        if (node.nodeType === node.ELEMENT_NODE && node.tagName.toLowerCase() === 'br') {
          var previousNode = node.previousSibling;
          if (previousNode && previousNode.nodeType === previousNode.TEXT_NODE) {
            previousNode.textContent = previousNode.textContent.replace(/\s+$/, '');
          }

          var nextNode = node.nextSibling;
          if (nextNode && nextNode.nodeType === nextNode.TEXT_NODE) {
            nextNode.textContent = nextNode.textContent.replace(/^\s+/, '');
          }
        }
      });
    }
  };

  var cleanupDoubleNewlinesSerializer = {
    deserialize: function deserialize(el, next) {
      if (el.nodeType !== el.TEXT_NODE) return;
      var previousNode = el.previousSibling;
      if (!previousNode || previousNode.nodeType === previousNode.ELEMENT_NODE && previousNode.tagName.toLowerCase() === 'p') {
        if (el.textContent === '\n\n') {
          return null;
        }
      }
    }
  };

  /**
   * Many TinyMCE tables / lists have an ending BR followed by a
   * newline or another block node. This ends up creating extra empty
   * lines, because they're converted into `\n`s by Slate, which show
   * up in Slate's `pre-wrap` editor.
   *
   * As best I can tell, the default behavior for brs in browsers is:
   * * If you're followed by an element with height, create a new line
   * * Otherwise, collapse into the next element
   *
   * Since we don't have that information at this point, I'm going to
   * do this instead:
   *
   * * If the br is the last element in an li, td, or p (or is only
   *   followed by a newline), strip it out.
   * * If the br is the last element before a ul / ol, strip it out.
   *
   * That fixes all of the spacing problems I've seen so far, and
   * should be about as light of a touch as we can have.
   */
  var cleanupBrNewlineSerializer = {
    deserialize: function deserialize(el, next) {
      if (el.nodeType !== el.ELEMENT_NODE) return;

      if (['td', 'li', 'p'].includes(el.tagName.toLowerCase())) {
        var possibleBr = el.lastElementChild;

        if (possibleBr && possibleBr.tagName.toLowerCase() === 'br') {
          if (el.lastChild === possibleBr || el.lastChild === possibleBr.nextSibling && el.lastChild.textContent === '\n') {
            if (el.lastChild !== possibleBr) {
              el.removeChild(el.lastChild);
            }
            el.removeChild(possibleBr);
          }
        }
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = el.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child.tagName.toLowerCase() === 'br' && child.nextSibling && child.nextSibling.nodeType === el.ELEMENT_NODE && ['ul', 'ol'].includes(child.nextSibling.tagName.toLowerCase())) {
            el.removeChild(child);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  };

  var removeStyleTagSerializer = {
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() === 'style') {
        return null;
      }
    }
  };

  return [emptyDivBrToParagraphSerializer, cleanupNewlinesAroundBrsSerializer, cleanupDoubleNewlinesSerializer, cleanupBrNewlineSerializer, cleanupTopLevelBrSerializer, removeStyleTagSerializer];
});

var codeSerializers = (function (options, utils, context) {
  return [{
    serialize: function serialize(obj, children) {
      if (obj.object !== 'block' || obj.type !== 'code') return;

      if (isLineBreak(obj)) return;

      var language = obj.data.get('language');
      if (!language) return;

      var grammar = Prism.languages[language];
      if (!grammar) return;

      var style = utils.alignment.alignmentStyleForData(obj.data);
      var highlightedText = Prism.highlight(obj.text, grammar, language);

      // Some services don't properly handle whitespace, but do handle
      // br tags. Also, Slate converts \ns in child nodes to brs, so
      // this is more consistent with non-highlighted blocks.
      highlightedText = highlightedText.replace(/\n/g, '<br/>');

      return React__default.createElement(
        'pre',
        { style: style },
        React__default.createElement('code', {
          'data-language': language,
          dangerouslySetInnerHTML: { __html: highlightedText }
        })
      );
    },
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'pre') return;
      if (el.children.length === 1 && el.children[0].tagName.toLowerCase() === 'code') {
        var codeNode = el.children[0];
        var language = codeNode.dataset.language;

        if (!language) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = codeNode.classList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var className = _step.value;

              if (className.startsWith('language-')) {
                language = className.slice('language-'.length);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        if (!language) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = codeNode.classList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _className = _step2.value;

              if (_className.startsWith('lang-')) {
                language = _className.slice('lang-'.length);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }

        if (!language) return;

        var data = utils.alignment.alignmentDataFromElement(el);

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = codeNode.querySelectorAll('br')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var br = _step3.value;

            br.outerHTML = '\n';
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var text = codeNode.textContent;
        if (text.endsWith('\n')) text = text.slice(0, -1);

        return {
          object: 'block',
          type: 'code',
          data: _extends({}, data, { language: language }),
          nodes: [{ object: 'text', text: text }]
        };
      }
    }
  }, {
    serialize: function serialize(obj, children) {
      if (obj.object !== 'block' || obj.type !== 'code') return;

      var style = utils.alignment.alignmentStyleForData(obj.data);

      return React__default.createElement(
        'pre',
        { style: style },
        React__default.createElement(
          'code',
          null,
          children,
          isLineBreak(obj) && React__default.createElement('br', null)
        )
      );
    },
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'pre') return;
      if (el.children.length === 1 && el.children[0].tagName.toLowerCase() === 'code') {
        var data = utils.alignment.alignmentDataFromElement(el);
        var codeNode = el.children[0];

        var lastNode = codeNode.lastChild;

        if (lastNode && lastNode.nodeType === lastNode.TEXT_NODE && lastNode.textContent.endsWith('\n')) {
          lastNode.textContent = lastNode.textContent.slice(0, -1);
        }

        return {
          object: 'block',
          type: 'code',
          data: data,
          nodes: next(codeNode.childNodes)
        };
      }
    }
  }, {
    // Medium, etc. don't wrap their code nodes
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'pre') return;
      if (el.getAttribute('ccp_infra_version')) {
        // This pre comes from Excel Web, and we just want to skip it
        // to get the table underneath.
        return;
      }
      var data = utils.alignment.alignmentDataFromElement(el);
      return {
        object: 'block',
        type: 'code',
        data: data,
        nodes: next(el.childNodes)
      };
    }
  }];
});

var dividerLineSerializers = (function (options, utils, context) {
  return [tagAndTypeSerializer('block', {
    'hr': 'divider-line'
  }, {
    'divider-line': function dividerLine(children, node) {
      return React__default.createElement('hr', null);
    }
  })];
});

var equationEditorSerializers = (function (options, utils, context) {
  return [tagAndTypeSerializer('block', {}, {
    line: function line(children, node) {
      return React__default.createElement(
        'p',
        null,
        node.text
      );
    }
  })];
});

var googleDocsSerializers = (function (options, utils, context) {
  return [{
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'b') return;
      if (!el.id.startsWith('docs-internal-guid')) return;
      return next(el.childNodes);
    }
  }, {
    deserialize: function deserialize(el, next) {
      // when the contents of a google sheets cell is copy/pasted,
      // the html is a <span> with a data-sheets-value attribute.
      // we need this info to later preserve whitespace if rendering
      // text nodes inside the cell
      if (el.tagName.toLowerCase() !== 'span') return;
      if (!el.dataset || !el.dataset.sheetsValue) return;

      return next(el.childNodes);
    }
  }];
});

/**
 * Slate doesn't support generating multiple marks from the same
 * element. But when we're parsing HTML style tags, that's exactly
 * what we need to do. Instead of recursing through children, we go
 * through a list of functions that look at the style tag and return a
 * mark. Then we process those marks, in the same way
 * slate-html-serializer does, to return a value that acts as if you
 * had a bunch of nested span tags, each with one of the important
 * styles on it.
 *
 * @param {Node} el the DOM element to process (a span tag)
 * @param {Function} next a function that takes a list of nodes and returns deserialized Slate objects, same as the one that slate-html-serializer gives you.
 * @param {Html} serializer Needed to manually deserialize nested marks.
 * @param {Array} fns an array of (el, next) => object|undefined functions. These should look at the style attribute of el and return the associated mark.
 * @return {Object|undefined}
 */
function marksFromElement(el, next, serializer, fns) {
  return fns.reduce(function (mark, fn) {
    var childMark = fn(el, next);

    if (childMark) {
      next = function next(els) {
        return serializer.deserializeMark(childMark);
      };
      return childMark;
    }

    return mark;
  }, undefined);
}

function detectBold(el, next) {
  if (el.style.fontWeight === 'bold' || parseInt(el.style.fontWeight, 10) >= 600) {
    return {
      object: 'mark',
      type: 'bold',
      data: {},
      nodes: next(el.childNodes)
    };
  }
}

function detectItalic(el, next) {
  if (!el.style.fontStyle) return;
  if (el.style.fontStyle === 'italic' || el.style.fontStyle.startsWith('oblique')) {
    return {
      object: 'mark',
      type: 'italic',
      data: {},
      nodes: next(el.childNodes)
    };
  }
}

function detectUnderline(el, next) {
  if (!el.style.textDecoration) return;
  if (el.style.textDecoration.match('underline')) {
    return {
      object: 'mark',
      type: 'underline',
      data: {},
      nodes: next(el.childNodes)
    };
  }
}

function detectHighlight(el, next) {
  if (el.classList.contains('inline-highlight')) {
    return {
      object: 'mark',
      type: 'color',
      data: { background: '#FFFF9D' },
      nodes: next(el.childNodes)
    };
  }
}

var detectTextColor = function detectTextColor(utils) {
  return function (el, next) {
    if (!el.style.color) return;

    var textColor = utils.color.normalizeTextColor(el.style.color);

    if (!textColor) return;

    return {
      object: 'mark',
      type: 'textColor',
      data: { textColor: textColor },
      nodes: next(el.childNodes)
    };
  };
};

var detectTextHighlight = function detectTextHighlight(utils) {
  return function (el, next) {
    if (!el.style.backgroundColor) return;

    var textHighlight = utils.color.normalizeTextHighlight(el.style.backgroundColor);

    if (!textHighlight) return;

    return {
      object: 'mark',
      type: 'textHighlight',
      data: { textHighlight: textHighlight },
      nodes: next(el.childNodes)
    };
  };
};

var detectFontSize = function detectFontSize(el, next) {
  if (!el.style.fontSize) return;
  if (el.style.fontSize === 'inherit') return;

  return {
    object: 'mark',
    type: 'fontSize',
    data: { fontSize: el.style.fontSize },
    nodes: next(el.childNodes)
  };
};

// Find the font in the serializer font list. If not found, fall
// back to converting to _ case.
function convertFontFamilyToMark(fontFamily) {
  var fontLowerCase = fontFamily.split(',')[0].toLowerCase();
  var foundFont = serializerFontList.find(function (font) {
    return font.fontFamily.toLowerCase().startsWith(fontLowerCase);
  });
  if (foundFont) {
    return foundFont.styleName;
  }
  return fontLowerCase.replace(/ /g, '_');
}

var detectFontFamily = function detectFontFamily(el, next) {
  if (!el.style.fontFamily) return;

  // We store the mark on a data-font-family-mark attribute. Get from here
  // if available, otherwise convert the fontFamily style
  var markName = el.dataset.fontFamilyMark ? el.dataset.fontFamilyMark : convertFontFamilyToMark(el.style.fontFamily);
  if (!markName) return;

  return {
    object: 'mark',
    type: 'fontFamily',
    data: { fontFamily: markName },
    nodes: next(el.childNodes)
  };
};

var makeDetectMarks = (function (options, utils) {
  return function (el, next, serializer) {
    var detectors = [detectTextColor(utils), detectTextHighlight(utils), detectHighlight, detectUnderline, detectItalic, detectBold];
    if (options.enableFontSizeMark) {
      detectors.push(detectFontSize);
    }
    if (options.enableFontFamilyMark) {
      detectors.push(detectFontFamily);
    }
    return marksFromElement(el, next, serializer, detectors);
  };
});

// find all marks that a node does not already have from
// a given list of marks to check for
function missingMarks(slateNode, marks) {
  var existingMarkTypes = (slateNode.marks || []).map(function (m) {
    return m.type;
  });
  return marks.filter(function (m) {
    return existingMarkTypes.indexOf(m.type) === -1;
  });
}

function extractMarks(domElement) {
  var marks = [];
  if (domElement.style.fontSize) {
    marks.push({
      object: 'mark',
      type: 'fontSize',
      data: { fontSize: domElement.style.fontSize }
    });
  }
  if (domElement.style.fontFamily) {
    var markName = convertFontFamilyToMark(domElement.style.fontFamily);
    if (markName) {
      marks.push({
        object: 'mark',
        type: 'fontFamily',
        data: { fontFamily: markName }
      });
    }
  }
  return marks;
}

var proseMirrorSerializers = (function (options, utils, context) {
  return [{
    deserialize: function deserialize(el, next) {
      if (el.dataset && el.tagName.toLowerCase() === 'p' && (el.dataset.prosemirrorNode || el.dataset.pmSlice)) {
        // in prosemirror, the <p> tag might have a lot of inline-related styling
        // information on it (e.g. font-size, font-family). This information needs
        // to be passed down and recorded as _marks_ on the slate text nodes
        var marks = extractMarks(el);

        var childNodes = next(el.childNodes);

        // visit each child text node, all the way down the tree. the text nodes
        // might be several levels deep (e.g. in the case where they are part of a ul/ol list)
        var stack = [].concat(toConsumableArray(childNodes));

        var _loop = function _loop() {
          var node = stack.pop();
          if (node.nodes && node.nodes.length > 0) {
            stack.concat(node.nodes);
          }
          if (node.object === 'text') {
            missingMarks(node, marks).forEach(function (mark) {
              node.marks.push(mark);
            });
          }
        };

        while (stack.length > 0) {
          _loop();
        }

        // some additional data is still needed on the block element itself (e.g. line height).
        // since line height is usually specified as a percentage, we'll need to include font size
        // as well.
        var fontSize = el.style.fontSize ? el.style.fontSize : '24px';
        var lineHeight = el.style.lineHeight ? el.style.lineHeight : '100%';
        var alignment = el.style.textAlign ? el.style.textAlign : 'left';

        return {
          object: 'block',
          type: 'paragraph',
          data: {
            fontSize: fontSize,
            lineHeight: lineHeight,
            alignment: alignment
          },
          nodes: childNodes
        };
      } else {}
    }
  }];
});

var imageSerializer = {
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() !== 'img') return;

    var width = void 0,
        height = void 0;

    var fullWidth = el.style.width === '100%';

    if (fullWidth) {
      width = attributeAsNumberIfExists(el, 'data-width', null);
      height = attributeAsNumberIfExists(el, 'data-height', null);
    } else {
      width = attributeAsNumberIfExists(el, 'width', null);
      height = attributeAsNumberIfExists(el, 'height', null);
    }

    var originalWidth = attributeAsNumberIfExists(el, 'data-original-width', width);
    var originalHeight = attributeAsNumberIfExists(el, 'data-original-height', height);
    var src = el.getAttribute('src');
    var dropShadow = el.classList.contains('dropShadow');

    var data = {
      src: src
    };

    var alt = el.getAttribute('alt');
    if (alt) {
      data.alt = alt;
    }

    if (width) {
      data.width = width;
      data.originalWidth = originalWidth;
    }

    if (height) {
      data.height = height;
      data.originalHeight = originalHeight;
    }

    if (dropShadow) data.dropShadow = true;
    if (fullWidth) data.fullWidth = true;

    return {
      object: 'inline',
      type: 'image',
      data: data
    };
  },
  serialize: function serialize(obj, children) {
    if (obj.object !== 'inline' || obj.type !== 'image') return;

    var _obj$data$toJSON = obj.data.toJSON(),
        width = _obj$data$toJSON.width,
        height = _obj$data$toJSON.height,
        originalWidth = _obj$data$toJSON.originalWidth,
        originalHeight = _obj$data$toJSON.originalHeight,
        src = _obj$data$toJSON.src,
        dropShadow = _obj$data$toJSON.dropShadow,
        fullWidth = _obj$data$toJSON.fullWidth,
        alt = _obj$data$toJSON.alt;

    var className = dropShadow ? 'dropShadow' : null;

    if (fullWidth) {
      var style = {
        width: '100%',
        maxWidth: originalWidth
      };

      return React__default.createElement('img', {
        'data-width': width,
        'data-height': height,
        'data-original-width': originalWidth,
        'data-original-height': originalHeight,
        src: src,
        alt: alt,
        className: className,
        style: style
      });
    } else {
      return React__default.createElement('img', {
        width: width,
        height: height,
        'data-original-width': originalWidth,
        'data-original-height': originalHeight,
        src: src,
        alt: alt,
        className: className
      });
    }
  }
};

var imageSerializers = (function (options, utils, context) {
  return [imageSerializer, tagAndTypeSerializer('inline', {}, {
    'image-placeholder': function imagePlaceholder(children) {
      return null;
    }
  })];
});

var videoSerializer = {
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() !== 'video') return;

    var width = attributeAsNumberIfExists(el, 'width', null);
    var height = attributeAsNumberIfExists(el, 'height', null);

    var originalWidth = attributeAsNumberIfExists(el, 'data-original-width', width);
    var originalHeight = attributeAsNumberIfExists(el, 'data-original-height', height);
    var src = el.getAttribute('src');

    var data = {
      src: src
    };

    var alt = el.getAttribute('aria-label');
    if (alt) {
      data.alt = alt;
    }

    if (width) {
      data.width = width;
      data.originalWidth = originalWidth;
    }

    if (height) {
      data.height = height;
      data.originalHeight = originalHeight;
    }

    return {
      object: 'inline',
      type: 'video',
      data: data
    };
  },
  serialize: function serialize(obj, children) {
    if (obj.object !== 'inline' || obj.type !== 'video') return;

    var _obj$data$toJSON = obj.data.toJSON(),
        width = _obj$data$toJSON.width,
        height = _obj$data$toJSON.height,
        originalWidth = _obj$data$toJSON.originalWidth,
        originalHeight = _obj$data$toJSON.originalHeight,
        src = _obj$data$toJSON.src,
        alt = _obj$data$toJSON.alt;

    return React__default.createElement('video', {
      width: width,
      height: height,
      'data-original-width': originalWidth,
      'data-original-height': originalHeight,
      controls: true,
      src: src,
      'aria-label': alt
    });
  }
};

var videoSerializers = (function (options, utils, context) {
  return [videoSerializer, tagAndTypeSerializer('inline', {}, {
    'video-placeholder': function videoPlaceholder(children) {
      return null;
    }
  })];
});

var audioSerializer = {
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() !== 'audio') return;

    var src = el.getAttribute('src');

    var data = {
      src: src
    };

    var alt = el.getAttribute('aria-label');
    if (alt) {
      data.alt = alt;
    }

    return {
      object: 'inline',
      type: 'audio',
      data: data
    };
  },
  serialize: function serialize(obj, children) {
    if (obj.object !== 'inline' || obj.type !== 'audio') return;

    var _obj$data$toJSON = obj.data.toJSON(),
        src = _obj$data$toJSON.src,
        alt = _obj$data$toJSON.alt;

    return React__default.createElement('audio', { controls: true, src: src, 'aria-label': alt });
  }
};

var audioSerializers = (function (options, utils, context) {
  return [audioSerializer, tagAndTypeSerializer('inline', {}, {
    'audio-placeholder': function audioPlaceholder(children) {
      return null;
    }
  })];
});

var embedSerializer = {
  deserialize: function deserialize(el, next) {
    if (el.tagName.toLowerCase() !== 'a') return;
    var src = el.getAttribute('data-embed-src');
    if (!src) return;

    var width = attributeAsNumberIfExists(el, 'data-width', null);
    var height = attributeAsNumberIfExists(el, 'data-height', null);
    var originalWidth = attributeAsNumberIfExists(el, 'data-original-width', width);
    var originalHeight = attributeAsNumberIfExists(el, 'data-original-height', height);
    var data = {
      embed_src: src,
      width: width,
      height: height,
      originalWidth: originalWidth,
      originalHeight: originalHeight
    };

    return {
      object: 'inline',
      type: 'embed',
      data: data
    };
  },
  serialize: function serialize(obj, children) {
    if (obj.object !== 'inline' || obj.type !== 'embed') return;

    var _obj$data$toJSON = obj.data.toJSON(),
        width = _obj$data$toJSON.width,
        height = _obj$data$toJSON.height,
        originalWidth = _obj$data$toJSON.originalWidth,
        originalHeight = _obj$data$toJSON.originalHeight,
        embed_src = _obj$data$toJSON.embed_src;

    return React__default.createElement(
      'a',
      {
        'data-width': width,
        'data-height': height,
        'data-original-width': originalWidth,
        'data-original-height': originalHeight,
        href: embed_src,
        'data-embed-src': embed_src
      },
      embed_src
    );
  }
};

var embedSerializers = (function (options, utils, context) {
  return [embedSerializer];
});

var linkSerializers = (function (options, utils, context) {
  return [{
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'a') return;

      var href = el.getAttribute('href');
      var name = el.getAttribute('name');
      var jiraImage = el.dataset.jiraImage;
      // If the link is an old style html anchor then add that to the parent block and continue.
      if (name && (!href || href.trim() === '')) {
        var parentBlock = findParent(function (parent) {
          return Object.keys(BlockElements).includes(parent.nodeName.toLowerCase());
        })(el);

        if (parentBlock) {
          parentBlock.setAttribute('data-anchor', name);
        }

        return next(el.childNodes);
      }

      var data = { href: el.getAttribute('href') };
      if (jiraImage) {
        data['jira-image'] = jiraImage;
      }
      return {
        object: 'inline',
        type: 'link',
        data: data,
        nodes: next(el.childNodes)
      };
    }
  }, tagAndTypeSerializer('inline', {}, {
    link: function link(children, obj) {
      var inputProps = {
        href: utils.link.normalizeHref(obj.data.get('href'))
      };
      if (obj.data.get('jira-image')) {
        inputProps['data-jira-image'] = obj.data.get('jira-image');
      }

      return React__default.createElement(
        'a',
        inputProps,
        children
      );
    },
    'link-placeholder': function linkPlaceholder(children, obj) {
      return React__default.createElement(
        'span',
        null,
        children
      );
    }
  })];
});

/**
 * It's technically invalid for a list to be a direct descendant of
 * another list -- the proper thing to do is to make it a child of its
 * previous list item sibling. This function will convert:
 * <ul>
 *   <li>Some text</li>
 *   <ol>...</ol>
 * </ul>
 *
 * to
 *
 * <ul>
 *   <li>Some text
 *     <ol>...</ol>
 *   </li>
 * </ul>
 *
 */
function moveBareListsToPreviousItems(children) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;

      if (['ul', 'ol'].includes(child.tagName.toLowerCase())) {
        var sibling = child.previousElementSibling;
        if (sibling) {
          sibling.appendChild(child);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/*
 * A <br> tag is an invalid child of an <ol> or <ul>... but sometimes
 * we get some rebels that include them anyway.
 */
function removeInvalidBrTagChildren(children) {
  return children.filter(function (child) {
    return child.tagName.toLowerCase() !== 'br';
  });
}

/**
 * Returns true if el is a list wrapper element we added when
 * serializing, false otherwise.
 */
function isListWrapper(el) {
  return el.style.listStyleType === 'none' && el.children.length === 1 && ['ul', 'ol'].includes(el.children[0].tagName.toLowerCase());
}

var checklistSerializer = {
  deserialize: function deserialize(el, next) {
    if (!['ul', 'ol'].includes(el.tagName.toLowerCase())) return;
    var children = Array.from(el.children);
    var listItems = children.filter(function (el) {
      return el.tagName.toLowerCase() === 'li' && !isListWrapper(el);
    });

    if (listItems.length === 0 && el.classList.contains('checklist')) {
      return {
        object: 'block',
        type: 'checklist',
        nodes: next(Array.from(el.children))
      };
    }

    var hasCheckbox = listItems.some(function (el) {
      return el.classList.contains('checklist-item--checked') || el.classList.contains('checklist-item--unchecked');
    });
    if (hasCheckbox) {
      moveBareListsToPreviousItems(el.children);

      return {
        object: 'block',
        type: 'checklist',
        nodes: next(Array.from(el.children))
      };
    }
  }
};

var listSerializer = function listSerializer(context) {
  return {
    serialize: function serialize(obj, children) {
      if (!['ul_list', 'ol_list', 'checklist'].includes(obj.type)) return;

      var listElement = null;

      switch (obj.type) {
        case 'ul_list':
          listElement = React__default.createElement(
            'ul',
            null,
            children
          );
          break;
        case 'ol_list':
          listElement = React__default.createElement(
            'ol',
            null,
            children
          );
          break;
        case 'checklist':
          listElement = React__default.createElement(
            'ul',
            { className: 'checklist' },
            children
          );
          break;
        default:
          break;
      }

      var parent = context.document.getParent(obj.key);

      // If our list is a direct descendant of another list, we need to
      // wrap it in an li. Otherwise, libxml2 might corrupt it when we
      // sanitize the content. We need to add list-style-type: none to
      // the wrapper to hide excess bullet points.
      if (parent && ['ul_list', 'ol_list', 'checklist'].includes(parent.type)) {
        return React__default.createElement(
          'li',
          { style: { listStyleType: 'none' } },
          listElement
        );
      } else {
        return listElement;
      }
    },
    deserialize: function deserialize(el, next) {
      if (!['ul', 'ol'].includes(el.tagName.toLowerCase())) return;
      var type = el.tagName.toLowerCase() === 'ul' ? 'ul_list' : 'ol_list';

      moveBareListsToPreviousItems(el.children);
      var children = removeInvalidBrTagChildren(Array.from(el.children));

      return {
        object: 'block',
        type: type,
        // Lists should only have elements as children, not text node children.
        nodes: next(children)
      };
    }
  };
};

// Serialization rules for lists. Expects a `context` object, with a
// `document` element, pointing to the root document being
// serialized. We need this to navigate up and down the document tree
// to detect checklists.
var listItemSerializer = function listItemSerializer(context) {
  return {
    serialize: function serialize(obj, children) {
      if (obj.object !== 'block' || obj.type !== 'list_item') return;

      var listParent = context.document.getClosest(obj.key, function (node) {
        return ['ul_list', 'ol_list', 'checklist'].includes(node.type);
      });
      var checklistParent = listParent.type === 'checklist' ? listParent : null;
      var style = getStyleFromChildMarks(obj);

      if (!checklistParent) return React__default.createElement(
        'li',
        { style: style },
        children
      );
      var className = obj.data.get('checked') ? 'checklist-item--checked' : 'checklist-item--unchecked';

      var indicator = obj.data.get('checked') ? '\u2611' : '\u2610';

      return React__default.createElement(
        'li',
        { className: className, style: style },
        React__default.createElement(
          'span',
          { className: 'checklist-item__indicator' },
          indicator
        ),
        children
      );
    },
    deserialize: function deserialize(el, next) {
      // skip checklist indicators entirely
      if (el.tagName.toLowerCase() === 'span' && el.classList.contains('checklist-item__indicator')) {
        return null;
      }

      if (el.tagName.toLowerCase() !== 'li') return;

      // If this is an li that we added to wrap a deeply nested list,
      // ignore it.
      if (isListWrapper(el)) {
        return;
      }

      // TinyMCE likes to use text nodes inside lists, which our Slate
      // schema doesn't support. So we need to wrap all top-level runs
      // of non-Block nodes in paragraph nodes.
      var nodes = wrapNonBlocksInContainer(next(el.childNodes), 'paragraph');

      var isChecklistItem = el.classList.contains('checklist-item--checked') || el.classList.contains('checklist-item--unchecked');
      if (!isChecklistItem) {
        return {
          object: 'block',
          type: 'list_item',
          nodes: nodes
        };
      }

      var data = {};
      if (el.classList.contains('checklist-item--checked')) {
        data.checked = true;
      }

      return {
        object: 'block',
        type: 'list_item',
        data: data,
        nodes: nodes
      };
    }
  };
};

var listSerializers = (function (options, utils, context) {
  return [checklistSerializer, listSerializer(context), listItemSerializer(context)];
});

var triggers = {
  '@': 'user-reference',
  '#': 'aha-reference'
};

var AHA_REFERENCE_REGEX = new RegExp('^(\\w+-((N|R|I|S|E|\\d+)-)?\\d+)$');

var AHA_REFERENCE_CLASS_ICONS = {
  Competitor: 'fa-solid fa-trophy',
  Epic: 'aha-icon aha-icon-epic-solid',
  Feature: 'fa-solid fa-grid-2 fa-fw',
  'Ideas::Idea': 'fa-solid fa-lightbulb',
  Initiative: 'fa-solid fa-sitemap',
  MasterFeature: 'aha-icon aha-icon-epic-solid',
  MasterRelease: 'fa-solid fa-calendar-lines',
  Page: 'fa-solid fa-file-lines',
  Persona: 'fa-solid fa-address-card',
  Release: 'fa-solid fa-calendar-lines',
  Requirement: 'fa-solid fa-list',
  StrategicImperative: 'fa-solid fa-flag'
};

var buildReferenceUrl = function buildReferenceUrl(referenceUrl, referenceClass) {
  var url = new URL(referenceUrl);
  var referenceUrlParams = new URLSearchParams();

  referenceUrlParams.set('reference-class', referenceClass);

  return url.origin + url.pathname + '?' + referenceUrlParams.toString();
};

var referenceSerializers = (function (options, rules, context) {
  return [{
    /**
     *
     * @param {HTMLElement} el
     * @param {*} next
     */
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'span') return;
      if (el.className !== 'reference') return;
      var type = triggers[el.textContent.slice(0, 1)];
      if (!type) return;
      if (!el.dataset.reference) return;
      var object = JSON.parse(el.dataset.reference);

      return {
        object: 'inline',
        type: type,
        data: { reference: object }
      };
    }
  }, {
    /**
     *
     * @param {HTMLElement} el
     * @param {*} next
     */
    deserialize: function deserialize(el, next) {
      var tagName = el.tagName.toLowerCase();
      var isLink = tagName === 'a';
      var linkedElementType = el.dataset && el.dataset.linkedElementType;
      var isPortalUserReference = tagName === 'span' && linkedElementType === 'Ideas::PortalUser';

      if (!isLink && !isPortalUserReference) return;

      var referenceDetails = {};
      var href = el.getAttribute('href');
      var referenceClass = void 0,
          referenceType = void 0;
      try {
        if (isUrl(href)) {
          var referenceUrl = new URL(href);
          referenceClass = new URLSearchParams(referenceUrl.search).get('reference-class');
        }
      } catch (error) {
        // Error parsing the url. Skip it because it is not a reference
      }

      var objectType = linkedElementType || referenceClass;

      if (!objectType) return;

      if (objectType === 'User') {
        referenceType = 'user-reference';
        referenceDetails.class = objectType;
        referenceDetails.name = el.textContent.slice(1);
        referenceDetails.url = href;
      } else if (objectType === 'Ideas::PortalUser') {
        referenceType = 'user-reference';
        referenceDetails.class = objectType;
        referenceDetails.name = el.textContent.slice(1);
        referenceDetails.id = el.dataset.linkedElementId;
      } else {
        referenceType = 'aha-reference';
        referenceDetails.class = objectType;
        referenceDetails.url = buildReferenceUrl(href, referenceDetails.class);
        if (el.dataset.visibleFields) {
          referenceDetails.visibleFields = el.dataset.visibleFields.split(',');
        }

        if (el.textContent.startsWith('#')) {
          // NOTE: will leave this here to support existing reference starting with `#`
          referenceDetails.reference_num = el.textContent.slice(1);
        } else {
          referenceDetails.name = el.textContent.trim();
          // NOTE: new reference won't start with # anymore so I added this check to populate the reference only if it was a valid one but avoid setting the reference number for exsiting references such as Goals
          if (referenceDetails.name.match(AHA_REFERENCE_REGEX)) {
            referenceDetails.reference_num = referenceDetails.name;
          }
        }
      }

      return {
        object: 'inline',
        type: referenceType,
        data: {
          reference: _extends({}, referenceDetails)
        }
      };
    }
  }, tagAndTypeSerializer('inline', {}, {
    'user-reference-editable': function userReferenceEditable(children, obj) {
      return React__default.createElement(
        'span',
        null,
        children
      );
    },
    'user-reference': function userReference(children, obj) {
      var user = obj.data.get('reference');

      if (!user) return React__default.createElement(
        React__default.Fragment,
        null,
        children
      );

      var name = 'guest';
      if (user && user.class === 'User') {
        // Only display the name for Aha! users
        name = user.name;
      }

      if (!user.url) return React__default.createElement(
        'span',
        { 'data-linked-element-type': user.class, 'data-linked-element-id': user.id },
        '@',
        name
      );

      return React__default.createElement(
        'a',
        {
          href: user.url,
          'data-mce-href': user.url,
          'data-linked-element-type': 'User'
        },
        '@',
        name
      );
    },
    'aha-reference-editable': function ahaReferenceEditable(children, obj) {
      return React__default.createElement(
        'span',
        null,
        children
      );
    },
    'aha-reference': function ahaReference(children, obj) {
      var item = obj.data.get('reference');

      if (!item) return React__default.createElement(
        React__default.Fragment,
        null,
        children
      );

      var content = item['reference_num'] || item.name;
      var referenceUrl = buildReferenceUrl(item.url, item.class);
      var visibleFields = item.visibleFields ? { 'data-visible-fields': item.visibleFields.join(',') } : {};

      return React__default.createElement(
        'a',
        _extends({
          href: referenceUrl,
          'data-mce-href': referenceUrl,
          'data-linked-element-type': item.class
        }, visibleFields),
        React__default.createElement('i', {
          className: AHA_REFERENCE_CLASS_ICONS[item.class] + ' aha-reference-icon'
        }),
        ' ',
        content
      );
    }
  })];
});

// Returns a deserializer that will wrap the children of `tag`
// elements with a `span` tag containing the same styles. For example,
// if `tag` is 'td', and you have the HTML:
//
//     <td style="font-weight:bold;">...</td>
//
// This function will turn it into:
//
//     <td style="font-weight:bold;">
//       <span style="font-weight:bold;">...</span>
//     </td>
//
// This will cause the deserializer to automatically use our
// span-to-mark deserializer, instead of having to deserialize styles
// specifically on every element that needs them.
function wrapElementInStyledSpan(tag) {
  return function (el, next) {
    if (el.tagName.toLowerCase() !== tag) return;
    if (el.style.length === 0) return;

    var clonedEl = el.cloneNode(false);
    // Have to use innerHTML here, because if we're on the server,
    // we may not have document in scope to call
    // document.createElement.
    clonedEl.innerHTML = '<span />';
    var wrapper = clonedEl.firstElementChild;

    var styleCopy = el.getAttribute('style');
    var strippedStyleCopy = styleCopy.replace(/background-color:\s?(#.{3,6}|var\(--[\w-]+\))/, '');

    wrapper.style.cssText = strippedStyleCopy;
    while (el.firstChild) {
      wrapper.appendChild(el.firstChild);
    }
    el.appendChild(wrapper);
    clonedEl.remove();
  };
}

var styleSerializers = (function (options, utils, context) {
  var detectMarks = makeDetectMarks(options, utils);
  return [{
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'span') return;
      return detectMarks(el, next, context.serializer.htmlSerializer);
    }
  }, { deserialize: wrapElementInStyledSpan('td') }, {
    serialize: function serialize(obj) {
      if (obj.object !== 'string') return;
      // See comment on line 84 for explanation.
      delete context.textFontSize;
    }
  }, tagAndTypeSerializer('mark', {}, {
    highlight: function highlight(children) {
      return React__default.createElement(
        'span',
        { style: { backgroundColor: '#FFFF9D' } },
        children
      );
    },
    color: function color(children, mark) {
      return React__default.createElement(
        'span',
        { style: utils.color.getStyleFromMark(mark, false) },
        children
      );
    },
    textColor: function textColor(children, mark) {
      return React__default.createElement(
        'span',
        { style: { color: mark.data.get('textColor') } },
        children
      );
    },
    fontSize: function fontSize(children, mark) {
      // As the font size effects the line height of text, styles can get messed up
      // if applied in the wrong order. To mitigate this, if a node has a font size
      // mark, we want to also add the font size style alongside background color
      // and strikethrough. We only care if font size is the inner most mark.
      //
      // It's a bit hacky, but this is achieved by adding a property to the context
      // whenever we encounter a fontSize mark and then checking for that property
      // when we encounter the other marks. We then clear it when we reach the next
      // string node.
      var fontSize = mark.data.get('fontSize');
      context.textFontSize = fontSize;
      return React__default.createElement(
        'span',
        { style: { fontSize: fontSize } },
        children
      );
    },
    textHighlight: function textHighlight(children, mark) {
      // See comment above on line 84 for explanation.
      var style = { backgroundColor: mark.data.get('textHighlight') };
      if (context.textFontSize) {
        style.fontSize = context.textFontSize;
      }
      return React__default.createElement(
        'span',
        { style: style },
        children
      );
    },
    fontFamily: function fontFamily(children, mark) {
      var markData = mark.data.get('fontFamily');
      var fontItem = serializerFontList.find(function (font) {
        return font.styleName === markData;
      });
      var fontFamily = fontItem ? fontItem.fontFamily : markData.split('_').join(' ');

      var style = { fontFamily: fontFamily };

      // See comment above on line 84 for explanation.
      if (context.textFontSize) {
        style.fontSize = context.textFontSize;
      } else {
        style.fontSize = 'inherit';
      }

      return React__default.createElement(
        'span',
        { style: style, 'data-font-family-mark': markData },
        children
      );
    }
  })];
});

function isTableWrapper(el) {
  if (el.tagName.toLowerCase() !== 'div') return false;

  var children = el.children;


  var tables = Array.from(children).filter(function (el) {
    return el.tagName.toLowerCase() === 'table';
  });

  // Table wrappers are a div that has 1 table child and a maxWidth of 100%
  if (tables.length === 1 && el.style.maxWidth === '100%') return true;

  return false;
}

function isTableRow(el) {
  return el.tagName.toLowerCase() === 'tr';
}

function isTableCell(el) {
  return ['th', 'td'].includes(el.tagName.toLowerCase());
}

function hasColspan(element) {
  var colspan = parseInt(element.getAttribute('colSpan'), 10);
  return !isNaN(colspan) && colspan !== 1;
}

function hasVerticalAlign(element) {
  return element.style.verticalAlign || element.getAttribute('valign');
}

// We only supprt top, middle, bottom alignment
// This takes a parsed value and normalizes it into one of our supported
// alignments as a lowercase string. It converts some known css values
// to allowed values
function normalizeVerticalAlignValue(parsedValue) {
  var normalizedValue = ['top', 'middle', 'bottom'].find(function (value) {
    return value === parsedValue.toLowerCase();
  });
  if (!normalizedValue) {
    switch (parsedValue.toLowerCase()) {
      case 'baseline':
        normalizedValue = 'bottom';
        break;
      case 'sub':
        normalizedValue = 'bottom';
        break;
      default:
        break;
    }
  }
  return normalizedValue;
}

function getVerticalAlign(el) {
  var verticalAlign = '';

  // style rule has precedence
  if (el.style.verticalAlign) {
    // baseline, top, middle, bottom (also, baseline, baseline, sub)
    verticalAlign = el.style.verticalAlign;
  } else if (el.getAttribute('valign')) {
    // baseline, top, middle, bottom
    verticalAlign = el.getAttribute('valign');
  }

  return normalizeVerticalAlignValue(verticalAlign);
}

function parseColumnWidths(columns) {
  // It's dangerous to parse column widths from columns with colspan,
  // because we don't necessarily know the correct width for each
  // column -- only the combined width for the colspan.
  if (columns.some(function (column) {
    return hasColspan(column);
  })) {
    return [];
  }

  return columns.map(function (el) {
    var widthStyle = el.style.width;
    var width = parseFloat(widthStyle);
    return isNaN(width) ? 0 : width;
  });
}

/**
 * `col` tags can have a `span` attribute that causes the tag to act
 * like there are `span` copies of that tag. In order to simplify code
 * downstream, this function will return `span` copies of each `col`
 * element in the group.
 */
function expandColsInColGroup(colElements) {
  return colElements.reduce(function (expandedElements, col) {
    var span = parseInt(col.getAttribute('span'), 10);
    if (isNaN(span)) {
      span = 1;
    }

    for (var i = 0; i < span; i++) {
      var node = col.cloneNode(false);
      node.removeAttribute('span');
      expandedElements.push(node);
    }

    return expandedElements;
  }, []);
}

/**
 * Returns parsed column widths from the table DOM element.
 *
 * We can get widths in one of two ways. If the table has a `colgroup`
 * element, we will assume that it contains the correct widths, and
 * use those directly. Otherwise, we will find the first `tr` element,
 * and try to parse widths from its cells. If any of the cells in the
 * `tr` spans multiple columns, we will stop trying to parse widths
 * and return an empty array, because we can't get per-column widths,
 * only the sum of widths from the spanned columns.
 *
 * @param {Node} table A `table` DOM element
 * @return {Array<number>} an array of parsed column widths
 */
function columnWidthsFromTable(table) {
  var children = Array.from(table.children);

  var colgroup = children.find(function (child) {
    return child.tagName.toLowerCase() === 'colgroup';
  });

  // If we have a colgroup, use the widths from it.
  if (colgroup) {
    var columns = Array.from(colgroup.children).filter(function (el) {
      return el.tagName.toLowerCase() === 'col';
    });

    var columnWidths = parseColumnWidths(expandColsInColGroup(columns));
    if (columnWidths.length > 0) {
      return columnWidths;
    }
  }

  var row = children.find(isTableRow);
  if (!row) {
    var container = children.find(function (child) {
      return ['thead', 'tbody', 'tfoot'].includes(child.tagName.toLowerCase());
    });
    if (container) {
      row = Array.from(container.children).find(isTableRow);
    }
  }

  if (row) {
    var tableCells = Array.from(row.children).filter(isTableCell);
    return parseColumnWidths(tableCells);
  }
  return [];
}

/**
 * Some integrations can send us weird tables with rows, but no
 * cells. These won't appear in the UI, and will actually break
 * editing. So if we detect a table with either no rows, or with rows
 * but no cells, we should not parse it.
 */
function isTableWithoutCells(table) {
  var containers = Array.from(table.children).filter(function (child) {
    return ['tbody', 'thead', 'tfoot'].includes(child.tagName.toLowerCase());
  });

  if (containers.length === 0) {
    containers = [table];
  }

  // Find all the table rows in all the containers. flatMap isn't well
  // supported, so we'll emulate it with reduce.
  var rows = containers.reduce(function (acc, container) {
    return acc.concat(Array.from(container.children).filter(isTableRow));
  }, []);

  return rows.every(function (row) {
    return Array.from(row.children).filter(isTableCell).length === 0;
  });
}

var tableSerializer = function tableSerializer(options) {
  return {
    serialize: function serialize(obj, children) {
      if (obj.type !== options.tableType) return;

      var style = {};
      if (obj.data.get('width')) {
        style.width = obj.data.get('width') + 'px';
        style.maxWidth = '100%';
      }

      var colgroup = null;

      if (obj.data.get('columnWidths')) {
        colgroup = React__default.createElement(
          'colgroup',
          null,
          obj.data.get('columnWidths').map(function (width, i) {
            var style = {
              width: typeof width === 'number' ? width + '%' : null
            };
            return React__default.createElement('col', { style: style, key: i });
          })
        );
      }

      if (style.width) {
        return (
          // In order to support resizing inside a parent without expanding
          // past enclosing parent enclosing container there is a wrapping element
          React__default.createElement(
            'div',
            { className: 'table-wrapper', style: style },
            React__default.createElement(
              'table',
              null,
              colgroup,
              React__default.createElement(
                'tbody',
                null,
                children
              )
            )
          )
        );
      }

      return React__default.createElement(
        'table',
        null,
        colgroup,
        React__default.createElement(
          'tbody',
          null,
          children
        )
      );
    },
    deserialize: function deserialize(el, next) {
      // To roundtrip tables, we have to be able to parse the cell width
      // out of the first row of table cells.
      if (el.tagName.toLowerCase() === 'table' || isTableWrapper(el)) {
        var table = isTableWrapper(el) ? el.firstElementChild : el;
        var firstChild = table.firstElementChild;
        if (!firstChild) return;

        if (isTableWithoutCells(table)) {
          // Passing [] here will cause the HTML serializer to stop
          // parsing this tree.
          return next([]);
        }

        var tableWidth = parseInt(el.style.width, 10);

        var columnWidths = columnWidthsFromTable(table);

        var totalWidth = columnWidths.reduce(function (sum, width) {
          return sum + width;
        }, 0);
        var normalizedWidths = totalWidth !== 0 && columnWidths.map(function (width) {
          return width / totalWidth * 100;
        });

        var data = {};

        if (!isNaN(tableWidth)) {
          data.width = tableWidth;
        }

        if (totalWidth !== 0) {
          data.columnWidths = normalizedWidths;
        }

        // Tables should only have block children, but sometimes
        // whitespace can turn into text or inline nodes. Filter those out
        // here, because they won't show up anyway.
        var nodes = next(Array.from(table.children)).filter(function (node) {
          return node.object === 'block';
        });

        return {
          object: 'block',
          type: options.tableType,
          data: data,
          nodes: nodes
        };
      }
    }
  };
};

var tableRowSerializer = function tableRowSerializer(options) {
  return {
    deserialize: function deserialize(el, next) {
      if (el.tagName.toLowerCase() !== 'tr') return;

      // Only process child elements (not child nodes), because tr
      // elements should only have element children.
      return {
        object: 'block',
        type: options.tableRowType,
        nodes: next(Array.from(el.children))
      };
    }
  };
};

var tableCellSerializer = function tableCellSerializer(options, utils, context) {
  return {
    serialize: function serialize(obj, children) {
      if (obj.object !== 'block' || obj.type !== options.tableCellType) return;

      var style = {};
      var width = utils.table.getWidthForCell(context.document, obj);
      var alignment = obj.data.get('verticalAlign');
      var cellColor = obj.data.get('cellColor');

      if (width) {
        style.width = width + '%';
      }
      if (alignment) {
        style.verticalAlign = alignment;
      }
      if (cellColor) {
        style.backgroundColor = cellColor;
      }

      var span = {};
      if (obj.data.get('rowspan') !== undefined) {
        span.rowSpan = obj.data.get('rowspan');
      }

      if (obj.data.get('colspan') !== undefined) {
        span.colSpan = obj.data.get('colspan');
      }

      return React__default.createElement(
        'td',
        _extends({ style: style }, span),
        children
      );
    },
    deserialize: function deserialize(el, next) {
      if (!isTableCell(el)) return;

      var data = {};

      if (el.getAttribute('rowSpan')) {
        var rowspan = parseInt(el.getAttribute('rowSpan'), 10);
        if (rowspan >= 1) {
          data.rowspan = rowspan;
        }
      }

      if (el.getAttribute('colSpan')) {
        var colspan = parseInt(el.getAttribute('colSpan'), 10);
        if (colspan >= 1) {
          data.colspan = colspan;
        }
      }

      if (el.style.backgroundColor && !el.style.backgroundColor.startsWith('var')) {
        data.cellColor = utils.color.rgbToHex(el.style.backgroundColor);
      }

      // for vertical allignment the style takes precedent
      if (hasVerticalAlign(el)) {
        data.verticalAlign = getVerticalAlign(el);
      }

      var alignmentData = utils.alignment.alignmentDataFromElement(el);
      if (Object.keys(alignmentData).length > 0) {
        // If alignment data is on the table cell itself, we should move
        // it to the child nodes, because we only support alignment on
        // specific block nodes.
        var alignmentClass = utils.alignment.alignmentClassForData(alignmentData);

        if (!el.children || el.children.length === 0) {
          var clonedEl = el.cloneNode();
          // Have to use innerHTML here, because if we're on the server,
          // we may not have document in scope to call
          // document.createElement.
          clonedEl.innerHTML = '<p />';
          var wrapper = clonedEl.firstElementChild;
          while (el.firstChild) {
            wrapper.appendChild(el.firstChild);
          }
          el.appendChild(wrapper);
          clonedEl.remove();
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = el.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;

            child.classList.add(alignmentClass);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      // TinyMCE likes to use text nodes inside table cells, which our
      // Slate schema doesn't support. So we need to wrap all top-level
      // runs of non-Block nodes in paragraph nodes.
      var nodes = wrapNonBlocksInContainer(next(el.childNodes), 'paragraph');

      if (nodes.isEmpty()) {
        nodes = nodes.push({
          object: 'block',
          type: 'paragraph',
          nodes: [{
            object: 'text',
            text: ''
          }]
        });
      }

      return {
        object: 'block',
        type: options.tableCellType,
        data: data,
        nodes: nodes
      };
    }
  };
};

var tableSerializers = (function (options, utils, context) {
  return [tableSerializer(options), tableRowSerializer(options), tableCellSerializer(options, utils, context), tagAndTypeSerializer('block', {}, defineProperty({}, options.tableRowType, function (children) {
    return React__default.createElement(
      'tr',
      null,
      children
    );
  }))];
});

/* eslint-disable no-irregular-whitespace */

var collapseWhitespace = function collapseWhitespace(text) {
  return text.replace(/\s+/g, ' ');
};

var isSpanWithSingleNoBreakSpace = function isSpanWithSingleNoBreakSpace(element) {
  return element.tagName && element.tagName.toLowerCase() === 'span' && element.childNodes.length === 1 && element.childNodes[0].nodeName === '#text' && element.childNodes[0].nodeValue === ' ';
}; // no-break space U+00a0

var preserveWhitespace = function preserveWhitespace(context) {
  return context.preDepth > 0 || context.inGoogleSheetCell;
};
var skipEmpty = function skipEmpty(context) {
  return context.treeDepth === 1;
};

var textSerializers = (function (options, utils, context) {
  return [{
    deserialize: function deserialize(el) {
      if (el.tagName && el.tagName.toLowerCase() === 'br') {
        return {
          object: 'text',
          text: '\n'
        };
      }

      // Convert spans with a single no-break space into a text node with a single space.
      // This fixes an issue that started happening with Chrome and Safari where copying and pasting text
      // from those browsers ended up removing spaces between some tags.
      // For example, `hello<span> </span><b>there</b>` would become `hello<b>there</b>` instead of
      // `hello <b>there</b>`
      if (isSpanWithSingleNoBreakSpace(el)) {
        return {
          object: 'text',
          text: ' '
        };
      }

      if (el.nodeName === '#text') {
        if (el.value && el.value.match(/<!--.*?-->/)) return;
        var text = preserveWhitespace(context) || options.preserveWhitespace ? el.nodeValue : collapseWhitespace(el.nodeValue);

        if (text === ' ' && skipEmpty(context)) {
          return null;
        }

        return {
          object: 'text',
          text: text
        };
      }
    }
  }];
});

/**
 * When deserializing a value, we can end up with a valid value that
 * is hard to normalize. For example, Slate will merge consecutive
 * text nodes, of which there are usually a lot when coming from HTML.
 *
 * Slate normalization on large, invalid documents can be very slow
 * and memory-intensive. Slate will call Change methods, which
 * generate operations, which affect the value. Each operation
 * includes the entire Slate Value that it operates on. And after
 * applying an operation, Slate needs to do several
 * depth-first-searches of the entire tree to generate paths.
 *
 * If we can give Slate a mostly-normalized document, we can skip all
 * that work. So this method does some of the default Slate
 * normalizations on the JavaScript object representation of the
 * Value, in order to prevent normalization on the Value itself later
 * on.
 *
 * @param {object} value A JavaScript object representation of a Slate value
 * @return {object} The partially-normalized value
 */
function normalizeValueJSON(value) {
  // We can't do json-based normalization if we have annotations,
  // because by merging text nodes, we will mess up the paths where
  // the annotation points to.
  //
  // I don't think this will be a problem, because we only saw
  // performance problems here when converting old tinymce documents,
  // which didn't have annotations. If this does become a problem, we
  // will have to rewrite this to transform annotation anchor / focus
  // as we adjust nodes in this function.
  if (value.annotations) return value;
  value.document = normalizeNode(value.document);
  return value;
}

function normalizeNode(node) {
  if (node.nodes) {
    mergeTextChildren(node);
    node.nodes = node.nodes.map(function (node) {
      return normalizeNode(node);
    });
  }
  return node;
}

/**
 * Merges node and prevNode into a single text node as long as marks
 * match.
 */
function mergeTextNode(prevNode, node) {
  if (prevNode && isEqual(prevNode.marks, node.marks)) {
    prevNode.text += node.text;
    return [prevNode];
  } else {
    return [prevNode, node];
  }
}

/**
 * Merges every run of text children of a node into as few text nodes
 * as possible.
 */
function mergeTextChildren(node) {
  node.nodes = node.nodes.reduce(function (acc, child) {
    var previousChild = acc[acc.length - 1];
    if (child.object !== 'text') {
      return acc.concat(child);
    } else if (!previousChild || previousChild.object !== 'text') {
      return acc.concat(child);
    } else {
      var results = mergeTextNode(previousChild, child);
      return acc.slice(0, -1).concat(results);
    }
  }, []);

  return node;
}

var MicrosoftPasteShim = function () {
  function MicrosoftPasteShim() {
    classCallCheck(this, MicrosoftPasteShim);
  }

  createClass(MicrosoftPasteShim, [{
    key: 'filter',
    value: function filter(html) {
      if (!html || !html.includes('schemas-microsoft-com')) {
        return html;
      }
      var defaultWordValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';

      var options = {
        paste_retain_style_properties: 'all',
        paste_data_images: true,
        paste_word_valid_elements: defaultWordValidElements + ',img[class|src|border=0|alt|title|hspace|vspace|width|height|align|name]'
      };

      return wordFilter(html, options);
    }
  }]);
  return MicrosoftPasteShim;
}();

var IE11Shim = function () {
  function IE11Shim() {
    classCallCheck(this, IE11Shim);
  }

  createClass(IE11Shim, [{
    key: 'filter',
    value: function filter(html) {
      // COMPAT: If given an empty string, IE11 will parse it as an HTML
      // Document without a body tag. This causes the serializer to
      // fail, since it calls `body.childNodes`. So, if we have an empty
      // string, pretend it's an empty body instead. This works
      // cross-browser, and also on the server side.
      if (!html || html === '') {
        html = '<body />';
      }

      return html;
    }
  }]);
  return IE11Shim;
}();

// Only include tableUtils, because we don't need slate-react and all
// that other stuff to serialize.
// Rules are functions that take (options, utils, context) from the
// serializer and return an Array of Slate serialization rules. Each
// ruleset inserted takes priority over all other rules, by default.
function defaultRules() {
  return new Rules().insertRules(dividerLineSerializers).insertRules(textSerializers).insertRules(annotationSerializers).insertRules(basicSerializers).insertRules(equationEditorSerializers).insertRules(blockSerializers).insertRules(infoBlockSerializers).insertRules(pillSerializers).insertRules(linkSerializers).insertRules(embedSerializers).insertRules(codeSerializers).insertRules(referenceSerializers).insertRules(imageSerializers).insertRules(videoSerializers).insertRules(audioSerializers).insertRules(tableSerializers).insertRules(listSerializers).insertRules(styleSerializers).insertRules(cleanupSerializers).insertRules(googleDocsSerializers).insertRules(proseMirrorSerializers);
}

function defaultHtmlFilters() {
  return [new IE11Shim(), new MicrosoftPasteShim()];
}

var Serializer = function () {
  function Serializer() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, Serializer);

    this.pluginOptions = {
      tableType: 'table',
      tableRowType: 'table-row',
      tableCellType: 'table-cell',
      enableFontSizeMark: options.enableFontSizeMark,
      enableFontFamilyMark: options.enableFontFamilyMark,
      preserveWhitespace: options.preserveWhitespace
    };

    this.context = {
      serializer: this
    };

    this.utils = {
      table: Utils(this.pluginOptions, { tableSelection: null }),
      alignment: AlignmentPlugin(this.pluginOptions).utils,
      link: linkUtils,
      color: utils
    };

    this.htmlFilters = defaultHtmlFilters();

    var rules = defaultRules();

    if (options.configure) {
      options.configure(rules);
    }

    this.htmlSerializer = new Html({
      parseHtml: options.parseHtml,
      rules: rules.resolve(this.pluginOptions, this.utils, this.context)
    });
  }

  createClass(Serializer, [{
    key: 'serialize',
    value: function serialize(valueOrJSON) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Slate.Value.isValue(valueOrJSON)) {
        valueOrJSON = new ValueMigrator(valueOrJSON).migrate();
      }

      var serializeOptions = options.serializeOptions,
          valueOptions = objectWithoutProperties(options, ['serializeOptions']);

      var value = Slate.Value.fromJSON(valueOrJSON, valueOptions);

      this.context.document = value.document;

      var result = this.htmlSerializer.serialize(value, serializeOptions);
      delete this.context.document;
      return result;
    }
  }, {
    key: 'deserialize',
    value: function deserialize(html, options) {
      options = options || {};
      var _options = options,
          toJSON = _options.toJSON;

      // preproces with our HTML filters,
      // these normalize non standard HTML like that
      // from MS Word

      this.htmlFilters.forEach(function (htmlFilter) {
        html = htmlFilter.filter(html);
      });

      var value = normalizeValueJSON(this.htmlSerializer.deserialize(html, _extends({}, options, {
        toJSON: true
      })));

      return toJSON ? value : new Slate.Editor({ value: Slate.Value.fromJSON(value) }).value;
    }
  }]);
  return Serializer;
}();

var instanceCount = 0;

var getPlugins = (function (options) {
  options = _extends({
    collaboration: {},
    image: {},
    video: {},
    audio: {},
    paste: {},
    serializer: {},
    table: {},
    link: {},
    color: {},
    fontFamily: {},
    fontSize: {},
    commandMenu: {},
    anchor: {}
  }, options);
  instanceCount += 1;

  var collaborationPlugin = CollaborationPlugin(options.collaboration);
  var collaborationPlugins = collaborationPlugin.plugins;

  // TODO: options.paste.configureSerializer is legacy. Change all
  // callers to not need it anymore, and remove it from these
  // configure options.
  var serializer = new Serializer(_extends({
    configure: options.serializer.configure || options.paste.configureSerializer
  }, options.serializer));

  // These should be re-initialized for every instance of the Slate editor
  var listPlugin = ListPlugin({
    types: ['ul_list', 'ol_list', 'checklist'],
    typeItem: 'list_item'
  });

  var tablePlugin = TablePlugin(_extends({
    menuIdentifier: 'table-menu-' + instanceCount,
    serializer: serializer
  }, options.table));

  var imagePlugin = ImagePlugin(options.image);
  var videoPlugin = VideoPlugin(options.video);
  var audioPlugin = AudioPlugin(options.audio);

  var linkPlugin = LinksPlugin(_extends({}, options.link));
  var embedPlugin = EmbedPlugin({ linkPlugin: linkPlugin });

  var alignmentPlugin = AlignmentPlugin();
  var alignmentUtils = alignmentPlugin.utils;

  var dropHtmlAttachmentPlugin = DropHtmlAttachments({
    imagePlugin: imagePlugin,
    linkPlugin: linkPlugin
  });

  var hasAnchor = options.anchor.enabled;

  var blockFormatPlugins = {
    paragraph: BlockFormatPlugin({
      title: 'Paragraph',
      type: 'paragraph',
      tag: 'p',
      clearFormattingAtEnd: false,
      alignmentUtils: alignmentUtils
    }),
    h1: BlockFormatPlugin({
      type: 'h1',
      title: 'Heading 1',
      hasAnchor: hasAnchor,
      baseUrl: options.anchor.baseUrl,
      alignmentUtils: alignmentUtils
    }),
    h2: BlockFormatPlugin({
      type: 'h2',
      title: 'Heading 2',
      hasAnchor: hasAnchor,
      baseUrl: options.anchor.baseUrl,
      alignmentUtils: alignmentUtils
    }),
    h3: BlockFormatPlugin({
      type: 'h3',
      title: 'Heading 3',
      hasAnchor: hasAnchor,
      baseUrl: options.anchor.baseUrl,
      alignmentUtils: alignmentUtils
    }),
    h4: BlockFormatPlugin({
      type: 'h4',
      title: 'Heading 4',
      hasAnchor: hasAnchor,
      baseUrl: options.anchor.baseUrl,
      alignmentUtils: alignmentUtils
    }),
    h5: BlockFormatPlugin({
      type: 'h5',
      title: 'Heading 5',
      hasAnchor: hasAnchor,
      baseUrl: options.anchor.baseUrl,
      alignmentUtils: alignmentUtils
    }),
    h6: BlockFormatPlugin({
      type: 'h6',
      title: 'Heading 6',
      hasAnchor: hasAnchor,
      baseUrl: options.anchor.baseUrl,
      alignmentUtils: alignmentUtils
    }),
    quote: BlockFormatPlugin({
      title: 'Quote',
      type: 'quote',
      tag: 'blockquote',
      exitOnBackspace: true,
      alignmentUtils: alignmentUtils
    })
  };

  var codeBlockPlugin = BlockFormatPlugin({
    title: 'Preformatted',
    type: 'code',
    tag: 'pre',
    isMultiline: true,
    allowTab: true,
    alignmentUtils: alignmentUtils
  });

  var infoBlockPlugin = InfoBlockPlugin({
    title: 'Information',
    type: 'infoBlock'
  });
  var noteBlockPlugin = InfoBlockPlugin({ title: 'Note', type: 'noteBlock' });
  var warningBlockPlugin = InfoBlockPlugin({
    title: 'Warning',
    type: 'warningBlock'
  });
  var tipBlockPlugin = InfoBlockPlugin({ title: 'Tip', type: 'tipBlock' });

  var colorFormattingPlugin = ColorFormattingPlugin(_extends({}, options.color));
  var clearFormattingPlugin = ClearFormattingPlugin();

  var dividerLinePlugin = DividerLinePlugin();

  var textColorAndHighlightPlugin = TextColorAndHighlightPlugin();
  var fontSizePlugin = FontSizePlugin(_extends({}, options.fontSize));
  var fontFamilyPlugin = FontFamilyPlugin(_extends({}, options.fontFamily));
  var lineHeightPlugin = LineHeightPlugin();
  var hotkeyOverridePlugin = HotkeyOverridePlugin();
  var tableOfContentsPlugin = TableOfContentsPlugin({
    toggleTableOfContentsVisibility: options.toggleTableOfContentsVisibility
  });

  var pastePlugin = PastePlugin({
    serializer: serializer,
    listPlugin: listPlugin,
    tablePlugin: tablePlugin,
    blockPlugins: _extends({}, blockFormatPlugins, { code: codeBlockPlugin }),
    pasteTransforms: options.pasteTransforms
  });

  var pasteMarkdownPlugin = options.paste.markdown ? PasteMarkdownPlugin() : { plugins: [] };

  var syntaxHighlightPlugin = SyntaxHighlightPlugin();

  var markdownPlugin = Markdown({
    listPlugin: listPlugin,
    linkPlugin: linkPlugin,
    blockFormatPlugins: _extends({}, blockFormatPlugins, { code: codeBlockPlugin })
  });

  var cloneEditorPlugin = CloneEditorPlugin({});

  var pillPlugin = PillPlugin();

  var convertNodesPlugin = convertNodesFromOtherEditors();
  var preserveMarksPlugin = PreserveMarksOnOverwritePlugin();
  var sortRangesPlugin = SortRangesPlugin();
  var annotationsPlugin = AnnotationsPlugin();
  var compositionPlugin = Composition();
  var grammarlyFixPlugin = GrammarlyFix();
  var serializationPlugin = SerializationPlugin({ serializer: serializer });
  var extrasPlugin = ExtrasPlugin();
  var basePlugin = BasePlugin();

  var commandMenuPlugin = options.commandMenu && options.commandMenu.enabled ? CommandMenuPlugin() : null;

  var plugins = [].concat(toConsumableArray(annotationsPlugin.plugins), toConsumableArray(cloneEditorPlugin.plugins), toConsumableArray(sortRangesPlugin.plugins), toConsumableArray(collaborationPlugins), toConsumableArray(markdownPlugin.plugins), toConsumableArray(syntaxHighlightPlugin.plugins), toConsumableArray(codeBlockPlugin.plugins), toConsumableArray(infoBlockPlugin.plugins), toConsumableArray(commandMenuPlugin ? commandMenuPlugin.plugins : []), toConsumableArray(noteBlockPlugin.plugins), toConsumableArray(warningBlockPlugin.plugins), toConsumableArray(tipBlockPlugin.plugins), toConsumableArray(listPlugin.plugins), toConsumableArray(flatMap(Object.values(blockFormatPlugins), function (plugin) {
    return plugin.plugins;
  })), toConsumableArray(tablePlugin.plugins), toConsumableArray(pillPlugin.plugins), toConsumableArray(imagePlugin.plugins), toConsumableArray(videoPlugin.plugins), toConsumableArray(audioPlugin.plugins), toConsumableArray(embedPlugin.plugins), toConsumableArray(linkPlugin.plugins), toConsumableArray(pasteMarkdownPlugin.plugins), toConsumableArray(pastePlugin.plugins), toConsumableArray(dropHtmlAttachmentPlugin.plugins), toConsumableArray(tableOfContentsPlugin.plugins), toConsumableArray(dividerLinePlugin.plugins), toConsumableArray(fontFamilyPlugin.plugins), toConsumableArray(fontSizePlugin.plugins), toConsumableArray(lineHeightPlugin.plugins), toConsumableArray(colorFormattingPlugin.plugins), toConsumableArray(textColorAndHighlightPlugin.plugins), toConsumableArray(convertNodesPlugin.plugins), toConsumableArray(preserveMarksPlugin.plugins), toConsumableArray(alignmentPlugin.plugins), toConsumableArray(compositionPlugin.plugins), toConsumableArray(grammarlyFixPlugin.plugins), toConsumableArray(serializationPlugin.plugins), toConsumableArray(extrasPlugin.plugins), toConsumableArray(basePlugin.plugins));

  return {
    plugins: plugins,
    listPlugin: listPlugin,
    tablePlugin: tablePlugin,
    collaborationPlugin: collaborationPlugin,
    pillPlugin: pillPlugin,
    imagePlugin: imagePlugin,
    videoPlugin: videoPlugin,
    audioPlugin: audioPlugin,
    linkPlugin: linkPlugin,
    embedPlugin: embedPlugin,
    dropHtmlAttachmentPlugin: dropHtmlAttachmentPlugin,
    blockFormatPlugins: _extends({}, blockFormatPlugins, { code: codeBlockPlugin }),
    alignmentPlugin: alignmentPlugin,
    colorFormattingPlugin: colorFormattingPlugin,
    textColorAndHighlightPlugin: textColorAndHighlightPlugin,
    fontFamilyPlugin: fontFamilyPlugin,
    fontSizePlugin: fontSizePlugin,
    lineHeightPlugin: lineHeightPlugin,
    hotkeyOverridePlugin: hotkeyOverridePlugin,
    commandMenuPlugin: commandMenuPlugin,
    clearFormattingPlugin: clearFormattingPlugin,
    dividerLinePlugin: dividerLinePlugin,
    markdownPlugin: markdownPlugin,
    tableOfContentsPlugin: tableOfContentsPlugin,
    infoBlockPlugin: infoBlockPlugin,
    noteBlockPlugin: noteBlockPlugin,
    warningBlockPlugin: warningBlockPlugin,
    tipBlockPlugin: tipBlockPlugin,
    cloneEditorPlugin: cloneEditorPlugin,
    syntaxHighlightPlugin: syntaxHighlightPlugin,
    codeBlockPlugin: codeBlockPlugin,
    pastePlugin: pastePlugin,
    convertNodesPlugin: convertNodesPlugin,
    preserveMarksPlugin: preserveMarksPlugin,
    extrasPlugin: extrasPlugin,
    basePlugin: basePlugin
  };
});

var emptyValue = {
  object: 'value',
  document: {
    data: {},
    object: 'document',
    nodes: [{
      object: 'block',
      type: 'paragraph',
      nodes: [{
        object: 'text',
        marks: [],
        text: ''
      }]
    }]
  }
};

var BlockToolbarItem = function (_React$PureComponent) {
  inherits(BlockToolbarItem, _React$PureComponent);

  function BlockToolbarItem() {
    classCallCheck(this, BlockToolbarItem);
    return possibleConstructorReturn(this, (BlockToolbarItem.__proto__ || Object.getPrototypeOf(BlockToolbarItem)).apply(this, arguments));
  }

  createClass(BlockToolbarItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClick = _props.onClick,
          hotkey = _props.hotkey,
          active = _props.active,
          plugin = _props.plugin,
          icon = _props.icon,
          className = _props.className;

      var clickHandler = function clickHandler() {
        trackToolbarAnalytics({
          eventName: 'User selects toolbar style',
          properties: { 'Style': plugin.title }
        });

        if (onClick) onClick.apply(undefined, arguments);
      };

      return React__default.createElement(
        ToolbarItem,
        {
          onClick: clickHandler,
          hotkey: hotkey,
          active: active,
          className: className
        },
        React__default.createElement(
          'span',
          { className: 'react-contextmenu-label' },
          icon && React__default.createElement('i', { className: icon }),
          React__default.createElement(
            'span',
            null,
            plugin.title
          )
        )
      );
    }
  }]);
  return BlockToolbarItem;
}(React__default.PureComponent);

var blockFormatToolbar = (function (plugins, toggleBlock, types) {
  return function (createChange) {
    return types.map(function (type) {
      var name = type.name,
          hotkey = type.hotkey,
          icon = type.icon;

      var plugin = plugins[name];
      return bindHotkey(hotkey, createChange, toggleBlock(plugin), function (onClick, hotkeyLabel$$1) {
        return function (_ref) {
          var editor = _ref.editor;

          var active = plugin.utils.inBlock(editor.value);
          return React__default.createElement(BlockToolbarItem, {
            plugin: plugin,
            active: active,
            hotkey: hotkeyLabel$$1,
            onClick: onClick,
            icon: icon
          });
        };
      }, { name: plugin.title + ' ' + type.name });
    });
  };
});

// Wraps toggleBlock, so that it applies to a table selection as
// well as a normal selection.
var toggleBlockOnTableFactory = (function (tablePlugin) {
  return function (plugin) {
    var toggleBlock = tablePlugin.utils.withCellSelection(plugin.changes.toggleBlock);

    var isBlock = tablePlugin.utils.onSelectedCells(plugin.utils.isBlock);

    return function (change) {
      var force = !isBlock(change);
      return change.command(toggleBlock, force);
    };
  };
});

function organizationToolbar(blockPlugins, pillPlugin, toggleBlock, performChange) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  options = _extends({
    tableOfContents: true,
    calloutBox: true,
    pill: true
  }, options);

  var blockPluginToolbarItem = function blockPluginToolbarItem(plugin, editor) {
    var iconValue = blockStyleMap[plugin.type];
    var iconContainerInlineStyle = {
      color: 'var(--theme-alert-' + iconValue.alertType + '-border)',
      backgroundColor: 'var(--theme-alert-' + iconValue.alertType + '-background)',
      borderColor: 'currentColor'
    };
    var onClick = function onClick() {
      trackToolbarAnalytics({
        eventName: 'User selects toolbar + menu',
        properties: { 'Toolbar + menu': 'Callout box' }
      });
      performChange(toggleBlock(plugin));
    };

    return React__default.createElement(
      ToolbarItem,
      {
        key: plugin.title,
        label: plugin.title,
        onClick: onClick,
        active: plugin.utils.inBlock(editor.value),
        className: 'aha-editor-toolbar--block-format-item'
      },
      React__default.createElement('i', {
        style: iconContainerInlineStyle,
        className: 'fa-regular fa-' + iconValue.icon + ' fa-fw aha-editor__block-icon'
      })
    );
  };

  var blockPluginToolbarItems = function blockPluginToolbarItems(plugins, editor) {
    return plugins.map(function (plugin) {
      return blockPluginToolbarItem(plugin, editor);
    });
  };

  var flatBlockPluginToolbarItems = function flatBlockPluginToolbarItems(plugins) {
    return plugins.map(function (plugin) {
      return {
        name: plugin.title,
        changeFunction: function changeFunction() {
          return performChange(toggleBlock(plugin));
        },
        item: function item(_ref) {
          var editor = _ref.editor;
          return blockPluginToolbarItem(plugin, editor);
        }
      };
    });
  };

  var items = [];

  if (options.tableOfContents) {
    items.push({
      name: 'Table of contents',
      changeFunction: function changeFunction(editor) {
        return editor.toggleTableOfContentsVisibility();
      },
      item: function item(_ref2) {
        var editor = _ref2.editor;
        return React__default.createElement(
          ToolbarItem,
          {
            key: 'table-of-contents',
            label: 'Table of contents',
            onClick: function onClick(event) {
              event.preventDefault();
              event.stopPropagation();
              trackToolbarAnalytics({
                eventName: 'User selects toolbar + menu',
                properties: { 'Toolbar + menu': 'Table of contents' }
              });
              editor.toggleTableOfContentsVisibility();
            },
            active: editor.tableOfContentsVisible()
          },
          React__default.createElement('i', { className: 'fa-regular fa-poll-h fa-fw' })
        );
      }
    });
  }

  if (options.pill) {
    items.push({
      name: 'Label',
      changeFunction: function changeFunction() {
        return performChange(pillPlugin.changes.togglePill);
      },
      item: function item(_ref3) {
        var editor = _ref3.editor;
        return React__default.createElement(
          ToolbarItem,
          {
            key: 'label-pill',
            label: 'Label',
            onClick: function onClick(event) {
              event.preventDefault();
              event.stopPropagation();
              trackToolbarAnalytics({
                eventName: 'User selects toolbar + menu',
                properties: { 'Toolbar + menu': 'Label' }
              });
              performChange(pillPlugin.changes.togglePill);
            },
            active: pillPlugin.utils.inPill(editor.value)
          },
          React__default.createElement(
            'i',
            { className: 'aha-editor__label-icon' },
            'L'
          )
        );
      }
    });
  }

  if (options.calloutBox) {
    if (options.flatten) {
      items.push.apply(items, toConsumableArray(flatBlockPluginToolbarItems(blockPlugins)));
    } else {
      items.push({
        name: 'Callout box',
        changeFunction: function changeFunction() {
          return performChange(toggleBlock(blockPlugins[0]));
        },
        item: function item(_ref4) {
          var editor = _ref4.editor;
          return React__default.createElement(
            ToolbarMenu,
            {
              icon: 'fa-regular fa-info-square fa-fw',
              label: 'Callout box',
              name: 'info-box'
            },
            blockPluginToolbarItems(blockPlugins, editor)
          );
        }
      });
    }
  }

  return items;
}

/** @typedef ToolbarProps
 * @prop {*} createChange
 */

/**
 * @param {ToolbarProps} props
 */
function BasicFormattingToolbarGroup(props, types) {
  // Value is unused, it's only here to break the memoize (because
  // editor doesn't change)
  var getActiveMarks = memoizeOne(function (editor, _value) {
    return editor.getActiveMarks();
  });

  return types.map(function (type) {
    return bindHotkey(type.hotkey, props.createChange, function (change) {
      return change.toggleMark(type.name);
    }, function (onClick, hotkeyLabel$$1) {
      return function (_ref) {
        var editor = _ref.editor;

        var clickHandler = function clickHandler() {
          trackToolbarAnalytics({
            eventName: 'User selects toolbar formatting',
            properties: { 'Formatting': type.label }
          });

          if (onClick) onClick.apply(undefined, arguments);
        };

        return React__default.createElement(
          ToolbarItem,
          {
            label: type.label,
            hotkey: hotkeyLabel$$1,
            onClick: clickHandler,
            active: getActiveMarks(editor, editor.value).some(function (mark) {
              return mark.type === type.name;
            })
          },
          React__default.createElement('i', { className: 'fa-regular fa-' + type.name + ' fa-fw' })
        );
      };
    });
  });
}

var clearFormattingToolbar = (function (changes) {
  return function (change) {
    return bindHotkey('mod+\\', change, changes.clearFormatting, function (onClick, hotkeyLabel$$1) {
      return function () {
        var clickHandler = function clickHandler() {
          trackToolbarAnalytics({
            eventName: 'User selects toolbar formatting',
            properties: { 'Formatting': 'Clear formatting' }
          });

          if (onClick) onClick.apply(undefined, arguments);
        };

        return React__default.createElement(
          ToolbarItem,
          {
            label: 'Clear styling',
            hotkey: hotkeyLabel$$1,
            onClick: clickHandler },
          React__default.createElement(
            'span',
            null,
            React__default.createElement('i', { className: 'fa-regular fa-eraser fa-fw' })
          )
        );
      };
    });
  };
});

var alignmentToolbar = (function (plugin) {
  return function (createChange) {
    var alignments = [{ name: 'left', label: 'Left align', hotkey: 'mod+shift+l' }, { name: 'center', label: 'Center align', hotkey: 'mod+shift+c' }, { name: 'right', label: 'Right align', hotkey: 'mod+shift+r' }, { name: 'justify', label: 'Justify', hotkey: 'mod+shift+j' }];

    var changeFunction = function changeFunction(alignment) {
      return function (change) {
        return change.setAlignment(alignment);
      };
    };

    // Value is unused, it's only here to break the memoize (because
    // editor doesn't change)
    var getActiveAlignment = memoizeOne(function (editor, _value) {
      return plugin.utils.getAlignment(editor);
    });

    return alignments.map(function (alignment) {
      return bindHotkey(alignment.hotkey, createChange, changeFunction(alignment.name), function (onClick, hotkeyLabel$$1) {
        return function (_ref) {
          var editor = _ref.editor;

          var clickHandler = function clickHandler() {
            trackToolbarAnalytics({
              eventName: 'User selects toolbar alignment',
              properties: { 'Alignment': alignment.label }
            });

            if (onClick) onClick.apply(undefined, arguments);
          };

          return React__default.createElement(
            ToolbarItem,
            {
              key: 'align-' + alignment.name,
              label: alignment.label,
              hotkey: hotkeyLabel$$1,
              onClick: clickHandler,
              active: getActiveAlignment(editor, editor.value) === alignment.name
            },
            React__default.createElement('i', { className: 'fa-regular fa-align-' + alignment.name + ' fa-fw' })
          );
        };
      });
    });
  };
});

var blockIcons = {
  paragraph: 'fa-regular fa-fw fa-paragraph',
  h1: 'fa-regular fa-fw fa-h1',
  h2: 'fa-regular fa-fw fa-h2',
  h3: 'fa-regular fa-fw fa-h3',
  h4: 'fa-regular fa-fw fa-h4',
  h5: 'fa-regular fa-fw fa-h5',
  h6: 'fa-regular fa-fw fa-h6',
  code: 'fa-regular fa-fw fa-rectangle-code',
  quote: 'fa-regular fa-fw fa-quote-right'
};

/**
 * @param {import('./types/aha-editor').AhaEditorComponent} ahaEditor
 * @param {import('./Configuration').Configuration} config
 * @param {object} options
 */
function configureStaticToolbar(ahaEditor, config) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ListToolbarGroup = ahaEditor.listPlugin.components.ListToolbarGroup;
  var TableToolbarGroup = ahaEditor.tablePlugin.components.TableToolbarGroup;
  var LinkToolbarItem = ahaEditor.linkPlugin.components.LinkToolbarItem;
  var DividerLineToolbarItem = ahaEditor.dividerLinePlugin.components.DividerLineToolbarItem;
  var _ahaEditor$textColorA = ahaEditor.textColorAndHighlightPlugin.components,
      TextColorToolbarGroup = _ahaEditor$textColorA.TextColorToolbarGroup,
      TextHighlightToolbarGroup = _ahaEditor$textColorA.TextHighlightToolbarGroup;
  var FontSizeToolbarGroup = ahaEditor.fontSizePlugin.components.FontSizeToolbarGroup;
  var FontToolbarGroup = ahaEditor.fontFamilyPlugin.components.FontToolbarGroup;
  var LineHeightToolbarGroup = ahaEditor.lineHeightPlugin.components.LineHeightToolbarGroup;
  var performChange = ahaEditor.performChange;


  config.insertToolbarGroup('blocks', {
    label: function label(_ref) {
      var editor = _ref.editor,
          compactToolbar = _ref.compactToolbar;

      var key = Object.keys(ahaEditor.blockFormatPlugins).find(function (key) {
        var plugin = ahaEditor.blockFormatPlugins[key];
        return plugin.utils.inBlock(editor.value);
      });
      if (key) {
        if (compactToolbar) {
          return React__default.createElement('i', { className: blockIcons[key] });
        }
        return ahaEditor.blockFormatPlugins[key].title;
      }
      if (compactToolbar) {
        return React__default.createElement('i', { className: blockIcons['paragraph'] });
      }
      return 'Paragraph';
    },
    ariaLabel: 'Font style',
    canExpand: false
  });

  config.insertToolbarGroup('formatting', {
    label: 'Formatting',
    icon: 'fa-regular fa-font',
    canCollapse: false,
    merge: 'formatting-extra',
    mergeToTop: true
  });

  config.insertToolbarGroup('formatting-extra', {
    label: 'Formatting',
    icon: 'fa-regular fa-font',
    canExpand: false
  });

  config.insertToolbarGroup('alignment', {
    label: 'Alignment',
    icon: 'fa-regular fa-align-left',
    canExpand: false
  });

  config.insertToolbarGroup('list', {
    label: 'List',
    icon: 'fa-regular fa-list-ul',
    canExpand: false
  });

  config.insertToolbarGroup('plus', {
    label: 'More',
    icon: 'fa-regular fa-plus',
    canExpand: false
  });

  config.insertToolbarItems(blockFormatToolbar(ahaEditor.blockFormatPlugins, toggleBlockOnTableFactory(ahaEditor.tablePlugin), [{
    name: 'paragraph',
    hotkey: 'mod+alt+p',
    icon: blockIcons['paragraph']
  }, { name: 'h1', hotkey: 'mod+alt+1', icon: blockIcons['h1'] }, { name: 'h2', hotkey: 'mod+alt+2', icon: blockIcons['h2'] }, { name: 'h3', hotkey: 'mod+alt+3', icon: blockIcons['h3'] }, { name: 'h4', hotkey: 'mod+alt+4', icon: blockIcons['h4'] }, { name: 'h5', hotkey: 'mod+alt+5', icon: blockIcons['h5'] }, { name: 'h6', hotkey: 'mod+alt+6', icon: blockIcons['h6'] }, {
    name: 'code',
    hotkey: 'mod+alt+/',
    icon: blockIcons['code']
  }, {
    name: 'quote',
    hotkey: "mod+alt+'",
    icon: blockIcons['quote']
  }])(performChange), { group: 'blocks' });

  config.insertToolbarItems(BasicFormattingToolbarGroup({
    createChange: performChange
  }, [{ name: 'bold', label: 'Bold', hotkey: 'mod+b' }, { name: 'italic', label: 'Italic', hotkey: 'mod+i' }, { name: 'underline', label: 'Underline', hotkey: 'mod+u' }]), {
    group: 'formatting'
  });

  config.insertToolbarItems(BasicFormattingToolbarGroup({
    createChange: performChange
  }, [{
    name: 'strikethrough',
    label: 'Strikethrough',
    hotkey: 'mod+shift+x'
  }, { name: 'code', label: 'Code snippet', hotkey: 'mod+/' }]), {
    group: 'formatting-extra'

  });

  var setTextColor = ahaEditor.tablePlugin.utils.withCellSelection(function (editor, color) {
    return editor.setTextColor(color);
  });

  var clearTextColor = ahaEditor.tablePlugin.utils.withCellSelection(function (editor) {
    return editor.clearTextColor();
  });

  var getCurrentTextColor = ahaEditor.tablePlugin.utils.onSelectedCells(function (editor) {
    return editor.getCurrentTextColor();
  });

  var setTextHighlight = ahaEditor.tablePlugin.utils.withCellSelection(function (editor, color) {
    return editor.setTextHighlight(color);
  });

  var clearTextHighlight = ahaEditor.tablePlugin.utils.withCellSelection(function (editor) {
    return editor.clearTextHighlight();
  });

  var getCurrentTextHighlight = ahaEditor.tablePlugin.utils.onSelectedCells(function (editor) {
    return editor.getCurrentTextHighlight();
  });

  config.insertToolbarItems(TextColorToolbarGroup({
    setTextColor: setTextColor,
    clearTextColor: clearTextColor,
    getCurrentTextColor: getCurrentTextColor
  })(performChange), { group: 'formatting-extra' });

  config.insertToolbarItems(TextHighlightToolbarGroup({
    setTextHighlight: setTextHighlight,
    clearTextHighlight: clearTextHighlight,
    getCurrentTextHighlight: getCurrentTextHighlight
  })(performChange), { group: 'formatting-extra' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'formatting-extra'
  });

  config.insertToolbarItems(FontToolbarGroup({
    fonts: ahaEditor.fontFamilyPlugin.fonts
  })(performChange), { group: 'formatting-extra' });

  config.insertToolbarItems(FontSizeToolbarGroup({
    fontSizes: ahaEditor.fontSizePlugin.fontSizes
  })(performChange), { group: 'formatting-extra' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'formatting-extra'
  });

  var clearFormatting = ahaEditor.tablePlugin.utils.withCellSelection(ahaEditor.clearFormattingPlugin.changes.clearFormatting);

  config.insertToolbarItem(clearFormattingToolbar({ clearFormatting: clearFormatting })(performChange), {
    group: 'formatting-extra'
  });

  var getAlignment = ahaEditor.tablePlugin.utils.onSelectedCells(ahaEditor.alignmentPlugin.utils.getAlignment);

  config.insertToolbarItems(alignmentToolbar({
    utils: { getAlignment: getAlignment }
  })(performChange), { group: 'alignment' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'alignment'
  });

  config.insertToolbarItems(LineHeightToolbarGroup()(performChange), { group: 'alignment' });

  config.insertToolbarItems(ListToolbarGroup({
    plugin: ahaEditor.listPlugin,
    change: performChange,
    wrappingEnabled: function wrappingEnabled(value) {
      return !ahaEditor.tablePlugin.utils.hasActiveTableSelection(value);
    }
  }), { group: 'list' });

  config.insertToolbarItem(LinkToolbarItem(performChange), {
    group: 'plus'
  });

  config.insertToolbarItem({
    item: function item(_ref2) {
      var editor = _ref2.editor;
      return React__default.createElement(TableToolbarGroup, {
        plugin: ahaEditor.tablePlugin,
        change: performChange,
        value: editor.value
      });
    }
  }, { group: 'plus' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'plus'
  });

  if (options.tableOfContentsEnabled) {
    config.insertToolbarItems(organizationToolbar([ahaEditor.infoBlockPlugin, ahaEditor.noteBlockPlugin, ahaEditor.warningBlockPlugin, ahaEditor.tipBlockPlugin], ahaEditor.pillPlugin, toggleBlockOnTableFactory(ahaEditor.tablePlugin), performChange), {
      group: 'plus'
    });
  }

  config.insertToolbarItem(DividerLineToolbarItem(performChange), {
    group: 'plus'
  });
}

/**
 * @param {import('./types/aha-editor').AhaEditorComponent} ahaEditor
 * @param {import('./Configuration').Configuration} config
 * @param {object} options
 */
function configureSelectionBasedToolbar(ahaEditor, config) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _ahaEditor$listPlugin = ahaEditor.listPlugin.components,
      ListCreateToolbarGroup = _ahaEditor$listPlugin.ListCreateToolbarGroup,
      ListIndentToolbarGroup = _ahaEditor$listPlugin.ListIndentToolbarGroup;
  var LinkToolbarItem = ahaEditor.linkPlugin.components.LinkToolbarItem;
  var ColorToolbarGroup = ahaEditor.colorFormattingPlugin.components.ColorToolbarGroup;
  var performChange = ahaEditor.performChange;

  /* Floating toolbar */

  config.insertToolbarGroup('blocks', {
    label: function label(_ref3) {
      var editor = _ref3.editor;

      var key = Object.keys(ahaEditor.blockFormatPlugins).find(function (key) {
        var plugin = ahaEditor.blockFormatPlugins[key];
        return plugin.utils.inBlock(editor.value);
      });
      if (key) {
        return ahaEditor.blockFormatPlugins[key].title;
      }
      return 'Paragraph';
    },
    ariaLabel: 'Font style',
    title: 'Turn into',
    canExpand: false
  });

  config.insertToolbarGroup('formatting-common', {
    label: 'Common Formatting',
    icon: 'fa-regular fa-font',
    priority: 4,
    canCollapse: false
  });

  config.insertToolbarGroup('formatting', {
    label: 'Formatting',
    icon: 'fa-regular fa-font',
    priority: 3
  });

  config.insertToolbarGroup('alignment', {
    label: 'Alignment',
    icon: 'fa-regular fa-align-left',
    canExpand: false
  });

  config.insertToolbarGroup('insert', {
    label: 'Insert',
    icon: 'fa-regular fa-link',
    canCollapse: false
  });

  config.insertToolbarItems(blockFormatToolbar(ahaEditor.blockFormatPlugins, toggleBlockOnTableFactory(ahaEditor.tablePlugin), [{
    name: 'paragraph',
    hotkey: 'mod+alt+p',
    icon: blockIcons['paragraph']
  }, { name: 'h1', hotkey: 'mod+alt+1', icon: blockIcons['h1'] }, { name: 'h2', hotkey: 'mod+alt+2', icon: blockIcons['h2'] }, { name: 'h3', hotkey: 'mod+alt+3', icon: blockIcons['h3'] }, { name: 'h4', hotkey: 'mod+alt+4', icon: blockIcons['h4'] }, { name: 'h5', hotkey: 'mod+alt+5', icon: blockIcons['h5'] }, { name: 'h6', hotkey: 'mod+alt+6', icon: blockIcons['h6'] }])(performChange), { group: 'blocks' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'blocks'
  });

  config.insertToolbarItems(ListCreateToolbarGroup({
    plugin: ahaEditor.listPlugin,
    change: performChange,
    wrappingEnabled: function wrappingEnabled(value) {
      return !ahaEditor.tablePlugin.utils.hasActiveTableSelection(value);
    }
  }), { group: 'blocks' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'blocks'
  });

  config.insertToolbarItems(blockFormatToolbar(ahaEditor.blockFormatPlugins, toggleBlockOnTableFactory(ahaEditor.tablePlugin), [{
    name: 'code',
    hotkey: 'mod+alt+/',
    icon: 'fa-regular fa-fw fa-rectangle-code'
  }, {
    name: 'quote',
    hotkey: "mod+alt+'",
    icon: 'fa-regular fa-fw fa-quote-right'
  }])(performChange), { group: 'blocks' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'blocks'
  });

  if (options.tableOfContentsEnabled) {
    config.insertToolbarItems(organizationToolbar([ahaEditor.infoBlockPlugin, ahaEditor.noteBlockPlugin, ahaEditor.warningBlockPlugin, ahaEditor.tipBlockPlugin], ahaEditor.pillPlugin, toggleBlockOnTableFactory(ahaEditor.tablePlugin), performChange, { tableOfContents: false }), {
      group: 'blocks'
    });
  }

  config.insertToolbarItems(BasicFormattingToolbarGroup({
    createChange: performChange
  }, [{ name: 'bold', label: 'Bold', hotkey: 'mod+b' }, { name: 'italic', label: 'Italic', hotkey: 'mod+i' }]), {
    group: 'formatting-common'
  });

  config.insertToolbarItems(BasicFormattingToolbarGroup({
    createChange: performChange
  }, [{ name: 'underline', label: 'Underline', hotkey: 'mod+u' }, {
    name: 'strikethrough',
    label: 'Strikethrough',
    hotkey: 'mod+shift+x'
  }, { name: 'code', label: 'Code snippet', hotkey: 'mod+/' }]), {
    group: 'formatting'
  });

  var isSameColor = ahaEditor.colorFormattingPlugin.utils.isSameColor;


  var setColor = ahaEditor.tablePlugin.utils.withCellSelection(ahaEditor.colorFormattingPlugin.changes.setColor);

  var clearColor = ahaEditor.tablePlugin.utils.withCellSelection(ahaEditor.colorFormattingPlugin.changes.clearColor);

  var getCurrentColor = ahaEditor.tablePlugin.utils.onSelectedCells(ahaEditor.colorFormattingPlugin.utils.getCurrentColor);

  config.insertToolbarItems(ColorToolbarGroup({
    utils: { getCurrentColor: getCurrentColor, isSameColor: isSameColor },
    changes: { setColor: setColor, clearColor: clearColor },
    colors: ahaEditor.colorFormattingPlugin.colors
  })(performChange), { group: 'formatting' });

  var clearFormatting = ahaEditor.tablePlugin.utils.withCellSelection(ahaEditor.clearFormattingPlugin.changes.clearFormatting);
  config.insertToolbarItem(clearFormattingToolbar({ clearFormatting: clearFormatting })(performChange), {
    group: 'formatting'
  });

  var getAlignment = ahaEditor.tablePlugin.utils.onSelectedCells(ahaEditor.alignmentPlugin.utils.getAlignment);

  config.insertToolbarItems(alignmentToolbar({
    utils: { getAlignment: getAlignment }
  })(performChange), { group: 'alignment' });

  config.insertToolbarItem({ item: function item() {
      return React__default.createElement(ToolbarItem, { divider: true });
    } }, {
    group: 'alignment'
  });

  config.insertToolbarItems(ListIndentToolbarGroup({
    plugin: ahaEditor.listPlugin,
    change: performChange
  }), { group: 'alignment' });

  config.insertToolbarItem(LinkToolbarItem(performChange), { group: 'insert' });
}

/**
 * @param {import('./types/aha-editor').AhaEditorComponent} ahaEditor
 * @param {import('./Configuration').Configuration} config
 * @param {object} options
 */
function configureCommandMenu(ahaEditor, config, options) {
  var ListCreateToolbarGroup = ahaEditor.listPlugin.components.ListCreateToolbarGroup;
  var DividerLineToolbarItem = ahaEditor.dividerLinePlugin.components.DividerLineToolbarItem;
  var LinkToolbarItem = ahaEditor.linkPlugin.components.LinkToolbarItem;

  // /* Command menu */

  if (ahaEditor.commandMenuPlugin) {
    var onCommandSelected = ahaEditor.commandMenuPlugin.onCommandSelected;

    var handleCommand = function handleCommand(command) {
      return ahaEditor.editor && onCommandSelected(ahaEditor.editor, command);
    };

    config.insertCommandItems(blockFormatToolbar(ahaEditor.blockFormatPlugins, toggleBlockOnTableFactory(ahaEditor.tablePlugin), [{ name: 'h1', hotkey: 'mod+alt+1', icon: blockIcons['h1'] }, { name: 'h2', hotkey: 'mod+alt+2', icon: blockIcons['h2'] }, { name: 'h3', hotkey: 'mod+alt+3', icon: blockIcons['h3'] }, { name: 'h4', hotkey: 'mod+alt+4', icon: blockIcons['h4'] }, { name: 'h5', hotkey: 'mod+alt+5', icon: blockIcons['h5'] }, { name: 'h6', hotkey: 'mod+alt+6', icon: blockIcons['h6'] }])(handleCommand), { group: 'headings' });

    config.insertCommandItems(ListCreateToolbarGroup({
      plugin: ahaEditor.listPlugin,
      change: handleCommand,
      wrappingEnabled: function wrappingEnabled(value) {
        return !ahaEditor.tablePlugin.utils.hasActiveTableSelection(value);
      }
    }), { group: 'list' });

    config.insertCommandItems(blockFormatToolbar(ahaEditor.blockFormatPlugins, toggleBlockOnTableFactory(ahaEditor.tablePlugin), [{
      name: 'code',
      hotkey: 'mod+alt+/',
      icon: 'fa-regular fa-fw fa-rectangle-code'
    }, {
      name: 'quote',
      hotkey: "mod+alt+'",
      icon: 'fa-regular fa-fw fa-quote-right'
    }])(handleCommand), { group: 'blocks' });

    config.insertCommandItem(LinkToolbarItem(handleCommand), {
      group: 'insert'
    });

    config.insertCommandItem({
      name: 'Table',
      enabled: function enabled(editor) {
        return !ahaEditor.tablePlugin.utils.getClosestTableByKey(editor.value.document, editor.value.selection.start.key);
      },
      changeFunction: function changeFunction(editor) {
        editor.call(ahaEditor.tablePlugin.changes.insertTable, 2, 2);
      },
      item: function item(_ref4) {
        var editor = _ref4.editor;
        return React__default.createElement(
          ToolbarItem,
          {
            label: 'Table',
            onClick: function onClick(event) {
              event.preventDefault();
              event.stopPropagation();
              handleCommand(function (editor) {
                return editor.call(ahaEditor.tablePlugin.changes.insertTable, 2, 2);
              });
            }
          },
          React__default.createElement('i', { className: 'fa-regular fa-table fa-fw' })
        );
      }
    }, { group: 'insert' });

    if (options.tableOfContentsEnabled) {
      config.insertCommandItems(organizationToolbar([ahaEditor.infoBlockPlugin, ahaEditor.noteBlockPlugin, ahaEditor.warningBlockPlugin, ahaEditor.tipBlockPlugin], ahaEditor.pillPlugin, toggleBlockOnTableFactory(ahaEditor.tablePlugin), handleCommand, { flatten: true }), {
        group: 'plus'
      });
    }

    config.insertCommandItem(DividerLineToolbarItem(handleCommand), {
      group: 'plus'
    });
  }
}

/**
 * @param {import('./types/aha-editor').AhaEditorComponent} ahaEditor
 * @param {import('./Configuration').Configuration} config
 * @param {object} options
 */
function configureToolbar(ahaEditor, config) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (options.useSelectionBasedToolbar) {
    configureSelectionBasedToolbar(ahaEditor, config, options);
  } else {
    configureStaticToolbar(ahaEditor, config, options);
  }

  if (options.commandMenu.enabled) {
    configureCommandMenu(ahaEditor, config, options);
  }
}

var TYPING_OPERATIONS = ['insert_text', 'remove_text'];

/**
 * @type {import('./types/aha-editor').AhaEditorComponent}
 */

var AhaEditor = function (_React$Component) {
  inherits(AhaEditor, _React$Component);

  /** @param {import('./types/aha-editor').AhaEditorProps} props */
  function AhaEditor(props) {
    classCallCheck(this, AhaEditor);

    var _this = possibleConstructorReturn(this, (AhaEditor.__proto__ || Object.getPrototypeOf(AhaEditor)).call(this, props));

    _initialiseProps$1.call(_this);

    var _props$pluginOptions = props.pluginOptions,
        pluginOptions = _props$pluginOptions === undefined ? {} : _props$pluginOptions;


    pluginOptions.toggleTableOfContentsVisibility = _this.toggleTableOfContentsVisibility;

    _this.configurePlugins(_this.configuration, pluginOptions);
    configureToolbar(_this, _this.configuration, {
      compact: _this.props.toolbarOptions && _this.props.toolbarOptions.compact,
      useSelectionBasedToolbar: _this.props.useSelectionBasedToolbar,
      tableOfContentsEnabled: _this.props.tableOfContentsEnabled,
      commandMenu: pluginOptions.commandMenu || { enabled: false }
    });

    _this.state = {
      spellCheck: true
    };

    _this.debouncedSpellcheck = debounce(function (spellCheck) {
      return _this.setState({ spellCheck: spellCheck });
    }, 300);

    if (_this.props.configure) {
      _this.props.configure(_this.configuration, _this);
    }

    if (_this.commandMenuPlugin) {
      _this.commandMenuPlugin.setConfiguration(_this.configuration);
    }
    return _this;
  }

  createClass(AhaEditor, [{
    key: 'loadCollaborativeDocument',
    value: function loadCollaborativeDocument() {
      this.collaborativeDocument = this.collaborationPlugin.openDocument(this.props.documentCollection, this.props.documentId, this.migratedValue, this.props.documentVersion, this.createEditor, this.props.onDocumentStateChange, this.updateState);

      this.collaborativeDocument.setUserInfo(this.props.userInfo);
    }
  }, {
    key: 'openCollaborativeDocument',
    value: function openCollaborativeDocument() {
      if (!this.collaborativeDocument) {
        this.loadCollaborativeDocument();
      }
      this.collaborationPlugin.connectDocument(this.collaborativeDocument);
    }
  }, {
    key: 'reloadCollaborativeDocument',
    value: function reloadCollaborativeDocument() {
      var _this2 = this;

      this.closeCollaborativeDocument(function () {
        _this2.openCollaborativeDocument();
      });
    }
  }, {
    key: 'closeCollaborativeDocument',
    value: function closeCollaborativeDocument(callback) {
      this.collaborationPlugin.closeDocument(this.collaborativeDocument, function () {
        if (callback) callback();
      });
      this.collaborativeDocument = null;
    }
  }, {
    key: 'browserRangeAtPoint',
    value: function browserRangeAtPoint(x, y) {
      if (window.document.caretRangeFromPoint) {
        return window.document.caretRangeFromPoint(x, y);
      } else if (window.document.caretPositionFromPoint) {
        var position = window.document.caretPositionFromPoint(x, y);
        var native = window.document.createRange();
        native.setStart(position.offsetNode, position.offset);
        native.setEnd(position.offsetNode, position.offset);
        return native;
      } else {
        // COMPAT: IE 11
        var _native = document.body.createTextRange();
        try {
          _native.moveToPoint(x, y);
        } catch (error) {
          // IE11 will raise an `unspecified error` sometimes. It
          // doesn't affect our cursor position, so ignore it.
        }
        return _native;
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.editor.focus();
    }

    /**
     * Focus the editor at the browser point X, Y. Useful for manually
     * setting selection based on a mouse click.
     */

  }, {
    key: 'focusOnPoint',
    value: function focusOnPoint(x, y) {
      var _this3 = this;

      // Give the editor time to sync up with the native selection
      // before we adjust it
      setTimeout(function () {
        return _this3.focusOnPointImmediately(x, y);
      }, 150);
    }

    /**
     * Focus the editor at the browser point X, Y immediately.
     */

  }, {
    key: 'focusOnPointImmediately',
    value: function focusOnPointImmediately(x, y) {
      var selection = this.browserRangeAtPoint(x, y);
      var range = this.editor.findRange(selection);

      if (range) {
        this.editor.select(range);
      }
      this.editor.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.editor.blur();
    }

    /**
     * Normalizes a Slate Value using the current editor's schema.
     * @param {Value} value
     * @return {Value}
     */

  }, {
    key: 'normalize',
    value: function normalize(value) {
      value = this.valueOrInitialValue(value);

      var editor = this.createEditor({ value: value }, { normalize: false });
      editor.withoutSaving(function (editor) {
        return editor.normalize();
      });
      return editor.value;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isCollaborative) {
        this.collaborationPlugin.init();
        if (this.props.deferCollaboration) {
          this.loadCollaborativeDocument();
        } else {
          this.openCollaborativeDocument();
        }
      }
    }
  }, {
    key: 'valueWasForceReset',
    value: function valueWasForceReset(prevProps) {
      if (!this.isCollaborative) return false;

      // If we don't have a collaborative document yet, we don't care
      // that the value was force reset. There's no danger in resetting
      // the value, since our only concern is getting the collaborative
      // value out of sync and missing operations.
      if (!this.collaborativeDocument) return false;

      var document = this.props.value ? this.props.value.document : null;
      var prevDocument = prevProps.value ? prevProps.value.document : null;
      var collaborativeDocument = this.collaborativeDocument && this.collaborativeDocument.value ? this.collaborativeDocument.value.document : null;

      return document !== prevDocument && document !== collaborativeDocument;
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(prevProps, prevState) {
      if (prevState === this.state && shallowCompare(prevProps, this.props)) {
        return false;
      }
      return true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.valueWasForceReset(prevProps)) {
        // We could have missed operations, so we need to re-initialize
        // the collaborative document from the new state.
        console.info('Value was force reset. Reloading...');
        this.reloadCollaborativeDocument();
      }
      if (this.collaborativeDocument && this.props.userInfo !== prevProps.userInfo) {
        this.collaborativeDocument.setUserInfo(this.props.userInfo);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.collaborativeDocument) {
        this.closeCollaborativeDocument();
      }
    }
  }, {
    key: 'createMigratedValueJSON',
    value: function createMigratedValueJSON(value) {
      return Slate.Value.fromJSON(new ValueMigrator(value).migrate());
    }
  }, {
    key: 'valueOrInitialValue',
    value: function valueOrInitialValue(value) {
      if (!value) return Slate.Value.fromJSON(emptyValue);

      if (!Slate.Value.isValue(value)) {
        // This could be expensive, but should only be called once per
        // value change. That's because the editor will attach the
        // schema, call normalize() and onChange with the new value, and
        // our parent component will pass the new, real value back through.
        return this.createMigratedValueJSON(value);
      } else {
        return value;
      }
    }

    // Sometimes, toolbar items need to trigger a change, but they don't
    // have a reference to the editor. They can use this function
    // instead to trigger a change on this editor.
    //
    // We can't just pass this.editor.change downward, because
    // this.editor might be invalid at render time. Instead, we want to
    // evaluate this.editor at the time we trigger the change.

  }, {
    key: 'configurePlugins',
    value: function configurePlugins(configuration, options) {
      var _getPlugins = getPlugins(options),
          plugins = _getPlugins.plugins,
          listPlugin = _getPlugins.listPlugin,
          tablePlugin = _getPlugins.tablePlugin,
          collaborationPlugin = _getPlugins.collaborationPlugin,
          imagePlugin = _getPlugins.imagePlugin,
          videoPlugin = _getPlugins.videoPlugin,
          audioPlugin = _getPlugins.audioPlugin,
          embedPlugin = _getPlugins.embedPlugin,
          linkPlugin = _getPlugins.linkPlugin,
          dropHtmlAttachmentPlugin = _getPlugins.dropHtmlAttachmentPlugin,
          alignmentPlugin = _getPlugins.alignmentPlugin,
          commandMenuPlugin = _getPlugins.commandMenuPlugin,
          fontSizePlugin = _getPlugins.fontSizePlugin,
          fontFamilyPlugin = _getPlugins.fontFamilyPlugin,
          lineHeightPlugin = _getPlugins.lineHeightPlugin,
          colorFormattingPlugin = _getPlugins.colorFormattingPlugin,
          textColorAndHighlightPlugin = _getPlugins.textColorAndHighlightPlugin,
          clearFormattingPlugin = _getPlugins.clearFormattingPlugin,
          dividerLinePlugin = _getPlugins.dividerLinePlugin,
          blockFormatPlugins = _getPlugins.blockFormatPlugins,
          tableOfContentsPlugin = _getPlugins.tableOfContentsPlugin,
          infoBlockPlugin = _getPlugins.infoBlockPlugin,
          noteBlockPlugin = _getPlugins.noteBlockPlugin,
          warningBlockPlugin = _getPlugins.warningBlockPlugin,
          tipBlockPlugin = _getPlugins.tipBlockPlugin,
          pillPlugin = _getPlugins.pillPlugin;

      configuration.insertPlugins(plugins);

      this.listPlugin = listPlugin;
      this.tablePlugin = tablePlugin;
      this.embedPlugin = embedPlugin;
      this.linkPlugin = linkPlugin;
      this.collaborationPlugin = collaborationPlugin;
      this.imagePlugin = imagePlugin;
      this.videoPlugin = videoPlugin;
      this.audioPlugin = audioPlugin;
      this.dropHtmlAttachmentPlugin = dropHtmlAttachmentPlugin;
      this.alignmentPlugin = alignmentPlugin;
      this.fontSizePlugin = fontSizePlugin;
      this.fontFamilyPlugin = fontFamilyPlugin;
      this.lineHeightPlugin = lineHeightPlugin;
      this.colorFormattingPlugin = colorFormattingPlugin;
      this.textColorAndHighlightPlugin = textColorAndHighlightPlugin;
      this.commandMenuPlugin = commandMenuPlugin;
      this.clearFormattingPlugin = clearFormattingPlugin;
      this.dividerLinePlugin = dividerLinePlugin;
      this.blockFormatPlugins = blockFormatPlugins;
      this.tableOfContentsPlugin = tableOfContentsPlugin;
      this.infoBlockPlugin = infoBlockPlugin;
      this.noteBlockPlugin = noteBlockPlugin;
      this.warningBlockPlugin = warningBlockPlugin;
      this.tipBlockPlugin = tipBlockPlugin;
      this.pillPlugin = pillPlugin;

      if (this.props.placeholderText) {
        configuration.insertPlugins([PlaceholderPlugin({ placeholder: this.props.placeholderText })]);
      }

      // This plugin needs to run before any other plugin that could call
      // onChange, because it should block any effect from happening
      // if it rejects a change. Hence alwaysBefore: true
      configuration.insertPlugins(AnnotateOnlyPlugin({ isModifiable: this.isModifiable }).plugins, {
        alwaysBefore: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var value = this.props.value;


      value = this.valueOrInitialValue(value);

      var passthroughProps = removeUndefined({
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        autoFocus: this.props.autoFocus,
        readOnly: this.props.readOnly
      });

      return React__default.createElement(slateReact.Editor, _extends({
        className: 'aha-editor-body',
        plugins: this.configuration.plugins,
        value: value,
        onChange: this.onChange,
        renderMark: this.renderMark,
        renderEditor: this.renderEditor
      }, passthroughProps, {
        ref: function ref(_ref) {
          _this4.editor = _ref;
        },
        spellCheck: this.state.spellCheck
      }));
    }
  }, {
    key: 'isCollaborative',
    get: function get$$1() {
      return this.props.collaborative && this.collaborationPlugin;
    }
  }, {
    key: 'migratedValue',
    get: function get$$1() {
      return this.normalize(this.valueOrInitialValue(this.props.value));
    }
  }]);
  return AhaEditor;
}(React__default.Component);

AhaEditor.propTypes = {
  value: PropTypes.object,
  placeholderText: PropTypes.string,
  userInfo: PropTypes.object,
  collaborative: PropTypes.bool,
  deferCollaboration: PropTypes.bool,
  documentCollection: PropTypes.string,
  documentId: PropTypes.string,
  documentVersion: PropTypes.number,
  autoFocus: PropTypes.bool,
  readOnly: PropTypes.bool,
  popupBoundaries: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  pluginOptions: PropTypes.object,
  configure: PropTypes.func,
  toolbarOptions: PropTypes.object,
  showTableOfContents: PropTypes.bool,
  tableOfContentsEnabled: PropTypes.bool,
  useSelectionBasedToolbar: PropTypes.bool
};

AhaEditor.valueJSON = function (value) {
  if (!Slate.Value.isValue(value)) return JSON.stringify(value);

  var _value = value,
      annotations = _value.annotations;


  if (annotations) {
    annotations = annotations.filterNot(function (a) {
      return a.key.startsWith('_local');
    });
    value = value.set('annotations', annotations);
  }

  return JSON.stringify(value.toJS({ preserveAnnotations: true }));
};

AhaEditor.isValue = function (value) {
  return Slate.Value.isValue(value);
};

AhaEditor.valueFromJSON = function (json) {
  return Slate.Value.fromJSON(new ValueMigrator(json).migrate());
};

var _initialiseProps$1 = function _initialiseProps() {
  var _this5 = this;

  this.editor = null;
  this.collaborativeDocument = null;
  this.configuration = new Configuration();

  this.createEditor = function () {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return createStubbedEditor(_this5.configuration.plugins, attrs, options);
  };

  this.renderMark = function (props, editor, next) {
    var children = props.children,
        mark = props.mark,
        marks = props.marks,
        attributes = props.attributes;

    switch (mark.type) {
      case 'bold':
        return React__default.createElement(
          'strong',
          attributes,
          children
        );
      case 'italic':
        return React__default.createElement(
          'em',
          attributes,
          children
        );
      case 'underline':
        return React__default.createElement(
          'u',
          attributes,
          children
        );
      case 'strikethrough':
        {
          var style = {};
          // If there is a sibling fontSize mark, we need to apply it here
          // to ensure the strikethrough is at the correct height for the size.
          marks.forEach(function (siblingMark) {
            if (siblingMark.type === 'fontSize') {
              style.fontSize = siblingMark.data.get('fontSize');
            }
          });
          return React__default.createElement(
            'del',
            _extends({ style: style }, attributes),
            children
          );
        }
      case 'code':
        return React__default.createElement(
          'code',
          attributes,
          children
        );
      case 'highlight':
        // Retired, support Aha Editor documents from 6/2018-2/2019
        return React__default.createElement(
          'span',
          _extends({ style: { backgroundColor: '#FFFF9D' } }, attributes),
          children
        );
      default:
    }
    return next();
  };

  this.maybeToggleSpellCheck = function (_ref2) {
    var operations = _ref2.operations;

    // Make sure we can inspect the operations, otherwise don't do anything
    if (!operations || !operations.last) {
      return;
    }

    var lastOperation = operations.last();
    var isTyping = lastOperation && TYPING_OPERATIONS.includes(lastOperation.type);
    if (!isTyping) return;

    _this5.setState({ spellCheck: false });
    _this5.debouncedSpellcheck(true);
  };

  this.onChange = function (change) {
    _this5.maybeToggleSpellCheck(change);

    if (_this5.isCollaborative) {
      _this5.collaborationPlugin.changes.apply(_this5.collaborativeDocument, change);
    } else {
      _this5.updateState(change.value, _this5.props.documentVersion, _this5.props.selections);
    }
  };

  this.updateState = function (value, version, selections) {
    if (_this5.props.onChange) _this5.props.onChange(value, version, selections);
  };

  this.isModifiable = function () {
    return !(_this5.props.annotateOnly || _this5.props.readOnly);
  };

  this.toggleTableOfContentsVisibility = function (editor) {
    var document = editor.value.document;
    var newData = {
      data: document.data.merge({
        tableOfContentsVisible: !editor.tableOfContentsVisible(editor)
      })
    };

    editor.setNodeByKey(document.key, newData);
  };

  this.performChange = function (changeFunction) {
    var _editor;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (_editor = _this5.editor).command.apply(_editor, [changeFunction].concat(args));
  };

  this.renderEditor = function (props, editor, next) {
    var _props = _this5.props,
        selections = _props.selections,
        useSelectionBasedToolbar = _props.useSelectionBasedToolbar;
    var Selections = _this5.collaborationPlugin.components.Selections;

    var toolbarOptions = _this5.props.toolbarOptions || {};

    return React__default.createElement(
      'div',
      { className: 'aha-editor' },
      renderIf(!toolbarOptions.hidden && !useSelectionBasedToolbar)(function () {
        return React__default.createElement(
          Anchor,
          { toolbarOffset: toolbarOptions.offset },
          React__default.createElement(Toolbar, {
            className: 'aha-editor-toolbar',
            groupClassName: 'aha-editor__toolbar-group',
            config: _this5.configuration,
            popupBoundaries: _this5.props.popupBoundaries,
            editor: editor,
            value: editor.value,
            readOnly: _this5.props.readOnly || _this5.props.annotateOnly,
            compactAtWidth: toolbarOptions.compactAtWidth
          })
        );
      }),
      renderIf(!toolbarOptions.hidden && useSelectionBasedToolbar)(function () {
        return React__default.createElement(SelectionBasedToolbar, {
          className: 'aha-editor-toolbar aha-editor-toolbar--selection-based',
          groupClassName: 'aha-editor__toolbar-group aha-editor__toolbar-group--selection-based',
          config: _this5.configuration,
          popupBoundaries: _this5.props.popupBoundaries,
          editor: editor,
          selection: editor.value.selection,
          readOnly: _this5.props.readOnly || _this5.props.annotateOnly
        });
      }),
      React__default.createElement(
        'div',
        { className: 'aha-editor-content' },
        React__default.createElement(
          'div',
          { className: 'aha-editor-body-with-toc' },
          editor.tableOfContentsVisible() && React__default.createElement(TableOfContents, {
            showTableOfContents: _this5.showTableOfContents,
            editor: editor
          }),
          next(),
          renderIf(_this5.isCollaborative && !_this5.props.readOnly)(React__default.createElement(Selections, {
            editor: editor,
            document: editor.value.document,
            selections: selections,
            fetchUserInfo: _this5.props.fetchUserInfo
          }))
        )
      )
    );
  };
};

var styles$12 = { "hidden": "Reference-module_hidden__3gFjX", "reference": "Reference-module_reference__1HrPn", "editing": "Reference-module_editing__2aaA8", "input": "Reference-module_input__37OHv", "spinnerIcon": "Reference-module_spinnerIcon__1JgVh", "nprogress-spinner": "Reference-module_nprogress-spinner__k9-l1" };

/// <reference path="../index.d.ts" />

// @ts-ignore
/**
 * @augments {React.Component<ReferencePlugin.ReferenceProps, ReferencePlugin.ReferenceState>}
 */

var Reference = function (_React$Component) {
  inherits(Reference, _React$Component);

  function Reference() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Reference);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Reference.__proto__ || Object.getPrototypeOf(Reference)).call.apply(_ref, [this].concat(args))), _this), _this.handleReferenceOptions = function (_ref2) {
      var _ref2$visibleFields = _ref2.visibleFields,
          visibleFields = _ref2$visibleFields === undefined ? [] : _ref2$visibleFields;
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;

      var reference = _extends({}, _this.reference, { visibleFields: visibleFields });
      var updatedNode = node.setIn(['data', 'reference'], reference);

      editor.replaceNodeByKey(node.key, updatedNode);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Reference, [{
    key: 'render',
    value: function render() {
      var attributes = this.props.attributes;

      var RenderComponent = this.props.renderComponent;

      return React__default.createElement(
        'span',
        _extends({ className: styles$12.reference }, attributes),
        React__default.createElement(RenderComponent, {
          reference: this.reference,
          onUpdateReferenceOptions: this.handleReferenceOptions
        })
      );
    }
  }, {
    key: 'data',
    get: function get$$1() {
      return this.props.node.data;
    }
  }, {
    key: 'reference',
    get: function get$$1() {
      return this.data.get('reference');
    }
  }]);
  return Reference;
}(React__default.Component);

var Reference$1 = enhanceWithComponentByKey(Reference);

var EditorPortal = function EditorPortal(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var _useState = React.useState(null),
      _useState2 = slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  var ref = React.useRef(null);

  React.useEffect(function () {
    var el = document.createElement('div');
    if (className) {
      el.className = className;
    }

    if (ref.current) {
      ref.current.closest('.aha-editor').appendChild(el);
      setContainer(el);
    }

    return function () {
      return el && el.remove();
    };
  }, [className, ref]);

  if (!container) return React__default.createElement('span', { ref: ref });

  return ReactDOM__default.createPortal(children({ container: container }), container);
};

var styles$13 = { "list": "ReferenceList-module_list__105-e", "empty": "ReferenceList-module_empty__2ys-h", "item": "ReferenceList-module_item__Rt6_O", "loading": "ReferenceList-module_loading__nOZDd", "selected": "ReferenceList-module_selected__31i8-", "hidden": "ReferenceList-module_hidden__hgIYt" };

/// <reference path="../index.d.ts" />

// @ts-ignore
/**
 * @augments {React.Component<ReferencePlugin.ReferenceListProps, ReferencePlugin.ReferenceListState>}
 */

var ReferenceList = function (_React$Component) {
  inherits(ReferenceList, _React$Component);

  /** @param {ReferencePlugin.ReferenceListProps} props */
  function ReferenceList(props) {
    classCallCheck(this, ReferenceList);

    var _this = possibleConstructorReturn(this, (ReferenceList.__proto__ || Object.getPrototypeOf(ReferenceList)).call(this, props));

    _this.onClick = function (index) {
      return function (event) {
        event.preventDefault();
        _this.props.onSelect(index);
        return false;
      };
    };

    _this.selectedRef = React__default.createRef();
    return _this;
  }

  createClass(ReferenceList, [{
    key: 'renderList',
    value: function renderList(_ref) {
      var _this2 = this,
          _classnames2;

      var ref = _ref.ref,
          style = _ref.style,
          outOfBoundaries = _ref.outOfBoundaries;
      var _props = this.props,
          selectedIndex = _props.selectedIndex,
          ListComponent = _props.ListComponent,
          key = _props.node.key,
          onMouseOverIndex = _props.onMouseOverIndex;


      var list = this.props.list.map(function (item, index) {
        var _classnames;

        return React__default.createElement(
          'div',
          _extends({
            key: 'list-container-' + key + '-' + index,
            role: 'listitem',
            className: classnames((_classnames = {}, defineProperty(_classnames, styles$13.item, true), defineProperty(_classnames, styles$13.selected, index === selectedIndex), _classnames)),
            ref: index === selectedIndex ? _this2.selectedRef : null
          }, onClickWithoutFocus(_this2.onClick(index)), {
            onMouseOver: onMouseOverIndex(index)
          }),
          React__default.createElement(ListComponent, _extends({
            key: 'list-' + key + '-' + index
          }, item, {
            selected: index === selectedIndex
          }))
        );
      });

      window.requestAnimationFrame(function () {
        if (_this2.selectedRef.current) {
          _this2.selectedRef.current.scrollIntoView({ block: 'nearest' });
        }
      });

      return React__default.createElement(
        'div',
        {
          className: classnames((_classnames2 = {}, defineProperty(_classnames2, styles$13.list, true), defineProperty(_classnames2, styles$13.empty, !(this.props.list.length > 0)), defineProperty(_classnames2, styles$13.hidden, outOfBoundaries), _classnames2)),
          role: 'list',
          ref: ref,
          style: style,
          onMouseMove: this.props.onMouseMove()
        },
        list
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        EditorPortal,
        {
          className: classnames('aha-editor-reference-list-container', styles$13.container)
        },
        function (_ref2) {
          var container = _ref2.container;
          return React__default.createElement(
            reactPopper.Popper,
            {
              placement: 'bottom-start',
              strategy: 'fixed',
              modifiers: [{
                name: 'flip',
                enabled: true,
                options: {
                  boundary: container.closest('.aha-editor')
                }
              }, {
                name: 'preventOverflow',
                enabled: true,
                options: { tether: true }
              }, { name: 'hide', enabled: true }]
            },
            function (attributes) {
              return _this3.renderList(attributes);
            }
          );
        }
      );
    }
  }]);
  return ReferenceList;
}(React__default.Component);

/** @param {ReferencePlugin.SolidOptions} options */
function changes$6(options) {
  var type = options.type,
      editableType = options.editableType;


  function createTriggerText() {
    return Slate.Text.create(options.trigger);
  }

  function unwrapReference(change) {
    return change.unwrapInline(editableType).unwrapInline(type);
  }

  /**
   * @param {string} before
   */
  function insertReference(change, before) {
    if (before) {
      change.insertText(before);
    }

    change.command(unwrapReference);

    return change.insertInline({
      type: editableType,
      nodes: [createTriggerText()],
      data: {}
    });
  }

  function insertNewReference(change, reference) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var keyData = key ? { key: key } : {};

    return change.insertInline({
      nodes: [Slate.Text.create(reference.linkUrl)],
      type: 'link',
      data: { href: reference.linkUrl }
    }).moveToStartOfNextText().deleteBackward(reference.linkUrl.length).insertInline(_extends({
      type: 'aha-reference',
      data: { reference: reference }
    }, keyData)).moveForward();
  }

  function updateReference(change, node, reference) {
    change.withoutNormalizing(function (change) {
      change.moveToEndOfNode(node).moveToStartOfNextText().insertText(' ').setNodeByKey(node.key, {
        type: type,
        data: { reference: reference }
      });

      node.nodes.forEach(function (child) {
        return change.removeNodeByKey(child.key);
      });
    });
  }

  /**
   * @param {AhaEditor.Node} node
   * @param {string} text
   */
  function removeAndReplaceWith(change, node, text) {
    change.moveToStartOfNextText().replaceNodeByKey(node.key, Slate.Text.create(text));
  }

  function remove(change, node) {
    change.moveToEndOfPreviousText().removeNodeByKey(node.key);
  }

  return {
    unwrapReference: unwrapReference,
    insertReference: insertReference,
    insertNewReference: insertNewReference,
    removeAndReplaceWith: removeAndReplaceWith,
    remove: remove,
    updateReference: updateReference
  };
}

/// <reference path="../index.d.ts" />

// @ts-ignore
/**
 * @augments {React.Component<ReferencePlugin.EditableReferenceProps, ReferencePlugin.EditableReferenceState>}
 */

var EditableReference = function (_React$Component) {
  inherits(EditableReference, _React$Component);

  /** @param {ReferencePlugin.ReferenceProps} props */
  function EditableReference(props) {
    classCallCheck(this, EditableReference);

    /** @type {ReferencePlugin.EditableReferenceState} */
    var _this = possibleConstructorReturn(this, (EditableReference.__proto__ || Object.getPrototypeOf(EditableReference)).call(this, props));

    _this.onMouseOverIndex = function (index) {
      return function (event) {
        if (_this.state.mousing) {
          // If the user is navigating with the keyboard then ignore this event
          // since it will happend when the list scrolls the new item into view,
          // undoing the scrolling.
          _this.setState({ selectedIndex: index });
        }
      };
    };

    _this.onSelect = function (index) {
      if (_this.validIndex(index)) {
        var item = _this.state.list[index];
        _this.reference = item;

        if (_this.props.onSelect) {
          _this.props.onSelect(item);
        }
      } else {
        _this.editor.command(function (change) {
          return _this.cancelSearch(change);
        });
      }
      setTimeout(function () {
        _this.editor.focus();
      }, 100);
    };

    _this.state = {
      searchText: '',
      list: [],
      listLoading: true,
      selectedIndex: 0,
      mousing: true // Whether user is navigating with mouse or keyboard.
    };

    _this.changes = changes$6(props);
    _this.updateIndex = 0;
    return _this;
  }

  createClass(EditableReference, [{
    key: 'nextUpdate',
    value: function nextUpdate() {
      this.updateIndex += 1;
      return this.updateIndex;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFocused) {
        this.onChange(this.state.searchText);
      } else {
        this.setState({ listLoading: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.nextUpdate();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.debouncedSearch = null;
      this.detectTextChange(props);
    }
  }, {
    key: 'validIndex',
    value: function validIndex(index) {
      return index < this.state.list.length;
    }
  }, {
    key: 'detectTextChange',
    value: function detectTextChange(props) {
      var textNode = props.node.nodes.first();
      /** @type {string} */
      var text = textNode.text;

      var searchText = text.substr(this.props.trigger.length);

      if (this.state.list.length === 0 && /\s$/.test(text)) {
        this.removeAndReplace('' + text);
      } else if (searchText !== this.state.searchText) {
        this.onChange(searchText);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(text) {
      this.setState({ searchText: text });

      if (text === ' ') {
        this.removeAndReplace(this.props.trigger + ' ');
      } else {
        this.loadList(text);
      }
    }

    /** @param {string} withText */

  }, {
    key: 'removeAndReplace',
    value: function removeAndReplace(withText) {
      this.editor.command(this.changes.removeAndReplaceWith, this.props.node, withText);
    }
  }, {
    key: 'search',
    value: function search(text, index) {
      var _this2 = this;

      if (!this.debouncedSearch) {
        this.debouncedSearch = debounce(function (text, index) {
          _this2.props.search(text).then(function (list) {
            if (index === _this2.updateIndex) {
              _this2.setState({ listLoading: false, list: list, selectedIndex: 0 });
            }
          }).catch(function (err) {
            if (err.message !== 'aborted') {
              console.error(err);
            }
          });
        }, this.props.debounce);
      }

      this.debouncedSearch(text, index);
    }

    /** @param {string} text */

  }, {
    key: 'loadList',
    value: function loadList(text) {
      this.setState({ listLoading: true });
      var index = this.nextUpdate();
      return this.search(text, index);
    }
  }, {
    key: 'cancelSearch',
    value: function cancelSearch(editor) {
      var _props = this.props,
          trigger = _props.trigger,
          node = _props.node;
      var searchText = this.state.searchText;

      return editor.command(this.changes.removeAndReplaceWith, node, trigger + searchText);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event, editor, next) {
      var _state = this.state,
          selectedIndex = _state.selectedIndex,
          list = _state.list;
      var trigger = this.props.trigger;


      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          this.cancelSearch(editor);
          setTimeout(function () {
            return editor.focus();
          }, 100);
          return false;
        case 'ArrowUp':
          event.preventDefault();
          return this.setState({
            mousing: false,
            selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : 0
          });
        case 'ArrowDown':
          event.preventDefault();
          return this.setState({
            mousing: false,
            selectedIndex: selectedIndex < list.length - 1 ? selectedIndex + 1 : list.length - 1
          });
        case 'Tab':
        case 'Enter':
          if (list.length > 0) {
            event.preventDefault();
            event.stopPropagation();
            this.onSelect(selectedIndex);
            return false;
          } else {
            event.preventDefault();
            editor.command(this.changes.removeAndReplaceWith, this.node, '' + trigger + this.node.text.substring(trigger.length) + String.fromCharCode(event.keyCode === 13 ? 10 : event.keyCode));
            return false;
          }
        case 'Backspace':
          if (this.state.searchText.length === 0) {
            event.preventDefault();
            editor.command(this.changes.remove, this.node);
            return false;
          } else if (editor.value.selection.focus.offset === trigger.length) {
            event.preventDefault();
            editor.command(this.changes.removeAndReplaceWith, this.node, this.node.text.substring(trigger.length));
            return false;
          }
          break;
        default:
      }
      return next();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          attributes = _props2.attributes,
          searchComponent = _props2.searchComponent;
      var _state2 = this.state,
          selectedIndex = _state2.selectedIndex,
          listLoading = _state2.listLoading,
          list = _state2.list;

      var childNode = this.props.children[0];

      return React__default.createElement(
        reactPopper.Manager,
        null,
        React__default.createElement(
          'span',
          { className: styles$12.reference },
          React__default.createElement(
            reactPopper.Reference,
            null,
            function (_ref) {
              var ref = _ref.ref;
              return React__default.createElement(
                'span',
                _extends({ className: styles$12.editing }, attributes, { ref: ref }),
                childNode,
                renderIf(_this3.state.listLoading)(React__default.createElement('span', { className: styles$12.spinnerIcon }))
              );
            }
          ),
          renderIf(this.isFocused)(React__default.createElement(ReferenceList, {
            node: this.props.node,
            parent: this,
            ListComponent: searchComponent,
            list: list,
            loading: listLoading,
            selectedIndex: selectedIndex,
            onSelect: this.onSelect,
            onMouseOverIndex: this.onMouseOverIndex,
            onMouseMove: function onMouseMove() {
              return function () {
                return _this3.setState({ mousing: true });
              };
            }
          }))
        )
      );
    }
  }, {
    key: 'editor',
    get: function get$$1() {
      return this.props.editor;
    }
  }, {
    key: 'node',
    get: function get$$1() {
      return this.props.node;
    }
  }, {
    key: 'textNode',
    get: function get$$1() {
      return this.node.nodes.get(0);
    }
  }, {
    key: 'data',
    get: function get$$1() {
      return this.props.node.data;
    }
  }, {
    key: 'reference',
    get: function get$$1() {
      return this.data.get('reference');
    },
    set: function set$$1(value) {
      this.editor.command(this.changes.updateReference, this.node, value);
    }

    // We should only show the list if the selection is collapsed, and
    // if the cursor is either inside the reference, or at the first
    // character of the next node.

  }, {
    key: 'isFocused',
    get: function get$$1() {
      var node = this.node,
          editor = this.editor;
      var _editor$value = editor.value,
          document = _editor$value.document,
          selection = _editor$value.selection;

      if (!selection.isFocused) return false;
      if (!selection.isCollapsed) return false;
      if (node.getDescendant(selection.anchor.key)) return true;

      var nextText = document.getNextText(node.getLastText().key);
      if (!nextText) return false;
      if (selection.isCollapsed && selection.anchor.isAtStartOfNode(node)) {
        return true;
      }
      return false;
    }
  }]);
  return EditableReference;
}(React__default.Component);

var EditableReference$1 = enhanceWithComponentByKey(EditableReference);

/// <reference path="./index.d.ts" />

/**
 * @param {ReferencePlugin.Options} opts
 */
function Plugin$9(opts) {
  var _inlines;

  var defaults$$1 = {
    type: opts.trigger + '-reference',
    debounce: 200
  };

  var options = _extends({}, defaults$$1, opts);
  options.editableType = options.editableType || options.type + '-editable';

  var type = options.type,
      editableType = options.editableType;

  var _changes = changes$6(options),
      insertReference = _changes.insertReference,
      unwrapReference = _changes.unwrapReference,
      removeAndReplaceWith = _changes.removeAndReplaceWith,
      insertNewReference = _changes.insertNewReference;

  function renderInline(props, editor, next) {
    var node = props.node,
        attributes = props.attributes;


    if (node.type === type) {
      return React__default.createElement(Reference$1, _extends({}, props, options, { attributes: attributes }));
    } else if (node.type === editableType) {
      return React__default.createElement(EditableReference$1, _extends({}, props, options, { attributes: attributes }));
    }
    return next();
  }

  function onKeyDown(event, editor, next) {
    var value = editor.value;

    var node = value.inlines.first();

    if (!node) return next();

    if (node.type === type) {
      if (event.key === 'Enter') {
        // Ignore split node
        return;
      }
    }

    if (node.type !== editableType) {
      return next();
    }

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowUp':
      case 'Escape':
      case 'Tab':
      case 'Enter':
      case 'Backspace':
        /** @type {any} */
        if (value.selection.isCollapsed) {
          var component = componentByKey(node.key);
          if (component && component.onKeyDown) {
            return component.onKeyDown(event, editor, next);
          }
        }
        break;
      default:
    }

    var result = next();

    var newNode = editor.value.document.getDescendant(node.key);
    if (newNode && newNode.text.substring(0, options.trigger.length) !== options.trigger) {
      editor.command(removeAndReplaceWith, newNode, newNode.text);
    }

    return result;
  }

  var serializer = new Serializer();

  function pasteFragment(editor, fragment, next) {
    var texts = fragment.getTexts();
    if (texts.size <= 1) {
      var text = texts.get(0);
      return editor.insertText(text.text);
    }

    editor.command(unwrapReference);
    return next();
  }

  function onPaste(event, editor, next) {
    var _editor$value = editor.value,
        focusInline = _editor$value.focusInline,
        selection = _editor$value.selection;

    var transfer = slateReact.getEventTransfer(event);
    var ahaReference = void 0;

    if (typeof options.detectReferenceLink === 'function') {
      ahaReference = options.detectReferenceLink(transfer.text);
    }

    if (isObject(ahaReference) || ahaReference instanceof Promise) {
      // If there is a selection, don't insert a reference.
      // The highlighted text will be converted to a link by the links plugin.
      if (!selection.isCollapsed) {
        return next();
      }

      if (ahaReference instanceof Promise) {
        var key = Slate.KeyUtils.create();
        return ahaReference.then(function (_ref) {
          var reference = _ref.reference,
              fetchData = _ref.fetchData;

          editor.command(insertNewReference, reference, key);
          return fetchData();
        }).then(function (data) {
          var node = editor.value.document.getDescendant(key);
          if (node) {
            editor.updateReferenceData(node, data);
            var updatedReference = editor.value.document.getDescendant(key).getIn(['data', 'reference']);
            options.onSelect(updatedReference);
          }
        });
      } else {
        options.onSelect(ahaReference);
        return editor.command(insertNewReference, ahaReference);
      }
    }

    if (focusInline && focusInline.type === editableType) {
      switch (transfer.type) {
        case 'html':
          var _serializer$deseriali = serializer.deserialize(transfer.html),
              document = _serializer$deseriali.document;

          return pasteFragment(editor, document, next);
        case 'fragment':
          return pasteFragment(editor, transfer.fragment, next);
        case 'text':
          return editor.insertText(transfer.text);
        default:
      }
    }
    return next();
  }

  var trigger = function trigger(e, editor, next) {
    return e.key === options.trigger && !editor.value.inlines.some(function (inline) {
      return inline.type.includes('-reference');
    });
  };

  var transform = function transform(editor, e, matches) {
    return editor.command(insertReference, matches.before[1]);
  };

  var updateReferenceData = function updateReferenceData(editor, node, data) {
    editor.withoutSaving(function () {
      editor.setNodeByKey(node.key, node.setIn(['data', 'reference'], _extends({}, node.getIn(['data', 'reference']), data)));
    });
  };

  var schema = {
    inlines: (_inlines = {}, defineProperty(_inlines, type, {
      isVoid: true
    }), defineProperty(_inlines, editableType, {
      text: /^.+$/ // remove empty references
    }), _inlines)
  };

  return {
    options: options,
    plugins: [{
      schema: schema,
      onKeyDown: onKeyDown,
      onPaste: onPaste,
      renderInline: renderInline,
      commands: {
        updateReferenceData: updateReferenceData
      }
    }, AutoReplace({
      before: /(^|\s)$/,
      trigger: trigger,
      change: transform
    }), StickyInlines({
      allowedTypes: [editableType],
      canBeEmpty: false
    })]
  };
}

/// <reference path="./index.d.ts" />

/**
 * @param {ReferencePlugin.Options} options
 */
function ReferencePlugin(options) {
  return _extends({}, Plugin$9(options));
}

var version = '1.4.81';

var plugins = { ReferencePlugin: ReferencePlugin };
var compatibleVersion = version.split('.').slice(0, 2).join('.');

exports.AhaEditor = AhaEditor;
exports.Serializer = Serializer;
exports.ValueMigrator = ValueMigrator;
exports.getPlugins = getPlugins;
exports.plugins = plugins;
exports.ToolbarItem = ToolbarItem;
exports.ToolbarMenu = ToolbarMenu;
exports.Resizer = Resizer;
exports.Selection = Selection;
exports.IS_MAC = slateDevEnvironment.IS_MAC;
exports.bindHotkey = bindHotkey;
exports.isModifyingOperation = isModifyingOperation;
exports.version = version;
exports.compatibleVersion = compatibleVersion;
